import * as React from 'react';
import React__default, { createContext, useContext, createElement, Fragment, forwardRef as forwardRef$2, useRef, useLayoutEffect as useLayoutEffect$1, memo, useMemo, useState, useCallback, useEffect, useImperativeHandle, useReducer } from 'react';
import require$$0 from 'react-is';
import $9Q8De$reactdom, { unstable_batchedUpdates } from 'react-dom';
import { Router, __RouterContext, matchPath } from 'react-router';

var SortDirection;

(function (SortDirection) {
  SortDirection["Ascending"] = "ascending";
  SortDirection["Descending"] = "descending";
  SortDirection["None"] = "none";
})(SortDirection || (SortDirection = {}));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/**
 * Do not edit directly
 * Generated on Wed, 07 Sep 2022 22:01:12 GMT
 */

var uiTokens = {
  "border": {
    "round": {
      "hairline": {
        "radius": {
          "value": "4px",
          "filePath": "tokens/base/border.json",
          "isSource": true,
          "original": {
            "value": "4px"
          },
          "name": "BorderRoundHairlineRadius",
          "attributes": {
            "category": "border",
            "type": "round",
            "item": "hairline",
            "subitem": "radius"
          },
          "path": [
            "border",
            "round",
            "hairline",
            "radius"
          ]
        },
        "width": {
          "value": "1px",
          "filePath": "tokens/base/border.json",
          "isSource": true,
          "original": {
            "value": "1px"
          },
          "name": "BorderRoundHairlineWidth",
          "attributes": {
            "category": "border",
            "type": "round",
            "item": "hairline",
            "subitem": "width"
          },
          "path": [
            "border",
            "round",
            "hairline",
            "width"
          ]
        }
      },
      "radius": {
        "value": "4px",
        "filePath": "tokens/base/border.json",
        "isSource": true,
        "original": {
          "value": "4px"
        },
        "name": "BorderRoundRadius",
        "attributes": {
          "category": "border",
          "type": "round",
          "item": "radius"
        },
        "path": [
          "border",
          "round",
          "radius"
        ]
      },
      "width": {
        "value": "2px",
        "filePath": "tokens/base/border.json",
        "isSource": true,
        "original": {
          "value": "2px"
        },
        "name": "BorderRoundWidth",
        "attributes": {
          "category": "border",
          "type": "round",
          "item": "width"
        },
        "path": [
          "border",
          "round",
          "width"
        ]
      }
    }
  },
  "color": {
    "brand": {
      "dust": {
        "value": "#f2ebe4",
        "filePath": "tokens/base/color.json",
        "isSource": true,
        "original": {
          "value": "#F2EBE4"
        },
        "name": "ColorBrandDust",
        "attributes": {
          "category": "color",
          "type": "brand",
          "item": "dust"
        },
        "path": [
          "color",
          "brand",
          "dust"
        ]
      },
      "asphalt": {
        "v40": {
          "value": "#a4abb4",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#A4ABB4"
          },
          "name": "ColorBrandAsphaltV40",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "asphalt",
            "subitem": "v40"
          },
          "path": [
            "color",
            "brand",
            "asphalt",
            "v40"
          ]
        },
        "v50": {
          "value": "#595f69",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#595f69"
          },
          "name": "ColorBrandAsphaltV50",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "asphalt",
            "subitem": "v50"
          },
          "path": [
            "color",
            "brand",
            "asphalt",
            "v50"
          ]
        },
        "v60": {
          "value": "#191919",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#191919"
          },
          "name": "ColorBrandAsphaltV60",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "asphalt",
            "subitem": "v60"
          },
          "path": [
            "color",
            "brand",
            "asphalt",
            "v60"
          ]
        }
      },
      "green": {
        "v40": {
          "value": "#d9e670",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#D9E670"
          },
          "name": "ColorBrandGreenV40",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "green",
            "subitem": "v40"
          },
          "path": [
            "color",
            "brand",
            "green",
            "v40"
          ]
        },
        "v60": {
          "value": "#373a25",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#373A25"
          },
          "name": "ColorBrandGreenV60",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "green",
            "subitem": "v60"
          },
          "path": [
            "color",
            "brand",
            "green",
            "v60"
          ]
        }
      },
      "copper": {
        "v40": {
          "value": "#cf8c29",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#CF8C29"
          },
          "name": "ColorBrandCopperV40",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "copper",
            "subitem": "v40"
          },
          "path": [
            "color",
            "brand",
            "copper",
            "v40"
          ]
        },
        "v60": {
          "value": "#432706",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#432706"
          },
          "name": "ColorBrandCopperV60",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "copper",
            "subitem": "v60"
          },
          "path": [
            "color",
            "brand",
            "copper",
            "v60"
          ]
        }
      },
      "magenta": {
        "v40": {
          "value": "#f10251",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#F10251"
          },
          "name": "ColorBrandMagentaV40",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "magenta",
            "subitem": "v40"
          },
          "path": [
            "color",
            "brand",
            "magenta",
            "v40"
          ]
        },
        "v60": {
          "value": "#341624",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#341624"
          },
          "name": "ColorBrandMagentaV60",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "magenta",
            "subitem": "v60"
          },
          "path": [
            "color",
            "brand",
            "magenta",
            "v60"
          ]
        }
      },
      "orange": {
        "v40": {
          "value": "#ff5132",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#ff5132"
          },
          "name": "ColorBrandOrangeV40",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "orange",
            "subitem": "v40"
          },
          "path": [
            "color",
            "brand",
            "orange",
            "v40"
          ]
        },
        "v60": {
          "value": "#4d1906",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#4D1906"
          },
          "name": "ColorBrandOrangeV60",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "orange",
            "subitem": "v60"
          },
          "path": [
            "color",
            "brand",
            "orange",
            "v60"
          ]
        }
      }
    },
    "base": {
      "white": {
        "value": "#ffffff",
        "filePath": "tokens/base/color.json",
        "isSource": true,
        "original": {
          "value": "#FFFFFF"
        },
        "name": "ColorBaseWhite",
        "attributes": {
          "category": "color",
          "type": "base",
          "item": "white"
        },
        "path": [
          "color",
          "base",
          "white"
        ]
      },
      "black": {
        "value": "#000000",
        "filePath": "tokens/base/color.json",
        "isSource": true,
        "original": {
          "value": "#000000"
        },
        "name": "ColorBaseBlack",
        "attributes": {
          "category": "color",
          "type": "base",
          "item": "black"
        },
        "path": [
          "color",
          "base",
          "black"
        ]
      },
      "blue": {
        "v500": {
          "value": "#005176",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#005176"
          },
          "name": "ColorBaseBlueV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "blue",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "blue",
            "v500"
          ]
        },
        "v300": {
          "value": "#4dc2f6",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#4DC2F6"
          },
          "name": "ColorBaseBlueV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "blue",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "blue",
            "v300"
          ]
        },
        "v100": {
          "value": "#a0bdf8",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#A0BDF8"
          },
          "name": "ColorBaseBlueV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "blue",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "blue",
            "v100"
          ]
        },
        "v50": {
          "value": "#e7efff",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#E7EFFF"
          },
          "name": "ColorBaseBlueV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "blue",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "blue",
            "v50"
          ]
        }
      },
      "green": {
        "v500": {
          "value": "#00762b",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#00762B"
          },
          "name": "ColorBaseGreenV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "green",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "green",
            "v500"
          ]
        },
        "v300": {
          "value": "#22c55e",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#22C55E"
          },
          "name": "ColorBaseGreenV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "green",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "green",
            "v300"
          ]
        },
        "v100": {
          "value": "#9adebd",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#9ADEBD"
          },
          "name": "ColorBaseGreenV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "green",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "green",
            "v100"
          ]
        },
        "v50": {
          "value": "#eaf8f1",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#EAF8F1"
          },
          "name": "ColorBaseGreenV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "green",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "green",
            "v50"
          ]
        }
      },
      "red": {
        "v500": {
          "value": "#bf1313",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#BF1313"
          },
          "name": "ColorBaseRedV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "red",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "red",
            "v500"
          ]
        },
        "v300": {
          "value": "#ef4444",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#EF4444"
          },
          "name": "ColorBaseRedV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "red",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "red",
            "v300"
          ]
        },
        "v100": {
          "value": "#eca9a3",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#ECA9A3"
          },
          "name": "ColorBaseRedV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "red",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "red",
            "v100"
          ]
        },
        "v50": {
          "value": "#fae0e0",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#FAE0E0"
          },
          "name": "ColorBaseRedV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "red",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "red",
            "v50"
          ]
        }
      },
      "orange": {
        "v500": {
          "value": "#b04e07",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#B04E07"
          },
          "name": "ColorBaseOrangeV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "orange",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "orange",
            "v500"
          ]
        },
        "v300": {
          "value": "#f97316",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#F97316"
          },
          "name": "ColorBaseOrangeV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "orange",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "orange",
            "v300"
          ]
        },
        "v100": {
          "value": "#ffbb8c",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#FFBB8C"
          },
          "name": "ColorBaseOrangeV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "orange",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "orange",
            "v100"
          ]
        },
        "v50": {
          "value": "#ffe8d8",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#FFE8D8"
          },
          "name": "ColorBaseOrangeV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "orange",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "orange",
            "v50"
          ]
        }
      },
      "yellow": {
        "v500": {
          "value": "#826811",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#826811"
          },
          "name": "ColorBaseYellowV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "yellow",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "yellow",
            "v500"
          ]
        },
        "v300": {
          "value": "#eab308",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#EAB308"
          },
          "name": "ColorBaseYellowV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "yellow",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "yellow",
            "v300"
          ]
        },
        "v100": {
          "value": "#ffe68c",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#FFE68C"
          },
          "name": "ColorBaseYellowV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "yellow",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "yellow",
            "v100"
          ]
        },
        "v50": {
          "value": "#fef8e1",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#FEF8E1"
          },
          "name": "ColorBaseYellowV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "yellow",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "yellow",
            "v50"
          ]
        }
      },
      "purple": {
        "v500": {
          "value": "#6000ba",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#6000BA"
          },
          "name": "ColorBasePurpleV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "purple",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "purple",
            "v500"
          ]
        },
        "v300": {
          "value": "#a855f7",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#A855F7"
          },
          "name": "ColorBasePurpleV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "purple",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "purple",
            "v300"
          ]
        },
        "v100": {
          "value": "#beacf0",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#BEACF0"
          },
          "name": "ColorBasePurpleV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "purple",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "purple",
            "v100"
          ]
        },
        "v50": {
          "value": "#ede7ff",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#EDE7FF"
          },
          "name": "ColorBasePurpleV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "purple",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "purple",
            "v50"
          ]
        }
      },
      "digitalSecondary": {
        "v300": {
          "value": "#0a7db3",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#0A7DB3"
          },
          "name": "ColorBaseDigitalSecondaryV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "digitalSecondary",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "digitalSecondary",
            "v300"
          ]
        }
      },
      "gray": {
        "v900": {
          "value": "#09091a",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#09091A"
          },
          "name": "ColorBaseGrayV900",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v900"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v900"
          ]
        },
        "v800": {
          "value": "#25252c",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#25252C"
          },
          "name": "ColorBaseGrayV800",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v800"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v800"
          ]
        },
        "v700": {
          "value": "#313140",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#313140"
          },
          "name": "ColorBaseGrayV700",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v700"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v700"
          ]
        },
        "v600": {
          "value": "#3f4055",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#3F4055"
          },
          "name": "ColorBaseGrayV600",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v600"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v600"
          ]
        },
        "v500": {
          "value": "#515369",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#515369"
          },
          "name": "ColorBaseGrayV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v500"
          ]
        },
        "v400": {
          "value": "#66687d",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#66687D"
          },
          "name": "ColorBaseGrayV400",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v400"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v400"
          ]
        },
        "v300": {
          "value": "#7b7e91",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#7B7E91"
          },
          "name": "ColorBaseGrayV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v300"
          ]
        },
        "v200": {
          "value": "#9295a6",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#9295A6"
          },
          "name": "ColorBaseGrayV200",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v200"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v200"
          ]
        },
        "v100": {
          "value": "#abadba",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#ABADBA"
          },
          "name": "ColorBaseGrayV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v100"
          ]
        },
        "v75": {
          "value": "#d7dae2",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#D7DAE2"
          },
          "name": "ColorBaseGrayV75",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v75"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v75"
          ]
        },
        "v50": {
          "value": "#e9ecf3",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#E9ECF3"
          },
          "name": "ColorBaseGrayV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v50"
          ]
        },
        "v25": {
          "value": "#f9fbff",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#F9FBFF"
          },
          "name": "ColorBaseGrayV25",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "gray",
            "subitem": "v25"
          },
          "path": [
            "color",
            "base",
            "gray",
            "v25"
          ]
        }
      },
      "graySemantic": {
        "v500": {
          "value": "#384152",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#384152"
          },
          "name": "ColorBaseGraySemanticV500",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "graySemantic",
            "subitem": "v500"
          },
          "path": [
            "color",
            "base",
            "graySemantic",
            "v500"
          ]
        },
        "v300": {
          "value": "#697a99",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#697A99"
          },
          "name": "ColorBaseGraySemanticV300",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "graySemantic",
            "subitem": "v300"
          },
          "path": [
            "color",
            "base",
            "graySemantic",
            "v300"
          ]
        },
        "v100": {
          "value": "#afb6c3",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#AFB6C3"
          },
          "name": "ColorBaseGraySemanticV100",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "graySemantic",
            "subitem": "v100"
          },
          "path": [
            "color",
            "base",
            "graySemantic",
            "v100"
          ]
        },
        "v50": {
          "value": "#e9edf3",
          "filePath": "tokens/base/color.json",
          "isSource": true,
          "original": {
            "value": "#E9EDF3"
          },
          "name": "ColorBaseGraySemanticV50",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "graySemantic",
            "subitem": "v50"
          },
          "path": [
            "color",
            "base",
            "graySemantic",
            "v50"
          ]
        }
      }
    }
  },
  "font": {
    "b100": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB100Family",
        "attributes": {
          "category": "font",
          "type": "b100",
          "item": "family"
        },
        "path": [
          "font",
          "b100",
          "family"
        ]
      },
      "size": {
        "value": "10px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "10px"
        },
        "name": "FontB100Size",
        "attributes": {
          "category": "font",
          "type": "b100",
          "item": "size"
        },
        "path": [
          "font",
          "b100",
          "size"
        ]
      },
      "weight": {
        "value": "500",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "500"
        },
        "name": "FontB100Weight",
        "attributes": {
          "category": "font",
          "type": "b100",
          "item": "weight"
        },
        "path": [
          "font",
          "b100",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "13px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "13px"
        },
        "name": "FontB100LineHeight",
        "attributes": {
          "category": "font",
          "type": "b100",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b100",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0.25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0.25px"
        },
        "name": "FontB100LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b100",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b100",
          "letterSpacing"
        ]
      }
    },
    "b200": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB200Family",
        "attributes": {
          "category": "font",
          "type": "b200",
          "item": "family"
        },
        "path": [
          "font",
          "b200",
          "family"
        ]
      },
      "size": {
        "value": "12px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "12px"
        },
        "name": "FontB200Size",
        "attributes": {
          "category": "font",
          "type": "b200",
          "item": "size"
        },
        "path": [
          "font",
          "b200",
          "size"
        ]
      },
      "weight": {
        "value": "400",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "400"
        },
        "name": "FontB200Weight",
        "attributes": {
          "category": "font",
          "type": "b200",
          "item": "weight"
        },
        "path": [
          "font",
          "b200",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "16px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "16px"
        },
        "name": "FontB200LineHeight",
        "attributes": {
          "category": "font",
          "type": "b200",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b200",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0"
        },
        "name": "FontB200LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b200",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b200",
          "letterSpacing"
        ]
      }
    },
    "b300": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB300Family",
        "attributes": {
          "category": "font",
          "type": "b300",
          "item": "family"
        },
        "path": [
          "font",
          "b300",
          "family"
        ]
      },
      "size": {
        "value": "14px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "14px"
        },
        "name": "FontB300Size",
        "attributes": {
          "category": "font",
          "type": "b300",
          "item": "size"
        },
        "path": [
          "font",
          "b300",
          "size"
        ]
      },
      "weight": {
        "value": "400",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "400"
        },
        "name": "FontB300Weight",
        "attributes": {
          "category": "font",
          "type": "b300",
          "item": "weight"
        },
        "path": [
          "font",
          "b300",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "19px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "19px"
        },
        "name": "FontB300LineHeight",
        "attributes": {
          "category": "font",
          "type": "b300",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b300",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.50px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.50px"
        },
        "name": "FontB300LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b300",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b300",
          "letterSpacing"
        ]
      }
    },
    "b400": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB400Family",
        "attributes": {
          "category": "font",
          "type": "b400",
          "item": "family"
        },
        "path": [
          "font",
          "b400",
          "family"
        ]
      },
      "size": {
        "value": "16px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "16px"
        },
        "name": "FontB400Size",
        "attributes": {
          "category": "font",
          "type": "b400",
          "item": "size"
        },
        "path": [
          "font",
          "b400",
          "size"
        ]
      },
      "weight": {
        "value": "400",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "400"
        },
        "name": "FontB400Weight",
        "attributes": {
          "category": "font",
          "type": "b400",
          "item": "weight"
        },
        "path": [
          "font",
          "b400",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "22px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "22px"
        },
        "name": "FontB400LineHeight",
        "attributes": {
          "category": "font",
          "type": "b400",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b400",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.85px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.85px"
        },
        "name": "FontB400LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b400",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b400",
          "letterSpacing"
        ]
      }
    },
    "b500": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB500Family",
        "attributes": {
          "category": "font",
          "type": "b500",
          "item": "family"
        },
        "path": [
          "font",
          "b500",
          "family"
        ]
      },
      "size": {
        "value": "18px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "18px"
        },
        "name": "FontB500Size",
        "attributes": {
          "category": "font",
          "type": "b500",
          "item": "size"
        },
        "path": [
          "font",
          "b500",
          "size"
        ]
      },
      "weight": {
        "value": "500",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "500"
        },
        "name": "FontB500Weight",
        "attributes": {
          "category": "font",
          "type": "b500",
          "item": "weight"
        },
        "path": [
          "font",
          "b500",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "24px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "24px"
        },
        "name": "FontB500LineHeight",
        "attributes": {
          "category": "font",
          "type": "b500",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b500",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.75px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.75px"
        },
        "name": "FontB500LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b500",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b500",
          "letterSpacing"
        ]
      }
    },
    "b600": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB600Family",
        "attributes": {
          "category": "font",
          "type": "b600",
          "item": "family"
        },
        "path": [
          "font",
          "b600",
          "family"
        ]
      },
      "size": {
        "value": "21px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "21px"
        },
        "name": "FontB600Size",
        "attributes": {
          "category": "font",
          "type": "b600",
          "item": "size"
        },
        "path": [
          "font",
          "b600",
          "size"
        ]
      },
      "weight": {
        "value": "600",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "600"
        },
        "name": "FontB600Weight",
        "attributes": {
          "category": "font",
          "type": "b600",
          "item": "weight"
        },
        "path": [
          "font",
          "b600",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "28px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "28px"
        },
        "name": "FontB600LineHeight",
        "attributes": {
          "category": "font",
          "type": "b600",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b600",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.50px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.50px"
        },
        "name": "FontB600LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b600",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b600",
          "letterSpacing"
        ]
      }
    },
    "b700": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB700Family",
        "attributes": {
          "category": "font",
          "type": "b700",
          "item": "family"
        },
        "path": [
          "font",
          "b700",
          "family"
        ]
      },
      "size": {
        "value": "24px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "24px"
        },
        "name": "FontB700Size",
        "attributes": {
          "category": "font",
          "type": "b700",
          "item": "size"
        },
        "path": [
          "font",
          "b700",
          "size"
        ]
      },
      "weight": {
        "value": "600",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "600"
        },
        "name": "FontB700Weight",
        "attributes": {
          "category": "font",
          "type": "b700",
          "item": "weight"
        },
        "path": [
          "font",
          "b700",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "32px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "32px"
        },
        "name": "FontB700LineHeight",
        "attributes": {
          "category": "font",
          "type": "b700",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b700",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.25px"
        },
        "name": "FontB700LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b700",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b700",
          "letterSpacing"
        ]
      }
    },
    "b800": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB800Family",
        "attributes": {
          "category": "font",
          "type": "b800",
          "item": "family"
        },
        "path": [
          "font",
          "b800",
          "family"
        ]
      },
      "size": {
        "value": "32px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "32px"
        },
        "name": "FontB800Size",
        "attributes": {
          "category": "font",
          "type": "b800",
          "item": "size"
        },
        "path": [
          "font",
          "b800",
          "size"
        ]
      },
      "weight": {
        "value": "700",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "FontB800Weight",
        "attributes": {
          "category": "font",
          "type": "b800",
          "item": "weight"
        },
        "path": [
          "font",
          "b800",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "40px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "40px"
        },
        "name": "FontB800LineHeight",
        "attributes": {
          "category": "font",
          "type": "b800",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b800",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0"
        },
        "name": "FontB800LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b800",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b800",
          "letterSpacing"
        ]
      }
    },
    "b900": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontB900Family",
        "attributes": {
          "category": "font",
          "type": "b900",
          "item": "family"
        },
        "path": [
          "font",
          "b900",
          "family"
        ]
      },
      "size": {
        "value": "48px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "48px"
        },
        "name": "FontB900Size",
        "attributes": {
          "category": "font",
          "type": "b900",
          "item": "size"
        },
        "path": [
          "font",
          "b900",
          "size"
        ]
      },
      "weight": {
        "value": "800",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "800"
        },
        "name": "FontB900Weight",
        "attributes": {
          "category": "font",
          "type": "b900",
          "item": "weight"
        },
        "path": [
          "font",
          "b900",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "60px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "60px"
        },
        "name": "FontB900LineHeight",
        "attributes": {
          "category": "font",
          "type": "b900",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "b900",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": ".25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": ".25px"
        },
        "name": "FontB900LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "b900",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "b900",
          "letterSpacing"
        ]
      }
    },
    "h70": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH70Family",
        "attributes": {
          "category": "font",
          "type": "h70",
          "item": "family"
        },
        "path": [
          "font",
          "h70",
          "family"
        ]
      },
      "size": {
        "value": "10px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "10px"
        },
        "name": "FontH70Size",
        "attributes": {
          "category": "font",
          "type": "h70",
          "item": "size"
        },
        "path": [
          "font",
          "h70",
          "size"
        ]
      },
      "weight": {
        "value": "700",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "FontH70Weight",
        "attributes": {
          "category": "font",
          "type": "h70",
          "item": "weight"
        },
        "path": [
          "font",
          "h70",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "13px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "13px"
        },
        "name": "FontH70LineHeight",
        "attributes": {
          "category": "font",
          "type": "h70",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h70",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0.25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0.25px"
        },
        "name": "FontH70LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h70",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h70",
          "letterSpacing"
        ]
      }
    },
    "h80": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH80Family",
        "attributes": {
          "category": "font",
          "type": "h80",
          "item": "family"
        },
        "path": [
          "font",
          "h80",
          "family"
        ]
      },
      "size": {
        "value": "12px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "12px"
        },
        "name": "FontH80Size",
        "attributes": {
          "category": "font",
          "type": "h80",
          "item": "size"
        },
        "path": [
          "font",
          "h80",
          "size"
        ]
      },
      "weight": {
        "value": "600",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "600"
        },
        "name": "FontH80Weight",
        "attributes": {
          "category": "font",
          "type": "h80",
          "item": "weight"
        },
        "path": [
          "font",
          "h80",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "16px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "16px"
        },
        "name": "FontH80LineHeight",
        "attributes": {
          "category": "font",
          "type": "h80",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h80",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0"
        },
        "name": "FontH80LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h80",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h80",
          "letterSpacing"
        ]
      }
    },
    "h90": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH90Family",
        "attributes": {
          "category": "font",
          "type": "h90",
          "item": "family"
        },
        "path": [
          "font",
          "h90",
          "family"
        ]
      },
      "size": {
        "value": "14px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "14px"
        },
        "name": "FontH90Size",
        "attributes": {
          "category": "font",
          "type": "h90",
          "item": "size"
        },
        "path": [
          "font",
          "h90",
          "size"
        ]
      },
      "weight": {
        "value": "500",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "500"
        },
        "name": "FontH90Weight",
        "attributes": {
          "category": "font",
          "type": "h90",
          "item": "weight"
        },
        "path": [
          "font",
          "h90",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "19px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "19px"
        },
        "name": "FontH90LineHeight",
        "attributes": {
          "category": "font",
          "type": "h90",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h90",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.50px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.50px"
        },
        "name": "FontH90LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h90",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h90",
          "letterSpacing"
        ]
      }
    },
    "h100": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH100Family",
        "attributes": {
          "category": "font",
          "type": "h100",
          "item": "family"
        },
        "path": [
          "font",
          "h100",
          "family"
        ]
      },
      "size": {
        "value": "16px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "16px"
        },
        "name": "FontH100Size",
        "attributes": {
          "category": "font",
          "type": "h100",
          "item": "size"
        },
        "path": [
          "font",
          "h100",
          "size"
        ]
      },
      "weight": {
        "value": "600",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "600"
        },
        "name": "FontH100Weight",
        "attributes": {
          "category": "font",
          "type": "h100",
          "item": "weight"
        },
        "path": [
          "font",
          "h100",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "22px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "22px"
        },
        "name": "FontH100LineHeight",
        "attributes": {
          "category": "font",
          "type": "h100",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h100",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.85px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.85px"
        },
        "name": "FontH100LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h100",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h100",
          "letterSpacing"
        ]
      }
    },
    "h200": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH200Family",
        "attributes": {
          "category": "font",
          "type": "h200",
          "item": "family"
        },
        "path": [
          "font",
          "h200",
          "family"
        ]
      },
      "size": {
        "value": "18px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "18px"
        },
        "name": "FontH200Size",
        "attributes": {
          "category": "font",
          "type": "h200",
          "item": "size"
        },
        "path": [
          "font",
          "h200",
          "size"
        ]
      },
      "weight": {
        "value": "600",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "600"
        },
        "name": "FontH200Weight",
        "attributes": {
          "category": "font",
          "type": "h200",
          "item": "weight"
        },
        "path": [
          "font",
          "h200",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "24px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "24px"
        },
        "name": "FontH200LineHeight",
        "attributes": {
          "category": "font",
          "type": "h200",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h200",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.75px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.75px"
        },
        "name": "FontH200LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h200",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h200",
          "letterSpacing"
        ]
      }
    },
    "h300": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH300Family",
        "attributes": {
          "category": "font",
          "type": "h300",
          "item": "family"
        },
        "path": [
          "font",
          "h300",
          "family"
        ]
      },
      "size": {
        "value": "21px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "21px"
        },
        "name": "FontH300Size",
        "attributes": {
          "category": "font",
          "type": "h300",
          "item": "size"
        },
        "path": [
          "font",
          "h300",
          "size"
        ]
      },
      "weight": {
        "value": "700",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "FontH300Weight",
        "attributes": {
          "category": "font",
          "type": "h300",
          "item": "weight"
        },
        "path": [
          "font",
          "h300",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "28px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "28px"
        },
        "name": "FontH300LineHeight",
        "attributes": {
          "category": "font",
          "type": "h300",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h300",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.50px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.50px"
        },
        "name": "FontH300LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h300",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h300",
          "letterSpacing"
        ]
      }
    },
    "h400": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH400Family",
        "attributes": {
          "category": "font",
          "type": "h400",
          "item": "family"
        },
        "path": [
          "font",
          "h400",
          "family"
        ]
      },
      "size": {
        "value": "24px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "24px"
        },
        "name": "FontH400Size",
        "attributes": {
          "category": "font",
          "type": "h400",
          "item": "size"
        },
        "path": [
          "font",
          "h400",
          "size"
        ]
      },
      "weight": {
        "value": "700",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "FontH400Weight",
        "attributes": {
          "category": "font",
          "type": "h400",
          "item": "weight"
        },
        "path": [
          "font",
          "h400",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "32px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "32px"
        },
        "name": "FontH400LineHeight",
        "attributes": {
          "category": "font",
          "type": "h400",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h400",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "-.25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "-.25px"
        },
        "name": "FontH400LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h400",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h400",
          "letterSpacing"
        ]
      }
    },
    "h500": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH500Family",
        "attributes": {
          "category": "font",
          "type": "h500",
          "item": "family"
        },
        "path": [
          "font",
          "h500",
          "family"
        ]
      },
      "size": {
        "value": "32px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "32px"
        },
        "name": "FontH500Size",
        "attributes": {
          "category": "font",
          "type": "h500",
          "item": "size"
        },
        "path": [
          "font",
          "h500",
          "size"
        ]
      },
      "weight": {
        "value": "700",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "FontH500Weight",
        "attributes": {
          "category": "font",
          "type": "h500",
          "item": "weight"
        },
        "path": [
          "font",
          "h500",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "40px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "40px"
        },
        "name": "FontH500LineHeight",
        "attributes": {
          "category": "font",
          "type": "h500",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h500",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": "0",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "0"
        },
        "name": "FontH500LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h500",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h500",
          "letterSpacing"
        ]
      }
    },
    "h600": {
      "family": {
        "value": "Inter UI",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "Inter UI"
        },
        "name": "FontH600Family",
        "attributes": {
          "category": "font",
          "type": "h600",
          "item": "family"
        },
        "path": [
          "font",
          "h600",
          "family"
        ]
      },
      "size": {
        "value": "48px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "48px"
        },
        "name": "FontH600Size",
        "attributes": {
          "category": "font",
          "type": "h600",
          "item": "size"
        },
        "path": [
          "font",
          "h600",
          "size"
        ]
      },
      "weight": {
        "value": "800",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "800"
        },
        "name": "FontH600Weight",
        "attributes": {
          "category": "font",
          "type": "h600",
          "item": "weight"
        },
        "path": [
          "font",
          "h600",
          "weight"
        ]
      },
      "lineHeight": {
        "value": "60px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": "60px"
        },
        "name": "FontH600LineHeight",
        "attributes": {
          "category": "font",
          "type": "h600",
          "item": "lineHeight"
        },
        "path": [
          "font",
          "h600",
          "lineHeight"
        ]
      },
      "letterSpacing": {
        "value": ".25px",
        "filePath": "tokens/base/font.json",
        "isSource": true,
        "original": {
          "value": ".25px"
        },
        "name": "FontH600LetterSpacing",
        "attributes": {
          "category": "font",
          "type": "h600",
          "item": "letterSpacing"
        },
        "path": [
          "font",
          "h600",
          "letterSpacing"
        ]
      }
    }
  },
  "spacing": {
    "v0": {
      "value": 0,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 0
      },
      "name": "SpacingV0",
      "attributes": {
        "category": "spacing",
        "type": "v0"
      },
      "path": [
        "spacing",
        "v0"
      ]
    },
    "v50": {
      "value": 4,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 4
      },
      "name": "SpacingV50",
      "attributes": {
        "category": "spacing",
        "type": "v50"
      },
      "path": [
        "spacing",
        "v50"
      ]
    },
    "v100": {
      "value": 8,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 8
      },
      "name": "SpacingV100",
      "attributes": {
        "category": "spacing",
        "type": "v100"
      },
      "path": [
        "spacing",
        "v100"
      ]
    },
    "v200": {
      "value": 16,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 16
      },
      "name": "SpacingV200",
      "attributes": {
        "category": "spacing",
        "type": "v200"
      },
      "path": [
        "spacing",
        "v200"
      ]
    },
    "v300": {
      "value": 24,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 24
      },
      "name": "SpacingV300",
      "attributes": {
        "category": "spacing",
        "type": "v300"
      },
      "path": [
        "spacing",
        "v300"
      ]
    },
    "v400": {
      "value": 32,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 32
      },
      "name": "SpacingV400",
      "attributes": {
        "category": "spacing",
        "type": "v400"
      },
      "path": [
        "spacing",
        "v400"
      ]
    },
    "v500": {
      "value": 48,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 48
      },
      "name": "SpacingV500",
      "attributes": {
        "category": "spacing",
        "type": "v500"
      },
      "path": [
        "spacing",
        "v500"
      ]
    },
    "v600": {
      "value": 64,
      "filePath": "tokens/base/spacing.json",
      "isSource": true,
      "original": {
        "value": 64
      },
      "name": "SpacingV600",
      "attributes": {
        "category": "spacing",
        "type": "v600"
      },
      "path": [
        "spacing",
        "v600"
      ]
    }
  },
  "box": {
    "backgroundColor": {
      "value": "#ffffff",
      "filePath": "tokens/components/box.json",
      "isSource": true,
      "original": {
        "value": "{color.base.white}"
      },
      "name": "BoxBackgroundColor",
      "attributes": {
        "category": "box",
        "type": "backgroundColor"
      },
      "path": [
        "box",
        "backgroundColor"
      ]
    },
    "border": {
      "radius": {
        "value": "4px",
        "filePath": "tokens/components/box.json",
        "isSource": true,
        "original": {
          "value": "{border.round.hairline.radius}"
        },
        "name": "BoxBorderRadius",
        "attributes": {
          "category": "box",
          "type": "border",
          "item": "radius"
        },
        "path": [
          "box",
          "border",
          "radius"
        ]
      },
      "width": {
        "value": "1px",
        "filePath": "tokens/components/box.json",
        "isSource": true,
        "original": {
          "value": "{border.round.hairline.width}"
        },
        "name": "BoxBorderWidth",
        "attributes": {
          "category": "box",
          "type": "border",
          "item": "width"
        },
        "path": [
          "box",
          "border",
          "width"
        ]
      }
    }
  },
  "button": {
    "border": {
      "radius": {
        "value": "4px",
        "filePath": "tokens/components/button.json",
        "isSource": true,
        "original": {
          "value": "{border.round.radius}"
        },
        "name": "ButtonBorderRadius",
        "attributes": {
          "category": "button",
          "type": "border",
          "item": "radius"
        },
        "path": [
          "button",
          "border",
          "radius"
        ]
      },
      "width": {
        "value": "2px",
        "filePath": "tokens/components/button.json",
        "isSource": true,
        "original": {
          "value": "{border.round.width}"
        },
        "name": "ButtonBorderWidth",
        "attributes": {
          "category": "button",
          "type": "border",
          "item": "width"
        },
        "path": [
          "button",
          "border",
          "width"
        ]
      }
    },
    "padding": {
      "vertical": {
        "value": 4,
        "filePath": "tokens/components/button.json",
        "isSource": true,
        "original": {
          "value": "{spacing.v50}"
        },
        "name": "ButtonPaddingVertical",
        "attributes": {
          "category": "button",
          "type": "padding",
          "item": "vertical"
        },
        "path": [
          "button",
          "padding",
          "vertical"
        ]
      },
      "horizontal": {
        "value": 16,
        "filePath": "tokens/components/button.json",
        "isSource": true,
        "original": {
          "value": "{spacing.v200}"
        },
        "name": "ButtonPaddingHorizontal",
        "attributes": {
          "category": "button",
          "type": "padding",
          "item": "horizontal"
        },
        "path": [
          "button",
          "padding",
          "horizontal"
        ]
      }
    },
    "primary": {
      "foregroundColor": {
        "default": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonPrimaryForegroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "foregroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "primary",
            "foregroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#9295a6",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v200}"
          },
          "name": "ButtonPrimaryForegroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "foregroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "primary",
            "foregroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#f9fbff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v25}"
          },
          "name": "ButtonPrimaryForegroundColorHover",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "foregroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "primary",
            "foregroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#f9fbff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v25}"
          },
          "name": "ButtonPrimaryForegroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "foregroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "primary",
            "foregroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#f9fbff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v25}"
          },
          "name": "ButtonPrimaryForegroundColorError",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "foregroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "primary",
            "foregroundColor",
            "error"
          ]
        }
      },
      "backgroundColor": {
        "default": {
          "value": "#0a7db3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.digitalSecondary.v300}"
          },
          "name": "ButtonPrimaryBackgroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "backgroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "primary",
            "backgroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#e7efff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v50}"
          },
          "name": "ButtonPrimaryBackgroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "backgroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "primary",
            "backgroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#005176",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v500}"
          },
          "name": "ButtonPrimaryBackgroundColorHover",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "backgroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "primary",
            "backgroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#384152",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.graySemantic.v500}"
          },
          "name": "ButtonPrimaryBackgroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "backgroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "primary",
            "backgroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonPrimaryBackgroundColorError",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "backgroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "primary",
            "backgroundColor",
            "error"
          ]
        }
      },
      "borderColor": {
        "default": {
          "value": "#0a7db3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.digitalSecondary.v300}"
          },
          "name": "ButtonPrimaryBorderColorDefault",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "borderColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "primary",
            "borderColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#e7efff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v50}"
          },
          "name": "ButtonPrimaryBorderColorDisabled",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "borderColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "primary",
            "borderColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#005176",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v500}"
          },
          "name": "ButtonPrimaryBorderColorHover",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "borderColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "primary",
            "borderColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#384152",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.graySemantic.v500}"
          },
          "name": "ButtonPrimaryBorderColorPressed",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "borderColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "primary",
            "borderColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonPrimaryBorderColorError",
          "attributes": {
            "category": "button",
            "type": "primary",
            "item": "borderColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "primary",
            "borderColor",
            "error"
          ]
        }
      }
    },
    "secondary": {
      "foregroundColor": {
        "default": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonSecondaryForegroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "foregroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "secondary",
            "foregroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#abadba",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v100}"
          },
          "name": "ButtonSecondaryForegroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "foregroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "secondary",
            "foregroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonSecondaryForegroundColorHover",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "foregroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "secondary",
            "foregroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonSecondaryForegroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "foregroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "secondary",
            "foregroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonSecondaryForegroundColorError",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "foregroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "secondary",
            "foregroundColor",
            "error"
          ]
        }
      },
      "backgroundColor": {
        "default": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonSecondaryBackgroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "backgroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "secondary",
            "backgroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonSecondaryBackgroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "backgroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "secondary",
            "backgroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonSecondaryBackgroundColorHover",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "backgroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "secondary",
            "backgroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonSecondaryBackgroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "backgroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "secondary",
            "backgroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonSecondaryBackgroundColorError",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "backgroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "secondary",
            "backgroundColor",
            "error"
          ]
        }
      },
      "borderColor": {
        "default": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonSecondaryBorderColorDefault",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "borderColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "secondary",
            "borderColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#e7efff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v50}"
          },
          "name": "ButtonSecondaryBorderColorDisabled",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "borderColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "secondary",
            "borderColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonSecondaryBorderColorHover",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "borderColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "secondary",
            "borderColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonSecondaryBorderColorPressed",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "borderColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "secondary",
            "borderColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonSecondaryBorderColorError",
          "attributes": {
            "category": "button",
            "type": "secondary",
            "item": "borderColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "secondary",
            "borderColor",
            "error"
          ]
        }
      }
    },
    "default": {
      "foregroundColor": {
        "default": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonDefaultForegroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "foregroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "default",
            "foregroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#abadba",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v100}"
          },
          "name": "ButtonDefaultForegroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "foregroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "default",
            "foregroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonDefaultForegroundColorHover",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "foregroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "default",
            "foregroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonDefaultForegroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "foregroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "default",
            "foregroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonDefaultForegroundColorError",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "foregroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "default",
            "foregroundColor",
            "error"
          ]
        }
      },
      "backgroundColor": {
        "default": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonDefaultBackgroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "backgroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "default",
            "backgroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonDefaultBackgroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "backgroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "default",
            "backgroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonDefaultBackgroundColorHover",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "backgroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "default",
            "backgroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonDefaultBackgroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "backgroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "default",
            "backgroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonDefaultBackgroundColorError",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "backgroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "default",
            "backgroundColor",
            "error"
          ]
        }
      },
      "borderColor": {
        "default": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonDefaultBorderColorDefault",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "borderColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "default",
            "borderColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#e7efff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v50}"
          },
          "name": "ButtonDefaultBorderColorDisabled",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "borderColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "default",
            "borderColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonDefaultBorderColorHover",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "borderColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "default",
            "borderColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonDefaultBorderColorPressed",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "borderColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "default",
            "borderColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonDefaultBorderColorError",
          "attributes": {
            "category": "button",
            "type": "default",
            "item": "borderColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "default",
            "borderColor",
            "error"
          ]
        }
      }
    },
    "icon": {
      "foregroundColor": {
        "default": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonIconForegroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "foregroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "icon",
            "foregroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#abadba",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v100}"
          },
          "name": "ButtonIconForegroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "foregroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "icon",
            "foregroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonIconForegroundColorHover",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "foregroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "icon",
            "foregroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#25252c",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v800}"
          },
          "name": "ButtonIconForegroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "foregroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "icon",
            "foregroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonIconForegroundColorError",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "foregroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "icon",
            "foregroundColor",
            "error"
          ]
        }
      },
      "backgroundColor": {
        "default": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonIconBackgroundColorDefault",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "backgroundColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "icon",
            "backgroundColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonIconBackgroundColorDisabled",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "backgroundColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "icon",
            "backgroundColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonIconBackgroundColorHover",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "backgroundColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "icon",
            "backgroundColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonIconBackgroundColorPressed",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "backgroundColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "icon",
            "backgroundColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonIconBackgroundColorError",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "backgroundColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "icon",
            "backgroundColor",
            "error"
          ]
        }
      },
      "borderColor": {
        "default": {
          "value": "#ffffff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.white}"
          },
          "name": "ButtonIconBorderColorDefault",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "borderColor",
            "subitem": "default"
          },
          "path": [
            "button",
            "icon",
            "borderColor",
            "default"
          ]
        },
        "disabled": {
          "value": "#e7efff",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.blue.v50}"
          },
          "name": "ButtonIconBorderColorDisabled",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "borderColor",
            "subitem": "disabled"
          },
          "path": [
            "button",
            "icon",
            "borderColor",
            "disabled"
          ]
        },
        "hover": {
          "value": "#e9ecf3",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v50}"
          },
          "name": "ButtonIconBorderColorHover",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "borderColor",
            "subitem": "hover"
          },
          "path": [
            "button",
            "icon",
            "borderColor",
            "hover"
          ]
        },
        "pressed": {
          "value": "#d7dae2",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.gray.v75}"
          },
          "name": "ButtonIconBorderColorPressed",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "borderColor",
            "subitem": "pressed"
          },
          "path": [
            "button",
            "icon",
            "borderColor",
            "pressed"
          ]
        },
        "error": {
          "value": "#bf1313",
          "filePath": "tokens/components/button.json",
          "isSource": true,
          "original": {
            "value": "{color.base.red.v500}"
          },
          "name": "ButtonIconBorderColorError",
          "attributes": {
            "category": "button",
            "type": "icon",
            "item": "borderColor",
            "subitem": "error"
          },
          "path": [
            "button",
            "icon",
            "borderColor",
            "error"
          ]
        }
      }
    }
  },
  "focusRing": {
    "outline": {
      "color": {
        "value": "#a0bdf8",
        "filePath": "tokens/components/focusRing.json",
        "isSource": true,
        "original": {
          "value": "{color.base.blue.v100}"
        },
        "name": "FocusRingOutlineColor",
        "attributes": {
          "category": "focusRing",
          "type": "outline",
          "item": "color"
        },
        "path": [
          "focusRing",
          "outline",
          "color"
        ]
      },
      "width": {
        "value": "2px",
        "filePath": "tokens/components/focusRing.json",
        "isSource": true,
        "original": {
          "value": "2px"
        },
        "name": "FocusRingOutlineWidth",
        "attributes": {
          "category": "focusRing",
          "type": "outline",
          "item": "width"
        },
        "path": [
          "focusRing",
          "outline",
          "width"
        ]
      },
      "offset": {
        "value": "2px",
        "filePath": "tokens/components/focusRing.json",
        "isSource": true,
        "original": {
          "value": "2px"
        },
        "name": "FocusRingOutlineOffset",
        "attributes": {
          "category": "focusRing",
          "type": "outline",
          "item": "offset"
        },
        "path": [
          "focusRing",
          "outline",
          "offset"
        ]
      }
    }
  },
  "link": {
    "foregroundColor": {
      "default": {
        "value": "#0a7db3",
        "filePath": "tokens/components/link.json",
        "isSource": true,
        "original": {
          "value": "{color.base.digitalSecondary.v300}"
        },
        "name": "LinkForegroundColorDefault",
        "attributes": {
          "category": "link",
          "type": "foregroundColor",
          "item": "default"
        },
        "path": [
          "link",
          "foregroundColor",
          "default"
        ]
      },
      "disabled": {
        "value": "#d7dae2",
        "filePath": "tokens/components/link.json",
        "isSource": true,
        "original": {
          "value": "{color.base.gray.v75}"
        },
        "name": "LinkForegroundColorDisabled",
        "attributes": {
          "category": "link",
          "type": "foregroundColor",
          "item": "disabled"
        },
        "path": [
          "link",
          "foregroundColor",
          "disabled"
        ]
      },
      "hover": {
        "value": "#0a7db3",
        "filePath": "tokens/components/link.json",
        "isSource": true,
        "original": {
          "value": "{color.base.digitalSecondary.v300}"
        },
        "name": "LinkForegroundColorHover",
        "attributes": {
          "category": "link",
          "type": "foregroundColor",
          "item": "hover"
        },
        "path": [
          "link",
          "foregroundColor",
          "hover"
        ]
      },
      "pressed": {
        "value": "#005176",
        "filePath": "tokens/components/link.json",
        "isSource": true,
        "original": {
          "value": "{color.base.blue.v500}"
        },
        "name": "LinkForegroundColorPressed",
        "attributes": {
          "category": "link",
          "type": "foregroundColor",
          "item": "pressed"
        },
        "path": [
          "link",
          "foregroundColor",
          "pressed"
        ]
      }
    }
  }
};

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign$1 = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position$1 = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign$1(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position$1 > 0 ? charat(characters, --position$1) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position$1 < length ? charat(characters, position$1++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position$1)
}

/**
 * @return {number}
 */
function caret () {
	return position$1
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position$1 = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position$1 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position$1
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position$1
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position$1 - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position$1)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse$1('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse$1 (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && characters.charCodeAt(length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset:
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse$1(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse$1(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse$1(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix$3 (value, length) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (strlen(value) - 1 - length > 6)
				switch (charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix$3(replace(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return replace(value, ':', ':' + WEBKIT) + value
				// (inline-)?fl(e)x
				case 101:
					return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix$3(element.value, element.length);
					break
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position$1);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position$1 - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var isBrowser$3 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$3 ? undefined : weakMemoize(function () {
  return memoize$1(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser$3 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  if (isBrowser$3) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser$3) {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

var reactIs = require$$0;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

var isBrowser$2 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$2 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$2 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$1 = typeof document !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef$2(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser$1) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */createContext({});

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'EmotionThemeContext';
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var isBrowser$1$1 = typeof document !== 'undefined';
var useInsertionEffect$1 = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe(create) {
  if (!isBrowser$1$1) {
    return create();
  }

  useInsertionEffect$1(create);
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (process.env.NODE_ENV !== 'production' && !!props.css && (typeof props.css !== 'object' || typeof props.css.name !== 'string' || props.css.name.indexOf('-') === -1)) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }

  return newProps;
};

var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectMaybe(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser$1 && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext));

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion$1, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/createElement(WrappedComponent, newProps));
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var pkg = {
	name: "@emotion/react",
	version: "11.9.0",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.13.10",
		"@emotion/babel-plugin": "^11.7.1",
		"@emotion/cache": "^11.7.1",
		"@emotion/serialize": "^1.0.3",
		"@emotion/utils": "^1.1.0",
		"@emotion/weak-memoize": "^0.2.5",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.13.10",
		"@emotion/css": "11.9.0",
		"@emotion/css-prettifier": "1.0.1",
		"@emotion/server": "11.4.0",
		"@emotion/styled": "11.8.1",
		"@types/react": "^16.9.11",
		dtslint: "^4.2.1",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact"
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement.apply(null, createElementArgArray);
};

var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : useLayoutEffect$1;
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && ( // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext));

  if (!isBrowser$1) {
    var _ref;

    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }

    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);

    if (shouldCache) {
      return null;
    }

    return /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = useRef();
  useInsertionEffect(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffect(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (process.env.NODE_ENV !== 'production') {
  Global.displayName = 'EmotionGlobal';
}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames$1 = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (process.env.NODE_ENV !== 'production' && arg.styles !== undefined && arg.name !== undefined) {
              console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
            }

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectMaybe(function () {
    var rules = '';

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);

      if (!isBrowser$1 && res !== undefined) {
        rules += res;
      }
    }

    if (!isBrowser$1) {
      return rules;
    }
  });

  if (!isBrowser$1 && rules.length !== 0) {
    var _ref2;

    return /*#__PURE__*/createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function (serialized) {
      return serialized.name;
    }).join(' '), _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames$1(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

if (process.env.NODE_ENV !== 'production') {
  ClassNames.displayName = 'EmotionClassNames';
}

if (process.env.NODE_ENV !== 'production') {
  var isBrowser = typeof document !== 'undefined'; // #1727 for some reason Jest evaluates modules twice if some consuming module gets mocked with jest.mock

  var isJest = typeof jest !== 'undefined';

  if (isBrowser && !isJest) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var globalContext = // $FlowIgnore
    typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
    : isBrowser ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";

    if (globalContext[globalKey]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }

    globalContext[globalKey] = true;
  }
}

var boxStyles = function boxStyles(_a) {
  var backgroundColor = _a.backgroundColor,
      maxHeight = _a.maxHeight,
      maxWidth = _a.maxWidth,
      minHeight = _a.minHeight,
      minWidth = _a.minWidth,
      type = _a.type,
      width = _a.width;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css({
      backgroundColor: backgroundColor || uiTokens.box.backgroundColor.value,
      borderRadius: uiTokens.box.border.radius.value,
      borderWidth: type === 'outline' ? uiTokens.box.border.width.value : 0,
      borderColor: 'grey',
      borderStyle: 'solid',
      display: 'flex',
      maxHeight: maxHeight || undefined,
      maxWidth: maxWidth || undefined,
      minHeight: minHeight || undefined,
      minWidth: minWidth || undefined,
      padding: "".concat(uiTokens.spacing.v200.value, "px"),
      width: width || undefined
    }, process.env.NODE_ENV === "production" ? "" : ";label:boxStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:boxStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};
/**
 The Box is a basic layout container with `display: flex` applied.
*/


var Box = function Box(_a) {
  var backgroundColor = _a.backgroundColor,
      children = _a.children,
      id = _a.id,
      maxHeight = _a.maxHeight,
      maxWidth = _a.maxWidth,
      minHeight = _a.minHeight,
      minWidth = _a.minWidth,
      tag = _a.tag,
      type = _a.type,
      width = _a.width;
  return jsx(tag, {
    id: id,
    css: boxStyles({
      backgroundColor: backgroundColor,
      maxHeight: maxHeight,
      maxWidth: maxWidth,
      minHeight: minHeight,
      minWidth: minWidth,
      type: type,
      width: width
    })
  }, children);
};

Box.defaultProps = {
  tag: 'div',
  type: 'fill'
};

/** @jsxRuntime classic */
// to override any existing styles on the children.

var childStyles$1 = function childStyles(_a) {
  var height = _a.height;
  return {
    flex: height === 'fill' ? '1 !important' : undefined,
    flexShrink: height && height !== 'fill' ? '0 !important' : undefined,
    height: height !== 'fill' && height !== 'fit' && height !== undefined && height !== null && height !== '' ? "".concat(height).concat(typeof height === 'number' ? "px " : " ", " !important") : undefined
  };
};

var columnStyles = function columnStyles(_a) {
  var _b = _a.alignmentHorizontal,
      alignmentHorizontal = _b === void 0 ? 'stretch' : _b,
      _c = _a.alignmentVertical,
      alignmentVertical = _c === void 0 ? 'top' : _c,
      backgroundColor = _a.backgroundColor,
      childHeights = _a.childHeights,
      height = _a.height,
      margin = _a.margin,
      maxHeight = _a.maxHeight,
      maxWidth = _a.maxWidth,
      minHeight = _a.minHeight,
      minWidth = _a.minWidth,
      overflowX = _a.overflowX,
      overflowY = _a.overflowY,
      type = _a.type,
      width = _a.width;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css({
      alignItems: {
        start: 'flex-start',
        end: 'flex-end',
        center: 'center',
        stretch: 'stretch'
      }[alignmentHorizontal],
      backgroundColor: backgroundColor,
      border: type === 'outline' ? "1px solid ".concat(uiTokens.color.base.black.value) : 'none',
      display: 'flex',
      flexDirection: 'column',
      height: height,
      justifyContent: {
        top: 'flex-start',
        bottom: 'flex-end',
        center: 'center',
        justify: 'space-between'
      }[alignmentVertical],
      maxHeight: maxHeight,
      maxWidth: maxWidth,
      minHeight: minHeight,
      minWidth: minWidth,
      overflowX: overflowX,
      overflowY: overflowY,
      width: width,
      // Set margins and heights on the children of the column. Use !important to
      // override any existing styles.
      '& > *': {
        // Make sure that any borders or padding applied to the child don't throw
        // off the heights that we apply
        boxSizing: 'border-box !important',
        margin: "0 0 ".concat(uiTokens.spacing["v".concat(margin)].value, "px 0 !important"),
        ':last-child': {
          margin: '0 !important'
        }
      }
    }, childHeights && !Array.isArray(childHeights) ? {
      '& > *': childStyles$1({
        height: childHeights
      })
    } : typeof childHeights !== 'undefined' && childHeights.map(function (h, index) {
      var _a;

      return _a = {}, _a["& > *:nth-child(".concat(index + 1, ")")] = childStyles$1({
        height: h
      }), _a;
    }), process.env.NODE_ENV === "production" ? "" : ";label:columnStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:columnStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};
/**
 * The Column component stacks children up vertically in a column with even
 * spacing in-between them.
 */


var Column = function Column(_a) {
  var _b = _a.alignmentHorizontal,
      alignmentHorizontal = _b === void 0 ? 'stretch' : _b,
      _c = _a.alignmentVertical,
      alignmentVertical = _c === void 0 ? 'top' : _c,
      backgroundColor = _a.backgroundColor,
      childHeights = _a.childHeights,
      children = _a.children,
      height = _a.height,
      id = _a.id,
      _d = _a.margin,
      margin = _d === void 0 ? '200' : _d,
      maxHeight = _a.maxHeight,
      maxWidth = _a.maxWidth,
      minHeight = _a.minHeight,
      minWidth = _a.minWidth,
      overflowX = _a.overflowX,
      overflowY = _a.overflowY,
      _e = _a.tag,
      tag = _e === void 0 ? 'div' : _e,
      type = _a.type,
      width = _a.width;
  return jsx(tag, {
    id: id,
    css: columnStyles({
      alignmentHorizontal: alignmentHorizontal,
      alignmentVertical: alignmentVertical,
      backgroundColor: backgroundColor,
      height: height,
      childHeights: childHeights,
      margin: margin,
      maxHeight: maxHeight,
      maxWidth: maxWidth,
      minHeight: minHeight,
      minWidth: minWidth,
      overflowX: overflowX,
      overflowY: overflowY,
      type: type,
      width: width
    })
  }, children);
};

var Column$1 = /*#__PURE__*/memo(Column);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

var lodash_uniqueid = uniqueId;

function $parcel$export$D(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9d939cbc98267846$exports = {};

$parcel$export$D($9d939cbc98267846$exports, "SSRProvider", () => $9d939cbc98267846$export$9f8ac96af4b1b2ae);
$parcel$export$D($9d939cbc98267846$exports, "useSSRSafeId", () => $9d939cbc98267846$export$619500959fc48b26);
$parcel$export$D($9d939cbc98267846$exports, "useIsSSR", () => $9d939cbc98267846$export$535bd6ca7f90a273);

// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $9d939cbc98267846$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $9d939cbc98267846$var$SSRContext = /*#__PURE__*/ React__default.createContext($9d939cbc98267846$var$defaultContext);
function $9d939cbc98267846$export$9f8ac96af4b1b2ae(props) {
    let cur = useContext($9d939cbc98267846$var$SSRContext);
    let value = useMemo(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $9d939cbc98267846$var$defaultContext ? '' : `${cur.prefix}-${++cur.current}`,
            current: 0
        })
    , [
        cur
    ]);
    return(/*#__PURE__*/ React__default.createElement($9d939cbc98267846$var$SSRContext.Provider, {
        value: value
    }, props.children));
}
let $9d939cbc98267846$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
function $9d939cbc98267846$export$619500959fc48b26(defaultId) {
    let ctx = useContext($9d939cbc98267846$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $9d939cbc98267846$var$defaultContext && !$9d939cbc98267846$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    return useMemo(()=>defaultId || `react-aria${ctx.prefix}-${++ctx.current}`
    , [
        defaultId
    ]);
}
function $9d939cbc98267846$export$535bd6ca7f90a273() {
    let cur = useContext($9d939cbc98267846$var$SSRContext);
    let isInSSRContext = cur !== $9d939cbc98267846$var$defaultContext;
    let [isSSR, setIsSSR] = useState(isInSSRContext);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof window !== 'undefined' && isInSSRContext) // This if statement technically breaks the rules of hooks, but is safe
    // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useLayoutEffect$1(()=>{
        setIsSSR(false);
    }, []);
    return isSSR;
}

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function $6nfFC$clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

function $parcel$export$C(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $458b0a5536c1a7cf$exports = {};

$parcel$export$C($458b0a5536c1a7cf$exports, "useControlledState", () => $458b0a5536c1a7cf$export$40bfa8c7b0832715);

function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value1, defaultValue, onChange) {
    let [stateValue, setStateValue] = useState(value1 || defaultValue);
    let ref = useRef(value1 !== undefined);
    let wasControlled = ref.current;
    let isControlled = value1 !== undefined;
    // Internal state reference for useCallback
    let stateRef = useRef(stateValue);
    if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? 'controlled' : 'uncontrolled'} to ${isControlled ? 'controlled' : 'uncontrolled'}.`);
    ref.current = isControlled;
    let setValue = useCallback((value2, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(stateRef.current, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) stateRef.current = value;
        };
        if (typeof value2 === 'function') {
            console.warn('We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320');
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value2(isControlled ? stateRef.current : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value2);
            onChangeCaller(value2, ...args);
        }
    }, [
        isControlled,
        onChange
    ]);
    // If a controlled component's value prop changes, we need to update stateRef
    if (isControlled) stateRef.current = value1;
    else value1 = stateValue;
    return [
        value1,
        setValue
    ];
}


var $9446cca9a3875146$exports = {};

$parcel$export$C($9446cca9a3875146$exports, "clamp", () => $9446cca9a3875146$export$7d15b64cf5a3a4c4);
$parcel$export$C($9446cca9a3875146$exports, "snapValueToStep", () => $9446cca9a3875146$export$cb6e0bb50bc19463);
$parcel$export$C($9446cca9a3875146$exports, "toFixedNumber", () => $9446cca9a3875146$export$b6268554fba451f);
function $9446cca9a3875146$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $9446cca9a3875146$export$cb6e0bb50bc19463(value, min, max, step) {
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf('.');
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $9446cca9a3875146$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

function $parcel$export$B(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $bdb11010cef70236$exports = {};

$parcel$export$B($bdb11010cef70236$exports, "useId", () => $bdb11010cef70236$export$f680877a34711e37);
$parcel$export$B($bdb11010cef70236$exports, "mergeIds", () => $bdb11010cef70236$export$cd8c9cb68f842629);
$parcel$export$B($bdb11010cef70236$exports, "useSlotId", () => $bdb11010cef70236$export$b4cc09c592e8fdb8);

var $f0a04ccd8dbdd83b$exports = {};

$parcel$export$B($f0a04ccd8dbdd83b$exports, "useLayoutEffect", () => $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c);

const $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof window !== 'undefined' ? React__default.useLayoutEffect : ()=>{
};




let $bdb11010cef70236$var$idsUpdaterMap = new Map();
function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
    let isRendering = useRef(true);
    isRendering.current = true;
    let [value, setValue] = useState(defaultId);
    let nextId = useRef(null);
    let res = $9d939cbc98267846$export$619500959fc48b26(value);
    // don't memo this, we want it new each render so that the Effects always run
    let updateValue = (val)=>{
        if (!isRendering.current) setValue(val);
        else nextId.current = val;
    };
    $bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        isRendering.current = false;
    }, [
        updateValue
    ]);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        let r = res;
        return ()=>{
            $bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    useEffect(()=>{
        let newId = nextId.current;
        if (newId) {
            setValue(newId);
            nextId.current = null;
        }
    }, [
        setValue,
        updateValue
    ]);
    return res;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $bdb11010cef70236$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $bdb11010cef70236$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = $1dbecbe27a04f9af$export$14d238f342723f25(id);
    let updateId = useCallback(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : null;
        });
    }, [
        id,
        setResolvedId
    ]);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}


var $ff5963eb1fccf552$exports = {};

$parcel$export$B($ff5963eb1fccf552$exports, "chain", () => $ff5963eb1fccf552$export$e08e3b67e392101e);
function $ff5963eb1fccf552$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === 'function') callback(...args);
    };
}


var $3ef42575df84b30b$exports = {};

$parcel$export$B($3ef42575df84b30b$exports, "mergeProps", () => $3ef42575df84b30b$export$9d1611c77c2fe928);



function $3ef42575df84b30b$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === 'function' && typeof b === 'function' && // This is a lot faster than a regex.
            key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = $ff5963eb1fccf552$export$e08e3b67e392101e(a, b);
            else if ((key === 'className' || key === 'UNSAFE_className') && typeof a === 'string' && typeof b === 'string') result[key] = $6nfFC$clsx(a, b);
            else if (key === 'id' && a && b) result.id = $bdb11010cef70236$export$cd8c9cb68f842629(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}


var $5dc95899b306f630$exports = {};

$parcel$export$B($5dc95899b306f630$exports, "mergeRefs", () => $5dc95899b306f630$export$c9058316764c140e);
function $5dc95899b306f630$export$c9058316764c140e(...refs) {
    return (value)=>{
        for (let ref of refs){
            if (typeof ref === 'function') ref(value);
            else if (ref != null) ref.current = value;
        }
    };
}


var $65484d02dcb7eb3e$exports = {};

$parcel$export$B($65484d02dcb7eb3e$exports, "filterDOMProps", () => $65484d02dcb7eb3e$export$457c3d6518dd4c6f);
const $65484d02dcb7eb3e$var$DOMPropNames = new Set([
    'id'
]);
const $65484d02dcb7eb3e$var$labelablePropNames = new Set([
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-details'
]);
const $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, opts = {
}) {
    let { labelable: labelable , propNames: propNames  } = opts;
    let filteredProps = {
    };
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $65484d02dcb7eb3e$var$labelablePropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}


var $7215afc6de606d6b$exports = {};

$parcel$export$B($7215afc6de606d6b$exports, "focusWithoutScrolling", () => $7215afc6de606d6b$export$de79e2c695e052f3);
function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
    if ($7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
    if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            var focusElem = document.createElement('div');
            focusElem.focus({
                get preventScroll () {
                    $7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(element) {
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element , scrollTop: scrollTop , scrollLeft: scrollLeft  } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}


var $ab71dadb03a6fb2e$exports = {};

$parcel$export$B($ab71dadb03a6fb2e$exports, "getOffset", () => $ab71dadb03a6fb2e$export$622cea445a1c5b7d);
function $ab71dadb03a6fb2e$export$622cea445a1c5b7d(element, reverse, orientation = 'horizontal') {
    let rect = element.getBoundingClientRect();
    if (reverse) return orientation === 'horizontal' ? rect.right : rect.bottom;
    return orientation === 'horizontal' ? rect.left : rect.top;
}


var $103b0e103f1b5952$exports = {};

$parcel$export$B($103b0e103f1b5952$exports, "clamp", () => $9446cca9a3875146$export$7d15b64cf5a3a4c4);
$parcel$export$B($103b0e103f1b5952$exports, "snapValueToStep", () => $9446cca9a3875146$export$cb6e0bb50bc19463);



var $bbed8b41f857bcc0$exports = {};

$parcel$export$B($bbed8b41f857bcc0$exports, "runAfterTransition", () => $bbed8b41f857bcc0$export$24490316f764c430);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === 'undefined') return;
    let onTransitionStart = (e)=>{
        // Add the transitioning property to the list for this element.
        let transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener('transitioncancel', onTransitionEnd);
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        // Remove property from list of transitioning properties.
        let properties = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener('transitioncancel', onTransitionEnd);
            $bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener('transitionrun', onTransitionStart);
    document.body.addEventListener('transitionend', onTransitionEnd);
}
if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') $bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener('DOMContentLoaded', $bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}


var $9cc09df9fd7676be$exports = {};

$parcel$export$B($9cc09df9fd7676be$exports, "useDrag1D", () => $9cc09df9fd7676be$export$7bbed75feba39706);


// Keep track of elements that we are currently handling dragging for via useDrag1D.
// If there's an ancestor and a descendant both using useDrag1D(), and the user starts
// dragging the descendant, we don't want useDrag1D events to fire for the ancestor.
const $9cc09df9fd7676be$var$draggingElements = [];
function $9cc09df9fd7676be$export$7bbed75feba39706(props) {
    console.warn('useDrag1D is deprecated, please use `useMove` instead https://react-spectrum.adobe.com/react-aria/useMove.html');
    let { containerRef: containerRef , reverse: reverse , orientation: orientation , onHover: onHover , onDrag: onDrag , onPositionChange: onPositionChange , onIncrement: onIncrement , onDecrement: onDecrement , onIncrementToMax: onIncrementToMax , onDecrementToMin: onDecrementToMin , onCollapseToggle: onCollapseToggle  } = props;
    let getPosition = (e)=>orientation === 'horizontal' ? e.clientX : e.clientY
    ;
    let getNextOffset = (e)=>{
        let containerOffset = $ab71dadb03a6fb2e$export$622cea445a1c5b7d(containerRef.current, reverse, orientation);
        let mouseOffset = getPosition(e);
        let nextOffset = reverse ? containerOffset - mouseOffset : mouseOffset - containerOffset;
        return nextOffset;
    };
    let dragging = useRef(false);
    let prevPosition = useRef(0);
    // Keep track of the current handlers in a ref so that the events can access them.
    let handlers = useRef({
        onPositionChange: onPositionChange,
        onDrag: onDrag
    });
    handlers.current.onDrag = onDrag;
    handlers.current.onPositionChange = onPositionChange;
    let onMouseDragged = (e)=>{
        e.preventDefault();
        let nextOffset = getNextOffset(e);
        if (!dragging.current) {
            dragging.current = true;
            if (handlers.current.onDrag) handlers.current.onDrag(true);
            if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        }
        if (prevPosition.current === nextOffset) return;
        prevPosition.current = nextOffset;
        if (onPositionChange) onPositionChange(nextOffset);
    };
    let onMouseUp = (e)=>{
        const target = e.target;
        dragging.current = false;
        let nextOffset = getNextOffset(e);
        if (handlers.current.onDrag) handlers.current.onDrag(false);
        if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        $9cc09df9fd7676be$var$draggingElements.splice($9cc09df9fd7676be$var$draggingElements.indexOf(target), 1);
        window.removeEventListener('mouseup', onMouseUp, false);
        window.removeEventListener('mousemove', onMouseDragged, false);
    };
    let onMouseDown = (e)=>{
        const target = e.currentTarget;
        // If we're already handling dragging on a descendant with useDrag1D, then
        // we don't want to handle the drag motion on this target as well.
        if ($9cc09df9fd7676be$var$draggingElements.some((elt)=>target.contains(elt)
        )) return;
        $9cc09df9fd7676be$var$draggingElements.push(target);
        window.addEventListener('mousemove', onMouseDragged, false);
        window.addEventListener('mouseup', onMouseUp, false);
    };
    let onMouseEnter = ()=>{
        if (onHover) onHover(true);
    };
    let onMouseOut = ()=>{
        if (onHover) onHover(false);
    };
    let onKeyDown = (e)=>{
        switch(e.key){
            case 'Left':
            case 'ArrowLeft':
                if (orientation === 'horizontal') {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case 'Up':
            case 'ArrowUp':
                if (orientation === 'vertical') {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case 'Right':
            case 'ArrowRight':
                if (orientation === 'horizontal') {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case 'Down':
            case 'ArrowDown':
                if (orientation === 'vertical') {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case 'Home':
                e.preventDefault();
                if (onDecrementToMin) onDecrementToMin();
                break;
            case 'End':
                e.preventDefault();
                if (onIncrementToMax) onIncrementToMax();
                break;
            case 'Enter':
                e.preventDefault();
                if (onCollapseToggle) onCollapseToggle();
                break;
        }
    };
    return {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        onKeyDown: onKeyDown
    };
}


var $03deb23ff14920c4$exports = {};

$parcel$export$B($03deb23ff14920c4$exports, "useGlobalListeners", () => $03deb23ff14920c4$export$4eaf04e54aa8eed6);

function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
    let globalListeners = useRef(new Map());
    let addGlobalListener = useCallback((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = useCallback((eventTarget, type, listener, options)=>{
        var ref;
        let fn = ((ref = globalListeners.current.get(listener)) === null || ref === void 0 ? void 0 : ref.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = useCallback(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    // eslint-disable-next-line arrow-body-style
    useEffect(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}


var $313b98861ee5dd6c$exports = {};

$parcel$export$B($313b98861ee5dd6c$exports, "useLabels", () => $313b98861ee5dd6c$export$d6875122194c7b44);

function $313b98861ee5dd6c$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id , 'aria-label': label , 'aria-labelledby': labelledBy  } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = $bdb11010cef70236$export$f680877a34711e37(id);
    if (labelledBy && label) {
        let ids = new Set([
            ...labelledBy.trim().split(/\s+/),
            id
        ]);
        labelledBy = [
            ...ids
        ].join(' ');
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(' ');
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        'aria-label': label,
        'aria-labelledby': labelledBy
    };
}


var $df56164dff5785e2$exports = {};

$parcel$export$B($df56164dff5785e2$exports, "useObjectRef", () => $df56164dff5785e2$export$4338b53315abf666);


function $df56164dff5785e2$export$4338b53315abf666(forwardedRef) {
    const objRef = useRef();
    /**
   * We're using `useLayoutEffect` here instead of `useEffect` because we want
   * to make sure that the `ref` value is up to date before other places in the
   * the execution cycle try to read it.
   */ $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        if (!forwardedRef) return;
        if (typeof forwardedRef === 'function') forwardedRef(objRef.current);
        else forwardedRef.current = objRef.current;
    }, [
        forwardedRef
    ]);
    return objRef;
}


var $4f58c5f72bcf79f7$exports = {};

$parcel$export$B($4f58c5f72bcf79f7$exports, "useUpdateEffect", () => $4f58c5f72bcf79f7$export$496315a1608d9602);

function $4f58c5f72bcf79f7$export$496315a1608d9602(effect, dependencies) {
    const isInitialMount = useRef(true);
    useEffect(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}



var $9daab02d461809db$exports = {};

$parcel$export$B($9daab02d461809db$exports, "useResizeObserver", () => $9daab02d461809db$export$683480f191c0e3ea);

function $9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== 'undefined';
}
function $9daab02d461809db$export$683480f191c0e3ea(options) {
    const { ref: ref , onResize: onResize  } = options;
    useEffect(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener('resize', onResize, false);
            return ()=>{
                window.removeEventListener('resize', onResize, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}


var $e7801be82b4b2a53$exports = {};

$parcel$export$B($e7801be82b4b2a53$exports, "useSyncRef", () => $e7801be82b4b2a53$export$4debdb1a3f0fa79e);

function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref) {
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                context.ref.current = null;
            };
        }
    }, [
        context,
        ref
    ]);
}


var $62d8ded9296f3872$exports = {};

$parcel$export$B($62d8ded9296f3872$exports, "getScrollParent", () => $62d8ded9296f3872$export$cfa2225e87938781);
function $62d8ded9296f3872$export$cfa2225e87938781(node) {
    while(node && !$62d8ded9296f3872$var$isScrollable(node))node = node.parentElement;
    return node || document.scrollingElement || document.documentElement;
}
function $62d8ded9296f3872$var$isScrollable(node) {
    let style = window.getComputedStyle(node);
    return /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
}


var $5df64b3807dc15ee$exports = {};

$parcel$export$B($5df64b3807dc15ee$exports, "useViewportSize", () => $5df64b3807dc15ee$export$d699905dd57c73ca);

// @ts-ignore
let $5df64b3807dc15ee$var$visualViewport = typeof window !== 'undefined' && window.visualViewport;
function $5df64b3807dc15ee$export$d699905dd57c73ca() {
    let [size1, setSize] = useState(()=>$5df64b3807dc15ee$var$getViewportSize()
    );
    useEffect(()=>{
        // Use visualViewport api to track available height even on iOS virtual keyboard opening
        let onResize = ()=>{
            setSize((size)=>{
                let newSize = $5df64b3807dc15ee$var$getViewportSize();
                if (newSize.width === size.width && newSize.height === size.height) return size;
                return newSize;
            });
        };
        if (!$5df64b3807dc15ee$var$visualViewport) window.addEventListener('resize', onResize);
        else $5df64b3807dc15ee$var$visualViewport.addEventListener('resize', onResize);
        return ()=>{
            if (!$5df64b3807dc15ee$var$visualViewport) window.removeEventListener('resize', onResize);
            else $5df64b3807dc15ee$var$visualViewport.removeEventListener('resize', onResize);
        };
    }, []);
    return size1;
}
function $5df64b3807dc15ee$var$getViewportSize() {
    return {
        width: ($5df64b3807dc15ee$var$visualViewport === null || $5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $5df64b3807dc15ee$var$visualViewport.width) || window.innerWidth,
        height: ($5df64b3807dc15ee$var$visualViewport === null || $5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $5df64b3807dc15ee$var$visualViewport.height) || window.innerHeight
    };
}


var $ef06256079686ba0$exports = {};

$parcel$export$B($ef06256079686ba0$exports, "useDescription", () => $ef06256079686ba0$export$f8aeda7b10753fa1);


let $ef06256079686ba0$var$descriptionId = 0;
const $ef06256079686ba0$var$descriptionNodes = new Map();
function $ef06256079686ba0$export$f8aeda7b10753fa1(description) {
    let [id1, setId] = useState(null);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        if (!description) return;
        let desc = $ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement('div');
            node.id = id;
            node.style.display = 'none';
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (--desc.refCount === 0) {
                desc.element.remove();
                $ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        'aria-describedby': description ? id1 : undefined
    };
}


var $c87311424ea30a05$exports = {};

$parcel$export$B($c87311424ea30a05$exports, "isMac", () => $c87311424ea30a05$export$9ac100e40613ea10);
$parcel$export$B($c87311424ea30a05$exports, "isIPhone", () => $c87311424ea30a05$export$186c6964ca17d99);
$parcel$export$B($c87311424ea30a05$exports, "isIPad", () => $c87311424ea30a05$export$7bef049ce92e4224);
$parcel$export$B($c87311424ea30a05$exports, "isIOS", () => $c87311424ea30a05$export$fedb369cb70207f1);
$parcel$export$B($c87311424ea30a05$exports, "isAppleDevice", () => $c87311424ea30a05$export$e1865c3bedcd822b);
$parcel$export$B($c87311424ea30a05$exports, "isWebKit", () => $c87311424ea30a05$export$78551043582a6a98);
$parcel$export$B($c87311424ea30a05$exports, "isChrome", () => $c87311424ea30a05$export$6446a186d09e379e);
$parcel$export$B($c87311424ea30a05$exports, "isAndroid", () => $c87311424ea30a05$export$a11b0059900ceec8);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c87311424ea30a05$var$testUserAgent(re) {
    var ref;
    if (typeof window === 'undefined' || window.navigator == null) return false;
    return ((ref = window.navigator['userAgentData']) === null || ref === void 0 ? void 0 : ref.brands.some((brand)=>re.test(brand.brand)
    )) || re.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test((window.navigator['userAgentData'] || window.navigator).platform) : false;
}
function $c87311424ea30a05$export$9ac100e40613ea10() {
    return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $c87311424ea30a05$export$186c6964ca17d99() {
    return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $c87311424ea30a05$export$7bef049ce92e4224() {
    return $c87311424ea30a05$var$testPlatform(/^iPad/i) || $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $c87311424ea30a05$export$fedb369cb70207f1() {
    return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}
function $c87311424ea30a05$export$e1865c3bedcd822b() {
    return $c87311424ea30a05$export$9ac100e40613ea10() || $c87311424ea30a05$export$fedb369cb70207f1();
}
function $c87311424ea30a05$export$78551043582a6a98() {
    return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
}
function $c87311424ea30a05$export$6446a186d09e379e() {
    return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
}
function $c87311424ea30a05$export$a11b0059900ceec8() {
    return $c87311424ea30a05$var$testUserAgent(/Android/i);
}


var $e9faafb641e167db$exports = {};

$parcel$export$B($e9faafb641e167db$exports, "useEvent", () => $e9faafb641e167db$export$90fc3a17d93f704c);

function $e9faafb641e167db$export$90fc3a17d93f704c(ref, event, handler1, options) {
    let handlerRef = useRef(handler1);
    handlerRef.current = handler1;
    let isDisabled = handler1 == null;
    useEffect(()=>{
        if (isDisabled) return;
        let element = ref.current;
        let handler = (e)=>handlerRef.current.call(this, e)
        ;
        element.addEventListener(event, handler, options);
        return ()=>{
            element.removeEventListener(event, handler, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled
    ]);
}


var $1dbecbe27a04f9af$exports = {};

$parcel$export$B($1dbecbe27a04f9af$exports, "useValueEffect", () => $1dbecbe27a04f9af$export$14d238f342723f25);


function $1dbecbe27a04f9af$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = useState(defaultValue);
    let valueRef = useRef(value);
    let effect = useRef(null);
    valueRef.current = value;
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = useRef(null);
    nextRef.current = ()=>{
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef.current();
        else setValue(newValue.value);
    };
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef.current();
    });
    let queue = useCallback((fn)=>{
        effect.current = fn(valueRef.current);
        nextRef.current();
    }, [
        effect,
        nextRef
    ]);
    return [
        value,
        queue
    ];
}


var $2f04cbc44ee30ce0$exports = {};

$parcel$export$B($2f04cbc44ee30ce0$exports, "scrollIntoView", () => $2f04cbc44ee30ce0$export$53a0910f038337bd);
function $2f04cbc44ee30ce0$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, 'left');
    let offsetY = $2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, 'top');
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    let maxX = x + scrollView.offsetWidth;
    let maxY = y + scrollView.offsetHeight;
    if (offsetX <= x) x = offsetX;
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= y) y = offsetY;
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === 'left' ? 'offsetLeft' : 'offsetTop';
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}

function $parcel$export$A(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $3b117e43dc0ca95d$exports = {};

$parcel$export$A($3b117e43dc0ca95d$exports, "Pressable", () => $3b117e43dc0ca95d$export$27c701ed9e449e99);

var $f6c31cce2adf654f$exports = {};

$parcel$export$A($f6c31cce2adf654f$exports, "usePress", () => $f6c31cce2adf654f$export$45712eceda6fad21);

// Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $14c0b72509d70225$var$state = 'default';
let $14c0b72509d70225$var$savedUserSelect = '';
let $14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $14c0b72509d70225$export$16a4697467175487(target) {
    if ($c87311424ea30a05$export$fedb369cb70207f1()) {
        if ($14c0b72509d70225$var$state === 'default') {
            $14c0b72509d70225$var$savedUserSelect = document.documentElement.style.webkitUserSelect;
            document.documentElement.style.webkitUserSelect = 'none';
        }
        $14c0b72509d70225$var$state = 'disabled';
    } else if (target) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = 'none';
    }
}
function $14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
    if ($c87311424ea30a05$export$fedb369cb70207f1()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($14c0b72509d70225$var$state !== 'disabled') return;
        $14c0b72509d70225$var$state = 'restoring';
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            // Wait for any CSS transitions to complete so we don't recompute style
            // for the whole page in the middle of the animation and cause jank.
            $bbed8b41f857bcc0$export$24490316f764c430(()=>{
                // Avoid race conditions
                if ($14c0b72509d70225$var$state === 'restoring') {
                    if (document.documentElement.style.webkitUserSelect === 'none') document.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || '';
                    $14c0b72509d70225$var$savedUserSelect = '';
                    $14c0b72509d70225$var$state = 'default';
                }
            });
        }, 300);
    } else // If not iOS, restore the target's original user-select if any
    // Ignore state since it doesn't apply for non iOS
    if (target && $14c0b72509d70225$var$modifiedElementMap.has(target)) {
        let targetOldUserSelect = $14c0b72509d70225$var$modifiedElementMap.get(target);
        if (target.style.userSelect === 'none') target.style.userSelect = targetOldUserSelect;
        if (target.getAttribute('style') === '') target.removeAttribute('style');
        $14c0b72509d70225$var$modifiedElementMap.delete(target);
    }
}






function $8a9cb279dc87e130$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    return event.detail === 0 && !event.pointerType;
}
class $8a9cb279dc87e130$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true
        ;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {
    }
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
    let stateRef = useRef({
        isFocused: false,
        onBlur: onBlur,
        observer: null
    });
    let state1 = stateRef.current;
    state1.onBlur = onBlur;
    // Clean up MutationObserver on unmount. See below.
    // eslint-disable-next-line arrow-body-style
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        return ()=>{
            if (state1.observer) {
                state1.observer.disconnect();
                state1.observer = null;
            }
        };
    }, [
        state1
    ]);
    // This function is called during a React onFocus event.
    return (e1)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e1.target instanceof HTMLButtonElement || e1.target instanceof HTMLInputElement || e1.target instanceof HTMLTextAreaElement || e1.target instanceof HTMLSelectElement) {
            state1.isFocused = true;
            let target = e1.target;
            let onBlurHandler = (e)=>{
                var // For backward compatibility, dispatch a (fake) React synthetic event.
                ref;
                let state = stateRef.current;
                state.isFocused = false;
                if (target.disabled) (ref = state.onBlur) === null || ref === void 0 ? void 0 : ref.call(state, new $8a9cb279dc87e130$export$905e7fc544a71f36('blur', e));
                // We no longer need the MutationObserver once the target is blurred.
                if (state.observer) {
                    state.observer.disconnect();
                    state.observer = null;
                }
            };
            target.addEventListener('focusout', onBlurHandler, {
                once: true
            });
            state1.observer = new MutationObserver(()=>{
                if (state1.isFocused && target.disabled) {
                    state1.observer.disconnect();
                    target.dispatchEvent(new FocusEvent('blur'));
                    target.dispatchEvent(new FocusEvent('focusout', {
                        bubbles: true
                    }));
                }
            });
            state1.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    'disabled'
                ]
            });
        }
    };
}



const $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = React__default.createContext(null);
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = 'PressResponderContext';


function $f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    if (context) {
        let { register: register , ...contextProps } = context;
        props = $3ef42575df84b30b$export$9d1611c77c2fe928(contextProps, props);
        register();
    }
    $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, props.ref);
    return props;
}
function $f6c31cce2adf654f$export$45712eceda6fad21(props) {
    let { onPress: onPress1 , onPressChange: onPressChange1 , onPressStart: onPressStart1 , onPressEnd: onPressEnd1 , onPressUp: onPressUp1 , isDisabled: isDisabled1 , isPressed: isPressedProp , preventFocusOnPress: preventFocusOnPress , shouldCancelOnPointerExit: shouldCancelOnPointerExit , allowTextSelectionOnPress: allowTextSelectionOnPress , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: _ , ...domProps } = $f6c31cce2adf654f$var$usePressResponderContext(props);
    let propsRef = useRef(null);
    propsRef.current = {
        onPress: onPress1,
        onPressChange: onPressChange1,
        onPressStart: onPressStart1,
        onPressEnd: onPressEnd1,
        onPressUp: onPressUp1,
        isDisabled: isDisabled1,
        shouldCancelOnPointerExit: shouldCancelOnPointerExit
    };
    let [isPressed, setPressed] = useState(false);
    let ref = useRef({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener , removeAllGlobalListeners: removeAllGlobalListeners  } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
    let pressProps1 = useMemo(()=>{
        let state = ref.current;
        let triggerPressStart = (originalEvent, pointerType)=>{
            let { onPressStart: onPressStart , onPressChange: onPressChange , isDisabled: isDisabled  } = propsRef.current;
            if (isDisabled || state.didFirePressStart) return;
            if (onPressStart) onPressStart({
                type: 'pressstart',
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
            if (onPressChange) onPressChange(true);
            state.didFirePressStart = true;
            setPressed(true);
        };
        let triggerPressEnd = (originalEvent, pointerType, wasPressed = true)=>{
            let { onPressEnd: onPressEnd , onPressChange: onPressChange , onPress: onPress , isDisabled: isDisabled  } = propsRef.current;
            if (!state.didFirePressStart) return;
            state.ignoreClickAfterPress = true;
            state.didFirePressStart = false;
            if (onPressEnd) onPressEnd({
                type: 'pressend',
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
            if (onPressChange) onPressChange(false);
            setPressed(false);
            if (onPress && wasPressed && !isDisabled) onPress({
                type: 'press',
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let triggerPressUp = (originalEvent, pointerType)=>{
            let { onPressUp: onPressUp , isDisabled: isDisabled  } = propsRef.current;
            if (isDisabled) return;
            if (onPressUp) onPressUp({
                type: 'pressup',
                pointerType: pointerType,
                target: originalEvent.currentTarget,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let cancel = (e)=>{
            if (state.isPressed) {
                if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isPressed = false;
                state.isOverTarget = false;
                state.activePointerId = null;
                state.pointerType = null;
                removeAllGlobalListeners();
                if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
            }
        };
        let pressProps = {
            onKeyDown (e) {
                if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent) && e.currentTarget.contains(e.target)) {
                    if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target)) e.preventDefault();
                    e.stopPropagation();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        triggerPressStart(e, 'keyboard');
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred.
                        addGlobalListener(document, 'keyup', onKeyUp, false);
                    }
                }
            },
            onKeyUp (e) {
                if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent) && !e.repeat && e.currentTarget.contains(e.target)) triggerPressUp($f6c31cce2adf654f$var$createEvent(state.target, e), 'keyboard');
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0) {
                    e.stopPropagation();
                    if (isDisabled1) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && (state.pointerType === 'virtual' || $8a9cb279dc87e130$export$60278871457622de(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled1 && !preventFocusOnPress) $7215afc6de606d6b$export$de79e2c695e052f3(e.currentTarget);
                        triggerPressStart(e, 'virtual');
                        triggerPressUp(e, 'virtual');
                        triggerPressEnd(e, 'virtual');
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                }
            }
        };
        let onKeyUp = (e)=>{
            if (state.isPressed && $f6c31cce2adf654f$var$isValidKeyboardEvent(e)) {
                if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target)) e.preventDefault();
                e.stopPropagation();
                state.isPressed = false;
                let target = e.target;
                triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), 'keyboard', state.target.contains(target));
                removeAllGlobalListeners();
                // If the target is a link, trigger the click method to open the URL,
                // but defer triggering pressEnd until onClick event handler.
                if (state.target.contains(target) && $f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) || state.target.getAttribute('role') === 'link') state.target.click();
            }
        };
        if (typeof PointerEvent !== 'undefined') {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ($f6c31cce2adf654f$var$isVirtualPointerEvent(e.nativeEvent)) {
                    state.pointerType = 'virtual';
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                e.stopPropagation();
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled1 && !preventFocusOnPress) $7215afc6de606d6b$export$de79e2c695e052f3(e.currentTarget);
                    if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
                    triggerPressStart(e, state.pointerType);
                    addGlobalListener(document, 'pointermove', onPointerMove, false);
                    addGlobalListener(document, 'pointerup', onPointerUp, false);
                    addGlobalListener(document, 'pointercancel', onPointerCancel, false);
                }
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === 'virtual') return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        triggerPressStart($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0) {
                    if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                e.stopPropagation();
                if (state.ignoreEmulatedMouseEvents) return;
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = $8a9cb279dc87e130$export$60278871457622de(e.nativeEvent) ? 'virtual' : 'mouse';
                if (!isDisabled1 && !preventFocusOnPress) $7215afc6de606d6b$export$de79e2c695e052f3(e.currentTarget);
                triggerPressStart(e, state.pointerType);
                addGlobalListener(document, 'mouseup', onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = true;
                    triggerPressStart(e, state.pointerType);
                }
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = false;
                    triggerPressEnd(e, state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType);
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if ($f6c31cce2adf654f$var$isOverTarget(e, state.target)) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.isOverTarget) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                let touch = $f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = 'touch';
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled1 && !preventFocusOnPress) $7215afc6de606d6b$export$de79e2c695e052f3(e.currentTarget);
                if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
                triggerPressStart(e, state.pointerType);
                addGlobalListener(window, 'scroll', onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (!state.isPressed) return;
                let touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    triggerPressEnd(e, state.pointerType, false);
                    if (propsRef.current.shouldCancelOnPointerExit) cancel(e);
                }
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (!state.isPressed) return;
                let touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    triggerPressUp(e, state.pointerType);
                    triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget) triggerPressEnd(e, state.pointerType, false);
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled1,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress
    ]);
    // Remove user-select: none in case component unmounts immediately after pressStart
    // eslint-disable-next-line arrow-body-style
    useEffect(()=>{
        return ()=>{
            if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(ref.current.target);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, pressProps1)
    };
}
function $f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === 'A' && target.hasAttribute('href');
}
function $f6c31cce2adf654f$var$isValidKeyboardEvent(event) {
    const { key: key , code: code , target: target  } = event;
    const element = target;
    const { tagName: tagName , isContentEditable: isContentEditable  } = element;
    const role = element.getAttribute('role');
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === 'Enter' || key === ' ' || key === 'Spacebar' || code === 'Space') && tagName !== 'INPUT' && tagName !== 'TEXTAREA' && isContentEditable !== true && (!$f6c31cce2adf654f$var$isHTMLAnchorLink(element) || role === 'button' && key !== 'Enter') && // An element with role='link' should only trigger with Enter key
    !(role === 'link' && key !== 'Enter');
}
function $f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches  } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = point.width / 2 || point.radiusX || 0;
    let offsetY = point.height / 2 || point.radiusY || 0;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $f6c31cce2adf654f$var$getPointClientRect(point);
    return $f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !target.draggable;
}
function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target) {
    return !((target.tagName === 'INPUT' || target.tagName === 'BUTTON') && target.type === 'submit');
}
function $f6c31cce2adf654f$var$isVirtualPointerEvent(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216
    return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0;
}



const $3b117e43dc0ca95d$export$27c701ed9e449e99 = /*#__PURE__*/ React__default.forwardRef(({ children: children , ...props }, ref)=>{
    let newRef = useRef();
    ref = ref !== null && ref !== void 0 ? ref : newRef;
    let { pressProps: pressProps  } = $f6c31cce2adf654f$export$45712eceda6fad21({
        ...props,
        ref: ref
    });
    let child = React__default.Children.only(children);
    return(/*#__PURE__*/ React__default.cloneElement(child, // @ts-ignore
    {
        ref: ref,
        ...$3ef42575df84b30b$export$9d1611c77c2fe928(child.props, pressProps)
    }));
});


var $f1ab8c75478c6f73$exports = {};

$parcel$export$A($f1ab8c75478c6f73$exports, "PressResponder", () => $f1ab8c75478c6f73$export$3351871ee4b288b8);



const $f1ab8c75478c6f73$export$3351871ee4b288b8 = /*#__PURE__*/ React__default.forwardRef(({ children: children , ...props }, ref)=>{
    let isRegistered = useRef(false);
    let prevContext = useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    let context = $3ef42575df84b30b$export$9d1611c77c2fe928(prevContext || {
    }, {
        ...props,
        ref: ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref),
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    $e7801be82b4b2a53$export$4debdb1a3f0fa79e(prevContext, ref);
    useEffect(()=>{
        if (!isRegistered.current) console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
    }, []);
    return(/*#__PURE__*/ React__default.createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children));
});


var $a1ea59d68270f0dd$exports = {};

$parcel$export$A($a1ea59d68270f0dd$exports, "useFocus", () => $a1ea59d68270f0dd$export$f8168d8dd8fd66e6);

function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
    let onBlur;
    if (!props.isDisabled && (props.onBlur || props.onFocusChange)) onBlur = (e)=>{
        if (e.target === e.currentTarget) {
            if (props.onBlur) props.onBlur(e);
            if (props.onFocusChange) props.onFocusChange(false);
            return true;
        }
    };
    else onBlur = null;
    let onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    let onFocus;
    if (!props.isDisabled && (props.onFocus || props.onFocusChange || props.onBlur)) onFocus = (e)=>{
        if (e.target === e.currentTarget) {
            if (props.onFocus) props.onFocus(e);
            if (props.onFocusChange) props.onFocusChange(true);
            onSyntheticFocus(e);
        }
    };
    return {
        focusProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}


var $507fabe10e71c6fb$exports = {};

$parcel$export$A($507fabe10e71c6fb$exports, "isFocusVisible", () => $507fabe10e71c6fb$export$b9b3dfddab17db27);
$parcel$export$A($507fabe10e71c6fb$exports, "getInteractionModality", () => $507fabe10e71c6fb$export$630ff653c5ada6a9);
$parcel$export$A($507fabe10e71c6fb$exports, "setInteractionModality", () => $507fabe10e71c6fb$export$8397ddfc504fdb9a);
$parcel$export$A($507fabe10e71c6fb$exports, "useInteractionModality", () => $507fabe10e71c6fb$export$98e20ec92f614cfe);
$parcel$export$A($507fabe10e71c6fb$exports, "useFocusVisible", () => $507fabe10e71c6fb$export$ffd9e5021c1fb2d6);
$parcel$export$A($507fabe10e71c6fb$exports, "useFocusVisibleListener", () => $507fabe10e71c6fb$export$ec71b4b83ac08ec3);



let $507fabe10e71c6fb$var$currentModality = null;
let $507fabe10e71c6fb$var$changeHandlers = new Set();
let $507fabe10e71c6fb$var$hasSetupGlobalListeners = false;
let $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !$c87311424ea30a05$export$9ac100e40613ea10() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($507fabe10e71c6fb$var$isValidKey(e)) {
        $507fabe10e71c6fb$var$currentModality = 'keyboard';
        $507fabe10e71c6fb$var$triggerChangeHandlers('keyboard', e);
    }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e) {
    $507fabe10e71c6fb$var$currentModality = 'pointer';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $507fabe10e71c6fb$var$triggerChangeHandlers('pointer', e);
    }
}
function $507fabe10e71c6fb$var$handleClickEvent(e) {
    if ($8a9cb279dc87e130$export$60278871457622de(e)) {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $507fabe10e71c6fb$var$currentModality = 'virtual';
    }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $507fabe10e71c6fb$var$currentModality = 'virtual';
        $507fabe10e71c6fb$var$triggerChangeHandlers('virtual', e);
    }
    $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $507fabe10e71c6fb$var$setupGlobalFocusEvents() {
    if (typeof window === 'undefined' || $507fabe10e71c6fb$var$hasSetupGlobalListeners) return;
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function() {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    document.addEventListener('keydown', $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener('keyup', $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener('click', $507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    window.addEventListener('focus', $507fabe10e71c6fb$var$handleFocusEvent, true);
    window.addEventListener('blur', $507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        document.addEventListener('pointerdown', $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener('pointermove', $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener('pointerup', $507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        document.addEventListener('mousedown', $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener('mousemove', $507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener('mouseup', $507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $507fabe10e71c6fb$var$hasSetupGlobalListeners = true;
}
if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    else document.addEventListener('DOMContentLoaded', $507fabe10e71c6fb$var$setupGlobalFocusEvents);
}
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
    return $507fabe10e71c6fb$var$currentModality !== 'pointer';
}
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
    return $507fabe10e71c6fb$var$currentModality;
}
function $507fabe10e71c6fb$export$8397ddfc504fdb9a(modality) {
    $507fabe10e71c6fb$var$currentModality = modality;
    $507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $507fabe10e71c6fb$export$98e20ec92f614cfe() {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = useState($507fabe10e71c6fb$var$currentModality);
    useEffect(()=>{
        let handler = ()=>{
            setModality($507fabe10e71c6fb$var$currentModality);
        };
        $507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return modality;
}
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    return !(isTextInput && modality === 'keyboard' && e instanceof KeyboardEvent && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $507fabe10e71c6fb$export$ffd9e5021c1fb2d6(props = {
}) {
    let { isTextInput: isTextInput , autoFocus: autoFocus  } = props;
    let [isFocusVisibleState, setFocusVisible] = useState(autoFocus || $507fabe10e71c6fb$export$b9b3dfddab17db27());
    $507fabe10e71c6fb$export$ec71b4b83ac08ec3(($507fabe10e71c6fb$export$b9b3dfddab17db27)=>{
        setFocusVisible($507fabe10e71c6fb$export$b9b3dfddab17db27);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    useEffect(()=>{
        let handler = (modality, e)=>{
            if (!$507fabe10e71c6fb$var$isKeyboardFocusEvent(opts === null || opts === void 0 ? void 0 : opts.isTextInput, modality, e)) return;
            fn($507fabe10e71c6fb$export$b9b3dfddab17db27());
        };
        $507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, deps);
}


var $9ab94262bd0047c7$exports = {};

$parcel$export$A($9ab94262bd0047c7$exports, "useFocusWithin", () => $9ab94262bd0047c7$export$420e68273165f4ec);


function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
    let state = useRef({
        isFocusWithin: false
    }).current;
    let onBlur = props.isDisabled ? null : (e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.isFocusWithin = false;
            if (props.onBlurWithin) props.onBlurWithin(e);
            if (props.onFocusWithinChange) props.onFocusWithinChange(false);
        }
    };
    let onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    let onFocus = props.isDisabled ? null : (e)=>{
        if (!state.isFocusWithin) {
            if (props.onFocusWithin) props.onFocusWithin(e);
            if (props.onFocusWithinChange) props.onFocusWithinChange(true);
            state.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}


var $6179b936705e76d3$exports = {};

$parcel$export$A($6179b936705e76d3$exports, "useHover", () => $6179b936705e76d3$export$ae780daf29e6d456);

// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === 'touch') $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === 'undefined') return;
    if (typeof PointerEvent !== 'undefined') document.addEventListener('pointerup', $6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener('touchend', $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $6179b936705e76d3$var$hoverCount--;
        if ($6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== 'undefined') document.removeEventListener('pointerup', $6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener('touchend', $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $6179b936705e76d3$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart , onHoverChange: onHoverChange , onHoverEnd: onHoverEnd , isDisabled: isDisabled  } = props;
    let [isHovered, setHovered] = useState(false);
    let state = useRef({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: '',
        target: null
    }).current;
    useEffect($6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps1 , triggerHoverEnd: triggerHoverEnd1  } = useMemo(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === 'touch' || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: 'hoverstart',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = '';
            state.target = null;
            if (pointerType === 'touch' || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: 'hoverend',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {
        };
        if (typeof PointerEvent !== 'undefined') {
            hoverProps.onPointerEnter = (e)=>{
                if ($6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, 'mouse');
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, 'mouse');
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    useEffect(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd1({
            currentTarget: state.target
        }, state.pointerType);
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps1,
        isHovered: isHovered
    };
}


var $e0b6e0b68ec7f50f$exports = {};

$parcel$export$A($e0b6e0b68ec7f50f$exports, "useInteractOutside", () => $e0b6e0b68ec7f50f$export$872b660ac5a1ff98);

function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(props) {
    let { ref: ref , onInteractOutside: onInteractOutside , isDisabled: isDisabled , onInteractOutsideStart: onInteractOutsideStart  } = props;
    let stateRef = useRef({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false,
        onInteractOutside: onInteractOutside,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let state = stateRef.current;
    state.onInteractOutside = onInteractOutside;
    state.onInteractOutsideStart = onInteractOutsideStart;
    useEffect(()=>{
        if (isDisabled) return;
        let onPointerDown = (e)=>{
            if ($e0b6e0b68ec7f50f$var$isValidEvent(e, ref) && state.onInteractOutside) {
                if (state.onInteractOutsideStart) state.onInteractOutsideStart(e);
                state.isPointerDown = true;
            }
        };
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== 'undefined') {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && state.onInteractOutside && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            // changing these to capture phase fixed combobox
            document.addEventListener('pointerdown', onPointerDown, true);
            document.addEventListener('pointerup', onPointerUp, true);
            return ()=>{
                document.removeEventListener('pointerdown', onPointerDown, true);
                document.removeEventListener('pointerup', onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && state.onInteractOutside && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.onInteractOutside && state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
                    state.isPointerDown = false;
                    state.onInteractOutside(e);
                }
            };
            document.addEventListener('mousedown', onPointerDown, true);
            document.addEventListener('mouseup', onMouseUp, true);
            document.addEventListener('touchstart', onPointerDown, true);
            document.addEventListener('touchend', onTouchEnd, true);
            return ()=>{
                document.removeEventListener('mousedown', onPointerDown, true);
                document.removeEventListener('mouseup', onMouseUp, true);
                document.removeEventListener('touchstart', onPointerDown, true);
                document.removeEventListener('touchend', onTouchEnd, true);
            };
        }
    }, [
        ref,
        state,
        isDisabled
    ]);
}
function $e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    // if the event target is no longer in the document
    if (event.target) {
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}


var $46d819fcbaf35654$exports = {};

$parcel$export$A($46d819fcbaf35654$exports, "useKeyboard", () => $46d819fcbaf35654$export$8f71654801c2f7cd);
function $93925083ecbb358c$export$48d1ea6320830260(handler) {
    if (!handler) return;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error('stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.');
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}


function $46d819fcbaf35654$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {
        } : {
            onKeyDown: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
            onKeyUp: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
        }
    };
}


var $e8a7022cf87cba2a$exports = {};

$parcel$export$A($e8a7022cf87cba2a$exports, "useMove", () => $e8a7022cf87cba2a$export$36da96379f79f245);



function $e8a7022cf87cba2a$export$36da96379f79f245(props) {
    let { onMoveStart: onMoveStart , onMove: onMove , onMoveEnd: onMoveEnd  } = props;
    let state = useRef({
        didMove: false,
        lastPosition: null,
        id: null
    });
    let { addGlobalListener: addGlobalListener , removeGlobalListener: removeGlobalListener  } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
    let moveProps1 = useMemo(()=>{
        let moveProps = {
        };
        let start = ()=>{
            $14c0b72509d70225$export$16a4697467175487();
            state.current.didMove = false;
        };
        let move = (originalEvent, pointerType, deltaX, deltaY)=>{
            if (deltaX === 0 && deltaY === 0) return;
            if (!state.current.didMove) {
                state.current.didMove = true;
                onMoveStart === null || onMoveStart === void 0 ? void 0 : onMoveStart({
                    type: 'movestart',
                    pointerType: pointerType,
                    shiftKey: originalEvent.shiftKey,
                    metaKey: originalEvent.metaKey,
                    ctrlKey: originalEvent.ctrlKey,
                    altKey: originalEvent.altKey
                });
            }
            onMove({
                type: 'move',
                pointerType: pointerType,
                deltaX: deltaX,
                deltaY: deltaY,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        let end = (originalEvent, pointerType)=>{
            $14c0b72509d70225$export$b0d6fa1ab32e3295();
            if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 ? void 0 : onMoveEnd({
                type: 'moveend',
                pointerType: pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        };
        if (typeof PointerEvent === 'undefined') {
            let onMouseMove = (e)=>{
                if (e.button === 0) {
                    move(e, 'mouse', e.pageX - state.current.lastPosition.pageX, e.pageY - state.current.lastPosition.pageY);
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onMouseUp = (e)=>{
                if (e.button === 0) {
                    end(e, 'mouse');
                    removeGlobalListener(window, 'mousemove', onMouseMove, false);
                    removeGlobalListener(window, 'mouseup', onMouseUp, false);
                }
            };
            moveProps.onMouseDown = (e)=>{
                if (e.button === 0) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    addGlobalListener(window, 'mousemove', onMouseMove, false);
                    addGlobalListener(window, 'mouseup', onMouseUp, false);
                }
            };
            let onTouchMove = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier  })=>identifier === state.current.id
                );
                if (touch >= 0) {
                    let { pageX: pageX , pageY: pageY  } = e.changedTouches[touch];
                    move(e, 'touch', pageX - state.current.lastPosition.pageX, pageY - state.current.lastPosition.pageY);
                    state.current.lastPosition = {
                        pageX: pageX,
                        pageY: pageY
                    };
                }
            };
            let onTouchEnd = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier  })=>identifier === state.current.id
                );
                if (touch >= 0) {
                    end(e, 'touch');
                    state.current.id = null;
                    removeGlobalListener(window, 'touchmove', onTouchMove);
                    removeGlobalListener(window, 'touchend', onTouchEnd);
                    removeGlobalListener(window, 'touchcancel', onTouchEnd);
                }
            };
            moveProps.onTouchStart = (e)=>{
                if (e.changedTouches.length === 0 || state.current.id != null) return;
                let { pageX: pageX , pageY: pageY , identifier: identifier  } = e.changedTouches[0];
                start();
                e.stopPropagation();
                e.preventDefault();
                state.current.lastPosition = {
                    pageX: pageX,
                    pageY: pageY
                };
                state.current.id = identifier;
                addGlobalListener(window, 'touchmove', onTouchMove, false);
                addGlobalListener(window, 'touchend', onTouchEnd, false);
                addGlobalListener(window, 'touchcancel', onTouchEnd, false);
            };
        } else {
            let onPointerMove = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || 'mouse';
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    move(e, pointerType, e.pageX - state.current.lastPosition.pageX, e.pageY - state.current.lastPosition.pageY);
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || 'mouse';
                    end(e, pointerType);
                    state.current.id = null;
                    removeGlobalListener(window, 'pointermove', onPointerMove, false);
                    removeGlobalListener(window, 'pointerup', onPointerUp, false);
                    removeGlobalListener(window, 'pointercancel', onPointerUp, false);
                }
            };
            moveProps.onPointerDown = (e)=>{
                if (e.button === 0 && state.current.id == null) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    state.current.id = e.pointerId;
                    addGlobalListener(window, 'pointermove', onPointerMove, false);
                    addGlobalListener(window, 'pointerup', onPointerUp, false);
                    addGlobalListener(window, 'pointercancel', onPointerUp, false);
                }
            };
        }
        let triggerKeyboardMove = (e, deltaX, deltaY)=>{
            start();
            move(e, 'keyboard', deltaX, deltaY);
            end(e, 'keyboard');
        };
        moveProps.onKeyDown = (e)=>{
            switch(e.key){
                case 'Left':
                case 'ArrowLeft':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case 'Right':
                case 'ArrowRight':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case 'Up':
                case 'ArrowUp':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case 'Down':
                case 'ArrowDown':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        state,
        onMoveStart,
        onMove,
        onMoveEnd,
        addGlobalListener,
        removeGlobalListener
    ]);
    return {
        moveProps: moveProps1
    };
}



var $7d0a636d7a4dcefd$exports = {};

$parcel$export$A($7d0a636d7a4dcefd$exports, "useScrollWheel", () => $7d0a636d7a4dcefd$export$2123ff2b87c81ca);


function $7d0a636d7a4dcefd$export$2123ff2b87c81ca(props, ref) {
    let { onScroll: onScroll , isDisabled: isDisabled  } = props;
    let onScrollHandler = useCallback((e)=>{
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    $e9faafb641e167db$export$90fc3a17d93f704c(ref, 'wheel', isDisabled ? null : onScrollHandler);
}


var $8a26561d2877236e$exports = {};

$parcel$export$A($8a26561d2877236e$exports, "useLongPress", () => $8a26561d2877236e$export$c24ed0104d07eab9);



const $8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $8a26561d2877236e$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled , onLongPressStart: onLongPressStart , onLongPressEnd: onLongPressEnd , onLongPress: onLongPress , threshold: threshold = $8a26561d2877236e$var$DEFAULT_THRESHOLD , accessibilityDescription: accessibilityDescription  } = props;
    const timeRef = useRef(null);
    let { addGlobalListener: addGlobalListener , removeGlobalListener: removeGlobalListener  } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
    let { pressProps: pressProps  } = $f6c31cce2adf654f$export$45712eceda6fad21({
        isDisabled: isDisabled,
        onPressStart (e1) {
            if (e1.pointerType === 'mouse' || e1.pointerType === 'touch') {
                if (onLongPressStart) onLongPressStart({
                    ...e1,
                    type: 'longpressstart'
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e1.target.dispatchEvent(new PointerEvent('pointercancel', {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e1,
                        type: 'longpress'
                    });
                    timeRef.current = null;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e1.pointerType === 'touch') {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e1.target, 'contextmenu', onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, 'pointerup', ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e1.target, 'contextmenu', onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === 'mouse' || e.pointerType === 'touch')) onLongPressEnd({
                ...e,
                type: 'longpressend'
            });
        }
    });
    let descriptionProps = $ef06256079686ba0$export$f8aeda7b10753fa1(onLongPress && !isDisabled ? accessibilityDescription : null);
    return {
        longPressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, descriptionProps)
    };
}

function $parcel$export$z(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9bf71ea28793e738$exports = {};

$parcel$export$z($9bf71ea28793e738$exports, "FocusScope", () => $9bf71ea28793e738$export$20e40289641fbbb6);
$parcel$export$z($9bf71ea28793e738$exports, "useFocusManager", () => $9bf71ea28793e738$export$10c5169755ce7bd7);
$parcel$export$z($9bf71ea28793e738$exports, "getFocusableTreeWalker", () => $9bf71ea28793e738$export$2d6ec8fc375ceafa);
$parcel$export$z($9bf71ea28793e738$exports, "createFocusManager", () => $9bf71ea28793e738$export$c5251b9e124bf29);
var $6a99195332edec8b$exports = {};

$parcel$export$z($6a99195332edec8b$exports, "focusSafely", () => $6a99195332edec8b$export$80f3e147d781571c);


function $6a99195332edec8b$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    if ($507fabe10e71c6fb$export$630ff653c5ada6a9() === 'virtual') {
        let lastFocusedElement = document.activeElement;
        $bbed8b41f857bcc0$export$24490316f764c430(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (document.activeElement === lastFocusedElement && document.contains(element)) $7215afc6de606d6b$export$de79e2c695e052f3(element);
        });
    } else $7215afc6de606d6b$export$de79e2c695e052f3(element);
}


/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $645f2e67b85a24c9$var$isStyleVisible(element) {
    if (!(element instanceof HTMLElement) && !(element instanceof SVGElement)) return false;
    let { display: display , visibility: visibility  } = element.style;
    let isVisible = display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';
    if (isVisible) {
        const { getComputedStyle: getComputedStyle  } = element.ownerDocument.defaultView;
        let { display: computedDisplay , visibility: computedVisibility  } = getComputedStyle(element);
        isVisible = computedDisplay !== 'none' && computedVisibility !== 'hidden' && computedVisibility !== 'collapse';
    }
    return isVisible;
}
function $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute('hidden') && (element.nodeName === 'DETAILS' && childElement && childElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== '#comment' && $645f2e67b85a24c9$var$isStyleVisible(element) && $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}




const $9bf71ea28793e738$var$FocusContext = /*#__PURE__*/ React__default.createContext(null);
let $9bf71ea28793e738$var$activeScope = null;
let $9bf71ea28793e738$var$scopes = new Map();
function $9bf71ea28793e738$export$20e40289641fbbb6(props) {
    let { children: children , contain: contain , restoreFocus: restoreFocus , autoFocus: autoFocus  } = props;
    let startRef = useRef();
    let endRef = useRef();
    let scopeRef = useRef([]);
    let ctx = useContext($9bf71ea28793e738$var$FocusContext);
    let parentScope = ctx === null || ctx === void 0 ? void 0 : ctx.scopeRef;
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = startRef.current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children,
        parentScope
    ]);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        $9bf71ea28793e738$var$scopes.set(scopeRef, parentScope);
        return ()=>{
            // Restore the active scope on unmount if this scope or a descendant scope is active.
            // Parent effect cleanups run before children, so we need to check if the
            // parent scope actually still exists before restoring the active scope to it.
            if ((scopeRef === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(scopeRef, $9bf71ea28793e738$var$activeScope)) && (!parentScope || $9bf71ea28793e738$var$scopes.has(parentScope))) $9bf71ea28793e738$var$activeScope = parentScope;
            $9bf71ea28793e738$var$scopes.delete(scopeRef);
        };
    }, [
        scopeRef,
        parentScope
    ]);
    $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    let focusManager = $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef);
    return(/*#__PURE__*/ React__default.createElement($9bf71ea28793e738$var$FocusContext.Provider, {
        value: {
            scopeRef: scopeRef,
            focusManager: focusManager
        }
    }, /*#__PURE__*/ React__default.createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, /*#__PURE__*/ React__default.createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    })));
}
function $9bf71ea28793e738$export$10c5169755ce7bd7() {
    var ref;
    return (ref = useContext($9bf71ea28793e738$var$FocusContext)) === null || ref === void 0 ? void 0 : ref.focusManager;
}
function $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {
        }) {
            let scope = scopeRef.current;
            let { from: from , tabbable: tabbable , wrap: wrap  } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[0].previousElementSibling;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable
            }, scope);
            walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {
        }) {
            let scope = scopeRef.current;
            let { from: from , tabbable: tabbable , wrap: wrap  } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable
            }, scope);
            walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {
        }) {
            let scope = scopeRef.current;
            let { tabbable: tabbable  } = opts;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {
        }) {
            let scope = scopeRef.current;
            let { tabbable: tabbable  } = opts;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: tabbable
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $9bf71ea28793e738$var$focusableElements = [
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]'
];
const $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]),') + ',[tabindex]:not([disabled]):not([hidden])';
$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = useRef();
    let raf = useRef(null);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        let scope1 = scopeRef.current;
        if (!contain) return;
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || scopeRef !== $9bf71ea28793e738$var$activeScope) return;
            let focusedElement = document.activeElement;
            let scope = scopeRef.current;
            if (!$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
                tabbable: true
            }, scope);
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if (!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) {
                $9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if (scopeRef === $9bf71ea28793e738$var$activeScope && !$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($9bf71ea28793e738$var$activeScope) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
            } else if (scopeRef === $9bf71ea28793e738$var$activeScope) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (scopeRef === $9bf71ea28793e738$var$activeScope && !$9bf71ea28793e738$var$isElementInChildScope(document.activeElement, scopeRef)) {
                    $9bf71ea28793e738$var$activeScope = scopeRef;
                    focusedNode.current = e.target;
                    focusedNode.current.focus();
                }
            });
        };
        document.addEventListener('keydown', onKeyDown, false);
        document.addEventListener('focusin', onFocus, false);
        scope1.forEach((element)=>element.addEventListener('focusin', onFocus, false)
        );
        scope1.forEach((element)=>element.addEventListener('focusout', onBlur, false)
        );
        return ()=>{
            document.removeEventListener('keydown', onKeyDown, false);
            document.removeEventListener('focusin', onFocus, false);
            scope1.forEach((element)=>element.removeEventListener('focusin', onFocus, false)
            );
            scope1.forEach((element)=>element.removeEventListener('focusout', onBlur, false)
            );
        };
    }, [
        scopeRef,
        contain
    ]);
    // eslint-disable-next-line arrow-body-style
    useEffect(()=>{
        return ()=>cancelAnimationFrame(raf.current)
        ;
    }, [
        raf
    ]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(element) {
    for (let scope of $9bf71ea28793e738$var$scopes.keys()){
        if ($9bf71ea28793e738$var$isElementInScope(element, scope.current)) return true;
    }
    return false;
}
function $9bf71ea28793e738$var$isElementInScope(element, scope) {
    return scope.some((node)=>node.contains(element)
    );
}
function $9bf71ea28793e738$var$isElementInChildScope(element, scope) {
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let s of $9bf71ea28793e738$var$scopes.keys()){
        if ((s === scope || $9bf71ea28793e738$var$isAncestorScope(scope, s)) && $9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    let parent = $9bf71ea28793e738$var$scopes.get(scope);
    if (!parent) return false;
    if (parent === ancestor) return true;
    return $9bf71ea28793e738$var$isAncestorScope(ancestor, parent);
}
function $9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        $6a99195332edec8b$export$80f3e147d781571c(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err1) {
    // ignore
    }
}
function $9bf71ea28793e738$var$focusFirstInScope(scope) {
    let sentinel = scope[0].previousElementSibling;
    let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa($9bf71ea28793e738$var$getScopeRoot(scope), {
        tabbable: true
    }, scope);
    walker.currentNode = sentinel;
    $9bf71ea28793e738$var$focusElement(walker.nextNode());
}
function $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = React__default.useRef(autoFocus);
    useEffect(()=>{
        if (autoFocusRef.current) {
            $9bf71ea28793e738$var$activeScope = scopeRef;
            if (!$9bf71ea28793e738$var$isElementInScope(document.activeElement, $9bf71ea28793e738$var$activeScope.current)) $9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, []);
}
function $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    const nodeToRestoreRef = useRef(typeof document !== 'undefined' ? document.activeElement : null);
    // useLayoutEffect instead of useEffect so the active element is saved synchronously instead of asynchronously.
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        let nodeToRestore = nodeToRestoreRef.current;
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey) return;
            let focusedElement = document.activeElement;
            if (!$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(document.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!document.body.contains(nodeToRestore) || nodeToRestore === document.body) nodeToRestore = null;
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current))
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
                else // If there is no next element and the nodeToRestore isn't within a FocusScope (i.e. we are leaving the top level focus scope)
                // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) document.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            if (!contain) document.removeEventListener('keydown', onKeyDown, true);
            if (restoreFocus && nodeToRestore && $9bf71ea28793e738$var$isElementInScope(document.activeElement, scopeRef.current)) requestAnimationFrame(()=>{
                if (document.body.contains(nodeToRestore)) $9bf71ea28793e738$var$focusElement(nodeToRestore);
            });
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var ref;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (ref = opts.from) === null || ref === void 0 ? void 0 : ref.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && $645f2e67b85a24c9$export$e989c0fffaa6b27a(node) && (!scope || $9bf71ea28793e738$var$isElementInScope(node, scope))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $9bf71ea28793e738$export$c5251b9e124bf29(ref) {
    return {
        focusNext (opts = {
        }) {
            let root = ref.current;
            let { from: from , tabbable: tabbable , wrap: wrap  } = opts;
            let node = from || document.activeElement;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {
        }) {
            let root = ref.current;
            let { from: from , tabbable: tabbable , wrap: wrap  } = opts;
            let node = from || document.activeElement;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $9bf71ea28793e738$var$last(walker);
                if (next) $9bf71ea28793e738$var$focusElement(next, true);
                return next;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                previousNode = $9bf71ea28793e738$var$last(walker);
            }
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {
        }) {
            let root = ref.current;
            let { tabbable: tabbable  } = opts;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable
            });
            let nextNode = walker.nextNode();
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {
        }) {
            let root = ref.current;
            let { tabbable: tabbable  } = opts;
            let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable
            });
            let next = $9bf71ea28793e738$var$last(walker);
            if (next) $9bf71ea28793e738$var$focusElement(next, true);
            return next;
        }
    };
}
function $9bf71ea28793e738$var$last(walker) {
    let next;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last)
    return next;
}


var $907718708eab68af$exports = {};

$parcel$export$z($907718708eab68af$exports, "FocusRing", () => $907718708eab68af$export$1a38b4ad7f578e1d);



var $f7dceffc5ad7768b$exports = {};

$parcel$export$z($f7dceffc5ad7768b$exports, "useFocusRing", () => $f7dceffc5ad7768b$export$4e328f61c538687f);



function $f7dceffc5ad7768b$export$4e328f61c538687f(props = {
}) {
    let { autoFocus: autoFocus = false , isTextInput: isTextInput , within: within  } = props;
    let state = useRef({
        isFocused: false,
        isFocusVisible: autoFocus || $507fabe10e71c6fb$export$b9b3dfddab17db27()
    }).current;
    let [isFocused1, setFocused] = useState(false);
    let [isFocusVisibleState, setFocusVisible] = useState(()=>state.isFocused && state.isFocusVisible
    );
    let updateState = ()=>setFocusVisible(state.isFocused && state.isFocusVisible)
    ;
    let onFocusChange = (isFocused)=>{
        state.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    };
    $507fabe10e71c6fb$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        state.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps  } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps  } = $9ab94262bd0047c7$export$420e68273165f4ec({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused1,
        isFocusVisible: state.isFocused && isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}


function $907718708eab68af$export$1a38b4ad7f578e1d(props) {
    let { children: children , focusClass: focusClass , focusRingClass: focusRingClass  } = props;
    let { isFocused: isFocused , isFocusVisible: isFocusVisible , focusProps: focusProps  } = $f7dceffc5ad7768b$export$4e328f61c538687f(props);
    let child = React__default.Children.only(children);
    return(/*#__PURE__*/ React__default.cloneElement(child, $3ef42575df84b30b$export$9d1611c77c2fe928(child.props, {
        ...focusProps,
        className: $6nfFC$clsx({
            [focusClass || '']: isFocused,
            [focusRingClass || '']: isFocusVisible
        })
    })));
}


var $e6afbd83fe6ebbd2$exports = {};

$parcel$export$z($e6afbd83fe6ebbd2$exports, "FocusableProvider", () => $e6afbd83fe6ebbd2$export$13f3202a3e5ddd5);
$parcel$export$z($e6afbd83fe6ebbd2$exports, "useFocusable", () => $e6afbd83fe6ebbd2$export$4c014de7c8940b4c);




let $e6afbd83fe6ebbd2$var$FocusableContext = /*#__PURE__*/ React__default.createContext(null);
function $e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = useContext($e6afbd83fe6ebbd2$var$FocusableContext) || {
    };
    $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref);
    // eslint-disable-next-line
    let { ref: _ , ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children , ...otherProps } = props;
    let context = {
        ...otherProps,
        ref: ref
    };
    return(/*#__PURE__*/ React__default.createElement($e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children));
}
let $e6afbd83fe6ebbd2$export$13f3202a3e5ddd5 = /*#__PURE__*/ React__default.forwardRef($e6afbd83fe6ebbd2$var$FocusableProvider);
function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps  } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props);
    let { keyboardProps: keyboardProps  } = $46d819fcbaf35654$export$8f71654801c2f7cd(props);
    let interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(focusProps, keyboardProps);
    let domProps = $e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {
    } : domProps;
    let autoFocusRef = useRef(props.autoFocus);
    useEffect(()=>{
        if (autoFocusRef.current && domRef.current) $6a99195332edec8b$export$80f3e147d781571c(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: $3ef42575df84b30b$export$9d1611c77c2fe928({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}

function $parcel$export$y(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $298d61e98472621b$exports = {};

$parcel$export$y($298d61e98472621b$exports, "useLink", () => $298d61e98472621b$export$dcf14c9974fe2767);



function $298d61e98472621b$export$dcf14c9974fe2767(props, ref) {
    let { elementType: elementType = 'a' , onPress: onPress , onPressStart: onPressStart , onPressEnd: onPressEnd , // @ts-ignore
    onClick: deprecatedOnClick , isDisabled: isDisabled , ...otherProps } = props;
    let linkProps;
    if (elementType !== 'a') linkProps = {
        role: 'link',
        tabIndex: !isDisabled ? 0 : undefined
    };
    let { focusableProps: focusableProps  } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, ref);
    let { pressProps: pressProps , isPressed: isPressed  } = $f6c31cce2adf654f$export$45712eceda6fad21({
        onPress: onPress,
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled,
        ref: ref
    });
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps, {
        labelable: true
    });
    let interactionHandlers = $3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, pressProps);
    return {
        isPressed: isPressed,
        linkProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
            ...interactionHandlers,
            ...linkProps,
            'aria-disabled': isDisabled || undefined,
            onClick: (e)=>{
                pressProps.onClick(e);
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn('onClick is deprecated, please use onPress');
                }
            }
        })
    };
}

var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}

// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

// @generated from regex-gen.ts
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = __assign(__assign(__assign({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = __assign(__assign(__assign({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = __assign(__assign({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = __assign(__assign({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = __assign(__assign({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = __assign(__assign({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = __assign(__assign({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData['001'];
    return hourCycles[0];
}

var _a;
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation$1(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation$1(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation$1(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation$1(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation$1(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation$1(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation$1(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation$1(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation$1(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation$1(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation$1(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation$1(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation$1(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation$1(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation$1(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation$1(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation$1(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation$1(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation$1(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation$1(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation$1(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation$1(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation$1(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation$1(typeEndPosition_1, __assign({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation$1(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation$1(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation$1(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation$1(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation$1(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation$1(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation$1(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation$1(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation$1(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation$1(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation$1(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = __assign({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}

//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    __extends(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));
var InvalidValueError = /** @class */ (function (_super) {
    __extends(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));
var InvalidValueTypeError = /** @class */ (function (_super) {
    __extends(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));
var MissingValueError = /** @class */ (function (_super) {
    __extends(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));

var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && isLiteralElement(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (isLiteralElement(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (isPoundElement(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new MissingValueError(varName, originalMessage);
        }
        var value = values[varName];
        if (isArgumentElement(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (isDateElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTimeElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isNumberElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : isNumberSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTagElement(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new InvalidValueTypeError(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if (isSelectElement(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if (isPluralElement(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
// -- MessageFormat --------------------------------------------------------
function mergeConfig$1(c1, c2) {
    if (!c2) {
        return c1;
    }
    return __assign(__assign(__assign({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = __assign(__assign({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig$1(defaultConfig[k], configs[k]);
        return all;
    }, __assign({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: strategies.variadic,
        }),
        getDateTimeFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: strategies.variadic,
        }),
        getPluralRules: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: strategies.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== PART_TYPE.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () { return ({
            locale: _this.resolvedLocale.toString(),
        }); };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());

function $parcel$export$x(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $d6fd23bc337660df$exports = {};

$parcel$export$x($d6fd23bc337660df$exports, "MessageDictionary", () => $d6fd23bc337660df$export$64839e615120df17);
class $d6fd23bc337660df$export$64839e615120df17 {
    getStringForLocale(key, locale) {
        let strings = this.messages[locale];
        if (!strings) {
            strings = $d6fd23bc337660df$var$getStringsForLocale(locale, this.messages, this.defaultLocale);
            this.messages[locale] = strings;
        }
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    constructor(messages, defaultLocale = 'en-US'){
        // Clone messages so we don't modify the original object.
        this.messages = {
            ...messages
        };
        this.defaultLocale = defaultLocale;
    }
}
function $d6fd23bc337660df$var$getStringsForLocale(locale, strings, defaultLocale = 'en-US') {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $d6fd23bc337660df$var$getLanguage(locale);
    for(let key in strings){
        if (key.startsWith(language + '-')) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $d6fd23bc337660df$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) // @ts-ignore
    return new Intl.Locale(locale).language;
    return locale.split('-')[0];
}


var $972eb555d604f491$exports = {};

$parcel$export$x($972eb555d604f491$exports, "MessageFormatter", () => $972eb555d604f491$export$526ebc05ff964723);

class $972eb555d604f491$export$526ebc05ff964723 {
    format(key, variables) {
        let message = this.cache[key];
        if (!message) {
            let msg = this.messages.getStringForLocale(key, this.locale);
            if (!msg) throw new Error(`Could not find intl message ${key} in ${this.locale} locale`);
            message = new IntlMessageFormat(msg, this.locale);
            this.cache[key] = message;
        }
        let varCopy;
        if (variables) varCopy = Object.keys(variables).reduce((acc, key)=>{
            acc[key] = variables[key] == null ? false : variables[key];
            return acc;
        }, {
        });
        return message.format(varCopy);
    }
    constructor(locale, messages){
        this.locale = locale;
        this.messages = messages;
        this.cache = {
        };
    }
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $fb18d541ea1ad717$var$formatterCache = new Map();
class $fb18d541ea1ad717$export$ad991b66133851cf {
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === 'function') // @ts-ignore
        return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} – ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === 'function') // @ts-ignore
        return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })
            ),
            {
                type: 'literal',
                value: ' – ',
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                })
            )
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if ($fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = $fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === 'h11' || this.resolvedHourCycle === 'h12';
        }
        return resolvedOptions;
    }
    constructor(locale, options = {
    }){
        this.formatter = $fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const $fb18d541ea1ad717$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: 'h11'
    },
    false: {
    }
};
function $fb18d541ea1ad717$var$getCachedDateFormatter(locale, options = {
}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === 'boolean' && $fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = $fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split('-')[0]];
        let defaultHourCycle = options.hour12 ? 'h12' : 'h23';
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1
    ).join() : '');
    if ($fb18d541ea1ad717$var$formatterCache.has(cacheKey)) return $fb18d541ea1ad717$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    $fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let $fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
    if ($fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null) $fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === '24';
    return $fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
let $fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
    if ($fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null) $fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat('fr', {
        hour: 'numeric',
        hour12: false
    }).resolvedOptions().hourCycle === 'h12';
    return $fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, '');
    locale += (locale.includes('-u-') ? '' : '-u') + '-nu-latn';
    let formatter = $fb18d541ea1ad717$var$getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === 'hour'
    ).value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === 'hour'
    ).value, 10);
    if (min === 0 && max === 23) return 'h23';
    if (min === 24 && max === 23) return 'h24';
    if (min === 0 && max === 11) return 'h11';
    if (min === 12 && max === 11) return 'h12';
    throw new Error('Unexpected hour cycle result');
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $488c6ddbf4ef74c2$var$formatterCache = new Map();
let $488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    // @ts-ignore
    $488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat('de-DE', {
        signDisplay: 'exceptZero'
    }).resolvedOptions().signDisplay === 'exceptZero';
// eslint-disable-next-line no-empty
} catch (e) {
}
let $488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    // @ts-ignore
    $488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat('de-DE', {
        style: 'unit',
        unit: 'degree'
    }).resolvedOptions().style === 'unit';
// eslint-disable-next-line no-empty
} catch (e1) {
}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: '°',
            'ja-JP': ' 度',
            'zh-TW': '度',
            'sl-SI': ' °'
        }
    }
};
class $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5 {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = '';
        if (!$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $488c6ddbf4ef74c2$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === 'unit' && !$488c6ddbf4ef74c2$var$supportsUnit) {
            var ref;
            let { unit: unit , unitDisplay: unitDisplay = 'short' , locale: locale  } = this.resolvedOptions();
            let values = (ref = $488c6ddbf4ef74c2$var$UNITS[unit]) === null || ref === void 0 ? void 0 : ref[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        // @ts-ignore
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRange === 'function') // @ts-ignore
        return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.format(start)} – ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRangeToParts === 'function') // @ts-ignore
        return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })
            ),
            {
                type: 'literal',
                value: ' – ',
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                })
            )
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === 'unit') options = {
            ...options,
            style: 'unit',
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {
    }){
        this.numberFormatter = $488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function $488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {
}) {
    let { numberingSystem: numberingSystem  } = options;
    if (numberingSystem && locale.indexOf('-u-nu-') === -1) locale = `${locale}-u-nu-${numberingSystem}`;
    if (options.style === 'unit' && !$488c6ddbf4ef74c2$var$supportsUnit) {
        var ref;
        let { unit: unit , unitDisplay: unitDisplay = 'short'  } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((ref = $488c6ddbf4ef74c2$var$UNITS[unit]) === null || ref === void 0 ? void 0 : ref[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: 'decimal'
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1
    ).join() : '');
    if ($488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $488c6ddbf4ef74c2$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === 'auto') return numberFormat.format(num);
    else if (signDisplay === 'never') return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === 'always') needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === 'exceptZero') {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, '').replace(/\u200e|\u061C/, '');
            if ([
                ...minus
            ].length !== 1) console.warn('@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case');
            let positive = negative.replace(noSign, '!!!').replace(minus, '+').replace('!!!', noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}

function $parcel$export$w(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $18f2051aff69b9bf$exports = {};

$parcel$export$w($18f2051aff69b9bf$exports, "I18nProvider", () => $18f2051aff69b9bf$export$a54013f0d02a8f82);
$parcel$export$w($18f2051aff69b9bf$exports, "useLocale", () => $18f2051aff69b9bf$export$43bb16f9c6d9e3f7);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    'Arab',
    'Syrc',
    'Samr',
    'Mand',
    'Thaa',
    'Mend',
    'Nkoo',
    'Adlm',
    'Rohg',
    'Hebr'
]);
const $148a7a147e38ea7f$var$RTL_LANGS = new Set([
    'ae',
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'he',
    'ku',
    'mzn',
    'nqo',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi'
]);
function $148a7a147e38ea7f$export$702d680b21cbd764(locale) {
    // If the Intl.Locale API is available, use it to get the script for the locale.
    // This is more accurate than guessing by language, since languages can be written in multiple scripts.
    // @ts-ignore
    if (Intl.Locale) {
        // @ts-ignore
        let script = new Intl.Locale(locale).maximize().script;
        return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = locale.split('-')[0];
    return $148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}





function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
    // @ts-ignore
    let locale = typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = 'en-US';
    }
    return {
        locale: locale,
        direction: $148a7a147e38ea7f$export$702d680b21cbd764(locale) ? 'rtl' : 'ltr'
    };
}
let $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
let $1e5a04cdaf7d1af8$var$listeners = new Set();
function $1e5a04cdaf7d1af8$var$updateLocale() {
    $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
    for (let listener of $1e5a04cdaf7d1af8$var$listeners)listener($1e5a04cdaf7d1af8$var$currentLocale);
}
function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
    let isSSR = $9d939cbc98267846$export$535bd6ca7f90a273();
    let [defaultLocale, setDefaultLocale] = useState($1e5a04cdaf7d1af8$var$currentLocale);
    useEffect(()=>{
        if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener('languagechange', $1e5a04cdaf7d1af8$var$updateLocale);
        $1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener('languagechange', $1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: 'en-US',
        direction: 'ltr'
    };
    return defaultLocale;
}



const $18f2051aff69b9bf$var$I18nContext = /*#__PURE__*/ React__default.createContext(null);
function $18f2051aff69b9bf$export$a54013f0d02a8f82(props) {
    let { locale: locale , children: children  } = props;
    let defaultLocale = $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let value = locale ? {
        locale: locale,
        direction: $148a7a147e38ea7f$export$702d680b21cbd764(locale) ? 'rtl' : 'ltr'
    } : defaultLocale;
    return(/*#__PURE__*/ React__default.createElement($18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children));
}
function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
    let defaultLocale = $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let context = useContext($18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}


var $321bc95feeb923dd$exports = {};

$parcel$export$w($321bc95feeb923dd$exports, "useMessageFormatter", () => $321bc95feeb923dd$export$ec23bf898b1eed85);



const $321bc95feeb923dd$var$cache = new WeakMap();
function $321bc95feeb923dd$var$getCachedDictionary(strings) {
    let dictionary = $321bc95feeb923dd$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new $d6fd23bc337660df$export$64839e615120df17(strings);
        $321bc95feeb923dd$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $321bc95feeb923dd$export$ec23bf898b1eed85(strings) {
    let { locale: locale  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let dictionary = useMemo(()=>$321bc95feeb923dd$var$getCachedDictionary(strings)
    , [
        strings
    ]);
    let formatter = useMemo(()=>new $972eb555d604f491$export$526ebc05ff964723(locale, dictionary)
    , [
        locale,
        dictionary
    ]);
    return useCallback((key, variables)=>formatter.format(key, variables)
    , [
        formatter
    ]);
}


var $896ba0a80a8f4d36$exports = {};

$parcel$export$w($896ba0a80a8f4d36$exports, "useDateFormatter", () => $896ba0a80a8f4d36$export$85fd5fdf27bacc79);



function $896ba0a80a8f4d36$export$85fd5fdf27bacc79(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    let lastOptions = useRef(null);
    if (options && lastOptions.current && $896ba0a80a8f4d36$var$isEqual(options, lastOptions.current)) options = lastOptions.current;
    lastOptions.current = options;
    let { locale: locale  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    return useMemo(()=>new $fb18d541ea1ad717$export$ad991b66133851cf(locale, options)
    , [
        locale,
        options
    ]);
}
function $896ba0a80a8f4d36$var$isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}


var $a916eb452884faea$exports = {};

$parcel$export$w($a916eb452884faea$exports, "useNumberFormatter", () => $a916eb452884faea$export$b7a616150fdb9f44);



function $a916eb452884faea$export$b7a616150fdb9f44(options = {
}) {
    let { locale: locale  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    return useMemo(()=>new $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5(locale, options)
    , [
        locale,
        options
    ]);
}


var $325a3faab7a68acd$exports = {};

$parcel$export$w($325a3faab7a68acd$exports, "useCollator", () => $325a3faab7a68acd$export$a16aca283550c30d);

let $325a3faab7a68acd$var$cache = new Map();
function $325a3faab7a68acd$export$a16aca283550c30d(options) {
    let { locale: locale  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1
    ).join() : '');
    if ($325a3faab7a68acd$var$cache.has(cacheKey)) return $325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}


var $bb77f239b46e8c72$exports = {};

$parcel$export$w($bb77f239b46e8c72$exports, "useFilter", () => $bb77f239b46e8c72$export$3274cf84b703fff);

function $bb77f239b46e8c72$export$3274cf84b703fff(options) {
    let collator = $325a3faab7a68acd$export$a16aca283550c30d({
        usage: 'search',
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    return {
        startsWith (string, substring) {
            if (substring.length === 0) return true;
            // Normalize both strings so we can slice safely
            // TODO: take into account the ignorePunctuation option as well...
            string = string.normalize('NFC');
            substring = substring.normalize('NFC');
            return collator.compare(string.slice(0, substring.length), substring) === 0;
        },
        endsWith (string, substring) {
            if (substring.length === 0) return true;
            string = string.normalize('NFC');
            substring = substring.normalize('NFC');
            return collator.compare(string.slice(-substring.length), substring) === 0;
        },
        contains (string, substring) {
            if (substring.length === 0) return true;
            string = string.normalize('NFC');
            substring = substring.normalize('NFC');
            let scan = 0;
            let sliceLen = substring.length;
            for(; scan + sliceLen <= string.length; scan++){
                let slice = string.slice(scan, scan + sliceLen);
                if (collator.compare(substring, slice) === 0) return true;
            }
            return false;
        }
    };
}

function $parcel$export$v(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault$8(a) {
  return a && a.__esModule ? a.default : a;
}
var $dafd15390222438a$exports = {};

$parcel$export$v($dafd15390222438a$exports, "useBreadcrumbItem", () => $dafd15390222438a$export$452b38fce62c9384);

function $dafd15390222438a$export$452b38fce62c9384(props, ref) {
    let { isCurrent: isCurrent , isDisabled: isDisabled , 'aria-current': ariaCurrent , elementType: elementType = 'a' , ...otherProps } = props;
    let { linkProps: linkProps  } = $298d61e98472621b$export$dcf14c9974fe2767({
        isDisabled: isDisabled || isCurrent,
        elementType: elementType,
        ...otherProps
    }, ref);
    let isHeading = /^h[1-6]$/.test(elementType);
    let itemProps = {
    };
    if (!isHeading) itemProps = linkProps;
    if (isCurrent) {
        itemProps['aria-current'] = ariaCurrent || 'page';
        // isCurrent sets isDisabled === true for the current item,
        // so we have to restore the tabIndex in order to support autoFocus.
        itemProps.tabIndex = props.autoFocus ? -1 : undefined;
    }
    return {
        itemProps: {
            'aria-disabled': isDisabled,
            ...itemProps
        }
    };
}


var $848231d7a2b3998e$exports = {};

$parcel$export$v($848231d7a2b3998e$exports, "useBreadcrumbs", () => $848231d7a2b3998e$export$8cefe241bd876ca0);

var $28dc7e2f5ed40c80$exports = {};
var $b91590b2dc47de39$exports = {};
$b91590b2dc47de39$exports = JSON.parse("{\"breadcrumbs\":\"عناصر الواجهة\"}");


var $55b0693b2cf3fe91$exports = {};
$55b0693b2cf3fe91$exports = JSON.parse("{\"breadcrumbs\":\"Трохи хляб\"}");


var $6ec1ed7729e948cc$exports = {};
$6ec1ed7729e948cc$exports = JSON.parse("{\"breadcrumbs\":\"Popis cesty\"}");


var $5a41bb2baa6861e4$exports = {};
$5a41bb2baa6861e4$exports = JSON.parse("{\"breadcrumbs\":\"Brødkrummer\"}");


var $f28bbea439e87eca$exports = {};
$f28bbea439e87eca$exports = JSON.parse("{\"breadcrumbs\":\"Breadcrumbs\"}");


var $b3eca51cb720961a$exports = {};
$b3eca51cb720961a$exports = JSON.parse("{\"breadcrumbs\":\"Πλοηγήσεις breadcrumb\"}");


var $0b39b205118db415$exports = {};
$0b39b205118db415$exports = JSON.parse("{\"breadcrumbs\":\"Breadcrumbs\"}");


var $f467c0ee7bfb0950$exports = {};
$f467c0ee7bfb0950$exports = JSON.parse("{\"breadcrumbs\":\"Migas de pan\"}");


var $ab711d2ffb4cdf3d$exports = {};
$ab711d2ffb4cdf3d$exports = JSON.parse("{\"breadcrumbs\":\"Lingiread\"}");


var $b63105d663e6f9d5$exports = {};
$b63105d663e6f9d5$exports = JSON.parse("{\"breadcrumbs\":\"Navigointilinkit\"}");


var $9d2ed7be7fcdc2a1$exports = {};
$9d2ed7be7fcdc2a1$exports = JSON.parse("{\"breadcrumbs\":\"Chemin de navigation\"}");


var $c5704294d85c7b5d$exports = {};
$c5704294d85c7b5d$exports = JSON.parse("{\"breadcrumbs\":\"שבילי ניווט\"}");


var $20c975671d6bbc63$exports = {};
$20c975671d6bbc63$exports = JSON.parse("{\"breadcrumbs\":\"Navigacijski putovi\"}");


var $2569ca3917233115$exports = {};
$2569ca3917233115$exports = JSON.parse("{\"breadcrumbs\":\"Morzsamenü\"}");


var $caa152f7f8e96c85$exports = {};
$caa152f7f8e96c85$exports = JSON.parse("{\"breadcrumbs\":\"Breadcrumb\"}");


var $cbc6af0cc98fad10$exports = {};
$cbc6af0cc98fad10$exports = JSON.parse("{\"breadcrumbs\":\"パンくずリスト\"}");


var $ad9be5d332b4d607$exports = {};
$ad9be5d332b4d607$exports = JSON.parse("{\"breadcrumbs\":\"탐색 표시\"}");


var $659de19a00ff9617$exports = {};
$659de19a00ff9617$exports = JSON.parse("{\"breadcrumbs\":\"Naršymo kelias\"}");


var $173e9fb4d14fe309$exports = {};
$173e9fb4d14fe309$exports = JSON.parse("{\"breadcrumbs\":\"Atpakaļceļi\"}");


var $d8e2640a066567a9$exports = {};
$d8e2640a066567a9$exports = JSON.parse("{\"breadcrumbs\":\"Navigasjonsstier\"}");


var $d71fd764236c0d12$exports = {};
$d71fd764236c0d12$exports = JSON.parse("{\"breadcrumbs\":\"Broodkruimels\"}");


var $f4ad3faf9f4aaec6$exports = {};
$f4ad3faf9f4aaec6$exports = JSON.parse("{\"breadcrumbs\":\"Struktura nawigacyjna\"}");


var $9703be9d55d8e9c2$exports = {};
$9703be9d55d8e9c2$exports = JSON.parse("{\"breadcrumbs\":\"Caminho detalhado\"}");


var $7e23baec8a14f309$exports = {};
$7e23baec8a14f309$exports = JSON.parse("{\"breadcrumbs\":\"Categorias\"}");


var $568f95594049d56e$exports = {};
$568f95594049d56e$exports = JSON.parse("{\"breadcrumbs\":\"Miez de pâine\"}");


var $625df06cecc70764$exports = {};
$625df06cecc70764$exports = JSON.parse("{\"breadcrumbs\":\"Навигация\"}");


var $b5a67525f3a2f594$exports = {};
$b5a67525f3a2f594$exports = JSON.parse("{\"breadcrumbs\":\"Navigačné prvky Breadcrumbs\"}");


var $16125922964febca$exports = {};
$16125922964febca$exports = JSON.parse("{\"breadcrumbs\":\"Drobtine\"}");


var $de104bf355206bcf$exports = {};
$de104bf355206bcf$exports = JSON.parse("{\"breadcrumbs\":\"Putanje navigacije\"}");


var $d5ab76bcbadc9c07$exports = {};
$d5ab76bcbadc9c07$exports = JSON.parse("{\"breadcrumbs\":\"Sökvägar\"}");


var $a6a1af5968159b55$exports = {};
$a6a1af5968159b55$exports = JSON.parse("{\"breadcrumbs\":\"İçerik haritaları\"}");


var $5204a30f0d17ffec$exports = {};
$5204a30f0d17ffec$exports = JSON.parse("{\"breadcrumbs\":\"Навігаційна стежка\"}");


var $8d15e736e12d3dfd$exports = {};
$8d15e736e12d3dfd$exports = JSON.parse("{\"breadcrumbs\":\"导航栏\"}");


var $f8c49dd804b75140$exports = {};
$f8c49dd804b75140$exports = JSON.parse("{\"breadcrumbs\":\"導覽列\"}");


$28dc7e2f5ed40c80$exports = {
    "ar-AE": $b91590b2dc47de39$exports,
    "bg-BG": $55b0693b2cf3fe91$exports,
    "cs-CZ": $6ec1ed7729e948cc$exports,
    "da-DK": $5a41bb2baa6861e4$exports,
    "de-DE": $f28bbea439e87eca$exports,
    "el-GR": $b3eca51cb720961a$exports,
    "en-US": $0b39b205118db415$exports,
    "es-ES": $f467c0ee7bfb0950$exports,
    "et-EE": $ab711d2ffb4cdf3d$exports,
    "fi-FI": $b63105d663e6f9d5$exports,
    "fr-FR": $9d2ed7be7fcdc2a1$exports,
    "he-IL": $c5704294d85c7b5d$exports,
    "hr-HR": $20c975671d6bbc63$exports,
    "hu-HU": $2569ca3917233115$exports,
    "it-IT": $caa152f7f8e96c85$exports,
    "ja-JP": $cbc6af0cc98fad10$exports,
    "ko-KR": $ad9be5d332b4d607$exports,
    "lt-LT": $659de19a00ff9617$exports,
    "lv-LV": $173e9fb4d14fe309$exports,
    "nb-NO": $d8e2640a066567a9$exports,
    "nl-NL": $d71fd764236c0d12$exports,
    "pl-PL": $f4ad3faf9f4aaec6$exports,
    "pt-BR": $9703be9d55d8e9c2$exports,
    "pt-PT": $7e23baec8a14f309$exports,
    "ro-RO": $568f95594049d56e$exports,
    "ru-RU": $625df06cecc70764$exports,
    "sk-SK": $b5a67525f3a2f594$exports,
    "sl-SI": $16125922964febca$exports,
    "sr-SP": $de104bf355206bcf$exports,
    "sv-SE": $d5ab76bcbadc9c07$exports,
    "tr-TR": $a6a1af5968159b55$exports,
    "uk-UA": $5204a30f0d17ffec$exports,
    "zh-CN": $8d15e736e12d3dfd$exports,
    "zh-TW": $f8c49dd804b75140$exports
};



function $848231d7a2b3998e$export$8cefe241bd876ca0(props) {
    let { 'aria-label': ariaLabel , ...otherProps } = props;
    let formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault$8($28dc7e2f5ed40c80$exports)));
    return {
        navProps: {
            ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps, {
                labelable: true
            }),
            'aria-label': ariaLabel || formatMessage('breadcrumbs')
        }
    };
}

function $parcel$export$u(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $701a24aa0da5b062$exports = {};

$parcel$export$u($701a24aa0da5b062$exports, "useButton", () => $701a24aa0da5b062$export$ea18c227d4417cc3);




function $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref) {
    let { elementType: elementType = 'button' , isDisabled: isDisabled , onPress: onPress , onPressStart: onPressStart , onPressEnd: onPressEnd , onPressChange: onPressChange , preventFocusOnPress: // @ts-ignore - undocumented
    preventFocusOnPress , allowFocusWhenDisabled: // @ts-ignore - undocumented
    allowFocusWhenDisabled , // @ts-ignore
    onClick: deprecatedOnClick , href: href , target: target , rel: rel , type: type = 'button'  } = props;
    let additionalProps;
    if (elementType === 'button') additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: 'button',
        tabIndex: isDisabled ? undefined : 0,
        href: elementType === 'a' && isDisabled ? undefined : href,
        target: elementType === 'a' ? target : undefined,
        type: elementType === 'input' ? type : undefined,
        disabled: elementType === 'input' ? isDisabled : undefined,
        'aria-disabled': !isDisabled || elementType === 'input' ? undefined : isDisabled,
        rel: elementType === 'a' ? rel : undefined
    };
    let { pressProps: pressProps , isPressed: isPressed  } = $f6c31cce2adf654f$export$45712eceda6fad21({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps  } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = $3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, pressProps, $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(additionalProps, buttonProps, {
            'aria-haspopup': props['aria-haspopup'],
            'aria-expanded': props['aria-expanded'],
            'aria-controls': props['aria-controls'],
            'aria-pressed': props['aria-pressed'],
            onClick: (e)=>{
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn('onClick is deprecated, please use onPress');
                }
            }
        })
    };
}


var $55f54f7887471b58$exports = {};

$parcel$export$u($55f54f7887471b58$exports, "useToggleButton", () => $55f54f7887471b58$export$51e84d46ca0bc451);



function $55f54f7887471b58$export$51e84d46ca0bc451(props, state, ref) {
    const { isSelected: isSelected  } = state;
    const { isPressed: isPressed , buttonProps: buttonProps  } = $701a24aa0da5b062$export$ea18c227d4417cc3({
        ...props,
        onPress: $ff5963eb1fccf552$export$e08e3b67e392101e(state.toggle, props.onPress)
    }, ref);
    return {
        isPressed: isPressed,
        buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, {
            'aria-pressed': isSelected
        })
    };
}

function $parcel$export$t(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $d2c8e2b0480f3f34$exports = {};

$parcel$export$t($d2c8e2b0480f3f34$exports, "useToggle", () => $d2c8e2b0480f3f34$export$cbe85ee05b554577);



function $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, ref) {
    let { isDisabled: isDisabled = false , isRequired: isRequired , isReadOnly: isReadOnly , value: value , name: name , children: children , 'aria-label': ariaLabel , 'aria-labelledby': ariaLabelledby , validationState: validationState = 'valid'  } = props;
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected(e.target.checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn('If you do not provide children, you must specify an aria-label for accessibility');
    // This handles focusing the input on pointer down, which Safari does not do by default.
    let { pressProps: pressProps  } = $f6c31cce2adf654f$export$45712eceda6fad21({
        isDisabled: isDisabled
    });
    let { focusableProps: focusableProps  } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, ref);
    let interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, focusableProps);
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    return {
        inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
            'aria-invalid': validationState === 'invalid' || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-controls': props['aria-controls'],
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            onChange: onChange,
            disabled: isDisabled,
            value: value,
            name: name,
            type: 'checkbox',
            ...interactions
        })
    };
}

function $parcel$export$s(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $2baaea4c71418dea$exports = {};

$parcel$export$s($2baaea4c71418dea$exports, "useField", () => $2baaea4c71418dea$export$294aa081a6c6f55d);
var $d191a55c9702f145$exports = {};

$parcel$export$s($d191a55c9702f145$exports, "useLabel", () => $d191a55c9702f145$export$8467354a121f1b9f);

function $d191a55c9702f145$export$8467354a121f1b9f(props) {
    let { id: id , label: label , 'aria-labelledby': ariaLabelledby , 'aria-label': ariaLabel , labelElementType: labelElementType = 'label'  } = props;
    id = $bdb11010cef70236$export$f680877a34711e37(id);
    let labelId = $bdb11010cef70236$export$f680877a34711e37();
    let labelProps = {
    };
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${ariaLabelledby} ${labelId}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === 'label' ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn('If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility');
    let fieldProps = $313b98861ee5dd6c$export$d6875122194c7b44({
        id: id,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}



function $2baaea4c71418dea$export$294aa081a6c6f55d(props) {
    let { description: description , errorMessage: errorMessage , validationState: validationState  } = props;
    let { labelProps: labelProps , fieldProps: fieldProps  } = $d191a55c9702f145$export$8467354a121f1b9f(props);
    let descriptionId = $bdb11010cef70236$export$b4cc09c592e8fdb8([
        Boolean(description),
        Boolean(errorMessage),
        validationState
    ]);
    let errorMessageId = $bdb11010cef70236$export$b4cc09c592e8fdb8([
        Boolean(description),
        Boolean(errorMessage),
        validationState
    ]);
    fieldProps = $3ef42575df84b30b$export$9d1611c77c2fe928(fieldProps, {
        'aria-describedby': [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props['aria-describedby']
        ].filter(Boolean).join(' ') || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

function $parcel$export$r(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $3017fa7ffdddec74$exports = {};

$parcel$export$r($3017fa7ffdddec74$exports, "useToggleState", () => $3017fa7ffdddec74$export$8042c6c013fd5226);

function $3017fa7ffdddec74$export$8042c6c013fd5226(props = {
}) {
    let { isReadOnly: isReadOnly  } = props;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    let [isSelected, setSelected] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.isSelected, props.defaultSelected || false, props.onChange);
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    return {
        isSelected: isSelected,
        setSelected: updateSelected,
        toggle: toggleState
    };
}

function $parcel$export$q(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $406796ff087fe49b$exports = {};

$parcel$export$q($406796ff087fe49b$exports, "useCheckbox", () => $406796ff087fe49b$export$e375f10ce42261c5);


function $406796ff087fe49b$export$e375f10ce42261c5(props, state, inputRef) {
    let { inputProps: inputProps  } = $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, inputRef);
    let { isSelected: isSelected  } = state;
    let { isIndeterminate: isIndeterminate  } = props;
    useEffect(()=>{
        // indeterminate is a property, but it can only be set via javascript
        // https://css-tricks.com/indeterminate-checkboxes/
        if (inputRef.current) inputRef.current.indeterminate = isIndeterminate;
    });
    return {
        inputProps: {
            ...inputProps,
            checked: isSelected,
            'aria-checked': isIndeterminate ? 'mixed' : isSelected
        }
    };
}


var $1e9fce0cfacc738b$exports = {};

$parcel$export$q($1e9fce0cfacc738b$exports, "useCheckboxGroup", () => $1e9fce0cfacc738b$export$49ff6f28c54f1cbe);
const $1ae600c947479353$export$31440636951aa68c = new WeakMap();




function $1e9fce0cfacc738b$export$49ff6f28c54f1cbe(props, state) {
    let { isDisabled: isDisabled , name: name  } = props;
    let { labelProps: labelProps , fieldProps: fieldProps  } = $d191a55c9702f145$export$8467354a121f1b9f({
        ...props,
        // Checkbox group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    // Pass name prop from group to all items by attaching to the state.
    $1ae600c947479353$export$31440636951aa68c.set(state, name);
    return {
        groupProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
            role: 'group',
            'aria-disabled': isDisabled || undefined,
            ...fieldProps
        }),
        labelProps: labelProps
    };
}


var $fba3e38d5ca8983f$exports = {};

$parcel$export$q($fba3e38d5ca8983f$exports, "useCheckboxGroupItem", () => $fba3e38d5ca8983f$export$353b32fc6898d37d);



function $fba3e38d5ca8983f$export$353b32fc6898d37d(props, state, inputRef) {
    const toggleState = $3017fa7ffdddec74$export$8042c6c013fd5226({
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isSelected: state.isSelected(props.value),
        onChange (isSelected) {
            if (isSelected) state.addValue(props.value);
            else state.removeValue(props.value);
            if (props.onChange) props.onChange(isSelected);
        }
    });
    let { inputProps: inputProps  } = $406796ff087fe49b$export$e375f10ce42261c5({
        ...props,
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isDisabled: props.isDisabled || state.isDisabled,
        name: props.name || $1ae600c947479353$export$31440636951aa68c.get(state)
    }, toggleState, inputRef);
    return {
        inputProps: inputProps
    };
}

function $parcel$export$p(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $5c3e21d68f1c4674$exports = {};

$parcel$export$p($5c3e21d68f1c4674$exports, "useVisuallyHidden", () => $5c3e21d68f1c4674$export$a966af930f325cab);
$parcel$export$p($5c3e21d68f1c4674$exports, "VisuallyHidden", () => $5c3e21d68f1c4674$export$439d29a4e110a164);



const $5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    margin: '0 -1px -1px 0',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: 1,
    whiteSpace: 'nowrap'
};
function $5c3e21d68f1c4674$export$a966af930f325cab(props = {
}) {
    let { style: style , isFocusable: isFocusable  } = props;
    let [isFocused, setFocused] = useState(false);
    let { focusProps: focusProps  } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
        isDisabled: !isFocusable,
        onFocusChange: setFocused
    });
    // If focused, don't hide the element.
    let combinedStyles = useMemo(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $5c3e21d68f1c4674$var$styles;
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusProps,
            style: combinedStyles
        }
    };
}
function $5c3e21d68f1c4674$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children , elementType: Element = 'div' , isFocusable: isFocusable , style: style , ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps  } = $5c3e21d68f1c4674$export$a966af930f325cab(props);
    return(/*#__PURE__*/ React__default.createElement(Element, $3ef42575df84b30b$export$9d1611c77c2fe928(otherProps, visuallyHiddenProps), children));
}

function $parcel$export$o(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $319e236875307eab$exports = {};

$parcel$export$o($319e236875307eab$exports, "announce", () => $319e236875307eab$export$a9b970dcc4ae71a9);
$parcel$export$o($319e236875307eab$exports, "clearAnnouncer", () => $319e236875307eab$export$d10ae4f68404609a);
$parcel$export$o($319e236875307eab$exports, "destroyAnnouncer", () => $319e236875307eab$export$d8686216b8b81b2f);



/* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ const $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7000;
let $319e236875307eab$var$liveRegionAnnouncer = /*#__PURE__*/ React__default.createRef();
let $319e236875307eab$var$node = null;
let $319e236875307eab$var$messageId = 0;
function $319e236875307eab$export$a9b970dcc4ae71a9(message, assertiveness = 'assertive', timeout = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
    $319e236875307eab$var$ensureInstance((announcer)=>announcer.announce(message, assertiveness, timeout)
    );
}
function $319e236875307eab$export$d10ae4f68404609a(assertiveness) {
    $319e236875307eab$var$ensureInstance((announcer)=>announcer.clear(assertiveness)
    );
}
function $319e236875307eab$export$d8686216b8b81b2f() {
    if ($319e236875307eab$var$liveRegionAnnouncer.current) {
        $9Q8De$reactdom.unmountComponentAtNode($319e236875307eab$var$node);
        document.body.removeChild($319e236875307eab$var$node);
        $319e236875307eab$var$node = null;
    }
}
/**
 * Ensures we only have one instance of the announcer so that we don't have elements competing.
 */ function $319e236875307eab$var$ensureInstance(callback) {
    if (!$319e236875307eab$var$liveRegionAnnouncer.current) {
        $319e236875307eab$var$node = document.createElement('div');
        $319e236875307eab$var$node.dataset.liveAnnouncer = 'true';
        document.body.prepend($319e236875307eab$var$node);
        $9Q8De$reactdom.render(/*#__PURE__*/ React__default.createElement($319e236875307eab$var$LiveRegionAnnouncer, {
            ref: $319e236875307eab$var$liveRegionAnnouncer
        }), $319e236875307eab$var$node, ()=>callback($319e236875307eab$var$liveRegionAnnouncer.current)
        );
    } else callback($319e236875307eab$var$liveRegionAnnouncer.current);
}
const $319e236875307eab$var$LiveRegionAnnouncer = /*#__PURE__*/ React__default.forwardRef((_, ref)=>{
    let [assertiveMessages, setAssertiveMessages] = useState([]);
    let [politeMessages, setPoliteMessages] = useState([]);
    let clear = (assertiveness)=>{
        if (!assertiveness || assertiveness === 'assertive') setAssertiveMessages([]);
        if (!assertiveness || assertiveness === 'polite') setPoliteMessages([]);
    };
    let $319e236875307eab$export$a9b970dcc4ae71a9 = (message1, assertiveness = 'assertive', timeout = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY)=>{
        let id = $319e236875307eab$var$messageId++;
        if (assertiveness === 'assertive') setAssertiveMessages((messages)=>[
                ...messages,
                {
                    id: id,
                    text: message1
                }
            ]
        );
        else setPoliteMessages((messages)=>[
                ...messages,
                {
                    id: id,
                    text: message1
                }
            ]
        );
        if (message1 !== '') setTimeout(()=>{
            if (assertiveness === 'assertive') setAssertiveMessages((messages)=>messages.filter((message)=>message.id !== id
                )
            );
            else setPoliteMessages((messages)=>messages.filter((message)=>message.id !== id
                )
            );
        }, timeout);
    };
    useImperativeHandle(ref, ()=>({
            announce: $319e236875307eab$export$a9b970dcc4ae71a9,
            clear: clear
        })
    );
    return(/*#__PURE__*/ React__default.createElement(Fragment, null, /*#__PURE__*/ React__default.createElement($319e236875307eab$var$MessageBlock, {
        "aria-live": "assertive"
    }, assertiveMessages.map((message)=>/*#__PURE__*/ React__default.createElement("div", {
            key: message.id
        }, message.text)
    )), /*#__PURE__*/ React__default.createElement($319e236875307eab$var$MessageBlock, {
        "aria-live": "polite"
    }, politeMessages.map((message)=>/*#__PURE__*/ React__default.createElement("div", {
            key: message.id
        }, message.text)
    ))));
});
function $319e236875307eab$var$MessageBlock({ children: children , 'aria-live': ariaLive  }) {
    return(/*#__PURE__*/ React__default.createElement($5c3e21d68f1c4674$export$439d29a4e110a164, {
        role: "log",
        "aria-live": ariaLive,
        "aria-relevant": "additions"
    }, children));
}

var style = {exports: {}};

var interopRequireDefault = {exports: {}};

(function (module) {
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}

	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (interopRequireDefault));

var camelizeStyle = {exports: {}};

var camelize = {exports: {}};

var hasRequiredCamelize;

function requireCamelize () {
	if (hasRequiredCamelize) return camelize.exports;
	hasRequiredCamelize = 1;
	(function (module, exports) {

		exports.__esModule = true;
		exports.default = camelize;
		var rHyphen = /-(.)/g;

		function camelize(string) {
		  return string.replace(rHyphen, function (_, chr) {
		    return chr.toUpperCase();
		  });
		}

		module.exports = exports["default"];
} (camelize, camelize.exports));
	return camelize.exports;
}

var hasRequiredCamelizeStyle;

function requireCamelizeStyle () {
	if (hasRequiredCamelizeStyle) return camelizeStyle.exports;
	hasRequiredCamelizeStyle = 1;
	(function (module, exports) {

		var _interopRequireDefault = interopRequireDefault.exports;

		exports.__esModule = true;
		exports.default = camelizeStyleName;

		var _camelize = _interopRequireDefault(requireCamelize());

		/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
		 */
		var msPattern = /^-ms-/;

		function camelizeStyleName(string) {
		  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
		}

		module.exports = exports["default"];
} (camelizeStyle, camelizeStyle.exports));
	return camelizeStyle.exports;
}

var hyphenateStyle = {exports: {}};

var hyphenate = {exports: {}};

var hasRequiredHyphenate;

function requireHyphenate () {
	if (hasRequiredHyphenate) return hyphenate.exports;
	hasRequiredHyphenate = 1;
	(function (module, exports) {

		exports.__esModule = true;
		exports.default = hyphenate;
		var rUpper = /([A-Z])/g;

		function hyphenate(string) {
		  return string.replace(rUpper, '-$1').toLowerCase();
		}

		module.exports = exports["default"];
} (hyphenate, hyphenate.exports));
	return hyphenate.exports;
}

var hasRequiredHyphenateStyle;

function requireHyphenateStyle () {
	if (hasRequiredHyphenateStyle) return hyphenateStyle.exports;
	hasRequiredHyphenateStyle = 1;
	(function (module, exports) {

		var _interopRequireDefault = interopRequireDefault.exports;

		exports.__esModule = true;
		exports.default = hyphenateStyleName;

		var _hyphenate = _interopRequireDefault(requireHyphenate());

		/**
		 * Copyright 2013-2014, Facebook, Inc.
		 * All rights reserved.
		 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
		 */
		var msPattern = /^ms-/;

		function hyphenateStyleName(string) {
		  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
		}

		module.exports = exports["default"];
} (hyphenateStyle, hyphenateStyle.exports));
	return hyphenateStyle.exports;
}

var getComputedStyle = {exports: {}};

var hasRequiredGetComputedStyle;

function requireGetComputedStyle () {
	if (hasRequiredGetComputedStyle) return getComputedStyle.exports;
	hasRequiredGetComputedStyle = 1;
	(function (module, exports) {

		var _interopRequireDefault = interopRequireDefault.exports;

		exports.__esModule = true;
		exports.default = _getComputedStyle;

		var _camelizeStyle = _interopRequireDefault(requireCamelizeStyle());

		var rposition = /^(top|right|bottom|left)$/;
		var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

		function _getComputedStyle(node) {
		  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
		  var doc = node.ownerDocument;
		  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
		    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
		    getPropertyValue: function getPropertyValue(prop) {
		      var style = node.style;
		      prop = (0, _camelizeStyle.default)(prop);
		      if (prop == 'float') prop = 'styleFloat';
		      var current = node.currentStyle[prop] || null;
		      if (current == null && style && style[prop]) current = style[prop];

		      if (rnumnonpx.test(current) && !rposition.test(prop)) {
		        // Remember the original values
		        var left = style.left;
		        var runStyle = node.runtimeStyle;
		        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

		        if (rsLeft) runStyle.left = node.currentStyle.left;
		        style.left = prop === 'fontSize' ? '1em' : current;
		        current = style.pixelLeft + 'px'; // Revert the changed values

		        style.left = left;
		        if (rsLeft) runStyle.left = rsLeft;
		      }

		      return current;
		    }
		  };
		}

		module.exports = exports["default"];
} (getComputedStyle, getComputedStyle.exports));
	return getComputedStyle.exports;
}

var removeStyle = {exports: {}};

var hasRequiredRemoveStyle;

function requireRemoveStyle () {
	if (hasRequiredRemoveStyle) return removeStyle.exports;
	hasRequiredRemoveStyle = 1;
	(function (module, exports) {

		exports.__esModule = true;
		exports.default = removeStyle;

		function removeStyle(node, key) {
		  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
		}

		module.exports = exports["default"];
} (removeStyle, removeStyle.exports));
	return removeStyle.exports;
}

var properties = {};

var inDOM = {exports: {}};

var hasRequiredInDOM;

function requireInDOM () {
	if (hasRequiredInDOM) return inDOM.exports;
	hasRequiredInDOM = 1;
	(function (module, exports) {

		exports.__esModule = true;
		exports.default = void 0;

		var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

		exports.default = _default;
		module.exports = exports["default"];
} (inDOM, inDOM.exports));
	return inDOM.exports;
}

var _interopRequireDefault$2 = interopRequireDefault.exports;

properties.__esModule = true;
properties.default = properties.animationEnd = properties.animationDelay = properties.animationTiming = properties.animationDuration = properties.animationName = properties.transitionEnd = properties.transitionDuration = properties.transitionDelay = properties.transitionTiming = properties.transitionProperty = properties.transform = void 0;

var _inDOM = _interopRequireDefault$2(requireInDOM());

var transform = 'transform';
properties.transform = transform;
var prefix$2, transitionEnd, animationEnd;
properties.animationEnd = animationEnd;
properties.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
properties.transitionDelay = transitionDelay;
properties.transitionTiming = transitionTiming;
properties.transitionDuration = transitionDuration;
properties.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
properties.animationDelay = animationDelay;
properties.animationTiming = animationTiming;
properties.animationDuration = animationDuration;
properties.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix$2 = _getTransitionPropert.prefix;
  properties.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  properties.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  properties.transform = transform = prefix$2 + "-" + transform;
  properties.transitionProperty = transitionProperty = prefix$2 + "-transition-property";
  properties.transitionDuration = transitionDuration = prefix$2 + "-transition-duration";
  properties.transitionDelay = transitionDelay = prefix$2 + "-transition-delay";
  properties.transitionTiming = transitionTiming = prefix$2 + "-transition-timing-function";
  properties.animationName = animationName = prefix$2 + "-animation-name";
  properties.animationDuration = animationDuration = prefix$2 + "-animation-duration";
  properties.animationTiming = animationTiming = prefix$2 + "-animation-delay";
  properties.animationDelay = animationDelay = prefix$2 + "-animation-timing-function";
}

var _default$1 = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
properties.default = _default$1;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

var isTransform = {exports: {}};

var hasRequiredIsTransform;

function requireIsTransform () {
	if (hasRequiredIsTransform) return isTransform.exports;
	hasRequiredIsTransform = 1;
	(function (module, exports) {

		exports.__esModule = true;
		exports.default = isTransform;
		var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

		function isTransform(property) {
		  return !!(property && supportedTransforms.test(property));
		}

		module.exports = exports["default"];
} (isTransform, isTransform.exports));
	return isTransform.exports;
}

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefault.exports;

	exports.__esModule = true;
	exports.default = style;

	var _camelizeStyle = _interopRequireDefault(requireCamelizeStyle());

	var _hyphenateStyle = _interopRequireDefault(requireHyphenateStyle());

	var _getComputedStyle2 = _interopRequireDefault(requireGetComputedStyle());

	var _removeStyle = _interopRequireDefault(requireRemoveStyle());

	var _properties = properties;

	var _isTransform = _interopRequireDefault(requireIsTransform());

	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;

	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }

	  Object.keys(props).forEach(function (key) {
	    var value = props[key];

	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });

	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }

	  node.style.cssText += ';' + css;
	}

	module.exports = exports["default"];
} (style, style.exports));

var $k7QOs$domhelpersstyle = /*@__PURE__*/getDefaultExportFromCjs(style.exports);

var offset = {exports: {}};

var contains = {exports: {}};

var hasRequiredContains;

function requireContains () {
	if (hasRequiredContains) return contains.exports;
	hasRequiredContains = 1;
	(function (module, exports) {

		var _interopRequireDefault = interopRequireDefault.exports;

		exports.__esModule = true;
		exports.default = void 0;

		var _inDOM = _interopRequireDefault(requireInDOM());

		var _default = function () {
		  // HTML DOM and SVG DOM may have different support levels,
		  // so we need to check on context instead of a document root element.
		  return _inDOM.default ? function (context, node) {
		    if (context.contains) {
		      return context.contains(node);
		    } else if (context.compareDocumentPosition) {
		      return context === node || !!(context.compareDocumentPosition(node) & 16);
		    } else {
		      return fallback(context, node);
		    }
		  } : fallback;
		}();

		exports.default = _default;

		function fallback(context, node) {
		  if (node) do {
		    if (node === context) return true;
		  } while (node = node.parentNode);
		  return false;
		}

		module.exports = exports["default"];
} (contains, contains.exports));
	return contains.exports;
}

var isWindow = {exports: {}};

var hasRequiredIsWindow;

function requireIsWindow () {
	if (hasRequiredIsWindow) return isWindow.exports;
	hasRequiredIsWindow = 1;
	(function (module, exports) {

		exports.__esModule = true;
		exports.default = getWindow;

		function getWindow(node) {
		  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
		}

		module.exports = exports["default"];
} (isWindow, isWindow.exports));
	return isWindow.exports;
}

var ownerDocument = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports.default = ownerDocument;

	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}

	module.exports = exports["default"];
} (ownerDocument, ownerDocument.exports));

var $k7QOs$domhelpersownerDocument = /*@__PURE__*/getDefaultExportFromCjs(ownerDocument.exports);

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefault.exports;

	exports.__esModule = true;
	exports.default = offset;

	var _contains = _interopRequireDefault(requireContains());

	var _isWindow = _interopRequireDefault(requireIsWindow());

	var _ownerDocument = _interopRequireDefault(ownerDocument.exports);

	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node

	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}

	module.exports = exports["default"];
} (offset, offset.exports));

var $k7QOs$domhelpersqueryoffset = /*@__PURE__*/getDefaultExportFromCjs(offset.exports);

var position = {exports: {}};

var _extends$3 = {exports: {}};

var hasRequired_extends;

function require_extends () {
	if (hasRequired_extends) return _extends$3.exports;
	hasRequired_extends = 1;
	(function (module) {
		function _extends() {
		  module.exports = _extends = Object.assign || function (target) {
		    for (var i = 1; i < arguments.length; i++) {
		      var source = arguments[i];

		      for (var key in source) {
		        if (Object.prototype.hasOwnProperty.call(source, key)) {
		          target[key] = source[key];
		        }
		      }
		    }

		    return target;
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
		  return _extends.apply(this, arguments);
		}

		module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (_extends$3));
	return _extends$3.exports;
}

var offsetParent = {exports: {}};

var hasRequiredOffsetParent;

function requireOffsetParent () {
	if (hasRequiredOffsetParent) return offsetParent.exports;
	hasRequiredOffsetParent = 1;
	(function (module, exports) {

		var _interopRequireDefault = interopRequireDefault.exports;

		exports.__esModule = true;
		exports.default = offsetParent;

		var _ownerDocument = _interopRequireDefault(ownerDocument.exports);

		var _style = _interopRequireDefault(style.exports);

		function nodeName(node) {
		  return node.nodeName && node.nodeName.toLowerCase();
		}

		function offsetParent(node) {
		  var doc = (0, _ownerDocument.default)(node),
		      offsetParent = node && node.offsetParent;

		  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
		    offsetParent = offsetParent.offsetParent;
		  }

		  return offsetParent || doc.documentElement;
		}

		module.exports = exports["default"];
} (offsetParent, offsetParent.exports));
	return offsetParent.exports;
}

var scrollTop = {exports: {}};

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefault.exports;

	exports.__esModule = true;
	exports.default = scrollTop;

	var _isWindow = _interopRequireDefault(requireIsWindow());

	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}

	module.exports = exports["default"];
} (scrollTop, scrollTop.exports));

var $k7QOs$domhelpersqueryscrollTop = /*@__PURE__*/getDefaultExportFromCjs(scrollTop.exports);

var scrollLeft = {exports: {}};

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefault.exports;

	exports.__esModule = true;
	exports.default = scrollTop;

	var _isWindow = _interopRequireDefault(requireIsWindow());

	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}

	module.exports = exports["default"];
} (scrollLeft, scrollLeft.exports));

var $k7QOs$domhelpersqueryscrollLeft = /*@__PURE__*/getDefaultExportFromCjs(scrollLeft.exports);

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefault.exports;

	exports.__esModule = true;
	exports.default = position;

	var _extends2 = _interopRequireDefault(require_extends());

	var _offset = _interopRequireDefault(offset.exports);

	var _offsetParent = _interopRequireDefault(requireOffsetParent());

	var _scrollTop = _interopRequireDefault(scrollTop.exports);

	var _scrollLeft = _interopRequireDefault(scrollLeft.exports);

	var _style = _interopRequireDefault(style.exports);

	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}

	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent

	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins


	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}

	module.exports = exports["default"];
} (position, position.exports));

var $k7QOs$domhelpersqueryposition = /*@__PURE__*/getDefaultExportFromCjs(position.exports);

function $parcel$export$n(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault$7(a) {
  return a && a.__esModule ? a.default : a;
}
var $2a41e45df1593e64$exports = {};

$parcel$export$n($2a41e45df1593e64$exports, "useOverlayPosition", () => $2a41e45df1593e64$export$d39e1813b3bdd0e1);






const $edcf132a9284368a$var$AXIS = {
    top: 'top',
    bottom: 'top',
    left: 'left',
    right: 'left'
};
const $edcf132a9284368a$var$FLIPPED_DIRECTION = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $edcf132a9284368a$var$CROSS_AXIS = {
    top: 'left',
    left: 'top'
};
const $edcf132a9284368a$var$AXIS_SIZE = {
    top: 'height',
    left: 'width'
};
const $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {
};
// @ts-ignore
let $edcf132a9284368a$var$visualViewport = typeof window !== 'undefined' && window.visualViewport;
function $edcf132a9284368a$var$getContainerDimensions(containerNode) {
    let width = 0, height = 0, top = 0, left = 0;
    let scroll = {
    };
    if (containerNode.tagName === 'BODY') {
        var ref;
        width = (ref = $edcf132a9284368a$var$visualViewport === null || $edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $edcf132a9284368a$var$visualViewport.width) !== null && ref !== void 0 ? ref : document.documentElement.clientWidth;
        var ref1;
        height = (ref1 = $edcf132a9284368a$var$visualViewport === null || $edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $edcf132a9284368a$var$visualViewport.height) !== null && ref1 !== void 0 ? ref1 : document.documentElement.clientHeight;
        scroll.top = $k7QOs$domhelpersqueryscrollTop($k7QOs$domhelpersownerDocument(containerNode).documentElement) || $k7QOs$domhelpersqueryscrollTop(containerNode);
        scroll.left = $k7QOs$domhelpersqueryscrollLeft($k7QOs$domhelpersownerDocument(containerNode).documentElement) || $k7QOs$domhelpersqueryscrollLeft(containerNode);
    } else {
        ({ width: width , height: height , top: top , left: left  } = $k7QOs$domhelpersqueryoffset(containerNode));
        scroll.top = $k7QOs$domhelpersqueryscrollTop(containerNode);
        scroll.left = $k7QOs$domhelpersqueryscrollLeft(containerNode);
    }
    return {
        width: width,
        height: height,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $edcf132a9284368a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
function $edcf132a9284368a$var$getDelta(axis, offset, size, containerDimensions, padding) {
    let containerScroll = containerDimensions.scroll[axis];
    let containerHeight = containerDimensions[$edcf132a9284368a$var$AXIS_SIZE[axis]];
    let startEdgeOffset = offset - padding - containerScroll;
    let endEdgeOffset = offset + padding - containerScroll + size;
    if (startEdgeOffset < 0) return -startEdgeOffset;
    else if (endEdgeOffset > containerHeight) return Math.max(containerHeight - endEdgeOffset, -startEdgeOffset);
    else return 0;
}
function $edcf132a9284368a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $edcf132a9284368a$var$parsePlacement(input) {
    if ($edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(' ');
    let axis = $edcf132a9284368a$var$AXIS[placement] || 'right';
    let crossAxis = $edcf132a9284368a$var$CROSS_AXIS[axis];
    if (!$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = 'center';
    let size = $edcf132a9284368a$var$AXIS_SIZE[axis];
    let crossSize = $edcf132a9284368a$var$AXIS_SIZE[crossAxis];
    $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned) {
    let { placement: placement , crossPlacement: crossPlacement , axis: axis , crossAxis: crossAxis , size: size , crossSize: crossSize  } = placementInfo;
    let position = {
    };
    // button position
    position[crossAxis] = childOffset[crossAxis];
    if (crossPlacement === 'center') //  + (button size / 2) - (overlay size / 2)
    // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
    else if (crossPlacement !== crossAxis) //  + (button size) - (overlay size)
    // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
     /* else {
    the overlay top should match the button top
  } */ 
    // add the crossOffset from props
    position[crossAxis] += crossOffset;
    // this is button center position - the overlay size + half of the button to align bottom of overlay with button center
    let minViablePosition = childOffset[crossAxis] + childOffset[crossSize] / 2 - overlaySize[crossSize];
    // this is button position of center, aligns top of overlay with button center
    let maxViablePosition = childOffset[crossAxis] + childOffset[crossSize] / 2;
    // clamp it into the range of the min/max positions
    position[crossAxis] = Math.min(Math.max(minViablePosition, position[crossAxis]), maxViablePosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[size];
        position[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding) {
    return position.top != null ? Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top - (containerOffsetWithBoundary.top + position.top) - (margins.top + margins.bottom + padding) // save additional space for margin and padding
    ) : Math.max(0, childOffset.top + containerOffsetWithBoundary.top - (boundaryDimensions.top + boundaryDimensions.scroll.top) - (margins.top + margins.bottom + padding) // save additional space for margin and padding
    );
}
function $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    let { placement: placement , axis: axis , size: size  } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $edcf132a9284368a$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight) {
    let placementInfo = $edcf132a9284368a$var$parsePlacement(placementInput);
    let { size: size , crossAxis: crossAxis , crossSize: crossSize , placement: placement , crossPlacement: crossPlacement  } = placementInfo;
    let position = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
    let normalizedOffset = offset;
    let space = $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        let flippedPlacementInfo = $edcf132a9284368a$var$parsePlacement(`${$edcf132a9284368a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
        let flippedSpace = $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    let delta = $edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
    position[crossAxis] += delta;
    let maxHeight = $edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned);
    delta = $edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
    position[crossAxis] += delta;
    let arrowPosition = {
    };
    arrowPosition[crossAxis] = childOffset[crossAxis] - position[crossAxis] + childOffset[crossSize] / 2;
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function $edcf132a9284368a$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement , targetNode: targetNode , overlayNode: overlayNode , scrollNode: scrollNode , padding: padding , shouldFlip: shouldFlip , boundaryElement: boundaryElement , offset: offset , crossOffset: crossOffset , maxHeight: maxHeight  } = opts;
    let container = overlayNode.offsetParent || document.body;
    let isBodyContainer = container.tagName === 'BODY';
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== 'static';
    let childOffset = isBodyContainer ? $k7QOs$domhelpersqueryoffset(targetNode) : $k7QOs$domhelpersqueryposition(targetNode, container);
    if (!isBodyContainer) {
        childOffset.top += parseInt($k7QOs$domhelpersstyle(targetNode, 'marginTop'), 10) || 0;
        childOffset.left += parseInt($k7QOs$domhelpersstyle(targetNode, 'marginLeft'), 10) || 0;
    }
    let overlaySize = $k7QOs$domhelpersqueryoffset(overlayNode);
    let margins = $edcf132a9284368a$var$getMargins(overlayNode);
    overlaySize.width += margins.left + margins.right;
    overlaySize.height += margins.top + margins.bottom;
    let scrollSize = $edcf132a9284368a$var$getScroll(scrollNode);
    let boundaryDimensions = $edcf132a9284368a$var$getContainerDimensions(boundaryElement);
    let containerOffsetWithBoundary = boundaryElement.tagName === 'BODY' ? $k7QOs$domhelpersqueryoffset(container) : $k7QOs$domhelpersqueryposition(container, boundaryElement);
    return $edcf132a9284368a$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight);
}




const $dd149f63282afbbf$export$f6211563215e3b37 = new WeakMap();
function $dd149f63282afbbf$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef , isOpen: isOpen , onClose: onClose  } = opts;
    useEffect(()=>{
        if (!isOpen) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || $dd149f63282afbbf$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener('scroll', onScroll, true);
        return ()=>{
            window.removeEventListener('scroll', onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}




// @ts-ignore
let $2a41e45df1593e64$var$visualViewport = typeof window !== 'undefined' && window.visualViewport;
function $2a41e45df1593e64$export$d39e1813b3bdd0e1(props) {
    let { direction: direction  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let { targetRef: targetRef , overlayRef: overlayRef , scrollRef: scrollRef = overlayRef , placement: placement = 'bottom' , containerPadding: containerPadding = 12 , shouldFlip: shouldFlip = true , boundaryElement: boundaryElement = typeof document !== 'undefined' ? document.body : null , offset: offset = 0 , crossOffset: crossOffset = 0 , shouldUpdatePosition: shouldUpdatePosition = true , isOpen: isOpen = true , onClose: onClose , maxHeight: maxHeight  } = props;
    let [position, setPosition] = useState({
        position: {
        },
        arrowOffsetLeft: undefined,
        arrowOffsetTop: undefined,
        maxHeight: undefined,
        placement: undefined
    });
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight
    ];
    let updatePosition = useCallback(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
        setPosition($edcf132a9284368a$export$b3ceb0cbf1056d98({
            placement: $2a41e45df1593e64$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight
        }));
    }, deps);
    // Update position when anything changes
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(updatePosition, deps);
    // Update position on window resize
    $2a41e45df1593e64$var$useResize(updatePosition);
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = useRef(false);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        $2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.addEventListener('resize', onResize);
        return ()=>{
            $2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.removeEventListener('resize', onResize);
        };
    }, [
        updatePosition
    ]);
    let close = useCallback(()=>{
        if (!isResizing.current) onClose();
    }, [
        onClose,
        isResizing
    ]);
    // When scrolling a parent scrollable region of the trigger (other than the body),
    // we hide the popover. Otherwise, its position would be incorrect.
    $dd149f63282afbbf$export$18fc8428861184da({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose ? close : undefined
    });
    return {
        overlayProps: {
            style: {
                position: 'absolute',
                zIndex: 100000,
                ...position.position,
                maxHeight: position.maxHeight
            }
        },
        placement: position.placement,
        arrowProps: {
            style: {
                left: position.arrowOffsetLeft,
                top: position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $2a41e45df1593e64$var$useResize(onResize) {
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        window.addEventListener('resize', onResize, false);
        return ()=>{
            window.removeEventListener('resize', onResize, false);
        };
    }, [
        onResize
    ]);
}
function $2a41e45df1593e64$var$translateRTL(position, direction) {
    if (direction === 'rtl') return position.replace('start', 'right').replace('end', 'left');
    return position.replace('start', 'left').replace('end', 'right');
}


var $a11501f3d1d39e6c$exports = {};

$parcel$export$n($a11501f3d1d39e6c$exports, "useOverlay", () => $a11501f3d1d39e6c$export$ea8f71083e90600f);


const $a11501f3d1d39e6c$var$visibleOverlays = [];
function $a11501f3d1d39e6c$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose , shouldCloseOnBlur: shouldCloseOnBlur , isOpen: isOpen , isDismissable: isDismissable = false , isKeyboardDismissDisabled: isKeyboardDismissDisabled = false , shouldCloseOnInteractOutside: shouldCloseOnInteractOutside  } = props;
    // Add the overlay ref to the stack of visible overlays on mount, and remove on unmount.
    useEffect(()=>{
        if (isOpen) $a11501f3d1d39e6c$var$visibleOverlays.push(ref);
        return ()=>{
            let index = $a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
            if (index >= 0) $a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack.
    let onHide = ()=>{
        if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === 'Escape' && !isKeyboardDismissDisabled) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    // Handle clicking outside the overlay to close it
    $e0b6e0b68ec7f50f$export$872b660ac5a1ff98({
        ref: ref,
        onInteractOutside: isDismissable ? onInteractOutside : null,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps  } = $9ab94262bd0047c7$export$420e68273165f4ec({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}


var $628037886ba31236$exports = {};

$parcel$export$n($628037886ba31236$exports, "useOverlayTrigger", () => $628037886ba31236$export$f9d5c8beee7d008d);



function $628037886ba31236$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type  } = props;
    let { isOpen: isOpen  } = state;
    // Backward compatibility. Share state close function with useOverlayPosition so it can close on scroll
    // without forcing users to pass onClose.
    useEffect(()=>{
        if (ref && ref.current) $dd149f63282afbbf$export$f6211563215e3b37.set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === 'menu') ariaHasPopup = true;
    else if (type === 'listbox') ariaHasPopup = 'listbox';
    let overlayId = $bdb11010cef70236$export$f680877a34711e37();
    return {
        triggerProps: {
            'aria-haspopup': ariaHasPopup,
            'aria-expanded': isOpen,
            'aria-controls': isOpen ? overlayId : null
        },
        overlayProps: {
            id: overlayId
        }
    };
}


var $49c51c25361d4cd2$exports = {};

$parcel$export$n($49c51c25361d4cd2$exports, "usePreventScroll", () => $49c51c25361d4cd2$export$ee0f7cc6afcd1c18);

// @ts-ignore
const $49c51c25361d4cd2$var$visualViewport = typeof window !== 'undefined' && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const $49c51c25361d4cd2$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $49c51c25361d4cd2$export$ee0f7cc6afcd1c18(options = {
}) {
    let { isDisabled: isDisabled  } = options;
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        if (isDisabled) return;
        if ($c87311424ea30a05$export$fedb369cb70207f1()) return $49c51c25361d4cd2$var$preventScrollMobileSafari();
        else return $49c51c25361d4cd2$var$preventScrollStandard();
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $49c51c25361d4cd2$var$preventScrollStandard() {
    return $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, 'overflow', 'hidden'));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Prevent default on `touchmove` events inside a scrollable element when the scroll position is at the
//    top or bottom. This avoids the whole page scrolling instead, but does prevent overscrolling.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $49c51c25361d4cd2$var$preventScrollMobileSafari() {
    let scrollable;
    let lastY = 0;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = $62d8ded9296f3872$export$cfa2225e87938781(e.target);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        lastY = e.changedTouches[0].pageY;
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead. Unfortunately, this disables bounce scrolling when at
        // the top but it's the best we can do.
        let y = e.changedTouches[0].pageY;
        let scrollTop = scrollable.scrollTop;
        let bottom = scrollable.scrollHeight - scrollable.clientHeight;
        if (scrollTop <= 0 && y > lastY || scrollTop >= bottom && y < lastY) e.preventDefault();
        lastY = y;
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if ($49c51c25361d4cd2$var$willOpenKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = 'translateY(-2000px)';
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = '';
            });
        }
    };
    let onFocus = (e)=>{
        let target = e.target;
        if ($49c51c25361d4cd2$var$willOpenKeyboard(target)) {
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = 'translateY(-2000px)';
            requestAnimationFrame(()=>{
                target.style.transform = '';
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($49c51c25361d4cd2$var$visualViewport) {
                    if ($49c51c25361d4cd2$var$visualViewport.height < window.innerHeight) // If the keyboard is already visible, do this after one additional frame
                    // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $49c51c25361d4cd2$var$scrollIntoView(target);
                    });
                    else // Otherwise, wait for the visual viewport to resize before scrolling so we can
                    // measure the correct position to scroll to.
                    $49c51c25361d4cd2$var$visualViewport.addEventListener('resize', ()=>$49c51c25361d4cd2$var$scrollIntoView(target)
                    , {
                        once: true
                    });
                }
            });
        }
    };
    let onWindowScroll = ()=>{
        // Last resort. If the window scrolled, scroll it back to the top.
        // It should always be at the top because the body will have a negative margin (see below).
        window.scrollTo(0, 0);
    };
    // Record the original scroll position so we can restore it.
    // Then apply a negative margin to the body to offset it by the scroll position. This will
    // enable us to scroll the window to the top, which is required for the rest of this to work.
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    let restoreStyles = $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, 'overflow', 'hidden'), $49c51c25361d4cd2$var$setStyle(document.body, 'marginTop', `-${scrollY}px`));
    // Scroll to the top. The negative margin on the body will make this appear the same.
    window.scrollTo(0, 0);
    let removeEvents = $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$addEvent(document, 'touchstart', onTouchStart, {
        passive: false,
        capture: true
    }), $49c51c25361d4cd2$var$addEvent(document, 'touchmove', onTouchMove, {
        passive: false,
        capture: true
    }), $49c51c25361d4cd2$var$addEvent(document, 'touchend', onTouchEnd, {
        passive: false,
        capture: true
    }), $49c51c25361d4cd2$var$addEvent(document, 'focus', onFocus, true), $49c51c25361d4cd2$var$addEvent(window, 'scroll', onWindowScroll));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreStyles();
        removeEvents();
        window.scrollTo(scrollX, scrollY);
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $49c51c25361d4cd2$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    return ()=>{
        target.removeEventListener(event, handler, options);
    };
}
function $49c51c25361d4cd2$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = $62d8ded9296f3872$export$cfa2225e87938781(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        target = scrollable.parentElement;
    }
}
function $49c51c25361d4cd2$var$willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}


var $f57aed4a881a3485$exports = {};

$parcel$export$n($f57aed4a881a3485$exports, "ModalProvider", () => $f57aed4a881a3485$export$178405afcd8c5eb);
$parcel$export$n($f57aed4a881a3485$exports, "useModalProvider", () => $f57aed4a881a3485$export$d9aaed4c3ece1bc0);
$parcel$export$n($f57aed4a881a3485$exports, "OverlayProvider", () => $f57aed4a881a3485$export$bf688221f59024e5);
$parcel$export$n($f57aed4a881a3485$exports, "OverlayContainer", () => $f57aed4a881a3485$export$b47c3594eab58386);
$parcel$export$n($f57aed4a881a3485$exports, "useModal", () => $f57aed4a881a3485$export$33ffd74ebf07f060);


const $f57aed4a881a3485$var$Context = /*#__PURE__*/ React__default.createContext(null);
function $f57aed4a881a3485$export$178405afcd8c5eb(props) {
    let { children: children  } = props;
    let parent = useContext($f57aed4a881a3485$var$Context);
    let [modalCount, setModalCount] = useState(0);
    let context = useMemo(()=>({
            parent: parent,
            modalCount: modalCount,
            addModal () {
                setModalCount((count)=>count + 1
                );
                if (parent) parent.addModal();
            },
            removeModal () {
                setModalCount((count)=>count - 1
                );
                if (parent) parent.removeModal();
            }
        })
    , [
        parent,
        modalCount
    ]);
    return(/*#__PURE__*/ React__default.createElement($f57aed4a881a3485$var$Context.Provider, {
        value: context
    }, children));
}
function $f57aed4a881a3485$export$d9aaed4c3ece1bc0() {
    let context = useContext($f57aed4a881a3485$var$Context);
    return {
        modalProviderProps: {
            'aria-hidden': context && context.modalCount > 0 ? true : null
        }
    };
}
/**
 * Creates a root node that will be aria-hidden if there are other modals open.
 */ function $f57aed4a881a3485$var$OverlayContainerDOM(props) {
    let { modalProviderProps: modalProviderProps  } = $f57aed4a881a3485$export$d9aaed4c3ece1bc0();
    return(/*#__PURE__*/ React__default.createElement("div", {
        "data-overlay-container": true,
        ...props,
        ...modalProviderProps
    }));
}
function $f57aed4a881a3485$export$bf688221f59024e5(props) {
    return(/*#__PURE__*/ React__default.createElement($f57aed4a881a3485$export$178405afcd8c5eb, null, /*#__PURE__*/ React__default.createElement($f57aed4a881a3485$var$OverlayContainerDOM, props)));
}
function $f57aed4a881a3485$export$b47c3594eab58386(props) {
    let { portalContainer: portalContainer = document.body , ...rest } = props;
    React__default.useEffect(()=>{
        if (portalContainer.closest('[data-overlay-container]')) throw new Error('An OverlayContainer must not be inside another container. Please change the portalContainer prop.');
    }, [
        portalContainer
    ]);
    let contents = /*#__PURE__*/ React__default.createElement($f57aed4a881a3485$export$bf688221f59024e5, rest);
    return(/*#__PURE__*/ $9Q8De$reactdom.createPortal(contents, portalContainer));
}
function $f57aed4a881a3485$export$33ffd74ebf07f060(options) {
    // Add aria-hidden to all parent providers on mount, and restore on unmount.
    let context = useContext($f57aed4a881a3485$var$Context);
    if (!context) throw new Error('Modal is not contained within a provider');
    useEffect(()=>{
        if ((options === null || options === void 0 ? void 0 : options.isDisabled) || !context || !context.parent) return;
        // The immediate context is from the provider containing this modal, so we only
        // want to trigger aria-hidden on its parents not on the modal provider itself.
        context.parent.addModal();
        return ()=>{
            if (context && context.parent) context.parent.removeModal();
        };
    }, [
        context,
        context.parent,
        options === null || options === void 0 ? void 0 : options.isDisabled
    ]);
    return {
        modalProps: {
            'data-ismodal': !(options === null || options === void 0 ? void 0 : options.isDisabled)
        }
    };
}


var $86ea4cb521eb2e37$exports = {};

$parcel$export$n($86ea4cb521eb2e37$exports, "DismissButton", () => $86ea4cb521eb2e37$export$2317d149ed6f78c4);
var $61fe14465afefc5e$exports = {};
var $773d5888b972f1cf$exports = {};
$773d5888b972f1cf$exports = JSON.parse("{\"dismiss\":\"تجاهل\"}");


var $d11f19852b941573$exports = {};
$d11f19852b941573$exports = JSON.parse("{\"dismiss\":\"Отхвърляне\"}");


var $b983974c2ee1efb3$exports = {};
$b983974c2ee1efb3$exports = JSON.parse("{\"dismiss\":\"Odstranit\"}");


var $5809cc9d4e92de73$exports = {};
$5809cc9d4e92de73$exports = JSON.parse("{\"dismiss\":\"Luk\"}");


var $c68c2e4fc74398d1$exports = {};
$c68c2e4fc74398d1$exports = JSON.parse("{\"dismiss\":\"Schließen\"}");


var $0898b4c153db2b77$exports = {};
$0898b4c153db2b77$exports = JSON.parse("{\"dismiss\":\"Απόρριψη\"}");


var $6d74810286a15183$exports = {};
$6d74810286a15183$exports = JSON.parse("{\"dismiss\":\"Dismiss\"}");


var $309d73dc65f78055$exports = {};
$309d73dc65f78055$exports = JSON.parse("{\"dismiss\":\"Descartar\"}");


var $44ad94f7205cf593$exports = {};
$44ad94f7205cf593$exports = JSON.parse("{\"dismiss\":\"Lõpeta\"}");


var $7c28f5687f0779a9$exports = {};
$7c28f5687f0779a9$exports = JSON.parse("{\"dismiss\":\"Hylkää\"}");


var $e6d75df4b68bd73a$exports = {};
$e6d75df4b68bd73a$exports = JSON.parse("{\"dismiss\":\"Rejeter\"}");


var $87505c9dab186d0f$exports = {};
$87505c9dab186d0f$exports = JSON.parse("{\"dismiss\":\"התעלם\"}");


var $553439c3ffb3e492$exports = {};
$553439c3ffb3e492$exports = JSON.parse("{\"dismiss\":\"Odbaci\"}");


var $74cf411061b983a2$exports = {};
$74cf411061b983a2$exports = JSON.parse("{\"dismiss\":\"Elutasítás\"}");


var $e933f298574dc435$exports = {};
$e933f298574dc435$exports = JSON.parse("{\"dismiss\":\"Ignora\"}");


var $ac91fc9fe02f71f6$exports = {};
$ac91fc9fe02f71f6$exports = JSON.parse("{\"dismiss\":\"閉じる\"}");


var $52b96f86422025af$exports = {};
$52b96f86422025af$exports = JSON.parse("{\"dismiss\":\"무시\"}");


var $c0d724c3e51dafa6$exports = {};
$c0d724c3e51dafa6$exports = JSON.parse("{\"dismiss\":\"Atmesti\"}");


var $c92899672a3fe72e$exports = {};
$c92899672a3fe72e$exports = JSON.parse("{\"dismiss\":\"Nerādīt\"}");


var $9f576b39d8e7a9d6$exports = {};
$9f576b39d8e7a9d6$exports = JSON.parse("{\"dismiss\":\"Lukk\"}");


var $9d025808aeec81a7$exports = {};
$9d025808aeec81a7$exports = JSON.parse("{\"dismiss\":\"Negeren\"}");


var $fce709921e2c0fa6$exports = {};
$fce709921e2c0fa6$exports = JSON.parse("{\"dismiss\":\"Zignoruj\"}");


var $2599cf0c4ab37f59$exports = {};
$2599cf0c4ab37f59$exports = JSON.parse("{\"dismiss\":\"Descartar\"}");


var $3c220ae7ef8a35fd$exports = {};
$3c220ae7ef8a35fd$exports = JSON.parse("{\"dismiss\":\"Dispensar\"}");


var $93562b5094072f54$exports = {};
$93562b5094072f54$exports = JSON.parse("{\"dismiss\":\"Revocare\"}");


var $cd9e2abd0d06c7b4$exports = {};
$cd9e2abd0d06c7b4$exports = JSON.parse("{\"dismiss\":\"Пропустить\"}");


var $45375701f409adf1$exports = {};
$45375701f409adf1$exports = JSON.parse("{\"dismiss\":\"Zrušiť\"}");


var $27fab53a576de9dd$exports = {};
$27fab53a576de9dd$exports = JSON.parse("{\"dismiss\":\"Opusti\"}");


var $4438748d9952e7c7$exports = {};
$4438748d9952e7c7$exports = JSON.parse("{\"dismiss\":\"Odbaci\"}");


var $0936d7347ef4da4c$exports = {};
$0936d7347ef4da4c$exports = JSON.parse("{\"dismiss\":\"Avvisa\"}");


var $29700c92185d38f8$exports = {};
$29700c92185d38f8$exports = JSON.parse("{\"dismiss\":\"Kapat\"}");


var $662ccaf2be4c25b3$exports = {};
$662ccaf2be4c25b3$exports = JSON.parse("{\"dismiss\":\"Скасувати\"}");


var $d80a27deda7cdb3c$exports = {};
$d80a27deda7cdb3c$exports = JSON.parse("{\"dismiss\":\"取消\"}");


var $2b2734393847c884$exports = {};
$2b2734393847c884$exports = JSON.parse("{\"dismiss\":\"關閉\"}");


$61fe14465afefc5e$exports = {
    "ar-AE": $773d5888b972f1cf$exports,
    "bg-BG": $d11f19852b941573$exports,
    "cs-CZ": $b983974c2ee1efb3$exports,
    "da-DK": $5809cc9d4e92de73$exports,
    "de-DE": $c68c2e4fc74398d1$exports,
    "el-GR": $0898b4c153db2b77$exports,
    "en-US": $6d74810286a15183$exports,
    "es-ES": $309d73dc65f78055$exports,
    "et-EE": $44ad94f7205cf593$exports,
    "fi-FI": $7c28f5687f0779a9$exports,
    "fr-FR": $e6d75df4b68bd73a$exports,
    "he-IL": $87505c9dab186d0f$exports,
    "hr-HR": $553439c3ffb3e492$exports,
    "hu-HU": $74cf411061b983a2$exports,
    "it-IT": $e933f298574dc435$exports,
    "ja-JP": $ac91fc9fe02f71f6$exports,
    "ko-KR": $52b96f86422025af$exports,
    "lt-LT": $c0d724c3e51dafa6$exports,
    "lv-LV": $c92899672a3fe72e$exports,
    "nb-NO": $9f576b39d8e7a9d6$exports,
    "nl-NL": $9d025808aeec81a7$exports,
    "pl-PL": $fce709921e2c0fa6$exports,
    "pt-BR": $2599cf0c4ab37f59$exports,
    "pt-PT": $3c220ae7ef8a35fd$exports,
    "ro-RO": $93562b5094072f54$exports,
    "ru-RU": $cd9e2abd0d06c7b4$exports,
    "sk-SK": $45375701f409adf1$exports,
    "sl-SI": $27fab53a576de9dd$exports,
    "sr-SP": $4438748d9952e7c7$exports,
    "sv-SE": $0936d7347ef4da4c$exports,
    "tr-TR": $29700c92185d38f8$exports,
    "uk-UA": $662ccaf2be4c25b3$exports,
    "zh-CN": $d80a27deda7cdb3c$exports,
    "zh-TW": $2b2734393847c884$exports
};






function $86ea4cb521eb2e37$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss , ...otherProps } = props;
    let formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault$7($61fe14465afefc5e$exports)));
    let labels = $313b98861ee5dd6c$export$d6875122194c7b44(otherProps, formatMessage('dismiss'));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return(/*#__PURE__*/ React__default.createElement($5c3e21d68f1c4674$export$439d29a4e110a164, null, /*#__PURE__*/ React__default.createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick
    })));
}


var $5e3802645cc19319$exports = {};

$parcel$export$n($5e3802645cc19319$exports, "ariaHideOutside", () => $5e3802645cc19319$export$1c3ebcada18427bf);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $5e3802645cc19319$var$refCountMap = new WeakMap();
function $5e3802645cc19319$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            // If this node is a live announcer, add it to the set of nodes to keep visible.
            if (node instanceof HTMLElement && node.dataset.liveAnnouncer === 'true') visibleNodes.add(node);
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive.
            if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement)) return NodeFilter.FILTER_REJECT;
            // VoiceOver on iOS has issues hiding elements with role="row". Hide the cells inside instead.
            // https://bugs.webkit.org/show_bug.cgi?id=222623
            if (node instanceof HTMLElement && node.getAttribute('role') === 'row') return NodeFilter.FILTER_SKIP;
            // Skip this node but continue to children if one of the targets is inside the node.
            if (targets.some((target)=>node.contains(target)
            )) return NodeFilter.FILTER_SKIP;
            return NodeFilter.FILTER_ACCEPT;
        }
    });
    let hide = (node)=>{
        var ref;
        let refCount = (ref = $5e3802645cc19319$var$refCountMap.get(node)) !== null && ref !== void 0 ? ref : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute('aria-hidden') === 'true' && refCount === 0) return;
        if (refCount === 0) node.setAttribute('aria-hidden', 'true');
        hiddenNodes.add(node);
        $5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
    };
    let node1 = walker.nextNode();
    while(node1 != null){
        hide(node1);
        node1 = walker.nextNode();
    }
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== 'childList' || change.addedNodes.length === 0) continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target)
            )) for (let node2 of change.addedNodes){
                if (node2 instanceof HTMLElement && node2.dataset.liveAnnouncer === 'true') visibleNodes.add(node2);
                else if (node2 instanceof Element) hide(node2);
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $5e3802645cc19319$var$refCountMap.get(node);
            if (count === 1) {
                node.removeAttribute('aria-hidden');
                $5e3802645cc19319$var$refCountMap.delete(node);
            } else $5e3802645cc19319$var$refCountMap.set(node, count - 1);
        }
    };
}

function $parcel$export$m(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $ae20dd8cbca75726$exports = {};

$parcel$export$m($ae20dd8cbca75726$exports, "useSelectableCollection", () => $ae20dd8cbca75726$export$d6daf82dcd84e87c);





function $feb5ffebff200149$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return $c87311424ea30a05$export$e1865c3bedcd822b() ? e.altKey : e.ctrlKey;
}
function $feb5ffebff200149$export$16792effe837dba3(e) {
    if ($c87311424ea30a05$export$9ac100e40613ea10()) return e.metaKey;
    return e.ctrlKey;
}



var $fb3050f43d946246$exports = {};

$parcel$export$m($fb3050f43d946246$exports, "useTypeSelect", () => $fb3050f43d946246$export$e32c88dfddc6e1d8);

function $fb3050f43d946246$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate , selectionManager: selectionManager , onTypeSelect: onTypeSelect  } = options;
    let state = useRef({
        search: '',
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === ' ' && state.search.trim().length > 0) {
            e.preventDefault();
            if (!('continuePropagation' in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = '';
        }, 500);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return '';
}


function $ae20dd8cbca75726$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager , keyboardDelegate: delegate , ref: ref , autoFocus: autoFocus = false , shouldFocusWrap: shouldFocusWrap = false , disallowEmptySelection: disallowEmptySelection = false , disallowSelectAll: disallowSelectAll = false , selectOnFocus: selectOnFocus = manager.selectionBehavior === 'replace' , disallowTypeAhead: disallowTypeAhead = false , shouldUseVirtualFocus: shouldUseVirtualFocus , allowsTabNavigation: allowsTabNavigation = false , isVirtualized: isVirtualized , scrollRef: // If no scrollRef is provided, assume the collection ref is the scrollable region
    scrollRef = ref  } = options;
    let { direction: direction  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === 'Tab') e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                manager.setFocusedKey(key, childFocus);
                if (e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(key);
                else if (selectOnFocus && !$feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case 'ArrowDown':
                if (delegate.getKeyBelow) {
                    var ref4, ref1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (ref4 = delegate.getFirstKey) === null || ref4 === void 0 ? void 0 : ref4.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (ref1 = delegate.getFirstKey) === null || ref1 === void 0 ? void 0 : ref1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case 'ArrowUp':
                if (delegate.getKeyAbove) {
                    var ref2, ref3;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (ref2 = delegate.getLastKey) === null || ref2 === void 0 ? void 0 : ref2.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (ref3 = delegate.getLastKey) === null || ref3 === void 0 ? void 0 : ref3.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case 'ArrowLeft':
                if (delegate.getKeyLeftOf) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyLeftOf(manager.focusedKey);
                    navigateToKey(nextKey, direction === 'rtl' ? 'first' : 'last');
                }
                break;
            case 'ArrowRight':
                if (delegate.getKeyRightOf) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyRightOf(manager.focusedKey);
                    navigateToKey(nextKey, direction === 'rtl' ? 'last' : 'first');
                }
                break;
            case 'Home':
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, $feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(firstKey);
                    if ($feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case 'End':
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, $feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(lastKey);
                    if ($feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case 'PageDown':
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case 'PageUp':
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case 'a':
                if ($feb5ffebff200149$export$16792effe837dba3(e) && manager.selectionMode === 'multiple' && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case 'Escape':
                e.preventDefault();
                if (!disallowEmptySelection) manager.clearSelection();
                break;
            case 'Tab':
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last)
                        if (next && !next.contains(document.activeElement)) $7215afc6de606d6b$export$de79e2c695e052f3(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = useRef({
        top: 0,
        left: 0
    });
    $e9faafb641e167db$export$90fc3a17d93f704c(scrollRef, 'scroll', isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _lastSelectedKey, _firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_lastSelectedKey = manager.lastSelectedKey) !== null && _lastSelectedKey !== void 0 ? _lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_firstSelectedKey = manager.firstSelectedKey) !== null && _firstSelectedKey !== void 0 ? _firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${manager.focusedKey}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection
                $7215afc6de606d6b$export$de79e2c695e052f3(element);
                $2f04cbc44ee30ce0$export$53a0910f038337bd(scrollRef.current, element);
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = useRef(autoFocus);
    useEffect(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === 'first') focusedKey = delegate.getFirstKey();
            if (autoFocus === 'last') focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) focusedKey = selectedKeys.values().next().value;
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) $6a99195332edec8b$export$80f3e147d781571c(ref.current);
        }
        autoFocusRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    useEffect(()=>{
        if (!isVirtualized && manager.focusedKey && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${manager.focusedKey}"]`);
            if (element) $2f04cbc44ee30ce0$export$53a0910f038337bd(scrollRef.current, element);
        }
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey
    ]);
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (e.currentTarget.contains(e.target)) // Prevent focus going to the collection when clicking on the scrollbar.
            e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps  } = $fb3050f43d946246$export$e32c88dfddc6e1d8({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = $3ef42575df84b30b$export$9d1611c77c2fe928(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}


var $880e95eb8b93ba9a$exports = {};

$parcel$export$m($880e95eb8b93ba9a$exports, "useSelectableItem", () => $880e95eb8b93ba9a$export$ecf600387e221c37);





function $880e95eb8b93ba9a$export$ecf600387e221c37(options) {
    let { selectionManager: manager , key: key , ref: ref , shouldSelectOnPressUp: shouldSelectOnPressUp , isVirtualized: isVirtualized , shouldUseVirtualFocus: shouldUseVirtualFocus , focus: focus , isDisabled: isDisabled , onAction: onAction , allowsDifferentPressOrigin: allowsDifferentPressOrigin  } = options;
    let onSelect = (e)=>{
        if (e.pointerType === 'keyboard' && $feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === 'none') return;
            if (manager.selectionMode === 'single') {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === 'toggle' || e && ($feb5ffebff200149$export$16792effe837dba3(e) || e.pointerType === 'touch' || e.pointerType === 'virtual')) // if touch or virtual (VO) then we just want to toggle, otherwise it's impossible to multi select because they don't have modifier keys
            manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    // Focus the associated DOM node when this item becomes the focusedKey
    let isFocused = key === manager.focusedKey;
    useEffect(()=>{
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus && document.activeElement !== ref.current) {
            if (focus) focus();
            else $6a99195332edec8b$export$80f3e147d781571c(ref.current);
        }
    }, [
        ref,
        isFocused,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {
    };
    if (!shouldUseVirtualFocus) itemProps = {
        tabIndex: isFocused ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    let modality = useRef(null);
    let hasPrimaryAction = onAction && manager.selectionMode === 'none';
    let hasSecondaryAction = onAction && manager.selectionMode !== 'none' && manager.selectionBehavior === 'replace';
    let allowsSelection = !isDisabled && manager.canSelectItem(key);
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {
    };
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            if (e.pointerType === 'keyboard') onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (e.pointerType !== 'keyboard') onSelect(e);
            if (hasPrimaryAction) onAction();
        };
        else {
            itemPressProps.onPressUp = (e)=>{
                if (e.pointerType !== 'keyboard') onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? ()=>onAction()
             : null;
        }
    } else {
        // On touch, it feels strange to select on touch down, so we special case this.
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            if (e.pointerType !== 'touch' && e.pointerType !== 'virtual') onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            if (e.pointerType === 'touch' || e.pointerType === 'virtual' || hasPrimaryAction) {
                // Single tap on touch with selectionBehavior = 'replace' performs an action, i.e. navigation.
                // Also perform action on press up when selectionMode = 'none'.
                if (hasPrimaryAction || hasSecondaryAction) onAction();
                else onSelect(e);
            }
        };
    }
    if (!isVirtualized) itemProps['data-key'] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps , isPressed: isPressed  } = $f6c31cce2adf654f$export$45712eceda6fad21(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === 'mouse') {
            e.stopPropagation();
            e.preventDefault();
            onAction();
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    // TODO: what about when drag and drop is also enabled??
    let { longPressProps: longPressProps  } = $8a26561d2877236e$export$c24ed0104d07eab9({
        isDisabled: !hasSecondaryAction,
        onLongPress (e) {
            if (e.pointerType === 'touch') {
                onSelect(e);
                manager.setSelectionBehavior('toggle');
            }
        }
    });
    // Pressing the Enter key with selectionBehavior = 'replace' performs an action (i.e. navigation).
    let onKeyUp = hasSecondaryAction ? (e)=>{
        if (e.key === 'Enter') onAction();
    } : undefined;
    return {
        itemProps: $3ef42575df84b30b$export$9d1611c77c2fe928(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {
        }, hasSecondaryAction ? longPressProps : {
        }, {
            onKeyUp: onKeyUp,
            onDoubleClick: onDoubleClick
        }),
        isPressed: isPressed
    };
}


var $982254629710d113$exports = {};

$parcel$export$m($982254629710d113$exports, "useSelectableList", () => $982254629710d113$export$b95089534ab7c1fd);

var $2a25aae57d74318e$exports = {};

$parcel$export$m($2a25aae57d74318e$exports, "ListKeyboardDelegate", () => $2a25aae57d74318e$export$a05409b8bb224a5a);
class $2a25aae57d74318e$export$a05409b8bb224a5a {
    getKeyBelow(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === 'item' && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
    }
    getKeyAbove(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === 'item' && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === 'item' && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === 'item' && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
    }
    getItem(key) {
        return this.ref.current.querySelector(`[data-key="${key}"]`);
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        let pageY = Math.max(0, item.offsetTop + item.offsetHeight - menu.offsetHeight);
        while(item && item.offsetTop > pageY){
            key = this.getKeyAbove(key);
            item = this.getItem(key);
        }
        return key;
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        let pageY = Math.min(menu.scrollHeight, item.offsetTop - item.offsetHeight + menu.offsetHeight);
        while(item && item.offsetTop < pageY){
            key = this.getKeyBelow(key);
            item = this.getItem(key);
        }
        return key;
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(collection, disabledKeys, ref, collator){
        this.collection = collection;
        this.disabledKeys = disabledKeys;
        this.ref = ref;
        this.collator = collator;
    }
}




function $982254629710d113$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager , collection: collection , disabledKeys: disabledKeys , ref: ref , keyboardDelegate: keyboardDelegate , autoFocus: autoFocus , shouldFocusWrap: shouldFocusWrap , isVirtualized: isVirtualized , disallowEmptySelection: disallowEmptySelection , selectOnFocus: selectOnFocus = false , disallowTypeAhead: disallowTypeAhead , shouldUseVirtualFocus: shouldUseVirtualFocus , allowsTabNavigation: allowsTabNavigation  } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = $325a3faab7a68acd$export$a16aca283550c30d({
        usage: 'search',
        sensitivity: 'base'
    });
    let delegate = useMemo(()=>keyboardDelegate || new $2a25aae57d74318e$export$a05409b8bb224a5a(collection, disabledKeys, ref, collator)
    , [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator
    ]);
    let { collectionProps: collectionProps  } = $ae20dd8cbca75726$export$d6daf82dcd84e87c({
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate,
        autoFocus: autoFocus,
        shouldFocusWrap: shouldFocusWrap,
        disallowEmptySelection: disallowEmptySelection,
        selectOnFocus: selectOnFocus,
        disallowTypeAhead: disallowTypeAhead,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        allowsTabNavigation: allowsTabNavigation,
        isVirtualized: isVirtualized,
        scrollRef: ref
    });
    return {
        listProps: collectionProps
    };
}

function $parcel$export$l(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $c1d7fb2ec91bae71$exports = {};

$parcel$export$l($c1d7fb2ec91bae71$exports, "Item", () => $c1d7fb2ec91bae71$export$6d08773d2e66f8f2);

function $c1d7fb2ec91bae71$var$Item(props) {
    return null;
}
$c1d7fb2ec91bae71$var$Item.getCollectionNode = function* getCollectionNode(props, context) {
    let { childItems: childItems , title: title , children: children  } = props;
    let rendered = props.title || props.children;
    let textValue = props.textValue || (typeof rendered === 'string' ? rendered : '') || props['aria-label'] || '';
    // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.
    if (!textValue && !(context === null || context === void 0 ? void 0 : context.suppressTextValueWarning)) console.warn('<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop.');
    yield {
        type: 'item',
        props: props,
        rendered: rendered,
        textValue: textValue,
        'aria-label': props['aria-label'],
        hasChildNodes: $c1d7fb2ec91bae71$var$hasChildItems(props),
        *childNodes () {
            if (childItems) for (let child1 of childItems)yield {
                type: 'item',
                value: child1
            };
            else if (title) {
                let items = [];
                React__default.Children.forEach(children, (child)=>{
                    items.push({
                        type: 'item',
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
function $c1d7fb2ec91bae71$var$hasChildItems(props) {
    if (props.hasChildItems != null) return props.hasChildItems;
    if (props.childItems) return true;
    if (props.title && React__default.Children.count(props.children) > 0) return true;
    return false;
}
// We don't want getCollectionNode to show up in the type definition
let $c1d7fb2ec91bae71$export$6d08773d2e66f8f2 = $c1d7fb2ec91bae71$var$Item;


var $9fc4852771d079eb$exports = {};

$parcel$export$l($9fc4852771d079eb$exports, "Section", () => $9fc4852771d079eb$export$6e2c8f0811a474ce);

function $9fc4852771d079eb$var$Section(props) {
    return null;
}
$9fc4852771d079eb$var$Section.getCollectionNode = function* getCollectionNode(props) {
    let { children: children , title: title , items: items1  } = props;
    yield {
        type: 'section',
        hasChildNodes: true,
        rendered: title,
        'aria-label': props['aria-label'],
        *childNodes () {
            if (typeof children === 'function') {
                if (!items1) throw new Error('props.children was a function but props.items is missing');
                for (let item of items1)yield {
                    type: 'item',
                    value: item,
                    renderer: children
                };
            } else {
                let items = [];
                React__default.Children.forEach(children, (child)=>{
                    items.push({
                        type: 'item',
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
// We don't want getCollectionNode to show up in the type definition
let $9fc4852771d079eb$export$6e2c8f0811a474ce = $9fc4852771d079eb$var$Section;


var $7613b1592d41b092$exports = {};

$parcel$export$l($7613b1592d41b092$exports, "useCollection", () => $7613b1592d41b092$export$6cd28814d92fa9c9);

class $eb2240fc39a57fa5$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props)
        );
    }
    *iterateCollection(props) {
        let { children: children , items: items  } = props;
        if (typeof children === 'function') {
            if (!items) throw new Error('props.children was a function but props.items is missing');
            for (let item of props.items)yield* this.getFullNode({
                value: item
            }, {
                renderer: children
            });
        } else {
            let items = [];
            React__default.Children.forEach(children, (child)=>{
                items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {
                });
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === 'cell' && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _key;
            let key = (_key = v.key) !== null && _key !== void 0 ? _key : v.id;
            if (key == null) throw new Error('No key found for item');
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if (React__default.isValidElement(element)) {
            let type = element.type;
            if (typeof type !== 'function' && typeof type.getCollectionNode !== 'function') {
                let name = typeof element.type === 'function' ? element.type.name : element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key;
                if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value || partialNode.value;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$eb2240fc39a57fa5$var$capitalize(parentNode.type)}>. Only <${$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null) return;
        // Create full node
        let builder = this;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue,
            'aria-label': partialNode['aria-label'],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes,
            childNodes: $eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // TODO: Remove this line entirely and enforce that users always provide unique keys.
                    // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    child.index = index;
                    let nodes = builder.getFullNode(child, builder.getChildState(state, child), node.key, node);
                    for (let node1 of nodes){
                        index++;
                        yield node1;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item1 of iterable){
                cache.push(item1);
                yield item1;
            }
        }
    };
}
function $eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element))
    ;
    if (outer) return outer;
    if (inner) return inner;
}
function $eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}



function $7613b1592d41b092$export$6cd28814d92fa9c9(props, factory, context, invalidators = []) {
    let builder = useMemo(()=>new $eb2240fc39a57fa5$export$bf788dd355e3a401()
    , []);
    let prev = useRef(null);
    return useMemo(()=>{
        let nodes = builder.build(props, context);
        prev.current = factory(nodes, prev.current);
        return prev.current;
    // Don't invalidate when any prop changes, just the two we care about.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        builder,
        props.children,
        props.items,
        context,
        ...invalidators
    ]);
}


var $453cc9f0df89c0a5$exports = {};

$parcel$export$l($453cc9f0df89c0a5$exports, "getItemCount", () => $453cc9f0df89c0a5$export$77d5aafae4e095b2);
const $453cc9f0df89c0a5$var$cache = new WeakMap();
function $453cc9f0df89c0a5$export$77d5aafae4e095b2(collection) {
    let count = $453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    count = 0;
    for (let item of collection)if (item.type === 'section') count += $453cc9f0df89c0a5$export$77d5aafae4e095b2(item.childNodes);
    else count++;
    $453cc9f0df89c0a5$var$cache.set(collection, count);
    return count;
}

function $parcel$export$k(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $c132121280ec012d$exports = {};

$parcel$export$k($c132121280ec012d$exports, "useListBox", () => $c132121280ec012d$export$50eacbbf140a3141);

var $b1f0cad8af73213b$exports = {};

$parcel$export$k($b1f0cad8af73213b$exports, "listData", () => $b1f0cad8af73213b$export$3585ede4d035bf14);
$parcel$export$k($b1f0cad8af73213b$exports, "getItemId", () => $b1f0cad8af73213b$export$9145995848b05025);
const $b1f0cad8af73213b$export$3585ede4d035bf14 = new WeakMap();
function $b1f0cad8af73213b$var$normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}
function $b1f0cad8af73213b$export$9145995848b05025(state, itemKey) {
    let data = $b1f0cad8af73213b$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error('Unknown list');
    return `${data.id}-option-${$b1f0cad8af73213b$var$normalizeKey(itemKey)}`;
}






function $c132121280ec012d$export$50eacbbf140a3141(props, state, ref) {
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    let { listProps: listProps  } = $982254629710d113$export$b95089534ab7c1fd({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys
    });
    let { focusWithinProps: focusWithinProps  } = $9ab94262bd0047c7$export$420e68273165f4ec({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = $bdb11010cef70236$export$f680877a34711e37(props.id);
    $b1f0cad8af73213b$export$3585ede4d035bf14.set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized
    });
    let { labelProps: labelProps , fieldProps: fieldProps  } = $d191a55c9702f145$export$8467354a121f1b9f({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    return {
        labelProps: labelProps,
        listBoxProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, focusWithinProps, state.selectionManager.selectionMode === 'multiple' ? {
            'aria-multiselectable': 'true'
        } : {
        }, {
            role: 'listbox',
            ...$3ef42575df84b30b$export$9d1611c77c2fe928(fieldProps, listProps)
        })
    };
}


var $293f70390ea03370$exports = {};

$parcel$export$k($293f70390ea03370$exports, "useOption", () => $293f70390ea03370$export$497855f14858aa34);





function $293f70390ea03370$export$497855f14858aa34(props, state, ref) {
    let { key: key  } = props;
    let data = $b1f0cad8af73213b$export$3585ede4d035bf14.get(state);
    var _isDisabled;
    let isDisabled = (_isDisabled = props.isDisabled) !== null && _isDisabled !== void 0 ? _isDisabled : state.disabledKeys.has(key);
    var _isSelected;
    let isSelected = (_isSelected = props.isSelected) !== null && _isSelected !== void 0 ? _isSelected : state.selectionManager.isSelected(key);
    let isFocused = state.selectionManager.focusedKey === key;
    var _shouldSelectOnPressUp;
    let shouldSelectOnPressUp = (_shouldSelectOnPressUp = props.shouldSelectOnPressUp) !== null && _shouldSelectOnPressUp !== void 0 ? _shouldSelectOnPressUp : data.shouldSelectOnPressUp;
    var _shouldFocusOnHover;
    let shouldFocusOnHover = (_shouldFocusOnHover = props.shouldFocusOnHover) !== null && _shouldFocusOnHover !== void 0 ? _shouldFocusOnHover : data.shouldFocusOnHover;
    var _shouldUseVirtualFocus;
    let shouldUseVirtualFocus = (_shouldUseVirtualFocus = props.shouldUseVirtualFocus) !== null && _shouldUseVirtualFocus !== void 0 ? _shouldUseVirtualFocus : data.shouldUseVirtualFocus;
    var _isVirtualized;
    let isVirtualized = (_isVirtualized = props.isVirtualized) !== null && _isVirtualized !== void 0 ? _isVirtualized : data.isVirtualized;
    let labelId = $bdb11010cef70236$export$b4cc09c592e8fdb8();
    let descriptionId = $bdb11010cef70236$export$b4cc09c592e8fdb8();
    let optionProps = {
        role: 'option',
        'aria-disabled': isDisabled,
        'aria-selected': state.selectionManager.selectionMode !== 'none' ? isSelected : undefined
    };
    // Safari with VoiceOver on macOS misreads options with aria-labelledby or aria-label as simply "text".
    // We should not map slots to the label and description on Safari and instead just have VoiceOver read the textContent.
    // https://bugs.webkit.org/show_bug.cgi?id=209279
    if (!($c87311424ea30a05$export$9ac100e40613ea10() && $c87311424ea30a05$export$78551043582a6a98())) {
        optionProps['aria-label'] = props['aria-label'];
        optionProps['aria-labelledby'] = labelId;
        optionProps['aria-describedby'] = descriptionId;
    }
    if (isVirtualized) {
        optionProps['aria-posinset'] = state.collection.getItem(key).index + 1;
        optionProps['aria-setsize'] = $453cc9f0df89c0a5$export$77d5aafae4e095b2(state.collection);
    }
    let { itemProps: itemProps , isPressed: isPressed  } = $880e95eb8b93ba9a$export$ecf600387e221c37({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        allowsDifferentPressOrigin: shouldSelectOnPressUp,
        isVirtualized: isVirtualized,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps  } = $6179b936705e76d3$export$ae780daf29e6d456({
        isDisabled: isDisabled || !shouldFocusOnHover,
        onHoverStart () {
            if (!$507fabe10e71c6fb$export$b9b3dfddab17db27()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    return {
        optionProps: {
            ...optionProps,
            ...$3ef42575df84b30b$export$9d1611c77c2fe928(itemProps, hoverProps),
            id: $b1f0cad8af73213b$export$9145995848b05025(state, key)
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        isFocused: isFocused,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed
    };
}


var $af383d3bef1cfdc9$exports = {};

$parcel$export$k($af383d3bef1cfdc9$exports, "useListBoxSection", () => $af383d3bef1cfdc9$export$c3f9f39876e4bc7);

function $af383d3bef1cfdc9$export$c3f9f39876e4bc7(props) {
    let { heading: heading , 'aria-label': ariaLabel  } = props;
    let headingId = $bdb11010cef70236$export$f680877a34711e37();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Techincally, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, and only use it
            // as a label for the nested group.
            id: headingId,
            'aria-hidden': true
        } : {
        },
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}

function $parcel$interopDefault$6(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export$j(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $168583247155ddda$exports = {};

$parcel$export$j($168583247155ddda$exports, "useMenuTrigger", () => $168583247155ddda$export$dc9c12ed27dd1b49);
var $9bdd31893c9700c3$exports = {};
var $c0398ad35c3639b7$exports = {};
$c0398ad35c3639b7$exports = JSON.parse("{\"longPressMessage\":\"اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة\"}");


var $7af657c4165927c3$exports = {};
$7af657c4165927c3$exports = JSON.parse("{\"longPressMessage\":\"Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто\"}");


var $d95d4da6d531ab81$exports = {};
$d95d4da6d531ab81$exports = JSON.parse("{\"longPressMessage\":\"Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku\"}");


var $24ebda9c775dca17$exports = {};
$24ebda9c775dca17$exports = JSON.parse("{\"longPressMessage\":\"Langt tryk eller tryk på Alt + pil ned for at åbne menuen\"}");


var $743e0dfca6cab1e9$exports = {};
$743e0dfca6cab1e9$exports = JSON.parse("{\"longPressMessage\":\"Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen\"}");


var $a2f41026e05f1c84$exports = {};
$a2f41026e05f1c84$exports = JSON.parse("{\"longPressMessage\":\"Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού\"}");


var $43b800e97c901737$exports = {};
$43b800e97c901737$exports = JSON.parse("{\"longPressMessage\":\"Long press or press Alt + ArrowDown to open menu\"}");


var $442f5f6ac211e29f$exports = {};
$442f5f6ac211e29f$exports = JSON.parse("{\"longPressMessage\":\"Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú\"}");


var $dff280acfeb2d8ac$exports = {};
$dff280acfeb2d8ac$exports = JSON.parse("{\"longPressMessage\":\"Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool\"}");


var $51608325613944d7$exports = {};
$51608325613944d7$exports = JSON.parse("{\"longPressMessage\":\"Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli\"}");


var $c4a1b1eabeaa87be$exports = {};
$c4a1b1eabeaa87be$exports = JSON.parse("{\"longPressMessage\":\"Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu.\"}");


var $8c74815cdee18d1b$exports = {};
$8c74815cdee18d1b$exports = JSON.parse("{\"longPressMessage\":\"לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט\"}");


var $fd0e9ef6a7fe0ec9$exports = {};
$fd0e9ef6a7fe0ec9$exports = JSON.parse("{\"longPressMessage\":\"Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika\"}");


var $a89a74a39eba465a$exports = {};
$a89a74a39eba465a$exports = JSON.parse("{\"longPressMessage\":\"Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához\"}");


var $edc7c66594a0ae8a$exports = {};
$edc7c66594a0ae8a$exports = JSON.parse("{\"longPressMessage\":\"Premere a lungo o premere Alt + Freccia giù per aprire il menu\"}");


var $f1ab51510712db52$exports = {};
$f1ab51510712db52$exports = JSON.parse("{\"longPressMessage\":\"長押しまたは Alt+下矢印キーでメニューを開く\"}");


var $f9b672d9b82fa3d6$exports = {};
$f9b672d9b82fa3d6$exports = JSON.parse("{\"longPressMessage\":\"길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기\"}");


var $a385f3910feda499$exports = {};
$a385f3910feda499$exports = JSON.parse("{\"longPressMessage\":\"Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“.\"}");


var $4f1bde932c441789$exports = {};
$4f1bde932c441789$exports = JSON.parse("{\"longPressMessage\":\"Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa\"}");


var $914a51a8a594d5be$exports = {};
$914a51a8a594d5be$exports = JSON.parse("{\"longPressMessage\":\"Langt trykk eller trykk Alt + PilNed for å åpne menyen\"}");


var $89aaf803103bb500$exports = {};
$89aaf803103bb500$exports = JSON.parse("{\"longPressMessage\":\"Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen\"}");


var $c685891476dbaaca$exports = {};
$c685891476dbaaca$exports = JSON.parse("{\"longPressMessage\":\"Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu\"}");


var $885879b9b10c2959$exports = {};
$885879b9b10c2959$exports = JSON.parse("{\"longPressMessage\":\"Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu\"}");


var $6b39616688a51692$exports = {};
$6b39616688a51692$exports = JSON.parse("{\"longPressMessage\":\"Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu\"}");


var $f26362aed63f47e2$exports = {};
$f26362aed63f47e2$exports = JSON.parse("{\"longPressMessage\":\"Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul\"}");


var $06cbade644558bf0$exports = {};
$06cbade644558bf0$exports = JSON.parse("{\"longPressMessage\":\"Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню\"}");


var $0a391ff68f9d59b1$exports = {};
$0a391ff68f9d59b1$exports = JSON.parse("{\"longPressMessage\":\"Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol\"}");


var $8193cf0e649c7928$exports = {};
$8193cf0e649c7928$exports = JSON.parse("{\"longPressMessage\":\"Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol\"}");


var $f398debcce5a5c55$exports = {};
$f398debcce5a5c55$exports = JSON.parse("{\"longPressMessage\":\"Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni\"}");


var $9e9fef000aa4c013$exports = {};
$9e9fef000aa4c013$exports = JSON.parse("{\"longPressMessage\":\"Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn\"}");


var $c016c8183bbe3d68$exports = {};
$c016c8183bbe3d68$exports = JSON.parse("{\"longPressMessage\":\"Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın\"}");


var $ca4f6c8462244e62$exports = {};
$ca4f6c8462244e62$exports = JSON.parse("{\"longPressMessage\":\"Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню\"}");


var $2d9960c02ccac927$exports = {};
$2d9960c02ccac927$exports = JSON.parse("{\"longPressMessage\":\"长按或按 Alt + 向下方向键以打开菜单\"}");


var $f1b682a4c8c5631c$exports = {};
$f1b682a4c8c5631c$exports = JSON.parse("{\"longPressMessage\":\"長按或按 Alt+向下鍵以開啟功能表\"}");


$9bdd31893c9700c3$exports = {
    "ar-AE": $c0398ad35c3639b7$exports,
    "bg-BG": $7af657c4165927c3$exports,
    "cs-CZ": $d95d4da6d531ab81$exports,
    "da-DK": $24ebda9c775dca17$exports,
    "de-DE": $743e0dfca6cab1e9$exports,
    "el-GR": $a2f41026e05f1c84$exports,
    "en-US": $43b800e97c901737$exports,
    "es-ES": $442f5f6ac211e29f$exports,
    "et-EE": $dff280acfeb2d8ac$exports,
    "fi-FI": $51608325613944d7$exports,
    "fr-FR": $c4a1b1eabeaa87be$exports,
    "he-IL": $8c74815cdee18d1b$exports,
    "hr-HR": $fd0e9ef6a7fe0ec9$exports,
    "hu-HU": $a89a74a39eba465a$exports,
    "it-IT": $edc7c66594a0ae8a$exports,
    "ja-JP": $f1ab51510712db52$exports,
    "ko-KR": $f9b672d9b82fa3d6$exports,
    "lt-LT": $a385f3910feda499$exports,
    "lv-LV": $4f1bde932c441789$exports,
    "nb-NO": $914a51a8a594d5be$exports,
    "nl-NL": $89aaf803103bb500$exports,
    "pl-PL": $c685891476dbaaca$exports,
    "pt-BR": $885879b9b10c2959$exports,
    "pt-PT": $6b39616688a51692$exports,
    "ro-RO": $f26362aed63f47e2$exports,
    "ru-RU": $06cbade644558bf0$exports,
    "sk-SK": $0a391ff68f9d59b1$exports,
    "sl-SI": $8193cf0e649c7928$exports,
    "sr-SP": $f398debcce5a5c55$exports,
    "sv-SE": $9e9fef000aa4c013$exports,
    "tr-TR": $c016c8183bbe3d68$exports,
    "uk-UA": $ca4f6c8462244e62$exports,
    "zh-CN": $2d9960c02ccac927$exports,
    "zh-TW": $f1b682a4c8c5631c$exports
};






function $168583247155ddda$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = 'menu' , isDisabled: isDisabled , trigger: trigger = 'press'  } = props;
    let menuTriggerId = $bdb11010cef70236$export$f680877a34711e37();
    let { triggerProps: triggerProps , overlayProps: overlayProps  } = $628037886ba31236$export$f9d5c8beee7d008d({
        type: type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === 'longPress' && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case 'Enter':
            case ' ':
                if (trigger === 'longPress') return;
            // fallthrough
            case 'ArrowDown':
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('first');
                break;
            case 'ArrowUp':
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('last');
                break;
        }
    };
    let formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault$6($9bdd31893c9700c3$exports)));
    let { longPressProps: longPressProps  } = $8a26561d2877236e$export$c24ed0104d07eab9({
        accessibilityDescription: formatMessage('longPressMessage'),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open('first');
        }
    });
    let pressProps = {
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== 'touch' && e.pointerType !== 'keyboard' && !isDisabled) // If opened with a screen reader, auto focus the first item.
            // Otherwise, the menu itself will be focused.
            state.toggle(e.pointerType === 'virtual' ? 'first' : null);
        },
        onPress (e) {
            if (e.pointerType === 'touch' && !isDisabled) state.toggle();
        }
    };
    triggerProps = $3ef42575df84b30b$export$9d1611c77c2fe928(triggerProps, trigger === 'press' ? pressProps : longPressProps);
    return {
        menuTriggerProps: {
            ...triggerProps,
            id: menuTriggerId,
            onKeyDown: onKeyDown
        },
        menuProps: {
            ...overlayProps,
            'aria-labelledby': menuTriggerId
        }
    };
}


var $d5336fe17ce95402$exports = {};

$parcel$export$j($d5336fe17ce95402$exports, "useMenu", () => $d5336fe17ce95402$export$38eaa17faae8f579);


function $d5336fe17ce95402$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true , ...otherProps } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    let { listProps: listProps  } = $982254629710d113$export$b95089534ab7c1fd({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap
    });
    return {
        menuProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
            role: 'menu',
            ...listProps
        })
    };
}


var $a2e5df62f93c7633$exports = {};

$parcel$export$j($a2e5df62f93c7633$exports, "useMenuItem", () => $a2e5df62f93c7633$export$9d32628fc2aea7da);




function $a2e5df62f93c7633$export$9d32628fc2aea7da(props, state, ref) {
    let { isSelected: isSelected , isDisabled: isDisabled , key: key , onClose: onClose , closeOnSelect: closeOnSelect , isVirtualized: isVirtualized , onAction: onAction  } = props;
    let role = 'menuitem';
    if (state.selectionManager.selectionMode === 'single') role = 'menuitemradio';
    else if (state.selectionManager.selectionMode === 'multiple') role = 'menuitemcheckbox';
    let labelId = $bdb11010cef70236$export$b4cc09c592e8fdb8();
    let descriptionId = $bdb11010cef70236$export$b4cc09c592e8fdb8();
    let keyboardId = $bdb11010cef70236$export$b4cc09c592e8fdb8();
    let ariaProps = {
        'aria-disabled': isDisabled,
        role: role,
        'aria-label': props['aria-label'],
        'aria-labelledby': labelId,
        'aria-describedby': [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(' ') || undefined
    };
    if (state.selectionManager.selectionMode !== 'none') ariaProps['aria-checked'] = isSelected;
    if (isVirtualized) {
        ariaProps['aria-posinset'] = state.collection.getItem(key).index;
        ariaProps['aria-setsize'] = $453cc9f0df89c0a5$export$77d5aafae4e095b2(state.collection);
    }
    let onKeyDown = (e)=>{
        // Ignore repeating events, which may have started on the menu trigger before moving
        // focus to the menu item. We want to wait for a second complete key press sequence.
        if (e.repeat) return;
        switch(e.key){
            case ' ':
                if (!isDisabled && state.selectionManager.selectionMode === 'none' && closeOnSelect !== false && onClose) onClose();
                break;
            case 'Enter':
                // The Enter key should always close on select, except if overridden.
                if (!isDisabled && closeOnSelect !== false && onClose) onClose();
                break;
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType === 'keyboard' && onAction) onAction(key);
    };
    let onPressUp = (e)=>{
        if (e.pointerType !== 'keyboard') {
            if (onAction) onAction(key);
            // Pressing a menu item should close by default in single selection mode but not multiple
            // selection mode, except if overridden by the closeOnSelect prop.
            if (onClose && (closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : state.selectionManager.selectionMode !== 'multiple')) onClose();
        }
    };
    let { itemProps: itemProps  } = $880e95eb8b93ba9a$export$ecf600387e221c37({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true
    });
    let { pressProps: pressProps  } = $f6c31cce2adf654f$export$45712eceda6fad21({
        onPressStart: onPressStart,
        onPressUp: onPressUp,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps  } = $6179b936705e76d3$export$ae780daf29e6d456({
        isDisabled: isDisabled,
        onHoverStart () {
            if (!$507fabe10e71c6fb$export$b9b3dfddab17db27()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    return {
        menuItemProps: {
            ...ariaProps,
            ...$3ef42575df84b30b$export$9d1611c77c2fe928(itemProps, pressProps, hoverProps, {
                onKeyDown: onKeyDown
            })
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        }
    };
}


var $3e5eb2498db5b506$exports = {};

$parcel$export$j($3e5eb2498db5b506$exports, "useMenuSection", () => $3e5eb2498db5b506$export$73f7a44322579622);

function $3e5eb2498db5b506$export$73f7a44322579622(props) {
    let { heading: heading , 'aria-label': ariaLabel  } = props;
    let headingId = $bdb11010cef70236$export$f680877a34711e37();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, and only use it
            // as a label for the nested group.
            id: headingId,
            'aria-hidden': true
        } : {
        },
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}

function $parcel$export$i(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $2d73ec29415bd339$exports = {};

$parcel$export$i($2d73ec29415bd339$exports, "useTextField", () => $2d73ec29415bd339$export$712718f7aec83d5);



function $2d73ec29415bd339$export$712718f7aec83d5(props, ref) {
    let { inputElementType: inputElementType = 'input' , isDisabled: isDisabled = false , isRequired: isRequired = false , isReadOnly: isReadOnly = false , validationState: validationState , type: type = 'text' , onChange: onChange = ()=>{
    }  } = props;
    let { focusableProps: focusableProps  } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, ref);
    let { labelProps: labelProps , fieldProps: fieldProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = $2baaea4c71418dea$export$294aa081a6c6f55d(props);
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    const inputOnlyProps = {
        type: type,
        pattern: props.pattern
    };
    return {
        labelProps: labelProps,
        inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, inputElementType === 'input' && inputOnlyProps, {
            disabled: isDisabled,
            readOnly: isReadOnly,
            'aria-required': isRequired || undefined,
            'aria-invalid': validationState === 'invalid' || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-activedescendant': props['aria-activedescendant'],
            'aria-autocomplete': props['aria-autocomplete'],
            'aria-haspopup': props['aria-haspopup'],
            value: props.value,
            defaultValue: props.value ? undefined : props.defaultValue,
            onChange: (e)=>onChange(e.target.value)
            ,
            autoComplete: props.autoComplete,
            maxLength: props.maxLength,
            minLength: props.minLength,
            name: props.name,
            placeholder: props.placeholder,
            inputMode: props.inputMode,
            // Clipboard events
            onCopy: props.onCopy,
            onCut: props.onCut,
            onPaste: props.onPaste,
            // Composition events
            onCompositionEnd: props.onCompositionEnd,
            onCompositionStart: props.onCompositionStart,
            onCompositionUpdate: props.onCompositionUpdate,
            // Selection events
            onSelect: props.onSelect,
            // Input events
            onBeforeInput: props.onBeforeInput,
            onInput: props.onInput,
            ...focusableProps,
            ...fieldProps
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}


var $d841c8010a73d545$exports = {};

$parcel$export$i($d841c8010a73d545$exports, "useFormattedTextField", () => $d841c8010a73d545$export$4f384c9210e583c3);



function $d841c8010a73d545$var$supportsNativeBeforeInputEvent() {
    return typeof window !== 'undefined' && window.InputEvent && // @ts-ignore
    typeof InputEvent.prototype.getTargetRanges === 'function';
}
function $d841c8010a73d545$export$4f384c9210e583c3(props, state1, inputRef) {
    let stateRef = useRef(state1);
    stateRef.current = state1;
    // All browsers implement the 'beforeinput' event natively except Firefox
    // (currently behind a flag as of Firefox 84). React's polyfill does not
    // run in all cases that the native event fires, e.g. when deleting text.
    // Use the native event if available so that we can prevent invalid deletions.
    // We do not attempt to polyfill this in Firefox since it would be very complicated,
    // the benefit of doing so is fairly minor, and it's going to be natively supported soon.
    useEffect(()=>{
        if (!$d841c8010a73d545$var$supportsNativeBeforeInputEvent()) return;
        let input = inputRef.current;
        let onBeforeInput = (e)=>{
            let state = stateRef.current;
            // Compute the next value of the input if the event is allowed to proceed.
            // See https://www.w3.org/TR/input-events-2/#interface-InputEvent-Attributes for a full list of input types.
            let nextValue;
            switch(e.inputType){
                case 'historyUndo':
                case 'historyRedo':
                    // Explicitly allow undo/redo. e.data is null in this case, but there's no need to validate,
                    // because presumably the input would have already been validated previously.
                    return;
                case 'deleteContent':
                case 'deleteByCut':
                case 'deleteByDrag':
                    nextValue = input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                    break;
                case 'deleteContentForward':
                    // This is potentially incorrect, since the browser may actually delete more than a single UTF-16
                    // character. In reality, a full Unicode grapheme cluster consisting of multiple UTF-16 characters
                    // or code points may be deleted. However, in our currently supported locales, there are no such cases.
                    // If we support additional locales in the future, this may need to change.
                    nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd + 1) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                    break;
                case 'deleteContentBackward':
                    nextValue = input.selectionEnd === input.selectionStart ? input.value.slice(0, input.selectionStart - 1) + input.value.slice(input.selectionStart) : input.value.slice(0, input.selectionStart) + input.value.slice(input.selectionEnd);
                    break;
                case 'deleteSoftLineBackward':
                case 'deleteHardLineBackward':
                    nextValue = input.value.slice(input.selectionStart);
                    break;
                default:
                    if (e.data != null) nextValue = input.value.slice(0, input.selectionStart) + e.data + input.value.slice(input.selectionEnd);
                    break;
            }
            // If we did not compute a value, or the new value is invalid, prevent the event
            // so that the browser does not update the input text, move the selection, or add to
            // the undo/redo stack.
            if (nextValue == null || !state.validate(nextValue)) e.preventDefault();
        };
        input.addEventListener('beforeinput', onBeforeInput, false);
        return ()=>{
            input.removeEventListener('beforeinput', onBeforeInput, false);
        };
    }, [
        inputRef,
        stateRef
    ]);
    let onBeforeInput1 = !$d841c8010a73d545$var$supportsNativeBeforeInputEvent() ? (e)=>{
        let nextValue = e.target.value.slice(0, e.target.selectionStart) + e.data + e.target.value.slice(e.target.selectionEnd);
        if (!state1.validate(nextValue)) e.preventDefault();
    } : null;
    let { labelProps: labelProps , inputProps: textFieldProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = $2d73ec29415bd339$export$712718f7aec83d5(props, inputRef);
    let compositionStartState = useRef(null);
    return {
        inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(textFieldProps, {
            onBeforeInput: onBeforeInput1,
            onCompositionStart () {
                // Chrome does not implement Input Events Level 2, which specifies the insertFromComposition
                // and deleteByComposition inputType values for the beforeinput event. These are meant to occur
                // at the end of a composition (e.g. Pinyin IME, Android auto correct, etc.), and crucially, are
                // cancelable. The insertCompositionText and deleteCompositionText input types are not cancelable,
                // nor would we want to cancel them because the input from the user is incomplete at that point.
                // In Safari, insertFromComposition/deleteFromComposition will fire, however, allowing us to cancel
                // the final composition result if it is invalid. As a fallback for Chrome and Firefox, which either
                // don't support Input Events Level 2, or beforeinput at all, we store the state of the input when
                // the compositionstart event fires, and undo the changes in compositionend (below) if it is invalid.
                // Unfortunately, this messes up the undo/redo stack, but until insertFromComposition/deleteByComposition
                // are implemented, there is no other way to prevent composed input.
                // See https://bugs.chromium.org/p/chromium/issues/detail?id=1022204
                let { value: value , selectionStart: selectionStart , selectionEnd: selectionEnd  } = inputRef.current;
                compositionStartState.current = {
                    value: value,
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd
                };
            },
            onCompositionEnd () {
                if (!state1.validate(inputRef.current.value)) {
                    // Restore the input value in the DOM immediately so we can synchronously update the selection position.
                    // But also update the value in React state as well so it is correct for future updates.
                    let { value: value , selectionStart: selectionStart , selectionEnd: selectionEnd  } = compositionStartState.current;
                    inputRef.current.value = value;
                    inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    state1.setInputValue(value);
                }
            }
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

function $parcel$interopDefault$5(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export$h(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $c350ade66beef0af$exports = {};

$parcel$export$h($c350ade66beef0af$exports, "useComboBox", () => $c350ade66beef0af$export$8c18d1b4f7232bbf);






var $2e84e748dc57e459$exports = {};
var $02cb4c75c506befe$exports = {};
$02cb4c75c506befe$exports = JSON.parse("{\"buttonLabel\":\"عرض المقترحات\",\"countAnnouncement\":\"{optionCount, plural, one {# خيار} other {# خيارات}} متاحة.\",\"focusAnnouncement\":\"{isGroupChange, select, true {المجموعة المدخلة {groupTitle}, مع {groupCount, plural, one {# خيار} other {# خيارات}}. } other {}}{optionText}{isSelected, select, true {, محدد} other {}}\",\"listboxLabel\":\"مقترحات\",\"selectedAnnouncement\":\"{optionText}، محدد\"}");


var $568b8163f1e56faf$exports = {};
$568b8163f1e56faf$exports = JSON.parse("{\"buttonLabel\":\"Покажи предложения\",\"countAnnouncement\":\"{optionCount, plural, one {# опция} other {# опции}} на разположение.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Въведена група {groupTitle}, с {groupCount, plural, one {# опция} other {# опции}}. } other {}}{optionText}{isSelected, select, true {, избрани} other {}}\",\"listboxLabel\":\"Предложения\",\"selectedAnnouncement\":\"{optionText}, избрани\"}");


var $87581c0202d106b8$exports = {};
$87581c0202d106b8$exports = JSON.parse("{\"buttonLabel\":\"Zobrazit doporučení\",\"countAnnouncement\":\"K dispozici {optionCount, plural, one {je # možnost} other {jsou/je # možnosti/-í}}.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Zadaná skupina „{groupTitle}“ {groupCount, plural, one {s # možností} other {se # možnostmi}}. } other {}}{optionText}{isSelected, select, true { (vybráno)} other {}}\",\"listboxLabel\":\"Návrhy\",\"selectedAnnouncement\":\"{optionText}, vybráno\"}");


var $a10a0369f5433ed1$exports = {};
$a10a0369f5433ed1$exports = JSON.parse("{\"buttonLabel\":\"Vis forslag\",\"countAnnouncement\":\"{optionCount, plural, one {# mulighed tilgængelig} other {# muligheder tilgængelige}}.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Angivet gruppe {groupTitle}, med {groupCount, plural, one {# mulighed} other {# muligheder}}. } other {}}{optionText}{isSelected, select, true {, valgt} other {}}\",\"listboxLabel\":\"Forslag\",\"selectedAnnouncement\":\"{optionText}, valgt\"}");


var $bfd288727d5cb166$exports = {};
$bfd288727d5cb166$exports = JSON.parse("{\"buttonLabel\":\"Empfehlungen anzeigen\",\"countAnnouncement\":\"{optionCount, plural, one {# Option} other {# Optionen}} verfügbar.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Eingetretene Gruppe {groupTitle}, mit {groupCount, plural, one {# Option} other {# Optionen}}. } other {}}{optionText}{isSelected, select, true {, ausgewählt} other {}}\",\"listboxLabel\":\"Empfehlungen\",\"selectedAnnouncement\":\"{optionText}, ausgewählt\"}");


var $ca177778f9a74e3c$exports = {};
$ca177778f9a74e3c$exports = JSON.parse("{\"buttonLabel\":\"Προβολή προτάσεων\",\"countAnnouncement\":\"{optionCount, plural, one {# επιλογή} other {# επιλογές }} διαθέσιμες.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Εισαγμένη ομάδα {groupTitle}, με {groupCount, plural, one {# επιλογή} other {# επιλογές}}. } other {}}{optionText}{isSelected, select, true {, επιλεγμένο} other {}}\",\"listboxLabel\":\"Προτάσεις\",\"selectedAnnouncement\":\"{optionText}, επιλέχθηκε\"}");


var $9b5aa79ef84beb6c$exports = {};
$9b5aa79ef84beb6c$exports = JSON.parse("{\"focusAnnouncement\":\"{isGroupChange, select, true {Entered group {groupTitle}, with {groupCount, plural, one {# option} other {# options}}. } other {}}{optionText}{isSelected, select, true {, selected} other {}}\",\"countAnnouncement\":\"{optionCount, plural, one {# option} other {# options}} available.\",\"selectedAnnouncement\":\"{optionText}, selected\",\"buttonLabel\":\"Show suggestions\",\"listboxLabel\":\"Suggestions\"}");


var $57968e8209de2557$exports = {};
$57968e8209de2557$exports = JSON.parse("{\"buttonLabel\":\"Mostrar sugerencias\",\"countAnnouncement\":\"{optionCount, plural, one {# opción} other {# opciones}} disponible(s).\",\"focusAnnouncement\":\"{isGroupChange, select, true {Se ha unido al grupo {groupTitle}, con {groupCount, plural, one {# opción} other {# opciones}}. } other {}}{optionText}{isSelected, select, true {, seleccionado} other {}}\",\"listboxLabel\":\"Sugerencias\",\"selectedAnnouncement\":\"{optionText}, seleccionado\"}");


var $60690790bf4c1c6a$exports = {};
$60690790bf4c1c6a$exports = JSON.parse("{\"buttonLabel\":\"Kuva soovitused\",\"countAnnouncement\":\"{optionCount, plural, one {# valik} other {# valikud}} saadaval.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Sisestatud rühm {groupTitle}, valikuga {groupCount, plural, one {# valik} other {# valikud}}. } other {}}{optionText}{isSelected, select, true {, valitud} other {}}\",\"listboxLabel\":\"Soovitused\",\"selectedAnnouncement\":\"{optionText}, valitud\"}");


var $1101246e8c7d9357$exports = {};
$1101246e8c7d9357$exports = JSON.parse("{\"buttonLabel\":\"Näytä ehdotukset\",\"countAnnouncement\":\"{optionCount, plural, one {# vaihtoehto} other {# vaihtoehdot}} saatavilla.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Mentiin ryhmään {groupTitle}, {groupCount, plural, one {# vaihtoehdon} other {# vaihtoehdon}} kanssa.} other {}}{optionText}{isSelected, select, true {, valittu} other {}}\",\"listboxLabel\":\"Ehdotukset\",\"selectedAnnouncement\":\"{optionText}, valittu\"}");


var $6404b5cb5b241730$exports = {};
$6404b5cb5b241730$exports = JSON.parse("{\"buttonLabel\":\"Afficher les suggestions\",\"countAnnouncement\":\"{optionCount, plural, one {# option} other {# options}} disponible(s).\",\"focusAnnouncement\":\"{isGroupChange, select, true {Groupe {groupTitle} saisi, avec {groupCount, plural, one {# option} other {# options}}. } other {}}{optionText}{isSelected, select, true {, sélectionné(s)} other {}}\",\"listboxLabel\":\"Suggestions\",\"selectedAnnouncement\":\"{optionText}, sélectionné\"}");


var $dfeafa702e92e31f$exports = {};
$dfeafa702e92e31f$exports = JSON.parse("{\"buttonLabel\":\"הצג הצעות\",\"countAnnouncement\":\"{optionCount, plural, one {אפשרות #} other {# אפשרויות}} במצב זמין.\",\"focusAnnouncement\":\"{isGroupChange, select, true {נכנס לקבוצה {groupTitle}, עם {groupCount, plural, one {אפשרות #} other {# אפשרויות}}. } other {}}{optionText}{isSelected, select, true {, נבחר} other {}}\",\"listboxLabel\":\"הצעות\",\"selectedAnnouncement\":\"{optionText}, נבחר\"}");


var $2d125e0b34676352$exports = {};
$2d125e0b34676352$exports = JSON.parse("{\"buttonLabel\":\"Prikaži prijedloge\",\"countAnnouncement\":\"Dostupno još: {optionCount, plural, one {# opcija} other {# opcije/a}}.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Unesena skupina {groupTitle}, s {groupCount, plural, one {# opcijom} other {# opcije/a}}. } other {}}{optionText}{isSelected, select, true {, odabranih} other {}}\",\"listboxLabel\":\"Prijedlozi\",\"selectedAnnouncement\":\"{optionText}, odabrano\"}");


var $ea029611d7634059$exports = {};
$ea029611d7634059$exports = JSON.parse("{\"buttonLabel\":\"Javaslatok megjelenítése\",\"countAnnouncement\":\"{optionCount, plural, one {# lehetőség} other {# lehetőség}} áll rendelkezésre.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Belépett a(z) {groupTitle} csoportba, amely {groupCount, plural, one {# lehetőséget} other {# lehetőséget}} tartalmaz. } other {}}{optionText}{isSelected, select, true {, kijelölve} other {}}\",\"listboxLabel\":\"Javaslatok\",\"selectedAnnouncement\":\"{optionText}, kijelölve\"}");


var $77f075bb86ad7091$exports = {};
$77f075bb86ad7091$exports = JSON.parse("{\"buttonLabel\":\"Mostra suggerimenti\",\"countAnnouncement\":\"{optionCount, plural, one {# opzione disponibile} other {# opzioni disponibili}}.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Ingresso nel gruppo {groupTitle}, con {groupCount, plural, one {# opzione} other {# opzioni}}. } other {}}{optionText}{isSelected, select, true {, selezionato} other {}}\",\"listboxLabel\":\"Suggerimenti\",\"selectedAnnouncement\":\"{optionText}, selezionato\"}");


var $6e87462e84907983$exports = {};
$6e87462e84907983$exports = JSON.parse("{\"buttonLabel\":\"候補を表示\",\"countAnnouncement\":\"{optionCount, plural, one {# 個のオプション} other {# 個のオプション}}を利用できます。\",\"focusAnnouncement\":\"{isGroupChange, select, true {入力されたグループ {groupTitle}、{groupCount, plural, one {# 個のオプション} other {# 個のオプション}}を含む。} other {}}{optionText}{isSelected, select, true {、選択済み} other {}}\",\"listboxLabel\":\"候補\",\"selectedAnnouncement\":\"{optionText}、選択済み\"}");


var $9246f2c6edc6b232$exports = {};
$9246f2c6edc6b232$exports = JSON.parse("{\"buttonLabel\":\"제안 사항 표시\",\"countAnnouncement\":\"{optionCount, plural, one {#개 옵션} other {#개 옵션}}을 사용할 수 있습니다.\",\"focusAnnouncement\":\"{isGroupChange, select, true {입력한 그룹 {groupTitle}, {groupCount, plural, one {#개 옵션} other {#개 옵션}}. } other {}}{optionText}{isSelected, select, true {, 선택됨} other {}}\",\"listboxLabel\":\"제안\",\"selectedAnnouncement\":\"{optionText}, 선택됨\"}");


var $e587accc6c0a434c$exports = {};
$e587accc6c0a434c$exports = JSON.parse("{\"buttonLabel\":\"Rodyti pasiūlymus\",\"countAnnouncement\":\"Yra {optionCount, plural, one {# parinktis} other {# parinktys (-ių)}}.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Įvesta grupė {groupTitle}, su {groupCount, plural, one {# parinktimi} other {# parinktimis (-ių)}}. } other {}}{optionText}{isSelected, select, true {, pasirinkta} other {}}\",\"listboxLabel\":\"Pasiūlymai\",\"selectedAnnouncement\":\"{optionText}, pasirinkta\"}");


var $03a1900e7400b5ab$exports = {};
$03a1900e7400b5ab$exports = JSON.parse("{\"buttonLabel\":\"Rādīt ieteikumus\",\"countAnnouncement\":\"Pieejamo opciju skaits: {optionCount, plural, one {# opcija} other {# opcijas}}.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Ievadīta grupa {groupTitle}, ar {groupCount, plural, one {# opciju} other {# opcijām}}. } other {}}{optionText}{isSelected, select, true {, atlasīta} other {}}\",\"listboxLabel\":\"Ieteikumi\",\"selectedAnnouncement\":\"{optionText}, atlasīta\"}");


var $1387676441be6cf6$exports = {};
$1387676441be6cf6$exports = JSON.parse("{\"buttonLabel\":\"Vis forslag\",\"countAnnouncement\":\"{optionCount, plural, one {# alternativ} other {# alternativer}} finnes.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Angitt gruppe {groupTitle}, med {groupCount, plural, one {# alternativ} other {# alternativer}}. } other {}}{optionText}{isSelected, select, true {, valgt} other {}}\",\"listboxLabel\":\"Forslag\",\"selectedAnnouncement\":\"{optionText}, valgt\"}");


var $17e82ebf0f8ab91f$exports = {};
$17e82ebf0f8ab91f$exports = JSON.parse("{\"buttonLabel\":\"Suggesties weergeven\",\"countAnnouncement\":\"{optionCount, plural, one {# optie} other {# opties}} beschikbaar.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Groep {groupTitle} ingevoerd met {groupCount, plural, one {# optie} other {# opties}}. } other {}}{optionText}{isSelected, select, true {, geselecteerd} other {}}\",\"listboxLabel\":\"Suggesties\",\"selectedAnnouncement\":\"{optionText}, geselecteerd\"}");


var $2f5377d3471630e5$exports = {};
$2f5377d3471630e5$exports = JSON.parse("{\"buttonLabel\":\"Wyświetlaj sugestie\",\"countAnnouncement\":\"dostępna/dostępne(-nych) {optionCount, plural, one {# opcja} other {# opcje(-i)}}.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Dołączono do grupy {groupTitle}, z {groupCount, plural, one {# opcją} other {# opcjami}}. } other {}}{optionText}{isSelected, select, true {, wybrano} other {}}\",\"listboxLabel\":\"Sugestie\",\"selectedAnnouncement\":\"{optionText}, wybrano\"}");


var $dee9868b6fa95ffe$exports = {};
$dee9868b6fa95ffe$exports = JSON.parse("{\"buttonLabel\":\"Mostrar sugestões\",\"countAnnouncement\":\"{optionCount, plural, one {# opção} other {# opções}} disponível.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Grupo inserido {groupTitle}, com {groupCount, plural, one {# opção} other {# opções}}. } other {}}{optionText}{isSelected, select, true {, selecionado} other {}}\",\"listboxLabel\":\"Sugestões\",\"selectedAnnouncement\":\"{optionText}, selecionado\"}");


var $f8b2e63637cbb5a6$exports = {};
$f8b2e63637cbb5a6$exports = JSON.parse("{\"buttonLabel\":\"Apresentar sugestões\",\"countAnnouncement\":\"{optionCount, plural, one {# opção} other {# opções}} disponível.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Grupo introduzido {groupTitle}, com {groupCount, plural, one {# opção} other {# opções}}. } other {}}{optionText}{isSelected, select, true {, selecionado} other {}}\",\"listboxLabel\":\"Sugestões\",\"selectedAnnouncement\":\"{optionText}, selecionado\"}");


var $46a885db3b44ea95$exports = {};
$46a885db3b44ea95$exports = JSON.parse("{\"buttonLabel\":\"Afișare sugestii\",\"countAnnouncement\":\"{optionCount, plural, one {# opțiune} other {# opțiuni}} disponibile.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Grup {groupTitle} introdus, cu {groupCount, plural, one {# opțiune} other {# opțiuni}}. } other {}}{optionText}{isSelected, select, true {, selectat} other {}}\",\"listboxLabel\":\"Sugestii\",\"selectedAnnouncement\":\"{optionText}, selectat\"}");


var $50d8a8f0afa9dee5$exports = {};
$50d8a8f0afa9dee5$exports = JSON.parse("{\"buttonLabel\":\"Показать предложения\",\"countAnnouncement\":\"{optionCount, plural, one {# параметр} other {# параметров}} доступно.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Введенная группа {groupTitle}, с {groupCount, plural, one {# параметром} other {# параметрами}}. } other {}}{optionText}{isSelected, select, true {, выбранными} other {}}\",\"listboxLabel\":\"Предложения\",\"selectedAnnouncement\":\"{optionText}, выбрано\"}");


var $2867ee6173245507$exports = {};
$2867ee6173245507$exports = JSON.parse("{\"buttonLabel\":\"Zobraziť návrhy\",\"countAnnouncement\":\"{optionCount, plural, one {# možnosť} other {# možnosti/-í}} k dispozícii.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Zadaná skupina {groupTitle}, s {groupCount, plural, one {# možnosťou} other {# možnosťami}}. } other {}}{optionText}{isSelected, select, true {, vybraté} other {}}\",\"listboxLabel\":\"Návrhy\",\"selectedAnnouncement\":\"{optionText}, vybraté\"}");


var $0631b65beeb09b50$exports = {};
$0631b65beeb09b50$exports = JSON.parse("{\"buttonLabel\":\"Prikaži predloge\",\"countAnnouncement\":\"Na voljo je {optionCount, plural, one {# opcija} other {# opcije}}.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Vnesena skupina {groupTitle}, z {groupCount, plural, one {# opcija} other {# opcije}}. } other {}}{optionText}{isSelected, select, true {, izbrano} other {}}\",\"listboxLabel\":\"Predlogi\",\"selectedAnnouncement\":\"{optionText}, izbrano\"}");


var $65fc749265dcd686$exports = {};
$65fc749265dcd686$exports = JSON.parse("{\"buttonLabel\":\"Prikaži predloge\",\"countAnnouncement\":\"Dostupno još: {optionCount, plural, one {# opcija} other {# opcije/a}}.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Unesena grupa {groupTitle}, s {groupCount, plural, one {# opcijom} other {# optione/a}}. } other {}}{optionText}{isSelected, select, true {, izabranih} other {}}\",\"listboxLabel\":\"Predlozi\",\"selectedAnnouncement\":\"{optionText}, izabrano\"}");


var $69ba655c7853c08e$exports = {};
$69ba655c7853c08e$exports = JSON.parse("{\"buttonLabel\":\"Visa förslag\",\"countAnnouncement\":\"{optionCount, plural, one {# alternativ} other {# alternativ}} tillgängliga.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Ingick i gruppen {groupTitle} med {groupCount, plural, one {# alternativ} other {# alternativ}}. } other {}}{optionText}{isSelected, select, true {, valda} other {}}\",\"listboxLabel\":\"Förslag\",\"selectedAnnouncement\":\"{optionText}, valda\"}");


var $a79794784d61577c$exports = {};
$a79794784d61577c$exports = JSON.parse("{\"buttonLabel\":\"Önerileri göster\",\"countAnnouncement\":\"{optionCount, plural, one {# seçenek} other {# seçenekler}} kullanılabilir.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Girilen grup {groupTitle}, ile {groupCount, plural, one {# seçenek} other {# seçenekler}}. } other {}}{optionText}{isSelected, select, true {, seçildi} other {}}\",\"listboxLabel\":\"Öneriler\",\"selectedAnnouncement\":\"{optionText}, seçildi\"}");


var $c2845791417ebaf4$exports = {};
$c2845791417ebaf4$exports = JSON.parse("{\"buttonLabel\":\"Показати пропозиції\",\"countAnnouncement\":\"{optionCount, plural, one {# параметр} other {# параметри(-ів)}} доступно.\",\"focusAnnouncement\":\"{isGroupChange, select, true {Введена група {groupTitle}, з {groupCount, plural, one {# параметр} other {# параметри(-ів)}}. } other {}}{optionText}{isSelected, select, true {, вибрано} other {}}\",\"listboxLabel\":\"Пропозиції\",\"selectedAnnouncement\":\"{optionText}, вибрано\"}");


var $29b642d0025cc7a4$exports = {};
$29b642d0025cc7a4$exports = JSON.parse("{\"buttonLabel\":\"显示建议\",\"countAnnouncement\":\"有 {optionCount, plural, one {# 个选项} other {# 个选项}}可用。\",\"focusAnnouncement\":\"{isGroupChange, select, true {进入了 {groupTitle} 组，其中有 {groupCount, plural, one {# 个选项} other {# 个选项}}. } other {}}{optionText}{isSelected, select, true {, 已选择} other {}}\",\"listboxLabel\":\"建议\",\"selectedAnnouncement\":\"{optionText}, 已选择\"}");


var $cd36dd33f9d46936$exports = {};
$cd36dd33f9d46936$exports = JSON.parse("{\"buttonLabel\":\"顯示建議\",\"countAnnouncement\":\"{optionCount, plural, one {# 選項} other {# 選項}} 可用。\",\"focusAnnouncement\":\"{isGroupChange, select, true {輸入的群組 {groupTitle}, 有 {groupCount, plural, one {# 選項} other {# 選項}}. } other {}}{optionText}{isSelected, select, true {, 已選取} other {}}\",\"listboxLabel\":\"建議\",\"selectedAnnouncement\":\"{optionText}, 已選取\"}");


$2e84e748dc57e459$exports = {
    "ar-AE": $02cb4c75c506befe$exports,
    "bg-BG": $568b8163f1e56faf$exports,
    "cs-CZ": $87581c0202d106b8$exports,
    "da-DK": $a10a0369f5433ed1$exports,
    "de-DE": $bfd288727d5cb166$exports,
    "el-GR": $ca177778f9a74e3c$exports,
    "en-US": $9b5aa79ef84beb6c$exports,
    "es-ES": $57968e8209de2557$exports,
    "et-EE": $60690790bf4c1c6a$exports,
    "fi-FI": $1101246e8c7d9357$exports,
    "fr-FR": $6404b5cb5b241730$exports,
    "he-IL": $dfeafa702e92e31f$exports,
    "hr-HR": $2d125e0b34676352$exports,
    "hu-HU": $ea029611d7634059$exports,
    "it-IT": $77f075bb86ad7091$exports,
    "ja-JP": $6e87462e84907983$exports,
    "ko-KR": $9246f2c6edc6b232$exports,
    "lt-LT": $e587accc6c0a434c$exports,
    "lv-LV": $03a1900e7400b5ab$exports,
    "nb-NO": $1387676441be6cf6$exports,
    "nl-NL": $17e82ebf0f8ab91f$exports,
    "pl-PL": $2f5377d3471630e5$exports,
    "pt-BR": $dee9868b6fa95ffe$exports,
    "pt-PT": $f8b2e63637cbb5a6$exports,
    "ro-RO": $46a885db3b44ea95$exports,
    "ru-RU": $50d8a8f0afa9dee5$exports,
    "sk-SK": $2867ee6173245507$exports,
    "sl-SI": $0631b65beeb09b50$exports,
    "sr-SP": $65fc749265dcd686$exports,
    "sv-SE": $69ba655c7853c08e$exports,
    "tr-TR": $a79794784d61577c$exports,
    "uk-UA": $c2845791417ebaf4$exports,
    "zh-CN": $29b642d0025cc7a4$exports,
    "zh-TW": $cd36dd33f9d46936$exports
};






function $c350ade66beef0af$export$8c18d1b4f7232bbf(props, state) {
    let { buttonRef: buttonRef , popoverRef: popoverRef , inputRef: inputRef , listBoxRef: listBoxRef , keyboardDelegate: keyboardDelegate , shouldFocusWrap: // completionMode = 'suggest',
    shouldFocusWrap , isReadOnly: isReadOnly , isDisabled: isDisabled  } = props;
    let formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault$5($2e84e748dc57e459$exports)));
    let { menuTriggerProps: menuTriggerProps , menuProps: menuProps  } = $168583247155ddda$export$dc9c12ed27dd1b49({
        type: 'listbox',
        isDisabled: isDisabled || isReadOnly
    }, state, buttonRef);
    // Set listbox id so it can be used when calling getItemId later
    $b1f0cad8af73213b$export$3585ede4d035bf14.set(state, {
        id: menuProps.id
    });
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let delegate = useMemo(()=>keyboardDelegate || new $2a25aae57d74318e$export$a05409b8bb224a5a(state.collection, state.disabledKeys, listBoxRef)
    , [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        listBoxRef
    ]);
    // Use useSelectableCollection to get the keyboard handlers to apply to the textfield
    let { collectionProps: collectionProps  } = $ae20dd8cbca75726$export$d6daf82dcd84e87c({
        selectionManager: state.selectionManager,
        keyboardDelegate: delegate,
        disallowTypeAhead: true,
        disallowEmptySelection: true,
        shouldFocusWrap: shouldFocusWrap,
        ref: inputRef,
        // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
        isVirtualized: true
    });
    // For textfield specific keydown operations
    let onKeyDown = (e)=>{
        switch(e.key){
            case 'Enter':
            case 'Tab':
                // Prevent form submission if menu is open since we may be selecting a option
                if (state.isOpen && e.key === 'Enter') e.preventDefault();
                state.commit();
                break;
            case 'Escape':
                state.revert();
                break;
            case 'ArrowDown':
                state.open('first', 'manual');
                break;
            case 'ArrowUp':
                state.open('last', 'manual');
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                state.selectionManager.setFocusedKey(null);
                break;
        }
    };
    let onBlur = (e)=>{
        var ref;
        // Ignore blur if focused moved to the button or into the popover.
        if (e.relatedTarget === (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) || ((ref = popoverRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.relatedTarget))) return;
        if (props.onBlur) props.onBlur(e);
        state.setFocused(false);
    };
    let onFocus = (e)=>{
        if (state.isFocused) return;
        if (props.onFocus) props.onFocus(e);
        state.setFocused(true);
    };
    let { labelProps: labelProps , inputProps: inputProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = $2d73ec29415bd339$export$712718f7aec83d5({
        ...props,
        onChange: state.setInputValue,
        onKeyDown: !isReadOnly && $ff5963eb1fccf552$export$e08e3b67e392101e(state.isOpen && collectionProps.onKeyDown, onKeyDown, props.onKeyDown),
        onBlur: onBlur,
        value: state.inputValue,
        onFocus: onFocus,
        autoComplete: 'off'
    }, inputRef);
    // Press handlers for the ComboBox button
    let onPress = (e)=>{
        if (e.pointerType === 'touch') {
            // Focus the input field in case it isn't focused yet
            inputRef.current.focus();
            state.toggle(null, 'manual');
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType !== 'touch') {
            inputRef.current.focus();
            state.toggle(e.pointerType === 'keyboard' || e.pointerType === 'virtual' ? 'first' : null, 'manual');
        }
    };
    let triggerLabelProps = $313b98861ee5dd6c$export$d6875122194c7b44({
        id: menuTriggerProps.id,
        'aria-label': formatMessage('buttonLabel'),
        'aria-labelledby': props['aria-labelledby'] || labelProps.id
    });
    let listBoxProps = $313b98861ee5dd6c$export$d6875122194c7b44({
        id: menuProps.id,
        'aria-label': formatMessage('listboxLabel'),
        'aria-labelledby': props['aria-labelledby'] || labelProps.id
    });
    // If a touch happens on direct center of ComboBox input, might be virtual click from iPad so open ComboBox menu
    let lastEventTime = useRef(0);
    let onTouchEnd = (e)=>{
        if (isDisabled || isReadOnly) return;
        // Sometimes VoiceOver on iOS fires two touchend events in quick succession. Ignore the second one.
        if (e.timeStamp - lastEventTime.current < 500) {
            e.preventDefault();
            inputRef.current.focus();
            return;
        }
        let rect = e.target.getBoundingClientRect();
        let touch = e.changedTouches[0];
        let centerX = Math.ceil(rect.left + 0.5 * rect.width);
        let centerY = Math.ceil(rect.top + 0.5 * rect.height);
        if (touch.clientX === centerX && touch.clientY === centerY) {
            e.preventDefault();
            inputRef.current.focus();
            state.toggle(null, 'manual');
            lastEventTime.current = e.timeStamp;
        }
    };
    // VoiceOver has issues with announcing aria-activedescendant properly on change
    // (especially on iOS). We use a live region announcer to announce focus changes
    // manually. In addition, section titles are announced when navigating into a new section.
    let focusedItem = state.selectionManager.focusedKey != null && state.isOpen ? state.collection.getItem(state.selectionManager.focusedKey) : undefined;
    var ref1;
    let sectionKey = (ref1 = focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.parentKey) !== null && ref1 !== void 0 ? ref1 : null;
    var _focusedKey;
    let itemKey = (_focusedKey = state.selectionManager.focusedKey) !== null && _focusedKey !== void 0 ? _focusedKey : null;
    let lastSection = useRef(sectionKey);
    let lastItem = useRef(itemKey);
    useEffect(()=>{
        if ($c87311424ea30a05$export$e1865c3bedcd822b() && focusedItem != null && itemKey !== lastItem.current) {
            let isSelected = state.selectionManager.isSelected(itemKey);
            let section = sectionKey != null ? state.collection.getItem(sectionKey) : null;
            let sectionTitle = (section === null || section === void 0 ? void 0 : section['aria-label']) || (typeof (section === null || section === void 0 ? void 0 : section.rendered) === 'string' ? section.rendered : '') || '';
            let announcement = formatMessage('focusAnnouncement', {
                isGroupChange: section && sectionKey !== lastSection.current,
                groupTitle: sectionTitle,
                groupCount: section ? [
                    ...section.childNodes
                ].length : 0,
                optionText: focusedItem['aria-label'] || focusedItem.textValue || '',
                isSelected: isSelected
            });
            $319e236875307eab$export$a9b970dcc4ae71a9(announcement);
        }
        lastSection.current = sectionKey;
        lastItem.current = itemKey;
    });
    // Announce the number of available suggestions when it changes
    let optionCount = $453cc9f0df89c0a5$export$77d5aafae4e095b2(state.collection);
    let lastSize = useRef(optionCount);
    let lastOpen = useRef(state.isOpen);
    useEffect(()=>{
        // Only announce the number of options available when the menu opens if there is no
        // focused item, otherwise screen readers will typically read e.g. "1 of 6".
        // The exception is VoiceOver since this isn't included in the message above.
        let didOpenWithoutFocusedItem = state.isOpen !== lastOpen.current && (state.selectionManager.focusedKey == null || $c87311424ea30a05$export$e1865c3bedcd822b());
        if (state.isOpen && (didOpenWithoutFocusedItem || optionCount !== lastSize.current)) {
            let announcement = formatMessage('countAnnouncement', {
                optionCount: optionCount
            });
            $319e236875307eab$export$a9b970dcc4ae71a9(announcement);
        }
        lastSize.current = optionCount;
        lastOpen.current = state.isOpen;
    });
    // Announce when a selection occurs for VoiceOver. Other screen readers typically do this automatically.
    let lastSelectedKey = useRef(state.selectedKey);
    useEffect(()=>{
        if ($c87311424ea30a05$export$e1865c3bedcd822b() && state.isFocused && state.selectedItem && state.selectedKey !== lastSelectedKey.current) {
            let optionText = state.selectedItem['aria-label'] || state.selectedItem.textValue || '';
            let announcement = formatMessage('selectedAnnouncement', {
                optionText: optionText
            });
            $319e236875307eab$export$a9b970dcc4ae71a9(announcement);
        }
        lastSelectedKey.current = state.selectedKey;
    });
    useEffect(()=>{
        if (state.isOpen) return $5e3802645cc19319$export$1c3ebcada18427bf([
            inputRef.current,
            popoverRef.current
        ]);
    }, [
        state.isOpen,
        inputRef,
        popoverRef
    ]);
    return {
        labelProps: labelProps,
        buttonProps: {
            ...menuTriggerProps,
            ...triggerLabelProps,
            excludeFromTabOrder: true,
            onPress: onPress,
            onPressStart: onPressStart,
            isDisabled: isDisabled || isReadOnly
        },
        inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(inputProps, {
            role: 'combobox',
            'aria-expanded': menuTriggerProps['aria-expanded'],
            'aria-controls': state.isOpen ? menuProps.id : undefined,
            // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
            'aria-autocomplete': 'list',
            'aria-activedescendant': focusedItem ? $b1f0cad8af73213b$export$9145995848b05025(state, focusedItem.key) : undefined,
            onTouchEnd: onTouchEnd,
            // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
            autoCorrect: 'off',
            // This disable's the macOS Safari spell check auto corrections.
            spellCheck: 'false'
        }),
        listBoxProps: $3ef42575df84b30b$export$9d1611c77c2fe928(menuProps, listBoxProps, {
            autoFocus: state.focusStrategy,
            shouldUseVirtualFocus: true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true
        }),
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

function $parcel$export$g(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $40df3f8667284809$exports = {};

$parcel$export$g($40df3f8667284809$exports, "useDialog", () => $40df3f8667284809$export$d55e7ee900f34e93);



function $40df3f8667284809$export$d55e7ee900f34e93(props, ref) {
    let { role: role = 'dialog'  } = props;
    let titleId = $bdb11010cef70236$export$b4cc09c592e8fdb8();
    titleId = props['aria-label'] ? undefined : titleId;
    // Focus the dialog itself on mount, unless a child element is already focused.
    useEffect(()=>{
        if (ref.current && !ref.current.contains(document.activeElement)) {
            $6a99195332edec8b$export$80f3e147d781571c(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            let timeout = setTimeout(()=>{
                if (document.activeElement === ref.current) {
                    ref.current.blur();
                    $6a99195332edec8b$export$80f3e147d781571c(ref.current);
                }
            }, 500);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        ref
    ]);
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: {
            ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
                labelable: true
            }),
            role: role,
            tabIndex: -1,
            'aria-labelledby': props['aria-labelledby'] || titleId
        },
        titleProps: {
            id: titleId
        }
    };
}

function $parcel$export$f(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $204d9ebcedfb8806$exports = {};

$parcel$export$f($204d9ebcedfb8806$exports, "useProgressBar", () => $204d9ebcedfb8806$export$ed5abd763a836edc);



function $204d9ebcedfb8806$export$ed5abd763a836edc(props) {
    let { value: value = 0 , minValue: minValue = 0 , maxValue: maxValue = 100 , valueLabel: valueLabel , isIndeterminate: isIndeterminate , formatOptions: formatOptions = {
        style: 'percent'
    }  } = props;
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    let { labelProps: labelProps , fieldProps: fieldProps  } = $d191a55c9702f145$export$8467354a121f1b9f({
        ...props,
        // Progress bar is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    value = $9446cca9a3875146$export$7d15b64cf5a3a4c4(value, minValue, maxValue);
    let percentage = (value - minValue) / (maxValue - minValue);
    let formatter = $a916eb452884faea$export$b7a616150fdb9f44(formatOptions);
    if (!isIndeterminate && !valueLabel) {
        let valueToFormat = formatOptions.style === 'percent' ? percentage : value;
        valueLabel = formatter.format(valueToFormat);
    }
    return {
        progressBarProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
            ...fieldProps,
            'aria-valuenow': isIndeterminate ? undefined : value,
            'aria-valuemin': minValue,
            'aria-valuemax': maxValue,
            'aria-valuetext': isIndeterminate ? undefined : valueLabel,
            role: 'progressbar'
        }),
        labelProps: labelProps
    };
}

function $parcel$export$e(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $0002d7e1d16de204$exports = {};

$parcel$export$e($0002d7e1d16de204$exports, "useMeter", () => $0002d7e1d16de204$export$e969dbfa146870ff);

function $0002d7e1d16de204$export$e969dbfa146870ff(props) {
    let { progressBarProps: progressBarProps , labelProps: labelProps  } = $204d9ebcedfb8806$export$ed5abd763a836edc(props);
    return {
        meterProps: {
            ...progressBarProps,
            // Use the meter role if available, but fall back to progressbar if not
            // Chrome currently falls back from meter automatically, and Firefox
            // does not support meter at all. Safari 13+ seems to support meter properly.
            // https://bugs.chromium.org/p/chromium/issues/detail?id=944542
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1460378
            role: 'meter progressbar'
        },
        labelProps: labelProps
    };
}

function $parcel$interopDefault$4(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export$d(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $d2e8511e6f209edf$exports = {};

$parcel$export$d($d2e8511e6f209edf$exports, "useSpinButton", () => $d2e8511e6f209edf$export$e908e06f4b8e3402);


var $c6208a7792e31a37$exports = {};
var $ed6aae4e5f766f1e$exports = {};
$ed6aae4e5f766f1e$exports = JSON.parse("{\"Empty\":\"فارغ\"}");


var $38854e2b175151fa$exports = {};
$38854e2b175151fa$exports = JSON.parse("{\"Empty\":\"Изпразни\"}");


var $15b25ab20f3945b2$exports = {};
$15b25ab20f3945b2$exports = JSON.parse("{\"Empty\":\"Prázdné\"}");


var $692a4298b6b649a2$exports = {};
$692a4298b6b649a2$exports = JSON.parse("{\"Empty\":\"Tom\"}");


var $1c6e1539193f1243$exports = {};
$1c6e1539193f1243$exports = JSON.parse("{\"Empty\":\"Leer\"}");


var $1e8678632c464b6d$exports = {};
$1e8678632c464b6d$exports = JSON.parse("{\"Empty\":\"Άδειο\"}");


var $4adc85d9bf5b9eed$exports = {};
$4adc85d9bf5b9eed$exports = JSON.parse("{\"Empty\":\"Empty\"}");


var $41c4b2bb61dafbca$exports = {};
$41c4b2bb61dafbca$exports = JSON.parse("{\"Empty\":\"Vacío\"}");


var $405f8b24f5dd2a60$exports = {};
$405f8b24f5dd2a60$exports = JSON.parse("{\"Empty\":\"Tühjenda\"}");


var $7efe3ed02b9b9dd4$exports = {};
$7efe3ed02b9b9dd4$exports = JSON.parse("{\"Empty\":\"Tyhjä\"}");


var $99fc4c101d92daf3$exports = {};
$99fc4c101d92daf3$exports = JSON.parse("{\"Empty\":\"Vide\"}");


var $f9e155e6e8cacaa2$exports = {};
$f9e155e6e8cacaa2$exports = JSON.parse("{\"Empty\":\"ריק\"}");


var $c31b5e8e9a249fd5$exports = {};
$c31b5e8e9a249fd5$exports = JSON.parse("{\"Empty\":\"Prazno\"}");


var $9c5435bc17499bd9$exports = {};
$9c5435bc17499bd9$exports = JSON.parse("{\"Empty\":\"Üres\"}");


var $6d1fc8e84d8165e1$exports = {};
$6d1fc8e84d8165e1$exports = JSON.parse("{\"Empty\":\"Vuoto\"}");


var $46ea6b3641b83e71$exports = {};
$46ea6b3641b83e71$exports = JSON.parse("{\"Empty\":\"空\"}");


var $0e3cc9a288289dc5$exports = {};
$0e3cc9a288289dc5$exports = JSON.parse("{\"Empty\":\"비어 있음\"}");


var $4ff2bb25c0089ffb$exports = {};
$4ff2bb25c0089ffb$exports = JSON.parse("{\"Empty\":\"Tuščias\"}");


var $6cf33cd4c010a2fb$exports = {};
$6cf33cd4c010a2fb$exports = JSON.parse("{\"Empty\":\"Tukšs\"}");


var $5a9f8486f8b8837e$exports = {};
$5a9f8486f8b8837e$exports = JSON.parse("{\"Empty\":\"Tom\"}");


var $583f94d807f6ecea$exports = {};
$583f94d807f6ecea$exports = JSON.parse("{\"Empty\":\"Leeg\"}");


var $cc4dcfeea2b4050d$exports = {};
$cc4dcfeea2b4050d$exports = JSON.parse("{\"Empty\":\"Pusty\"}");


var $68ac2954d56e12b4$exports = {};
$68ac2954d56e12b4$exports = JSON.parse("{\"Empty\":\"Vazio\"}");


var $fdb0616f309780b0$exports = {};
$fdb0616f309780b0$exports = JSON.parse("{\"Empty\":\"Vazio\"}");


var $fe1eccf4ee1d6f52$exports = {};
$fe1eccf4ee1d6f52$exports = JSON.parse("{\"Empty\":\"Gol\"}");


var $a38b6c4e18725976$exports = {};
$a38b6c4e18725976$exports = JSON.parse("{\"Empty\":\"Не заполнено\"}");


var $6c14ae2b766b652c$exports = {};
$6c14ae2b766b652c$exports = JSON.parse("{\"Empty\":\"Prázdne\"}");


var $8f1c9692e16dc5eb$exports = {};
$8f1c9692e16dc5eb$exports = JSON.parse("{\"Empty\":\"Prazen\"}");


var $d2aa7abea627cafa$exports = {};
$d2aa7abea627cafa$exports = JSON.parse("{\"Empty\":\"Prazno\"}");


var $676b82e4b56408e6$exports = {};
$676b82e4b56408e6$exports = JSON.parse("{\"Empty\":\"Tomt\"}");


var $14c9042552d7ce08$exports = {};
$14c9042552d7ce08$exports = JSON.parse("{\"Empty\":\"Boş\"}");


var $393254ebcb66c9f5$exports = {};
$393254ebcb66c9f5$exports = JSON.parse("{\"Empty\":\"Пусто\"}");


var $d49d621f310cf6ce$exports = {};
$d49d621f310cf6ce$exports = JSON.parse("{\"Empty\":\"空\"}");


var $94b60c866ca5dfe6$exports = {};
$94b60c866ca5dfe6$exports = JSON.parse("{\"Empty\":\"空白\"}");


$c6208a7792e31a37$exports = {
    "ar-AE": $ed6aae4e5f766f1e$exports,
    "bg-BG": $38854e2b175151fa$exports,
    "cs-CZ": $15b25ab20f3945b2$exports,
    "da-DK": $692a4298b6b649a2$exports,
    "de-DE": $1c6e1539193f1243$exports,
    "el-GR": $1e8678632c464b6d$exports,
    "en-US": $4adc85d9bf5b9eed$exports,
    "es-ES": $41c4b2bb61dafbca$exports,
    "et-EE": $405f8b24f5dd2a60$exports,
    "fi-FI": $7efe3ed02b9b9dd4$exports,
    "fr-FR": $99fc4c101d92daf3$exports,
    "he-IL": $f9e155e6e8cacaa2$exports,
    "hr-HR": $c31b5e8e9a249fd5$exports,
    "hu-HU": $9c5435bc17499bd9$exports,
    "it-IT": $6d1fc8e84d8165e1$exports,
    "ja-JP": $46ea6b3641b83e71$exports,
    "ko-KR": $0e3cc9a288289dc5$exports,
    "lt-LT": $4ff2bb25c0089ffb$exports,
    "lv-LV": $6cf33cd4c010a2fb$exports,
    "nb-NO": $5a9f8486f8b8837e$exports,
    "nl-NL": $583f94d807f6ecea$exports,
    "pl-PL": $cc4dcfeea2b4050d$exports,
    "pt-BR": $68ac2954d56e12b4$exports,
    "pt-PT": $fdb0616f309780b0$exports,
    "ro-RO": $fe1eccf4ee1d6f52$exports,
    "ru-RU": $a38b6c4e18725976$exports,
    "sk-SK": $6c14ae2b766b652c$exports,
    "sl-SI": $8f1c9692e16dc5eb$exports,
    "sr-SP": $d2aa7abea627cafa$exports,
    "sv-SE": $676b82e4b56408e6$exports,
    "tr-TR": $14c9042552d7ce08$exports,
    "uk-UA": $393254ebcb66c9f5$exports,
    "zh-CN": $d49d621f310cf6ce$exports,
    "zh-TW": $94b60c866ca5dfe6$exports
};




function $d2e8511e6f209edf$export$e908e06f4b8e3402(props) {
    const _async = useRef();
    let { value: value , textValue: textValue , minValue: minValue , maxValue: maxValue , isDisabled: isDisabled , isReadOnly: isReadOnly , isRequired: isRequired , onIncrement: onIncrement , onIncrementPage: onIncrementPage , onDecrement: onDecrement , onDecrementPage: onDecrementPage , onDecrementToMin: onDecrementToMin , onIncrementToMax: onIncrementToMax  } = props;
    const formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault$4($c6208a7792e31a37$exports)));
    const propsRef = useRef(props);
    propsRef.current = props;
    const clearAsync = ()=>clearTimeout(_async.current)
    ;
    // eslint-disable-next-line arrow-body-style
    useEffect(()=>{
        return ()=>clearAsync()
        ;
    }, []);
    let onKeyDown = (e)=>{
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || isReadOnly) return;
        switch(e.key){
            case 'PageUp':
                if (onIncrementPage) {
                    e.preventDefault();
                    onIncrementPage();
                    break;
                }
            // fallthrough!
            case 'ArrowUp':
            case 'Up':
                if (onIncrement) {
                    e.preventDefault();
                    onIncrement();
                }
                break;
            case 'PageDown':
                if (onDecrementPage) {
                    e.preventDefault();
                    onDecrementPage();
                    break;
                }
            // fallthrough
            case 'ArrowDown':
            case 'Down':
                if (onDecrement) {
                    e.preventDefault();
                    onDecrement();
                }
                break;
            case 'Home':
                if (onDecrementToMin) {
                    e.preventDefault();
                    onDecrementToMin();
                }
                break;
            case 'End':
                if (onIncrementToMax) {
                    e.preventDefault();
                    onIncrementToMax();
                }
                break;
        }
    };
    let isFocused = useRef(false);
    let onFocus = ()=>{
        isFocused.current = true;
    };
    let onBlur = ()=>{
        isFocused.current = false;
    };
    // Replace Unicode hyphen-minus (U+002D) with minus sign (U+2212).
    // This ensures that macOS VoiceOver announces it as "minus" even with other characters between the minus sign
    // and the number (e.g. currency symbol). Otherwise it announces nothing because it assumes the character is a hyphen.
    // In addition, replace the empty string with the word "Empty" so that iOS VoiceOver does not read "50%" for an empty field.
    textValue = textValue === '' ? formatMessage('Empty') : (textValue || `${value}`).replace('-', '\u2212');
    useEffect(()=>{
        if (isFocused.current) $319e236875307eab$export$a9b970dcc4ae71a9(textValue, 'assertive');
    }, [
        textValue
    ]);
    const onIncrementPressStart = useCallback((initialStepDelay)=>{
        clearAsync();
        propsRef.current.onIncrement();
        // Start spinning after initial delay
        _async.current = window.setTimeout(()=>{
            if (isNaN(maxValue) || isNaN(value) || value < maxValue) onIncrementPressStart(60);
        }, initialStepDelay);
    }, [
        onIncrement,
        maxValue,
        value
    ]);
    const onDecrementPressStart = useCallback((initialStepDelay)=>{
        clearAsync();
        propsRef.current.onDecrement();
        // Start spinning after initial delay
        _async.current = window.setTimeout(()=>{
            if (isNaN(minValue) || isNaN(value) || value > minValue) onDecrementPressStart(60);
        }, initialStepDelay);
    }, [
        onDecrement,
        minValue,
        value
    ]);
    let cancelContextMenu = (e)=>{
        e.preventDefault();
    };
    let { addGlobalListener: addGlobalListener , removeAllGlobalListeners: removeAllGlobalListeners  } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
    return {
        spinButtonProps: {
            role: 'spinbutton',
            'aria-valuenow': !isNaN(value) ? value : null,
            'aria-valuetext': textValue,
            'aria-valuemin': minValue,
            'aria-valuemax': maxValue,
            'aria-disabled': isDisabled || null,
            'aria-readonly': isReadOnly || null,
            'aria-required': isRequired || null,
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: onBlur
        },
        incrementButtonProps: {
            onPressStart: ()=>{
                onIncrementPressStart(400);
                addGlobalListener(window, 'contextmenu', cancelContextMenu);
            },
            onPressEnd: ()=>{
                clearAsync();
                removeAllGlobalListeners();
            },
            onFocus: onFocus,
            onBlur: onBlur
        },
        decrementButtonProps: {
            onPressStart: ()=>{
                onDecrementPressStart(400);
                addGlobalListener(window, 'contextmenu', cancelContextMenu);
            },
            onPressEnd: ()=>{
                clearAsync();
                removeAllGlobalListeners();
            },
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

function $parcel$interopDefault$3(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export$c(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $81397a9303501bda$exports = {};

$parcel$export$c($81397a9303501bda$exports, "useNumberField", () => $81397a9303501bda$export$23f548e970bdf099);


var $c3ef0f8b54adbb57$exports = {};
var $fb78e0f6ab6349ed$exports = {};
$fb78e0f6ab6349ed$exports = JSON.parse("{\"decrease\":\"خفض {fieldLabel}\",\"increase\":\"زيادة {fieldLabel}\",\"numberField\":\"حقل رقمي\"}");


var $2776acdd9959a647$exports = {};
$2776acdd9959a647$exports = JSON.parse("{\"decrease\":\"Намаляване {fieldLabel}\",\"increase\":\"Усилване {fieldLabel}\",\"numberField\":\"Номер на полето\"}");


var $741954410a365ad3$exports = {};
$741954410a365ad3$exports = JSON.parse("{\"decrease\":\"Snížit {fieldLabel}\",\"increase\":\"Zvýšit {fieldLabel}\",\"numberField\":\"Číselné pole\"}");


var $8321ed0f8ab642f0$exports = {};
$8321ed0f8ab642f0$exports = JSON.parse("{\"decrease\":\"Reducer {fieldLabel}\",\"increase\":\"Øg {fieldLabel}\",\"numberField\":\"Talfelt\"}");


var $92978e0c4ecafa32$exports = {};
$92978e0c4ecafa32$exports = JSON.parse("{\"decrease\":\"{fieldLabel} verringern\",\"increase\":\"{fieldLabel} erhöhen\",\"numberField\":\"Nummernfeld\"}");


var $ac5ff71962864a84$exports = {};
$ac5ff71962864a84$exports = JSON.parse("{\"decrease\":\"Μείωση {fieldLabel}\",\"increase\":\"Αύξηση {fieldLabel}\",\"numberField\":\"Πεδίο αριθμού\"}");


var $efe4685e2440d8be$exports = {};
$efe4685e2440d8be$exports = JSON.parse("{\"decrease\":\"Decrease {fieldLabel}\",\"increase\":\"Increase {fieldLabel}\",\"numberField\":\"Number field\"}");


var $e50a9a48739b90e1$exports = {};
$e50a9a48739b90e1$exports = JSON.parse("{\"decrease\":\"Reducir {fieldLabel}\",\"increase\":\"Aumentar {fieldLabel}\",\"numberField\":\"Campo de número\"}");


var $6e0d5294ecbb8ab6$exports = {};
$6e0d5294ecbb8ab6$exports = JSON.parse("{\"decrease\":\"Vähenda {fieldLabel}\",\"increase\":\"Suurenda {fieldLabel}\",\"numberField\":\"Numbri väli\"}");


var $e7129d65f607f77f$exports = {};
$e7129d65f607f77f$exports = JSON.parse("{\"decrease\":\"Vähennä {fieldLabel}\",\"increase\":\"Lisää {fieldLabel}\",\"numberField\":\"Numerokenttä\"}");


var $d72adf5b20573e34$exports = {};
$d72adf5b20573e34$exports = JSON.parse("{\"decrease\":\"Diminuer {fieldLabel}\",\"increase\":\"Augmenter {fieldLabel}\",\"numberField\":\"Champ de nombre\"}");


var $a25c707e88b844a7$exports = {};
$a25c707e88b844a7$exports = JSON.parse("{\"decrease\":\"הקטן {fieldLabel}\",\"increase\":\"הגדל {fieldLabel}\",\"numberField\":\"שדה מספר\"}");


var $69b41140b9a4ca54$exports = {};
$69b41140b9a4ca54$exports = JSON.parse("{\"decrease\":\"Smanji {fieldLabel}\",\"increase\":\"Povećaj {fieldLabel}\",\"numberField\":\"Polje broja\"}");


var $81dab28f37f59d1a$exports = {};
$81dab28f37f59d1a$exports = JSON.parse("{\"decrease\":\"{fieldLabel} csökkentése\",\"increase\":\"{fieldLabel} növelése\",\"numberField\":\"Számmező\"}");


var $866555b31f2d7711$exports = {};
$866555b31f2d7711$exports = JSON.parse("{\"decrease\":\"Riduci {fieldLabel}\",\"increase\":\"Aumenta {fieldLabel}\",\"numberField\":\"Campo numero\"}");


var $dafcd55d52b9d371$exports = {};
$dafcd55d52b9d371$exports = JSON.parse("{\"decrease\":\"{fieldLabel}を縮小\",\"increase\":\"{fieldLabel}を拡大\",\"numberField\":\"数値フィールド\"}");


var $f090c1f8c5da0145$exports = {};
$f090c1f8c5da0145$exports = JSON.parse("{\"decrease\":\"{fieldLabel} 감소\",\"increase\":\"{fieldLabel} 증가\",\"numberField\":\"번호 필드\"}");


var $6f10f3a13360a75c$exports = {};
$6f10f3a13360a75c$exports = JSON.parse("{\"decrease\":\"Sumažinti {fieldLabel}\",\"increase\":\"Padidinti {fieldLabel}\",\"numberField\":\"Numerio laukas\"}");


var $47432cefd4b7bd1b$exports = {};
$47432cefd4b7bd1b$exports = JSON.parse("{\"decrease\":\"Samazināšana {fieldLabel}\",\"increase\":\"Palielināšana {fieldLabel}\",\"numberField\":\"Skaitļu lauks\"}");


var $dc578a950a2bf23d$exports = {};
$dc578a950a2bf23d$exports = JSON.parse("{\"decrease\":\"Reduser {fieldLabel}\",\"increase\":\"Øk {fieldLabel}\",\"numberField\":\"Tallfelt\"}");


var $353f1bfca4dc395a$exports = {};
$353f1bfca4dc395a$exports = JSON.parse("{\"decrease\":\"{fieldLabel} verlagen\",\"increase\":\"{fieldLabel} verhogen\",\"numberField\":\"Getalveld\"}");


var $241bc0bbd870e982$exports = {};
$241bc0bbd870e982$exports = JSON.parse("{\"decrease\":\"Zmniejsz {fieldLabel}\",\"increase\":\"Zwiększ {fieldLabel}\",\"numberField\":\"Pole numeru\"}");


var $da3005c7bd72b0a8$exports = {};
$da3005c7bd72b0a8$exports = JSON.parse("{\"decrease\":\"Diminuir {fieldLabel}\",\"increase\":\"Aumentar {fieldLabel}\",\"numberField\":\"Campo de número\"}");


var $cf48bfc540882310$exports = {};
$cf48bfc540882310$exports = JSON.parse("{\"decrease\":\"Diminuir {fieldLabel}\",\"increase\":\"Aumentar {fieldLabel}\",\"numberField\":\"Campo numérico\"}");


var $b63a28c481ab9ee3$exports = {};
$b63a28c481ab9ee3$exports = JSON.parse("{\"decrease\":\"Scădere {fieldLabel}\",\"increase\":\"Creștere {fieldLabel}\",\"numberField\":\"Câmp numeric\"}");


var $19f9df95c2464ab6$exports = {};
$19f9df95c2464ab6$exports = JSON.parse("{\"decrease\":\"Уменьшение {fieldLabel}\",\"increase\":\"Увеличение {fieldLabel}\",\"numberField\":\"Числовое поле\"}");


var $b272932a685e8482$exports = {};
$b272932a685e8482$exports = JSON.parse("{\"decrease\":\"Znížiť {fieldLabel}\",\"increase\":\"Zvýšiť {fieldLabel}\",\"numberField\":\"Číselné pole\"}");


var $cbaf8b5b61f9e544$exports = {};
$cbaf8b5b61f9e544$exports = JSON.parse("{\"decrease\":\"Upadati {fieldLabel}\",\"increase\":\"Povečajte {fieldLabel}\",\"numberField\":\"Številčno polje\"}");


var $e0a3af6ac1449b2f$exports = {};
$e0a3af6ac1449b2f$exports = JSON.parse("{\"decrease\":\"Decrease {fieldLabel}\",\"increase\":\"Increase {fieldLabel}\",\"numberField\":\"Number field\"}");


var $71e167d2458a6019$exports = {};
$71e167d2458a6019$exports = JSON.parse("{\"decrease\":\"Minska {fieldLabel}\",\"increase\":\"Öka {fieldLabel}\",\"numberField\":\"Nummerfält\"}");


var $3719245abc082946$exports = {};
$3719245abc082946$exports = JSON.parse("{\"decrease\":\"{fieldLabel} azalt\",\"increase\":\"{fieldLabel} arttır\",\"numberField\":\"Sayı alanı\"}");


var $2ccc589e2f51824d$exports = {};
$2ccc589e2f51824d$exports = JSON.parse("{\"decrease\":\"Зменшити {fieldLabel}\",\"increase\":\"Збільшити {fieldLabel}\",\"numberField\":\"Поле номера\"}");


var $e1103cb9b4c13942$exports = {};
$e1103cb9b4c13942$exports = JSON.parse("{\"decrease\":\"降低 {fieldLabel}\",\"increase\":\"提高 {fieldLabel}\",\"numberField\":\"数字字段\"}");


var $448607634f80dccb$exports = {};
$448607634f80dccb$exports = JSON.parse("{\"decrease\":\"縮小 {fieldLabel}\",\"increase\":\"放大 {fieldLabel}\",\"numberField\":\"數字欄位\"}");


$c3ef0f8b54adbb57$exports = {
    "ar-AE": $fb78e0f6ab6349ed$exports,
    "bg-BG": $2776acdd9959a647$exports,
    "cs-CZ": $741954410a365ad3$exports,
    "da-DK": $8321ed0f8ab642f0$exports,
    "de-DE": $92978e0c4ecafa32$exports,
    "el-GR": $ac5ff71962864a84$exports,
    "en-US": $efe4685e2440d8be$exports,
    "es-ES": $e50a9a48739b90e1$exports,
    "et-EE": $6e0d5294ecbb8ab6$exports,
    "fi-FI": $e7129d65f607f77f$exports,
    "fr-FR": $d72adf5b20573e34$exports,
    "he-IL": $a25c707e88b844a7$exports,
    "hr-HR": $69b41140b9a4ca54$exports,
    "hu-HU": $81dab28f37f59d1a$exports,
    "it-IT": $866555b31f2d7711$exports,
    "ja-JP": $dafcd55d52b9d371$exports,
    "ko-KR": $f090c1f8c5da0145$exports,
    "lt-LT": $6f10f3a13360a75c$exports,
    "lv-LV": $47432cefd4b7bd1b$exports,
    "nb-NO": $dc578a950a2bf23d$exports,
    "nl-NL": $353f1bfca4dc395a$exports,
    "pl-PL": $241bc0bbd870e982$exports,
    "pt-BR": $da3005c7bd72b0a8$exports,
    "pt-PT": $cf48bfc540882310$exports,
    "ro-RO": $b63a28c481ab9ee3$exports,
    "ru-RU": $19f9df95c2464ab6$exports,
    "sk-SK": $b272932a685e8482$exports,
    "sl-SI": $cbaf8b5b61f9e544$exports,
    "sr-SP": $e0a3af6ac1449b2f$exports,
    "sv-SE": $71e167d2458a6019$exports,
    "tr-TR": $3719245abc082946$exports,
    "uk-UA": $2ccc589e2f51824d$exports,
    "zh-CN": $e1103cb9b4c13942$exports,
    "zh-TW": $448607634f80dccb$exports
};







function $81397a9303501bda$export$23f548e970bdf099(props, state, inputRef) {
    let { id: id , decrementAriaLabel: decrementAriaLabel , incrementAriaLabel: incrementAriaLabel , isDisabled: isDisabled , isReadOnly: isReadOnly , isRequired: isRequired , minValue: minValue , maxValue: maxValue , autoFocus: autoFocus , validationState: validationState , label: label , formatOptions: formatOptions , onBlur: onBlur , onFocus: onFocus , onFocusChange: onFocusChange , onKeyDown: onKeyDown , onKeyUp: onKeyUp , description: description , errorMessage: errorMessage , ...otherProps } = props;
    let { increment: increment , incrementToMax: incrementToMax , decrement: decrement , decrementToMin: decrementToMin , numberValue: numberValue , commit: commit  } = state;
    const formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault$3($c3ef0f8b54adbb57$exports)));
    let inputId = $bdb11010cef70236$export$f680877a34711e37(id);
    let { focusProps: focusProps  } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
        onBlur: ()=>{
            // Set input value to normalized valid value
            commit();
        }
    });
    let { spinButtonProps: spinButtonProps , incrementButtonProps: incButtonProps , decrementButtonProps: decButtonProps  } = $d2e8511e6f209edf$export$e908e06f4b8e3402({
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        maxValue: maxValue,
        minValue: minValue,
        onIncrement: increment,
        onIncrementToMax: incrementToMax,
        onDecrement: decrement,
        onDecrementToMin: decrementToMin,
        value: numberValue,
        textValue: state.inputValue
    });
    let [focusWithin, setFocusWithin] = useState(false);
    let { focusWithinProps: focusWithinProps  } = $9ab94262bd0047c7$export$420e68273165f4ec({
        isDisabled: isDisabled,
        onFocusWithinChange: setFocusWithin
    });
    let onWheel = useCallback((e)=>{
        // if on a trackpad, users can scroll in both X and Y at once, check the magnitude of the change
        // if it's mostly in the X direction, then just return, the user probably doesn't mean to inc/dec
        // this isn't perfect, events come in fast with small deltas and a part of the scroll may give a false indication
        // especially if the user is scrolling near 45deg
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (e.deltaY > 0) increment();
        else if (e.deltaY < 0) decrement();
    }, [
        decrement,
        increment
    ]);
    // If the input isn't supposed to receive input, disable scrolling.
    let scrollingDisabled = isDisabled || isReadOnly || !focusWithin;
    $7d0a636d7a4dcefd$export$2123ff2b87c81ca({
        onScroll: onWheel,
        isDisabled: scrollingDisabled
    }, inputRef);
    // The inputMode attribute influences the software keyboard that is shown on touch devices.
    // Browsers and operating systems are quite inconsistent about what keys are available, however.
    // We choose between numeric and decimal based on whether we allow negative and fractional numbers,
    // and based on testing on various devices to determine what keys are available in each inputMode.
    let numberFormatter = $a916eb452884faea$export$b7a616150fdb9f44(formatOptions);
    let intlOptions = useMemo(()=>numberFormatter.resolvedOptions()
    , [
        numberFormatter
    ]);
    let hasDecimals = intlOptions.maximumFractionDigits > 0;
    let hasNegative = isNaN(state.minValue) || state.minValue < 0;
    let inputMode = 'numeric';
    if ($c87311424ea30a05$export$186c6964ca17d99()) {
        // iPhone doesn't have a minus sign in either numeric or decimal.
        // Note this is only for iPhone, not iPad, which always has both
        // minus and decimal in numeric.
        if (hasNegative) inputMode = 'text';
        else if (hasDecimals) inputMode = 'decimal';
    } else if ($c87311424ea30a05$export$a11b0059900ceec8()) {
        // Android numeric has both a decimal point and minus key.
        // decimal does not have a minus key.
        if (hasNegative) inputMode = 'numeric';
        else if (hasDecimals) inputMode = 'decimal';
    }
    let onChange = (value)=>{
        state.setInputValue(value);
    };
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props);
    let { labelProps: labelProps , inputProps: textFieldProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = $d841c8010a73d545$export$4f384c9210e583c3({
        ...otherProps,
        ...domProps,
        label: label,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        validationState: validationState,
        value: state.inputValue,
        defaultValue: undefined,
        autoComplete: 'off',
        'aria-label': props['aria-label'] || null,
        'aria-labelledby': props['aria-labelledby'] || null,
        id: inputId,
        type: 'text',
        inputMode: inputMode,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        onFocusChange: onFocusChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        description: description,
        errorMessage: errorMessage
    }, state, inputRef);
    let inputProps = $3ef42575df84b30b$export$9d1611c77c2fe928(spinButtonProps, textFieldProps, focusProps, {
        // override the spinbutton role, we can't focus a spin button with VO
        role: null,
        // ignore aria-roledescription on iOS so that required state will announce when it is present
        'aria-roledescription': !$c87311424ea30a05$export$fedb369cb70207f1() ? formatMessage('numberField') : null,
        'aria-valuemax': null,
        'aria-valuemin': null,
        'aria-valuenow': null,
        'aria-valuetext': null,
        autoCorrect: 'off',
        spellCheck: 'false'
    });
    let onButtonPressStart = (e)=>{
        // If focus is already on the input, keep it there so we don't hide the
        // software keyboard when tapping the increment/decrement buttons.
        if (document.activeElement === inputRef.current) return;
        // Otherwise, when using a mouse, move focus to the input.
        // On touch, or with a screen reader, focus the button so that the software
        // keyboard does not appear and the screen reader cursor is not moved off the button.
        if (e.pointerType === 'mouse') inputRef.current.focus();
        else e.target.focus();
    };
    // Determine the label for the increment and decrement buttons. There are 4 cases:
    //
    // 1. With a visible label that is a string: aria-label: `Increase ${props.label}`
    // 2. With a visible label that is JSX: aria-label: 'Increase', aria-labelledby: '${incrementId} ${labelId}'
    // 3. With an aria-label: aria-label: `Increase ${props['aria-label']}`
    // 4. With an aria-labelledby: aria-label: 'Increase', aria-labelledby: `${incrementId} ${props['aria-labelledby']}`
    //
    // (1) and (2) could possibly be combined and both use aria-labelledby. However, placing the label in
    // the aria-label string rather than using aria-labelledby gives more flexibility to translators to change
    // the order or add additional words around the label if needed.
    let fieldLabel = props['aria-label'] || (typeof props.label === 'string' ? props.label : '');
    let ariaLabelledby;
    if (!fieldLabel) ariaLabelledby = props.label != null ? labelProps.id : props['aria-labelledby'];
    let incrementId = $bdb11010cef70236$export$f680877a34711e37();
    let decrementId = $bdb11010cef70236$export$f680877a34711e37();
    let incrementButtonProps = $3ef42575df84b30b$export$9d1611c77c2fe928(incButtonProps, {
        'aria-label': incrementAriaLabel || formatMessage('increase', {
            fieldLabel: fieldLabel
        }).trim(),
        id: ariaLabelledby && !incrementAriaLabel ? incrementId : null,
        'aria-labelledby': ariaLabelledby && !incrementAriaLabel ? `${incrementId} ${ariaLabelledby}` : null,
        'aria-controls': inputId,
        excludeFromTabOrder: true,
        preventFocusOnPress: true,
        allowFocusWhenDisabled: true,
        isDisabled: !state.canIncrement,
        onPressStart: onButtonPressStart
    });
    let decrementButtonProps = $3ef42575df84b30b$export$9d1611c77c2fe928(decButtonProps, {
        'aria-label': decrementAriaLabel || formatMessage('decrease', {
            fieldLabel: fieldLabel
        }).trim(),
        id: ariaLabelledby && !decrementAriaLabel ? decrementId : null,
        'aria-labelledby': ariaLabelledby && !decrementAriaLabel ? `${decrementId} ${ariaLabelledby}` : null,
        'aria-controls': inputId,
        excludeFromTabOrder: true,
        preventFocusOnPress: true,
        allowFocusWhenDisabled: true,
        isDisabled: !state.canDecrement,
        onPressStart: onButtonPressStart
    });
    return {
        groupProps: {
            role: 'group',
            'aria-disabled': isDisabled,
            'aria-invalid': validationState === 'invalid' ? 'true' : undefined,
            ...focusWithinProps
        },
        labelProps: labelProps,
        inputProps: inputProps,
        incrementButtonProps: incrementButtonProps,
        decrementButtonProps: decrementButtonProps,
        errorMessageProps: errorMessageProps,
        descriptionProps: descriptionProps
    };
}

function $parcel$export$b(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $0d5c49892c1215da$exports = {};

$parcel$export$b($0d5c49892c1215da$exports, "useRadio", () => $0d5c49892c1215da$export$37b0961d2f4751e2);

const $884aeceb3d67f00f$export$3b7b268d09480394 = new WeakMap();




function $0d5c49892c1215da$export$37b0961d2f4751e2(props, state, ref) {
    let { value: value , children: children , 'aria-label': ariaLabel , 'aria-labelledby': ariaLabelledby  } = props;
    const isDisabled = props.isDisabled || state.isDisabled;
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn('If you do not provide children, you must specify an aria-label for accessibility');
    let checked = state.selectedValue === value;
    let onChange = (e)=>{
        e.stopPropagation();
        state.setSelectedValue(value);
    };
    let { pressProps: pressProps  } = $f6c31cce2adf654f$export$45712eceda6fad21({
        isDisabled: isDisabled
    });
    let { focusableProps: focusableProps  } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c($3ef42575df84b30b$export$9d1611c77c2fe928(props, {
        onFocus: ()=>state.setLastFocusedValue(value)
    }), ref);
    let interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, focusableProps);
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    let tabIndex = state.lastFocusedValue === value || state.lastFocusedValue == null ? 0 : -1;
    if (isDisabled) tabIndex = undefined;
    return {
        inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
            ...interactions,
            type: 'radio',
            name: $884aeceb3d67f00f$export$3b7b268d09480394.get(state),
            tabIndex: tabIndex,
            disabled: isDisabled,
            checked: checked,
            value: value,
            onChange: onChange
        })
    };
}


var $430f30ed08ec25fa$exports = {};

$parcel$export$b($430f30ed08ec25fa$exports, "useRadioGroup", () => $430f30ed08ec25fa$export$62b9571f283ff5c2);






function $430f30ed08ec25fa$export$62b9571f283ff5c2(props, state) {
    let { name: name , validationState: validationState , isReadOnly: isReadOnly , isRequired: isRequired , isDisabled: isDisabled , orientation: orientation = 'vertical'  } = props;
    let { direction: direction  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let { labelProps: labelProps , fieldProps: fieldProps  } = $d191a55c9702f145$export$8467354a121f1b9f({
        ...props,
        // Radio group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    // When the radio group loses focus, reset the focusable radio to null if
    // there is no selection. This allows tabbing into the group from either
    // direction to go to the first or last radio.
    let { focusWithinProps: focusWithinProps  } = $9ab94262bd0047c7$export$420e68273165f4ec({
        onBlurWithin () {
            if (!state.selectedValue) state.setLastFocusedValue(null);
        }
    });
    let onKeyDown = (e)=>{
        let nextDir;
        switch(e.key){
            case 'ArrowRight':
                if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'prev';
                else nextDir = 'next';
                break;
            case 'ArrowLeft':
                if (direction === 'rtl' && orientation !== 'vertical') nextDir = 'next';
                else nextDir = 'prev';
                break;
            case 'ArrowDown':
                nextDir = 'next';
                break;
            case 'ArrowUp':
                nextDir = 'prev';
                break;
            default:
                return;
        }
        e.preventDefault();
        let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(e.currentTarget, {
            from: e.target
        });
        let nextElem;
        if (nextDir === 'next') {
            nextElem = walker.nextNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.firstChild();
            }
        } else {
            nextElem = walker.previousNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.lastChild();
            }
        }
        if (nextElem) {
            // Call focus on nextElem so that keyboard navigation scrolls the radio into view
            nextElem.focus();
            state.setSelectedValue(nextElem.value);
        }
    };
    let groupName = $bdb11010cef70236$export$f680877a34711e37(name);
    $884aeceb3d67f00f$export$3b7b268d09480394.set(state, groupName);
    return {
        radioGroupProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
            // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
            role: 'radiogroup',
            onKeyDown: onKeyDown,
            'aria-invalid': validationState === 'invalid' || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            'aria-disabled': isDisabled || undefined,
            'aria-orientation': orientation,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps: labelProps
    };
}

function $parcel$interopDefault$2(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export$a(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $4d52238874b24f86$exports = {};

$parcel$export$a($4d52238874b24f86$exports, "useSearchField", () => $4d52238874b24f86$export$9bb30bbe003b82e0);

var $ad5aea03cc53c961$exports = {};
var $03c9a1a10de12f06$exports = {};
$03c9a1a10de12f06$exports = JSON.parse("{\"Clear search\":\"مسح البحث\"}");


var $4da0c2ffa4ba4159$exports = {};
$4da0c2ffa4ba4159$exports = JSON.parse("{\"Clear search\":\"Изчистване на търсене\"}");


var $8c59fd0c2c96821b$exports = {};
$8c59fd0c2c96821b$exports = JSON.parse("{\"Clear search\":\"Vymazat hledání\"}");


var $0a371f9c1df8120f$exports = {};
$0a371f9c1df8120f$exports = JSON.parse("{\"Clear search\":\"Ryd søgning\"}");


var $67f4d0b0de9f8a52$exports = {};
$67f4d0b0de9f8a52$exports = JSON.parse("{\"Clear search\":\"Suche zurücksetzen\"}");


var $72a312d948f0214b$exports = {};
$72a312d948f0214b$exports = JSON.parse("{\"Clear search\":\"Απαλοιφή αναζήτησης\"}");


var $5012d21d933388c1$exports = {};
$5012d21d933388c1$exports = JSON.parse("{\"Clear search\":\"Clear search\"}");


var $0159854399308e2e$exports = {};
$0159854399308e2e$exports = JSON.parse("{\"Clear search\":\"Borrar búsqueda\"}");


var $390613981d970276$exports = {};
$390613981d970276$exports = JSON.parse("{\"Clear search\":\"Tühjenda otsing\"}");


var $961ae0833f811705$exports = {};
$961ae0833f811705$exports = JSON.parse("{\"Clear search\":\"Tyhjennä haku\"}");


var $26d76742decfd829$exports = {};
$26d76742decfd829$exports = JSON.parse("{\"Clear search\":\"Effacer la recherche\"}");


var $92ef254c82a5c769$exports = {};
$92ef254c82a5c769$exports = JSON.parse("{\"Clear search\":\"נקה חיפוש\"}");


var $e0321b43bdefb8b3$exports = {};
$e0321b43bdefb8b3$exports = JSON.parse("{\"Clear search\":\"Obriši pretragu\"}");


var $0c1ee0b8d50940d9$exports = {};
$0c1ee0b8d50940d9$exports = JSON.parse("{\"Clear search\":\"Keresés törlése\"}");


var $b09198915a38946f$exports = {};
$b09198915a38946f$exports = JSON.parse("{\"Clear search\":\"Cancella ricerca\"}");


var $3a9a3d180c3145c0$exports = {};
$3a9a3d180c3145c0$exports = JSON.parse("{\"Clear search\":\"検索をクリア\"}");


var $b7a611726449f4a3$exports = {};
$b7a611726449f4a3$exports = JSON.parse("{\"Clear search\":\"검색 지우기\"}");


var $d9a3d49db610dd5c$exports = {};
$d9a3d49db610dd5c$exports = JSON.parse("{\"Clear search\":\"Išvalyti iešką\"}");


var $3ab64b73ea27c23a$exports = {};
$3ab64b73ea27c23a$exports = JSON.parse("{\"Clear search\":\"Notīrīt meklēšanu\"}");


var $bf5cce1b47d23baf$exports = {};
$bf5cce1b47d23baf$exports = JSON.parse("{\"Clear search\":\"Tøm søk\"}");


var $4e0c9a9a010e4598$exports = {};
$4e0c9a9a010e4598$exports = JSON.parse("{\"Clear search\":\"Zoekactie wissen\"}");


var $63cf4a75ec270508$exports = {};
$63cf4a75ec270508$exports = JSON.parse("{\"Clear search\":\"Wyczyść zawartość wyszukiwania\"}");


var $083b0cad27fdbd06$exports = {};
$083b0cad27fdbd06$exports = JSON.parse("{\"Clear search\":\"Limpar pesquisa\"}");


var $1b7f0864d830ba6d$exports = {};
$1b7f0864d830ba6d$exports = JSON.parse("{\"Clear search\":\"Limpar pesquisa\"}");


var $d6d2588377fc9718$exports = {};
$d6d2588377fc9718$exports = JSON.parse("{\"Clear search\":\"Ştergeţi căutarea\"}");


var $701c918a4653e946$exports = {};
$701c918a4653e946$exports = JSON.parse("{\"Clear search\":\"Очистить поиск\"}");


var $7cacc29a1e5f4fbe$exports = {};
$7cacc29a1e5f4fbe$exports = JSON.parse("{\"Clear search\":\"Vymazať vyhľadávanie\"}");


var $c63231bcc300d0df$exports = {};
$c63231bcc300d0df$exports = JSON.parse("{\"Clear search\":\"Počisti iskanje\"}");


var $b61510478bc0e6f6$exports = {};
$b61510478bc0e6f6$exports = JSON.parse("{\"Clear search\":\"Obriši pretragu\"}");


var $ce325e6dd3f9c37a$exports = {};
$ce325e6dd3f9c37a$exports = JSON.parse("{\"Clear search\":\"Rensa sökning\"}");


var $1f7e1cf2285af2b2$exports = {};
$1f7e1cf2285af2b2$exports = JSON.parse("{\"Clear search\":\"Aramayı temizle\"}");


var $2d999353ca652e34$exports = {};
$2d999353ca652e34$exports = JSON.parse("{\"Clear search\":\"Очистити пошук\"}");


var $117b536bfb1ae554$exports = {};
$117b536bfb1ae554$exports = JSON.parse("{\"Clear search\":\"清除搜索\"}");


var $525f6fa4ac26e278$exports = {};
$525f6fa4ac26e278$exports = JSON.parse("{\"Clear search\":\"清除搜尋條件\"}");


$ad5aea03cc53c961$exports = {
    "ar-AE": $03c9a1a10de12f06$exports,
    "bg-BG": $4da0c2ffa4ba4159$exports,
    "cs-CZ": $8c59fd0c2c96821b$exports,
    "da-DK": $0a371f9c1df8120f$exports,
    "de-DE": $67f4d0b0de9f8a52$exports,
    "el-GR": $72a312d948f0214b$exports,
    "en-US": $5012d21d933388c1$exports,
    "es-ES": $0159854399308e2e$exports,
    "et-EE": $390613981d970276$exports,
    "fi-FI": $961ae0833f811705$exports,
    "fr-FR": $26d76742decfd829$exports,
    "he-IL": $92ef254c82a5c769$exports,
    "hr-HR": $e0321b43bdefb8b3$exports,
    "hu-HU": $0c1ee0b8d50940d9$exports,
    "it-IT": $b09198915a38946f$exports,
    "ja-JP": $3a9a3d180c3145c0$exports,
    "ko-KR": $b7a611726449f4a3$exports,
    "lt-LT": $d9a3d49db610dd5c$exports,
    "lv-LV": $3ab64b73ea27c23a$exports,
    "nb-NO": $bf5cce1b47d23baf$exports,
    "nl-NL": $4e0c9a9a010e4598$exports,
    "pl-PL": $63cf4a75ec270508$exports,
    "pt-BR": $083b0cad27fdbd06$exports,
    "pt-PT": $1b7f0864d830ba6d$exports,
    "ro-RO": $d6d2588377fc9718$exports,
    "ru-RU": $701c918a4653e946$exports,
    "sk-SK": $7cacc29a1e5f4fbe$exports,
    "sl-SI": $c63231bcc300d0df$exports,
    "sr-SP": $b61510478bc0e6f6$exports,
    "sv-SE": $ce325e6dd3f9c37a$exports,
    "tr-TR": $1f7e1cf2285af2b2$exports,
    "uk-UA": $2d999353ca652e34$exports,
    "zh-CN": $117b536bfb1ae554$exports,
    "zh-TW": $525f6fa4ac26e278$exports
};




function $4d52238874b24f86$export$9bb30bbe003b82e0(props, state, inputRef) {
    let formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault$2($ad5aea03cc53c961$exports)));
    let { isDisabled: isDisabled , onSubmit: onSubmit = ()=>{
    } , onClear: onClear , type: type = 'search'  } = props;
    let onKeyDown = (e)=>{
        const key = e.key;
        if (key === 'Enter' || key === 'Escape') e.preventDefault();
        if (isDisabled) return;
        if (key === 'Enter') onSubmit(state.value);
        if (key === 'Escape') {
            state.setValue('');
            if (onClear) onClear();
        }
    };
    let onClearButtonClick = ()=>{
        state.setValue('');
        if (onClear) onClear();
    };
    let onPressStart = ()=>{
        // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
        // the input and close the keyboard
        inputRef.current.focus();
    };
    let { labelProps: labelProps , inputProps: inputProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = $2d73ec29415bd339$export$712718f7aec83d5({
        ...props,
        value: state.value,
        onChange: state.setValue,
        onKeyDown: $ff5963eb1fccf552$export$e08e3b67e392101e(onKeyDown, props.onKeyDown),
        type: type
    }, inputRef);
    return {
        labelProps: labelProps,
        inputProps: {
            ...inputProps,
            // already handled by useSearchFieldState
            defaultValue: undefined
        },
        clearButtonProps: {
            'aria-label': formatMessage('Clear search'),
            excludeFromTabOrder: true,
            // @ts-ignore
            preventFocusOnPress: true,
            onPress: onClearButtonClick,
            onPressStart: onPressStart
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

function $parcel$export$9(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $58aed456727eb0f3$exports = {};

$parcel$export$9($58aed456727eb0f3$exports, "useSelect", () => $58aed456727eb0f3$export$e64b2f635402ca43);







function $58aed456727eb0f3$export$e64b2f635402ca43(props, state, ref) {
    let { keyboardDelegate: keyboardDelegate , isDisabled: isDisabled  } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = $325a3faab7a68acd$export$a16aca283550c30d({
        usage: 'search',
        sensitivity: 'base'
    });
    let delegate = useMemo(()=>keyboardDelegate || new $2a25aae57d74318e$export$a05409b8bb224a5a(state.collection, state.disabledKeys, null, collator)
    , [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        collator
    ]);
    let { menuTriggerProps: menuTriggerProps , menuProps: menuProps  } = $168583247155ddda$export$dc9c12ed27dd1b49({
        isDisabled: isDisabled,
        type: 'listbox'
    }, state, ref);
    let onKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowLeft':
                {
                    // prevent scrolling containers
                    e.preventDefault();
                    let key = state.selectedKey != null ? delegate.getKeyAbove(state.selectedKey) : delegate.getFirstKey();
                    if (key) state.setSelectedKey(key);
                    break;
                }
            case 'ArrowRight':
                {
                    // prevent scrolling containers
                    e.preventDefault();
                    let key = state.selectedKey != null ? delegate.getKeyBelow(state.selectedKey) : delegate.getFirstKey();
                    if (key) state.setSelectedKey(key);
                    break;
                }
        }
    };
    let { typeSelectProps: typeSelectProps  } = $fb3050f43d946246$export$e32c88dfddc6e1d8({
        keyboardDelegate: delegate,
        selectionManager: state.selectionManager,
        onTypeSelect (key) {
            state.setSelectedKey(key);
        }
    });
    let { labelProps: labelProps , fieldProps: fieldProps , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = $2baaea4c71418dea$export$294aa081a6c6f55d({
        ...props,
        labelElementType: 'span'
    });
    typeSelectProps.onKeyDown = typeSelectProps.onKeyDownCapture;
    delete typeSelectProps.onKeyDownCapture;
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    let triggerProps = $3ef42575df84b30b$export$9d1611c77c2fe928(typeSelectProps, menuTriggerProps, fieldProps);
    let valueId = $bdb11010cef70236$export$f680877a34711e37();
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                if (!props.isDisabled) {
                    ref.current.focus();
                    // Show the focus ring so the user knows where focus went
                    $507fabe10e71c6fb$export$8397ddfc504fdb9a('keyboard');
                }
            }
        },
        triggerProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
            ...triggerProps,
            onKeyDown: $ff5963eb1fccf552$export$e08e3b67e392101e(triggerProps.onKeyDown, onKeyDown, props.onKeyDown),
            onKeyUp: props.onKeyUp,
            'aria-labelledby': [
                triggerProps['aria-labelledby'],
                triggerProps['aria-label'] && !triggerProps['aria-labelledby'] ? triggerProps.id : null,
                valueId
            ].filter(Boolean).join(' '),
            onFocus (e) {
                if (state.isFocused) return;
                if (props.onFocus) props.onFocus(e);
                if (props.onFocusChange) props.onFocusChange(true);
                state.setFocused(true);
            },
            onBlur (e) {
                if (state.isOpen) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            }
        }),
        valueProps: {
            id: valueId
        },
        menuProps: {
            ...menuProps,
            autoFocus: state.focusStrategy || true,
            shouldSelectOnPressUp: true,
            shouldFocusOnHover: true,
            disallowEmptySelection: true,
            onBlur: (e)=>{
                if (e.currentTarget.contains(e.relatedTarget)) return;
                if (props.onBlur) props.onBlur(e);
                if (props.onFocusChange) props.onFocusChange(false);
                state.setFocused(false);
            },
            'aria-labelledby': [
                fieldProps['aria-labelledby'],
                triggerProps['aria-label'] && !fieldProps['aria-labelledby'] ? triggerProps.id : null
            ].filter(Boolean).join(' ')
        },
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}


var $bdd25dc72710631f$exports = {};

$parcel$export$9($bdd25dc72710631f$exports, "useHiddenSelect", () => $bdd25dc72710631f$export$f809e80f58e251d1);
$parcel$export$9($bdd25dc72710631f$exports, "HiddenSelect", () => $bdd25dc72710631f$export$cbd84cdb2e668835);



function $bdd25dc72710631f$export$f809e80f58e251d1(props, state, triggerRef) {
    let { autoComplete: autoComplete , name: name , isDisabled: isDisabled  } = props;
    let modality = $507fabe10e71c6fb$export$98e20ec92f614cfe();
    let { visuallyHiddenProps: visuallyHiddenProps  } = $5c3e21d68f1c4674$export$a966af930f325cab();
    var _selectedKey;
    // In Safari, the <select> cannot have `display: none` or `hidden` for autofill to work.
    // In Firefox, there must be a <label> to identify the <select> whereas other browsers
    // seem to identify it just by surrounding text.
    // The solution is to use <VisuallyHidden> to hide the elements, which clips the elements to a
    // 1px rectangle. In addition, we hide from screen readers with aria-hidden, and make the <select>
    // non tabbable with tabIndex={-1}.
    //
    // In mobile browsers, there are next/previous buttons above the software keyboard for navigating
    // between fields in a form. These only support native form inputs that are tabbable. In order to
    // support those, an additional hidden input is used to marshall focus to the button. It is tabbable
    // except when the button is focused, so that shift tab works properly to go to the actual previous
    // input in the form. Using the <select> for this also works, but Safari on iOS briefly flashes
    // the native menu on focus, so this isn't ideal. A font-size of 16px or greater is required to
    // prevent Safari from zooming in on the input when it is focused.
    //
    // If the current interaction modality is null, then the user hasn't interacted with the page yet.
    // In this case, we set the tabIndex to -1 on the input element so that automated accessibility
    // checkers don't throw false-positives about focusable elements inside an aria-hidden parent.
    return {
        containerProps: {
            ...visuallyHiddenProps,
            'aria-hidden': true
        },
        inputProps: {
            type: 'text',
            tabIndex: modality == null || state.isFocused || state.isOpen ? -1 : 0,
            style: {
                fontSize: 16
            },
            onFocus: ()=>triggerRef.current.focus()
            ,
            disabled: isDisabled
        },
        selectProps: {
            tabIndex: -1,
            autoComplete: autoComplete,
            disabled: isDisabled,
            name: name,
            size: state.collection.size,
            value: (_selectedKey = state.selectedKey) !== null && _selectedKey !== void 0 ? _selectedKey : '',
            onChange: (e)=>state.setSelectedKey(e.target.value)
        }
    };
}
function $bdd25dc72710631f$export$cbd84cdb2e668835(props) {
    let { state: state , triggerRef: triggerRef , label: label , name: name , isDisabled: isDisabled  } = props;
    let { containerProps: containerProps , inputProps: inputProps , selectProps: selectProps  } = $bdd25dc72710631f$export$f809e80f58e251d1(props, state, triggerRef);
    // If used in a <form>, use a hidden input so the value can be submitted to a server.
    // If the collection isn't too big, use a hidden <select> element for this so that browser
    // autofill will work. Otherwise, use an <input type="hidden">.
    if (state.collection.size <= 300) return(/*#__PURE__*/ React__default.createElement("div", containerProps, /*#__PURE__*/ React__default.createElement("input", inputProps), /*#__PURE__*/ React__default.createElement("label", null, label, /*#__PURE__*/ React__default.createElement("select", selectProps, /*#__PURE__*/ React__default.createElement("option", null), [
        ...state.collection.getKeys()
    ].map((key)=>{
        let item = state.collection.getItem(key);
        if (item.type === 'item') return(/*#__PURE__*/ React__default.createElement("option", {
            key: item.key,
            value: item.key
        }, item.textValue));
    })))));
    else if (name) return(/*#__PURE__*/ React__default.createElement("input", {
        type: "hidden",
        autoComplete: selectProps.autoComplete,
        name: name,
        disabled: isDisabled,
        value: state.selectedKey
    }));
    return null;
}

function $parcel$export$8(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $f4b273590fab9f93$exports = {};

$parcel$export$8($f4b273590fab9f93$exports, "useSeparator", () => $f4b273590fab9f93$export$52210f68a14655d0);

function $f4b273590fab9f93$export$52210f68a14655d0(props) {
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    let ariaOrientation;
    // if orientation is horizontal, aria-orientation default is horizontal, so we leave it undefined
    // if it's vertical, we need to specify it
    if (props.orientation === 'vertical') ariaOrientation = 'vertical';
    // hr elements implicitly have role = separator and a horizontal orientation
    if (props.elementType !== 'hr') return {
        separatorProps: {
            ...domProps,
            role: 'separator',
            'aria-orientation': ariaOrientation
        }
    };
    return {
        separatorProps: domProps
    };
}

function $parcel$export$7(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $bcca50147b47f54d$exports = {};

$parcel$export$7($bcca50147b47f54d$exports, "useSlider", () => $bcca50147b47f54d$export$56b2c08e277f365);

const $aa519ee6cf463259$export$7a8d2b02c9371cbf = new WeakMap();
function $aa519ee6cf463259$export$68e648cbec363a18(state, index) {
    let id = $aa519ee6cf463259$export$7a8d2b02c9371cbf.get(state);
    if (!id) throw new Error('Unknown slider state');
    return `${id}-${index}`;
}






function $bcca50147b47f54d$export$56b2c08e277f365(props, state, trackRef) {
    let { labelProps: labelProps , fieldProps: fieldProps  } = $d191a55c9702f145$export$8467354a121f1b9f(props);
    let isVertical = props.orientation === 'vertical';
    var _id;
    // Attach id of the label to the state so it can be accessed by useSliderThumb.
    $aa519ee6cf463259$export$7a8d2b02c9371cbf.set(state, (_id = labelProps.id) !== null && _id !== void 0 ? _id : fieldProps.id);
    let { direction: direction  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let { addGlobalListener: addGlobalListener , removeGlobalListener: removeGlobalListener  } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
    // When the user clicks or drags the track, we want the motion to set and drag the
    // closest thumb.  Hence we also need to install useMove() on the track element.
    // Here, we keep track of which index is the "closest" to the drag start point.
    // It is set onMouseDown/onTouchDown; see trackProps below.
    const realTimeTrackDraggingIndex = useRef(null);
    const stateRef = useRef(null);
    stateRef.current = state;
    const reverseX = direction === 'rtl';
    const currentPosition = useRef(null);
    const { moveProps: moveProps  } = $e8a7022cf87cba2a$export$36da96379f79f245({
        onMoveStart () {
            currentPosition.current = null;
        },
        onMove ({ deltaX: deltaX , deltaY: deltaY  }) {
            let size = isVertical ? trackRef.current.offsetHeight : trackRef.current.offsetWidth;
            if (currentPosition.current == null) currentPosition.current = stateRef.current.getThumbPercent(realTimeTrackDraggingIndex.current) * size;
            let delta = isVertical ? deltaY : deltaX;
            if (isVertical || reverseX) delta = -delta;
            currentPosition.current += delta;
            if (realTimeTrackDraggingIndex.current != null && trackRef.current) {
                const percent = $9446cca9a3875146$export$7d15b64cf5a3a4c4(currentPosition.current / size, 0, 1);
                stateRef.current.setThumbPercent(realTimeTrackDraggingIndex.current, percent);
            }
        },
        onMoveEnd () {
            if (realTimeTrackDraggingIndex.current != null) {
                stateRef.current.setThumbDragging(realTimeTrackDraggingIndex.current, false);
                realTimeTrackDraggingIndex.current = null;
            }
        }
    });
    let currentPointer = useRef(undefined);
    let onDownTrack = (e, id, clientX, clientY)=>{
        // We only trigger track-dragging if the user clicks on the track itself and nothing is currently being dragged.
        if (trackRef.current && !props.isDisabled && state.values.every((_, i)=>!state.isThumbDragging(i)
        )) {
            let size = isVertical ? trackRef.current.offsetHeight : trackRef.current.offsetWidth;
            // Find the closest thumb
            const trackPosition = trackRef.current.getBoundingClientRect()[isVertical ? 'top' : 'left'];
            const clickPosition = isVertical ? clientY : clientX;
            const offset = clickPosition - trackPosition;
            let percent = offset / size;
            if (direction === 'rtl' || isVertical) percent = 1 - percent;
            let value = state.getPercentValue(percent);
            // to find the closet thumb we split the array based on the first thumb position to the "right/end" of the click.
            let closestThumb;
            let split = state.values.findIndex((v)=>value - v < 0
            );
            if (split === 0) closestThumb = split;
            else if (split === -1) closestThumb = state.values.length - 1;
            else {
                let lastLeft = state.values[split - 1];
                let firstRight = state.values[split];
                // Pick the last left/start thumb, unless they are stacked on top of each other, then pick the right/end one
                if (Math.abs(lastLeft - value) < Math.abs(firstRight - value)) closestThumb = split - 1;
                else closestThumb = split;
            }
            // Confirm that the found closest thumb is editable, not disabled, and move it
            if (closestThumb >= 0 && state.isThumbEditable(closestThumb)) {
                // Don't unfocus anything
                e.preventDefault();
                realTimeTrackDraggingIndex.current = closestThumb;
                state.setFocusedThumb(closestThumb);
                currentPointer.current = id;
                state.setThumbDragging(realTimeTrackDraggingIndex.current, true);
                state.setThumbValue(closestThumb, value);
                addGlobalListener(window, 'mouseup', onUpTrack, false);
                addGlobalListener(window, 'touchend', onUpTrack, false);
                addGlobalListener(window, 'pointerup', onUpTrack, false);
            } else realTimeTrackDraggingIndex.current = null;
        }
    };
    let onUpTrack = (e)=>{
        var ref;
        var _pointerId;
        let id = (_pointerId = e.pointerId) !== null && _pointerId !== void 0 ? _pointerId : (ref = e.changedTouches) === null || ref === void 0 ? void 0 : ref[0].identifier;
        if (id === currentPointer.current) {
            if (realTimeTrackDraggingIndex.current != null) {
                state.setThumbDragging(realTimeTrackDraggingIndex.current, false);
                realTimeTrackDraggingIndex.current = null;
            }
            removeGlobalListener(window, 'mouseup', onUpTrack, false);
            removeGlobalListener(window, 'touchend', onUpTrack, false);
            removeGlobalListener(window, 'pointerup', onUpTrack, false);
        }
    };
    if (labelProps.htmlFor) {
        // Ideally the `for` attribute should point to the first thumb, but VoiceOver on iOS
        // causes this to override the `aria-labelledby` on the thumb. This causes the first
        // thumb to only be announced as the slider label rather than its individual name as well.
        // See https://bugs.webkit.org/show_bug.cgi?id=172464.
        delete labelProps.htmlFor;
        labelProps.onClick = ()=>{
            var // Safari does not focus <input type="range"> elements when clicking on an associated <label>,
            // so do it manually. In addition, make sure we show the focus ring.
            ref;
            (ref = document.getElementById($aa519ee6cf463259$export$68e648cbec363a18(state, 0))) === null || ref === void 0 ? void 0 : ref.focus();
            $507fabe10e71c6fb$export$8397ddfc504fdb9a('keyboard');
        };
    }
    return {
        labelProps: labelProps,
        // The root element of the Slider will have role="group" to group together
        // all the thumb inputs in the Slider.  The label of the Slider will
        // be used to label the group.
        groupProps: {
            role: 'group',
            ...fieldProps
        },
        trackProps: $3ef42575df84b30b$export$9d1611c77c2fe928({
            onMouseDown (e) {
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onDownTrack(e, undefined, e.clientX, e.clientY);
            },
            onPointerDown (e) {
                if (e.pointerType === 'mouse' && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
                onDownTrack(e, e.pointerId, e.clientX, e.clientY);
            },
            onTouchStart (e) {
                onDownTrack(e, e.changedTouches[0].identifier, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            }
        }, moveProps),
        outputProps: {
            htmlFor: state.values.map((_, index)=>$aa519ee6cf463259$export$68e648cbec363a18(state, index)
            ).join(' '),
            'aria-live': 'off'
        }
    };
}


var $47b897dc8cdb026b$exports = {};

$parcel$export$7($47b897dc8cdb026b$exports, "useSliderThumb", () => $47b897dc8cdb026b$export$8d15029008292ae);







function $47b897dc8cdb026b$export$8d15029008292ae(opts, state) {
    let { index: index , isRequired: isRequired , isDisabled: isDisabled , validationState: validationState , trackRef: trackRef , inputRef: inputRef  } = opts;
    let isVertical = opts.orientation === 'vertical';
    let { direction: direction  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let { addGlobalListener: addGlobalListener , removeGlobalListener: removeGlobalListener  } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
    let labelId = $aa519ee6cf463259$export$7a8d2b02c9371cbf.get(state);
    var ref1;
    const { labelProps: labelProps , fieldProps: fieldProps  } = $d191a55c9702f145$export$8467354a121f1b9f({
        ...opts,
        id: $aa519ee6cf463259$export$68e648cbec363a18(state, index),
        'aria-labelledby': `${labelId} ${(ref1 = opts['aria-labelledby']) !== null && ref1 !== void 0 ? ref1 : ''}`.trim()
    });
    const value = state.values[index];
    const focusInput = useCallback(()=>{
        if (inputRef.current) $7215afc6de606d6b$export$de79e2c695e052f3(inputRef.current);
    }, [
        inputRef
    ]);
    const isFocused = state.focusedThumb === index;
    useEffect(()=>{
        if (isFocused) focusInput();
    }, [
        isFocused,
        focusInput
    ]);
    const stateRef = useRef(null);
    stateRef.current = state;
    let reverseX = direction === 'rtl';
    let currentPosition = useRef(null);
    let { keyboardProps: keyboardProps  } = $46d819fcbaf35654$export$8f71654801c2f7cd({
        onKeyDown (e) {
            let { getThumbMaxValue: getThumbMaxValue , getThumbMinValue: getThumbMinValue , decrementThumb: decrementThumb , incrementThumb: incrementThumb , setThumbValue: setThumbValue , setThumbDragging: setThumbDragging , pageSize: pageSize  } = stateRef.current;
            // these are the cases that useMove or useSlider don't handle
            if (!/^(PageUp|PageDown|Home|End)$/.test(e.key)) {
                e.continuePropagation();
                return;
            }
            // same handling as useMove, stopPropagation to prevent useSlider from handling the event as well.
            e.preventDefault();
            // remember to set this so that onChangeEnd is fired
            setThumbDragging(index, true);
            switch(e.key){
                case 'PageUp':
                    incrementThumb(index, pageSize);
                    break;
                case 'PageDown':
                    decrementThumb(index, pageSize);
                    break;
                case 'Home':
                    setThumbValue(index, getThumbMinValue(index));
                    break;
                case 'End':
                    setThumbValue(index, getThumbMaxValue(index));
                    break;
            }
            setThumbDragging(index, false);
        }
    });
    let { moveProps: moveProps  } = $e8a7022cf87cba2a$export$36da96379f79f245({
        onMoveStart () {
            currentPosition.current = null;
            stateRef.current.setThumbDragging(index, true);
        },
        onMove ({ deltaX: deltaX , deltaY: deltaY , pointerType: pointerType , shiftKey: shiftKey  }) {
            const { getThumbPercent: getThumbPercent , setThumbPercent: setThumbPercent , decrementThumb: decrementThumb , incrementThumb: incrementThumb , step: step , pageSize: pageSize  } = stateRef.current;
            let size = isVertical ? trackRef.current.offsetHeight : trackRef.current.offsetWidth;
            if (currentPosition.current == null) currentPosition.current = getThumbPercent(index) * size;
            if (pointerType === 'keyboard') {
                if (deltaX > 0 && reverseX || deltaX < 0 && !reverseX || deltaY > 0) decrementThumb(index, shiftKey ? pageSize : step);
                else incrementThumb(index, shiftKey ? pageSize : step);
            } else {
                let delta = isVertical ? deltaY : deltaX;
                if (isVertical || reverseX) delta = -delta;
                currentPosition.current += delta;
                setThumbPercent(index, $9446cca9a3875146$export$7d15b64cf5a3a4c4(currentPosition.current / size, 0, 1));
            }
        },
        onMoveEnd () {
            stateRef.current.setThumbDragging(index, false);
        }
    });
    // Immediately register editability with the state
    state.setThumbEditable(index, !isDisabled);
    const { focusableProps: focusableProps  } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c($3ef42575df84b30b$export$9d1611c77c2fe928(opts, {
        onFocus: ()=>state.setFocusedThumb(index)
        ,
        onBlur: ()=>state.setFocusedThumb(undefined)
    }), inputRef);
    let currentPointer = useRef(undefined);
    let onDown = (id)=>{
        focusInput();
        currentPointer.current = id;
        state.setThumbDragging(index, true);
        addGlobalListener(window, 'mouseup', onUp, false);
        addGlobalListener(window, 'touchend', onUp, false);
        addGlobalListener(window, 'pointerup', onUp, false);
    };
    let onUp = (e)=>{
        var ref;
        var _pointerId;
        let id = (_pointerId = e.pointerId) !== null && _pointerId !== void 0 ? _pointerId : (ref = e.changedTouches) === null || ref === void 0 ? void 0 : ref[0].identifier;
        if (id === currentPointer.current) {
            focusInput();
            state.setThumbDragging(index, false);
            removeGlobalListener(window, 'mouseup', onUp, false);
            removeGlobalListener(window, 'touchend', onUp, false);
            removeGlobalListener(window, 'pointerup', onUp, false);
        }
    };
    // We install mouse handlers for the drag motion on the thumb div, but
    // not the key handler for moving the thumb with the slider.  Instead,
    // we focus the range input, and let the browser handle the keyboard
    // interactions; we then listen to input's onChange to update state.
    return {
        inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, fieldProps, {
            type: 'range',
            tabIndex: !isDisabled ? 0 : undefined,
            min: state.getThumbMinValue(index),
            max: state.getThumbMaxValue(index),
            step: state.step,
            value: value,
            disabled: isDisabled,
            'aria-orientation': opts.orientation,
            'aria-valuetext': state.getThumbValueLabel(index),
            'aria-required': isRequired || undefined,
            'aria-invalid': validationState === 'invalid' || undefined,
            'aria-errormessage': opts['aria-errormessage'],
            onChange: (e)=>{
                stateRef.current.setThumbValue(index, parseFloat(e.target.value));
            }
        }),
        thumbProps: !isDisabled ? $3ef42575df84b30b$export$9d1611c77c2fe928(keyboardProps, moveProps, {
            onMouseDown: (e)=>{
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onDown();
            },
            onPointerDown: (e)=>{
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onDown(e.pointerId);
            },
            onTouchStart: (e)=>{
                onDown(e.changedTouches[0].identifier);
            }
        }) : {
        },
        labelProps: labelProps
    };
}

function $parcel$export$6(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $b418ec0c85c52f27$exports = {};

$parcel$export$6($b418ec0c85c52f27$exports, "useSwitch", () => $b418ec0c85c52f27$export$d853f7095ae95f88);

function $b418ec0c85c52f27$export$d853f7095ae95f88(props, state, ref) {
    let { inputProps: inputProps  } = $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, ref);
    let { isSelected: isSelected  } = state;
    return {
        inputProps: {
            ...inputProps,
            role: 'switch',
            checked: isSelected,
            'aria-checked': isSelected
        }
    };
}

function $parcel$export$5(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $c74cda7d31af1253$exports = {};

$parcel$export$5($c74cda7d31af1253$exports, "Layout", () => $c74cda7d31af1253$export$c84671f46d6a1ca);
class $c74cda7d31af1253$export$c84671f46d6a1ca {
    /**
   * Returns whether the layout should invalidate in response to
   * visible rectangle changes. By default, it only invalidates
   * when the collection view's size changes. Return true always
   * to make the layout invalidate while scrolling (e.g. sticky headers).
   */ shouldInvalidate(newRect, oldRect) {
        // By default, invalidate when the size changes
        return newRect.width !== oldRect.width || newRect.height !== oldRect.height;
    }
    /**
   * This method allows the layout to perform any pre-computation
   * it needs to in order to prepare {@link LayoutInfo}s for retrieval.
   * Called by the collection view before {@link getVisibleLayoutInfos}
   * or {@link getLayoutInfo} are called.
   */ validate(invalidationContext) {
    }
    /**
   * Returns a {@link DragTarget} describing a view at the given point to be dragged.
   * Return `null` to cancel the drag. The default implementation returns the view at the given point.
   * @param point The point at which the drag occurred.
   */ // getDragTarget(point: Point): DragTarget | null {
    //   let target = this.virtualizer.keyAtPoint(point);
    //   if (!target) {
    //     return null;
    //   }
    //   return {
    //     type: 'item',
    //     key: target
    //   };
    // }
    /**
   * Returns a {@link DragTarget} object describing where a drop should occur. Return `null`
   * to reject the drop. The dropped items will be inserted before the resulting target.
   * @param point The point at which the drop occurred.
   */ // getDropTarget(point: Point): DropTarget | null {
    //   return null;
    // }
    /**
   * Returns the starting attributes for an animated insertion.
   * The view is animated from this {@link LayoutInfo} to the one returned by {@link getLayoutInfo}.
   * The default implementation just returns its input.
   *
   * @param layoutInfo The proposed LayoutInfo for this view.
   */ getInitialLayoutInfo(layoutInfo) {
        return layoutInfo;
    }
    /**
   * Returns the ending attributes for an animated removal.
   * The view is animated from the {@link LayoutInfo} returned by {@link getLayoutInfo}
   * to the one returned by this method. The default implementation returns its input.
   *
   * @param layoutInfo The original LayoutInfo for this view.
   */ getFinalLayoutInfo(layoutInfo) {
        return layoutInfo;
    }
}


var $d7fd61009c21d0bb$exports = {};

$parcel$export$5($d7fd61009c21d0bb$exports, "LayoutInfo", () => $d7fd61009c21d0bb$export$7e0eeb9da702a085);
class $d7fd61009c21d0bb$export$7e0eeb9da702a085 {
    /**
   * Returns a copy of the LayoutInfo.
   */ copy() {
        let res = new $d7fd61009c21d0bb$export$7e0eeb9da702a085(this.type, this.key, this.rect.copy());
        res.estimatedSize = this.estimatedSize;
        res.opacity = this.opacity;
        res.transform = this.transform;
        res.parentKey = this.parentKey;
        res.isSticky = this.isSticky;
        res.zIndex = this.zIndex;
        res.allowOverflow = this.allowOverflow;
        return res;
    }
    /**
   * @param type A string representing the view type. Should be `'item'` for item views.
                            Other types are used by supplementary views.
   * @param key The unique key for this view.
   * @param rect The rectangle describing the size and position of this view.
   */ constructor(type, key, rect){
        this.type = type;
        this.key = key;
        this.parentKey = null;
        this.rect = rect;
        this.estimatedSize = false;
        this.isSticky = false;
        this.opacity = 1;
        this.transform = null;
        this.zIndex = 0;
        this.allowOverflow = false;
    }
}


var $3041db3296945e6e$exports = {};

$parcel$export$5($3041db3296945e6e$exports, "Point", () => $3041db3296945e6e$export$baf26146a414f24a);
class $3041db3296945e6e$export$baf26146a414f24a {
    /**
   * Returns a copy of this point.
   */ copy() {
        return new $3041db3296945e6e$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Checks if two points are equal.
   */ equals(point) {
        return this.x === point.x && this.y === point.y;
    }
    /**
   * Returns true if this point is the origin.
   */ isOrigin() {
        return this.x === 0 && this.y === 0;
    }
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
}


var $60423f92c7f9ad87$exports = {};

$parcel$export$5($60423f92c7f9ad87$exports, "Rect", () => $60423f92c7f9ad87$export$c79fc6492f3af13d);

class $60423f92c7f9ad87$export$c79fc6492f3af13d {
    /**
   * The maximum x-coordinate in the rectangle.
   */ get maxX() {
        return this.x + this.width;
    }
    /**
   * The maximum y-coordinate in the rectangle.
   */ get maxY() {
        return this.y + this.height;
    }
    /**
   * The area of the rectangle.
   */ get area() {
        return this.width * this.height;
    }
    /**
   * The top left corner of the rectangle.
   */ get topLeft() {
        return new $3041db3296945e6e$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * The top right corner of the rectangle.
   */ get topRight() {
        return new $3041db3296945e6e$export$baf26146a414f24a(this.maxX, this.y);
    }
    /**
   * The bottom left corner of the rectangle.
   */ get bottomLeft() {
        return new $3041db3296945e6e$export$baf26146a414f24a(this.x, this.maxY);
    }
    /**
   * The bottom right corner of the rectangle.
   */ get bottomRight() {
        return new $3041db3296945e6e$export$baf26146a414f24a(this.maxX, this.maxY);
    }
    /**
   * Returns whether this rectangle intersects another rectangle.
   * @param rect - The rectangle to check.
   */ intersects(rect) {
        return this.x <= rect.x + rect.width && rect.x <= this.x + this.width && this.y <= rect.y + rect.height && rect.y <= this.y + this.height;
    }
    /**
   * Returns whether this rectangle fully contains another rectangle.
   * @param rect - The rectangle to check.
   */ containsRect(rect) {
        return this.x <= rect.x && this.y <= rect.y && this.maxX >= rect.maxX && this.maxY >= rect.maxY;
    }
    /**
   * Returns whether the rectangle contains the given point.
   * @param point - The point to check.
   */ containsPoint(point) {
        return this.x <= point.x && this.y <= point.y && this.maxX >= point.x && this.maxY >= point.y;
    }
    /**
   * Returns the first corner of this rectangle (from top to bottom, left to right)
   * that is contained in the given rectangle, or null of the rectangles do not intersect.
   * @param rect - The rectangle to check.
   */ getCornerInRect(rect) {
        for (let key of [
            'topLeft',
            'topRight',
            'bottomLeft',
            'bottomRight'
        ]){
            if (rect.containsPoint(this[key])) return key;
        }
        return null;
    }
    equals(rect) {
        return rect.x === this.x && rect.y === this.y && rect.width === this.width && rect.height === this.height;
    }
    pointEquals(point) {
        return this.x === point.x && this.y === point.y;
    }
    sizeEquals(size) {
        return this.width === size.width && this.height === size.height;
    }
    /**
   * Returns a copy of this rectangle.
   */ copy() {
        return new $60423f92c7f9ad87$export$c79fc6492f3af13d(this.x, this.y, this.width, this.height);
    }
    constructor(x = 0, y = 0, width = 0, height = 0){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
}


var $ee1bfa90a957fb8a$exports = {};

$parcel$export$5($ee1bfa90a957fb8a$exports, "Size", () => $ee1bfa90a957fb8a$export$cb6da89c6af1a8ec);
class $ee1bfa90a957fb8a$export$cb6da89c6af1a8ec {
    /**
   * Returns a copy of this size.
   */ copy() {
        return new $ee1bfa90a957fb8a$export$cb6da89c6af1a8ec(this.width, this.height);
    }
    /**
   * Returns whether this size is equal to another one.
   */ equals(other) {
        return this.width === other.width && this.height === other.height;
    }
    constructor(width = 0, height = 0){
        this.width = width;
        this.height = height;
    }
}


var $ad1d98aa8f0c31b4$exports = {};

$parcel$export$5($ad1d98aa8f0c31b4$exports, "ReusableView", () => $ad1d98aa8f0c31b4$export$1a5223887c560441);
let $ad1d98aa8f0c31b4$var$KEY = 0;
class $ad1d98aa8f0c31b4$export$1a5223887c560441 {
    /**
   * Prepares the view for reuse. Called just before the view is removed from the DOM.
   */ prepareForReuse() {
        this.content = null;
        this.rendered = null;
        this.layoutInfo = null;
    }
    constructor(virtualizer){
        this.virtualizer = virtualizer;
        this.key = ++$ad1d98aa8f0c31b4$var$KEY;
    }
}


var $fc0b13b484ac1194$exports = {};

$parcel$export$5($fc0b13b484ac1194$exports, "useVirtualizerState", () => $fc0b13b484ac1194$export$1505db82fe357e65);




// use high res timer if available
let $3eb131dcf37ad5f8$var$perf = typeof window !== 'undefined' ? window.performance : null;
// @ts-ignore
let $3eb131dcf37ad5f8$var$perfNow = $3eb131dcf37ad5f8$var$perf && ($3eb131dcf37ad5f8$var$perf.now || $3eb131dcf37ad5f8$var$perf.webkitNow || $3eb131dcf37ad5f8$var$perf.msNow || $3eb131dcf37ad5f8$var$perf.mozNow);
let $3eb131dcf37ad5f8$var$getTime = $3eb131dcf37ad5f8$var$perfNow ? $3eb131dcf37ad5f8$var$perfNow.bind($3eb131dcf37ad5f8$var$perf) : function() {
    return Date.now ? Date.now() : new Date().getTime();
};
let $3eb131dcf37ad5f8$var$fixTs;
function $3eb131dcf37ad5f8$export$dc0b63720788090c(begin, end, duration, ease, fn) {
    let canceled = false;
    let raf_id;
    let promise = new Promise((resolve)=>{
        let start = $3eb131dcf37ad5f8$var$getTime();
        let diffX = end.x - begin.x;
        let diffY = end.y - begin.y;
        raf_id = requestAnimationFrame(function run(t) {
            // if we're using a high res timer, make sure timestamp is not the old epoch-based value.
            // http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
            if ($3eb131dcf37ad5f8$var$fixTs == null) $3eb131dcf37ad5f8$var$fixTs = t > 1000000000000 !== $3eb131dcf37ad5f8$var$getTime() > 1000000000000;
            if ($3eb131dcf37ad5f8$var$fixTs) t = $3eb131dcf37ad5f8$var$getTime();
            // check if we're done
            let delta = t - start;
            if (delta > duration) {
                fn(end);
                resolve();
            } else {
                // call frame callback after computing eased time and get the next frame
                let proceed = fn(new $3041db3296945e6e$export$baf26146a414f24a(begin.x + diffX * ease(delta / duration), begin.y + diffY * ease(delta / duration)));
                if (proceed !== false && !canceled) raf_id = requestAnimationFrame(run);
            }
        });
    });
    promise.cancel = function() {
        canceled = true;
        cancelAnimationFrame(raf_id);
    };
    return promise;
}
function $3eb131dcf37ad5f8$export$57636bb43b1ccbb0(t) {
    return Math.sin(t * Math.PI / 2);
}


function $fc36f9a046a9ce79$export$37a26b283fd7740e(a, b) {
    let res = new Set();
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}
function $fc36f9a046a9ce79$export$acaf96a27438246b(a, b) {
    let toRemove = $fc36f9a046a9ce79$export$37a26b283fd7740e(a, b);
    let toAdd = $fc36f9a046a9ce79$export$37a26b283fd7740e(b, a);
    let toUpdate = new Set;
    for (let key of a.keys())if (b.has(key)) toUpdate.add(key);
    return {
        toRemove: toRemove,
        toAdd: toAdd,
        toUpdate: toUpdate
    };
}
function* $fc36f9a046a9ce79$export$cfc14088dfefce5f(...iterators) {
    for (let iterator of iterators)yield* iterator;
}




class $364191b3decf3697$var$RollingAverage {
    addSample(sample) {
        this.count++;
        this.value += (sample - this.value) / this.count;
    }
    constructor(){
        this.count = 0;
        this.value = 0;
    }
}
class $364191b3decf3697$export$4455ee6afb38dcbb {
    setVisibleRect(rect) {
        let time = performance.now() - this.startTime;
        if (time < 500) {
            this.averageTime.addSample(time);
            if (rect.x !== this.visibleRect.x && time > 0) this.velocity.x = (rect.x - this.visibleRect.x) / time;
            if (rect.y !== this.visibleRect.y && time > 0) this.velocity.y = (rect.y - this.visibleRect.y) / time;
        }
        this.startTime = performance.now();
        this.visibleRect = rect;
    }
    collectMetrics() {
        let time = performance.now() - this.startTime;
        if (time < 500) this.averagePerf.addSample(time);
        if (this.visibleRect.height > 0) {
            let o = Math.abs(this.velocity.y * (this.averageTime.value + this.averagePerf.value));
            this.overscanY.addSample(o);
        }
        if (this.visibleRect.width > 0) {
            let o = Math.abs(this.velocity.x * (this.averageTime.value + this.averagePerf.value));
            this.overscanX.addSample(o);
        }
    }
    getOverscannedRect() {
        let overscanned = this.visibleRect.copy();
        let overscanY = Math.round(Math.min(this.visibleRect.height * 2, this.overscanY.value) / 100) * 100;
        if (this.velocity.y > 0) {
            overscanned.y -= overscanY * 0.2;
            overscanned.height += overscanY + overscanY * 0.2;
        } else {
            overscanned.y -= overscanY;
            overscanned.height += overscanY + overscanY * 0.2;
        }
        let overscanX = Math.round(Math.min(this.visibleRect.width * 2, this.overscanX.value) / 100) * 100;
        if (this.velocity.x > 0) {
            overscanned.x -= overscanX * 0.2;
            overscanned.width += overscanX + overscanX * 0.2;
        } else {
            overscanned.x -= overscanX;
            overscanned.width += overscanX + overscanX * 0.2;
        }
        return overscanned;
    }
    constructor(){
        this.startTime = 0;
        this.averagePerf = new $364191b3decf3697$var$RollingAverage();
        this.averageTime = new $364191b3decf3697$var$RollingAverage();
        this.velocity = new $3041db3296945e6e$export$baf26146a414f24a(5, 5);
        this.overscanX = new $364191b3decf3697$var$RollingAverage();
        this.overscanY = new $364191b3decf3697$var$RollingAverage();
        this.visibleRect = new $60423f92c7f9ad87$export$c79fc6492f3af13d();
    }
}






class $8e135e531d8dcb66$export$febc5573c75cefb0 {
    constructor(){
        this.level = 0;
        this.actions = [];
        this.animated = true;
        this.initialMap = new Map();
        this.finalMap = new Map();
        this.initialLayoutInfo = new Map();
        this.finalLayoutInfo = new Map();
        this.removed = new Map();
        this.toRemove = new Map();
    }
}


class $38b9490c1cca8fc4$export$89be5a243e59c4b2 {
    _setContentSize(size) {
        this._contentSize = size;
        this.delegate.setContentSize(size);
    }
    _setContentOffset(offset) {
        let rect = new $60423f92c7f9ad87$export$c79fc6492f3af13d(offset.x, offset.y, this._visibleRect.width, this._visibleRect.height);
        this.delegate.setVisibleRect(rect);
    }
    /**
   * Get the size of the scrollable content.
   */ get contentSize() {
        return this._contentSize;
    }
    /**
   * Get the collection view's currently visible rectangle.
   */ get visibleRect() {
        return this._visibleRect;
    }
    /**
   * Set the collection view's currently visible rectangle.
   */ set visibleRect(rect) {
        this._setVisibleRect(rect);
    }
    _setVisibleRect(rect, forceUpdate = false) {
        let current = this._visibleRect;
        // Ignore if the rects are equal
        if (rect.equals(current)) return;
        if (this.shouldOverscan) this._overscanManager.setVisibleRect(rect);
        let shouldInvalidate = this.layout && this.layout.shouldInvalidate(rect, this._visibleRect);
        this._resetAnimatedContentOffset();
        this._visibleRect = rect;
        if (shouldInvalidate) this.relayout({
            offsetChanged: !rect.pointEquals(current),
            sizeChanged: !rect.sizeEquals(current)
        });
        else this.updateSubviews(forceUpdate);
    }
    get collection() {
        return this._collection;
    }
    set collection(data) {
        this._setData(data);
    }
    _setData(data) {
        if (data === this._collection) return;
        if (this._collection) this._runTransaction(()=>{
            this._collection = data;
        }, this.transitionDuration > 0);
        else {
            this._collection = data;
            this.reloadData();
        }
    }
    /**
   * Reloads the data from the data source and relayouts the collection view.
   * Does not animate any changes. Equivalent to re-assigning the same data source
   * to the collection view.
   */ reloadData() {
        this.relayout({
            contentChanged: true
        });
    }
    /**
   * Returns the item with the given key.
   */ getItem(key) {
        return this._collection ? this._collection.getItem(key) : null;
    }
    /**
   * Get the collection view's layout.
   */ get layout() {
        return this._layout;
    }
    /**
   * Set the collection view's layout.
   */ set layout(layout) {
        this.setLayout(layout);
    }
    /**
   * Sets the collection view's layout, optionally with an animated transition
   * from the current layout to the new layout.
   * @param layout The layout to switch to.
   * @param animated Whether to animate the layout change.
   */ setLayout(layout, animated = false) {
        if (layout === this._layout) return;
        let applyLayout = ()=>{
            if (this._layout) // @ts-ignore
            this._layout.virtualizer = null;
            layout.virtualizer = this;
            this._layout = layout;
        };
        if (animated) // Animated layout transitions are really simple, thanks to our transaction support.
        // We just set the layout inside a transaction action, which runs after the initial
        // layout infos for the animation are retrieved from the previous layout. Then, the
        // final layout infos are retrieved from the new layout, and animations occur.
        this._runTransaction(applyLayout);
        else {
            applyLayout();
            this.relayout();
        }
    }
    _getReuseType(layoutInfo, content) {
        if (layoutInfo.type === 'item' && content) {
            let type = this.delegate.getType ? this.delegate.getType(content) : 'item';
            let reuseType = type === 'item' ? 'item' : layoutInfo.type + '_' + type;
            return {
                type: type,
                reuseType: reuseType
            };
        }
        return {
            type: layoutInfo.type,
            reuseType: layoutInfo.type
        };
    }
    getReusableView(layoutInfo) {
        let content = this.getItem(layoutInfo.key);
        let { reuseType: reuseType  } = this._getReuseType(layoutInfo, content);
        if (!this._reusableViews[reuseType]) this._reusableViews[reuseType] = [];
        let reusable = this._reusableViews[reuseType];
        let view = reusable.length > 0 ? reusable.pop() : new $ad1d98aa8f0c31b4$export$1a5223887c560441(this);
        view.viewType = reuseType;
        if (!this._animatedContentOffset.isOrigin()) {
            layoutInfo = layoutInfo.copy();
            layoutInfo.rect.x += this._animatedContentOffset.x;
            layoutInfo.rect.y += this._animatedContentOffset.y;
        }
        view.layoutInfo = layoutInfo;
        this._renderView(view);
        return view;
    }
    _renderView(reusableView) {
        let { type: type , key: key  } = reusableView.layoutInfo;
        reusableView.content = this.getItem(key);
        reusableView.rendered = this._renderContent(type, reusableView.content);
    }
    _renderContent(type, content) {
        let cached = this._renderedContent.get(content);
        if (cached != null) return cached;
        let rendered = this.delegate.renderView(type, content);
        if (content) this._renderedContent.set(content, rendered);
        return rendered;
    }
    /**
   * Returns an array of all currently visible views, including both
   * item views and supplementary views.
   */ get visibleViews() {
        return Array.from(this._visibleViews.values());
    }
    /**
   * Gets the visible view for the given type and key. Returns null if
   * the view is not currently visible.
   *
   * @param key The key of the view to retrieve.
   */ getView(key) {
        return this._visibleViews.get(key) || null;
    }
    /**
   * Returns an array of visible views matching the given type.
   * @param type The view type to find.
   */ getViewsOfType(type) {
        return this.visibleViews.filter((v)=>v.layoutInfo && v.layoutInfo.type === type
        );
    }
    /**
   * Returns the key for the given view. Returns null
   * if the view is not currently visible.
   */ keyForView(view) {
        if (view && view.layoutInfo) return view.layoutInfo.key;
        return null;
    }
    /**
   * Returns the key for the item view currently at the given point.
   */ keyAtPoint(point) {
        let rect = new $60423f92c7f9ad87$export$c79fc6492f3af13d(point.x, point.y, 1, 1);
        let layoutInfos = this.layout.getVisibleLayoutInfos(rect);
        let layoutInfo = layoutInfos[0];
        if (!layoutInfo) return null;
        return layoutInfo.key;
    }
    /**
   * Cleanup for when the Virtualizer will be unmounted.
   */ willUnmount() {
        cancelAnimationFrame(this._relayoutRaf);
    }
    /**
   * Triggers a layout invalidation, and updates the visible subviews.
   */ relayout(context = {
    }) {
        // Ignore relayouts while animating the scroll position
        if (this._scrollAnimation || typeof requestAnimationFrame === 'undefined') return;
        // If we already scheduled a relayout, extend the invalidation
        // context so we coalesce multiple relayouts in the same frame.
        if (this._invalidationContext) {
            Object.assign(this._invalidationContext, context);
            return;
        }
        this._invalidationContext = context;
        this._relayoutRaf = requestAnimationFrame(()=>{
            this._relayoutRaf = null;
            this.relayoutNow();
        });
    }
    /**
   * Performs a relayout immediately. Prefer {@link relayout} over this method
   * where possible, since it coalesces multiple layout passes in the same tick.
   */ relayoutNow(context = this._invalidationContext || {
    }) {
        // Cancel the scheduled relayout, since we're doing it now.
        if (this._relayoutRaf) {
            cancelAnimationFrame(this._relayoutRaf);
            this._relayoutRaf = null;
            // Update the provided context with the current invalidationContext since we are cancelling
            // a scheduled relayoutNow call that has this._invalidationContext set as its default context arg (relayoutNow() in relayout)
            context = {
                ...this._invalidationContext,
                ...context
            };
        }
        // Reset the invalidation context
        this._invalidationContext = null;
        // Do nothing if we don't have a layout or content, or we are
        // in the middle of an animated scroll transition.
        if (!this.layout || !this._collection || this._scrollAnimation) return;
        let scrollAnchor = this._getScrollAnchor();
        // Trigger the beforeLayout hook, if provided
        if (typeof context.beforeLayout === 'function') context.beforeLayout();
        // Validate the layout
        this.layout.validate(context);
        this._setContentSize(this.layout.getContentSize());
        // Trigger the afterLayout hook, if provided
        if (typeof context.afterLayout === 'function') context.afterLayout();
        // Adjust scroll position based on scroll anchor, and constrain.
        // If the content changed, scroll to the top.
        let visibleRect = this.getVisibleRect();
        let restoredScrollAnchor = this._restoreScrollAnchor(scrollAnchor, context);
        let contentOffsetX = context.contentChanged ? 0 : restoredScrollAnchor.x;
        let contentOffsetY = context.contentChanged ? 0 : restoredScrollAnchor.y;
        contentOffsetX = Math.max(0, Math.min(this.contentSize.width - visibleRect.width, contentOffsetX));
        contentOffsetY = Math.max(0, Math.min(this.contentSize.height - visibleRect.height, contentOffsetY));
        let hasLayoutUpdates = false;
        if (contentOffsetX !== visibleRect.x || contentOffsetY !== visibleRect.y) {
            // If this is an animated relayout, we do not immediately scroll because it would be jittery.
            // Save the difference between the current and new content offsets, and apply it to the
            // individual content items instead. At the end of the animation, we'll reset and set the
            // scroll offset for real. This ensures jitter-free animation since we don't need to sync
            // the scroll animation and the content animation.
            if (context.animated || !this._animatedContentOffset.isOrigin()) {
                this._animatedContentOffset.x += visibleRect.x - contentOffsetX;
                this._animatedContentOffset.y += visibleRect.y - contentOffsetY;
                hasLayoutUpdates = this.updateSubviews(context.contentChanged);
            } else this._setContentOffset(new $3041db3296945e6e$export$baf26146a414f24a(contentOffsetX, contentOffsetY));
        } else hasLayoutUpdates = this.updateSubviews(context.contentChanged);
        // Apply layout infos, unless this is coming from an animated transaction
        if (!(context.transaction && context.animated)) this._applyLayoutInfos();
        // Wait for animations, and apply the afterAnimation hook, if provided
        if (context.animated && hasLayoutUpdates) {
            this._enableTransitions();
            let done = ()=>{
                this._disableTransitions();
                // Reset scroll position after animations (see above comment).
                if (!this._animatedContentOffset.isOrigin()) {
                    // Get the content offset to scroll to, taking _animatedContentOffset into account.
                    let { x: x , y: y  } = this.getVisibleRect();
                    this._resetAnimatedContentOffset();
                    this._setContentOffset(new $3041db3296945e6e$export$baf26146a414f24a(x, y));
                }
                if (typeof context.afterAnimation === 'function') context.afterAnimation();
            };
            // Sometimes the animation takes slightly longer than expected.
            setTimeout(done, this.transitionDuration + 100);
            return;
        } else if (typeof context.afterAnimation === 'function') context.afterAnimation();
    }
    /**
   * Corrects DOM order of visible views to match item order of collection.
   */ _correctItemOrder() {
        // Defer until after scrolling and animated transactions are complete
        if (this._isScrolling || this._transaction) return;
        for (let key of this._visibleLayoutInfos.keys()){
            let view = this._visibleViews.get(key);
            this._children.delete(view);
            this._children.add(view);
        }
    }
    _enableTransitions() {
        this.delegate.beginAnimations();
    }
    _disableTransitions() {
        this.delegate.endAnimations();
    }
    _getScrollAnchor() {
        if (!this.anchorScrollPosition) return null;
        let visibleRect = this.getVisibleRect();
        // Ask the delegate to provide a scroll anchor, if possible
        if (this.delegate.getScrollAnchor) {
            let key = this.delegate.getScrollAnchor(visibleRect);
            if (key != null) {
                let layoutInfo = this.layout.getLayoutInfo(key);
                let corner = layoutInfo.rect.getCornerInRect(visibleRect);
                if (corner) {
                    let key = layoutInfo.key;
                    let offset = layoutInfo.rect[corner].y - visibleRect.y;
                    return {
                        key: key,
                        layoutInfo: layoutInfo,
                        corner: corner,
                        offset: offset
                    };
                }
            }
        }
        // No need to anchor the scroll position if it is at the top
        if (visibleRect.y === 0 && !this.anchorScrollPositionAtTop) return null;
        // Find a view with a visible corner that has the smallest distance to the top of the collection view
        let cornerAnchor = null;
        for (let [key, view] of this._visibleViews){
            let layoutInfo = view.layoutInfo;
            if (layoutInfo && layoutInfo.rect.area > 0) {
                let corner = layoutInfo.rect.getCornerInRect(visibleRect);
                if (corner) {
                    let offset = layoutInfo.rect[corner].y - visibleRect.y;
                    if (!cornerAnchor || offset < cornerAnchor.offset) cornerAnchor = {
                        key: key,
                        layoutInfo: layoutInfo,
                        corner: corner,
                        offset: offset
                    };
                }
            }
        }
        return cornerAnchor;
    }
    _restoreScrollAnchor(scrollAnchor, context) {
        let contentOffset = this.getVisibleRect();
        if (scrollAnchor) {
            var ref;
            let finalAnchor = ((ref = context.transaction) === null || ref === void 0 ? void 0 : ref.animated) ? context.transaction.finalMap.get(scrollAnchor.key) : this.layout.getLayoutInfo(scrollAnchor.layoutInfo.key);
            if (finalAnchor) {
                let adjustment = finalAnchor.rect[scrollAnchor.corner].y - contentOffset.y - scrollAnchor.offset;
                contentOffset.y += adjustment;
            }
        }
        return contentOffset;
    }
    getVisibleRect() {
        let v = this.visibleRect;
        let x = v.x - this._animatedContentOffset.x;
        let y = v.y - this._animatedContentOffset.y;
        return new $60423f92c7f9ad87$export$c79fc6492f3af13d(x, y, v.width, v.height);
    }
    getVisibleLayoutInfos() {
        let rect = this.shouldOverscan ? this._overscanManager.getOverscannedRect() : this.getVisibleRect();
        this._visibleLayoutInfos = this._getLayoutInfoMap(rect);
        return this._visibleLayoutInfos;
    }
    _getLayoutInfoMap(rect, copy = false) {
        let layoutInfos = this.layout.getVisibleLayoutInfos(rect);
        let map = new Map;
        for (let layoutInfo of layoutInfos){
            if (copy) layoutInfo = layoutInfo.copy();
            map.set(layoutInfo.key, layoutInfo);
        }
        return map;
    }
    updateSubviews(forceUpdate = false) {
        if (!this._collection) return;
        let visibleLayoutInfos = this.getVisibleLayoutInfos();
        let currentlyVisible = this._visibleViews;
        let toAdd, toRemove, toUpdate;
        // If this is a force update, remove and re-add all views.
        // Otherwise, find and update the diff.
        if (forceUpdate) {
            toAdd = visibleLayoutInfos;
            toRemove = currentlyVisible;
            toUpdate = new Set();
        } else {
            ({ toAdd: toAdd , toRemove: toRemove , toUpdate: toUpdate  } = $fc36f9a046a9ce79$export$acaf96a27438246b(currentlyVisible, visibleLayoutInfos));
            for (let key of toUpdate){
                let view = currentlyVisible.get(key);
                if (!view || !view.layoutInfo) continue;
                let item = this.getItem(visibleLayoutInfos.get(key).key);
                if (view.content === item) toUpdate.delete(key);
                else {
                    // If the view type changes, delete and recreate the view instead of updating
                    let { reuseType: reuseType  } = this._getReuseType(view.layoutInfo, item);
                    if (view.viewType !== reuseType) {
                        toUpdate.delete(key);
                        toAdd.add(key);
                        toRemove.add(key);
                    }
                }
            }
            // We are done if the sets are equal
            if (toAdd.size === 0 && toRemove.size === 0 && toUpdate.size === 0) {
                if (this._transaction) this._applyLayoutInfos();
                return;
            }
        }
        // Track views that should be removed. They are not removed from
        // the DOM immediately, since we may reuse and need to re-insert
        // them back into the DOM anyway.
        let removed = new Set();
        for (let key of toRemove.keys()){
            let view = this._visibleViews.get(key);
            if (view) {
                removed.add(view);
                this._visibleViews.delete(key);
                // If we are in the middle of a transaction, wait until the end
                // of the animations to remove the views from the DOM. Also means
                // we can't reuse those views immediately.
                if (this._transaction) this._transaction.toRemove.set(key, view);
                else this.reuseView(view);
            }
        }
        for (let key1 of toAdd.keys()){
            let layoutInfo = visibleLayoutInfos.get(key1);
            let view;
            // If we're in a transaction, and a layout change happens
            // during the animations such that a view that was going
            // to be removed is now not, we don't create a new view
            // since the old one is still in the DOM, marked as toRemove.
            if (this._transaction) {
                // if transaction, get initial layout attributes for the animation
                if (this._transaction.initialLayoutInfo.has(key1)) layoutInfo = this._transaction.initialLayoutInfo.get(key1);
                view = this._transaction.toRemove.get(key1);
                if (view) {
                    this._transaction.toRemove.delete(key1);
                    this._applyLayoutInfo(view, layoutInfo);
                }
            }
            if (!view) {
                // Create or reuse a view for this row
                view = this.getReusableView(layoutInfo);
                // Add the view to the DOM if needed
                if (!removed.has(view)) this._children.add(view);
            }
            this._visibleViews.set(key1, view);
            removed.delete(view);
        }
        for (let key2 of toUpdate){
            let view = currentlyVisible.get(key2);
            this._renderedContent.delete(key2);
            this._renderView(view);
        }
        // Remove the remaining rows to delete from the DOM
        if (!this._transaction) this.removeViews(removed);
        this._correctItemOrder();
        this._flushVisibleViews();
        let hasLayoutUpdates = this._transaction && (toAdd.size > 0 || toRemove.size > 0 || this._hasLayoutUpdates());
        if (hasLayoutUpdates) requestAnimationFrame(()=>{
            // If we're in a transaction, apply animations to visible views
            // and "to be removed" views, which animate off screen.
            if (this._transaction) requestAnimationFrame(()=>this._applyLayoutInfos()
            );
        });
        return hasLayoutUpdates;
    }
    afterRender() {
        if (this.shouldOverscan) this._overscanManager.collectMetrics();
    }
    _flushVisibleViews() {
        // CollectionVirtualizer deals with a flattened set of LayoutInfos, but they can represent heirarchy
        // by referencing a parentKey. Just before rendering the visible views, we rebuild this heirarchy
        // by creating a mapping of views by parent key and recursively calling the delegate's renderWrapper
        // method to build the final tree.
        let viewsByParentKey = new Map([
            [
                null,
                []
            ]
        ]);
        for (let view1 of this._children){
            if (!viewsByParentKey.has(view1.layoutInfo.parentKey)) viewsByParentKey.set(view1.layoutInfo.parentKey, []);
            viewsByParentKey.get(view1.layoutInfo.parentKey).push(view1);
            if (!viewsByParentKey.has(view1.layoutInfo.key)) viewsByParentKey.set(view1.layoutInfo.key, []);
        }
        let buildTree = (parent, views)=>views.map((view)=>{
                let children = viewsByParentKey.get(view.layoutInfo.key);
                return this.delegate.renderWrapper(parent, view, children, (childViews)=>buildTree(view, childViews)
                );
            })
        ;
        let children1 = buildTree(null, viewsByParentKey.get(null));
        this.delegate.setVisibleViews(children1);
    }
    _applyLayoutInfo(view, layoutInfo) {
        if (view.layoutInfo === layoutInfo) return false;
        view.layoutInfo = layoutInfo;
        return true;
    }
    _applyLayoutInfos() {
        let updated = false;
        // Apply layout infos to visible views
        for (let view of this._visibleViews.values()){
            let cur = view.layoutInfo;
            if (cur) {
                let layoutInfo = this.layout.getLayoutInfo(cur.key);
                if (this._applyLayoutInfo(view, layoutInfo)) updated = true;
            }
        }
        // Apply final layout infos for views that will be removed
        if (this._transaction) {
            for (let view of this._transaction.toRemove.values()){
                let cur = view.layoutInfo;
                let layoutInfo = this.layout.getLayoutInfo(cur.key);
                if (this._applyLayoutInfo(view, layoutInfo)) updated = true;
            }
            for (let view2 of this._transaction.removed.values()){
                let cur = view2.layoutInfo;
                let layoutInfo = this._transaction.finalLayoutInfo.get(cur.key) || cur;
                layoutInfo = this.layout.getFinalLayoutInfo(layoutInfo.copy());
                if (this._applyLayoutInfo(view2, layoutInfo)) updated = true;
            }
        }
        if (updated) this._flushVisibleViews();
    }
    _hasLayoutUpdates() {
        if (!this._transaction) return false;
        for (let view of this._visibleViews.values()){
            let cur = view.layoutInfo;
            if (!cur) return true;
            let layoutInfo = this.layout.getLayoutInfo(cur.key);
            if (// Uses equals rather than pointEquals so that width/height changes are taken into account
            !cur.rect.equals(layoutInfo.rect) || cur.opacity !== layoutInfo.opacity || cur.transform !== layoutInfo.transform) return true;
        }
        return false;
    }
    reuseView(view) {
        view.prepareForReuse();
        this._reusableViews[view.viewType].push(view);
    }
    removeViews(toRemove) {
        for (let view of toRemove)this._children.delete(view);
    }
    updateItemSize(key, size) {
        // TODO: we should be able to invalidate a single index path
        // @ts-ignore
        if (!this.layout.updateItemSize) return;
        // If the scroll position is currently animating, add the update
        // to a queue to be processed after the animation is complete.
        if (this._scrollAnimation) {
            this._sizeUpdateQueue.set(key, size);
            return;
        }
        // @ts-ignore
        let changed = this.layout.updateItemSize(key, size);
        if (changed) this.relayout();
    }
    startScrolling() {
        this._isScrolling = true;
    }
    endScrolling() {
        this._isScrolling = false;
        this._correctItemOrder();
        this._flushVisibleViews();
    }
    _resetAnimatedContentOffset() {
        // Reset the animated content offset of subviews. See comment in relayoutNow for details.
        if (!this._animatedContentOffset.isOrigin()) {
            this._animatedContentOffset = new $3041db3296945e6e$export$baf26146a414f24a(0, 0);
            this._applyLayoutInfos();
        }
    }
    /**
   * Scrolls the item with the given key into view, optionally with an animation.
   * @param key The key of the item to scroll into view.
   * @param duration The duration of the scroll animation.
   */ scrollToItem(key, options) {
        // key can be 0, so check if null or undefined
        if (key == null) return;
        let layoutInfo = this.layout.getLayoutInfo(key);
        if (!layoutInfo) return;
        let { duration: duration = 300 , shouldScrollX: shouldScrollX = true , shouldScrollY: shouldScrollY = true , offsetX: offsetX = 0 , offsetY: offsetY = 0  } = options;
        let x = this.visibleRect.x;
        let y = this.visibleRect.y;
        let minX = layoutInfo.rect.x - offsetX;
        let minY = layoutInfo.rect.y - offsetY;
        let maxX = x + this.visibleRect.width;
        let maxY = y + this.visibleRect.height;
        if (shouldScrollX) {
            if (minX <= x || maxX === 0) x = minX;
            else if (layoutInfo.rect.maxX > maxX) x += layoutInfo.rect.maxX - maxX;
        }
        if (shouldScrollY) {
            if (minY <= y || maxY === 0) y = minY;
            else if (layoutInfo.rect.maxY > maxY) y += layoutInfo.rect.maxY - maxY;
        }
        return this.scrollTo(new $3041db3296945e6e$export$baf26146a414f24a(x, y), duration);
    }
    /**
   * Performs an animated scroll to the given offset.
   * @param offset - The offset to scroll to.
   * @param duration The duration of the animation.
   * @returns A promise that resolves when the animation is complete.
   */ scrollTo(offset1, duration = 300) {
        // Cancel the current scroll animation
        if (this._scrollAnimation) {
            this._scrollAnimation.cancel();
            this._scrollAnimation = null;
        }
        // Set the content offset synchronously if the duration is zero
        if (duration <= 0 || this.visibleRect.pointEquals(offset1)) {
            this._setContentOffset(offset1);
            return Promise.resolve();
        }
        this.startScrolling();
        this._scrollAnimation = $3eb131dcf37ad5f8$export$dc0b63720788090c(this.visibleRect, offset1, duration, $3eb131dcf37ad5f8$export$57636bb43b1ccbb0, (offset)=>{
            this._setContentOffset(offset);
        });
        this._scrollAnimation.then(()=>{
            this._scrollAnimation = null;
            // Process view size updates that occurred during the animation.
            // Only views that are still visible will be actually updated.
            for (let [key, size] of this._sizeUpdateQueue)this.updateItemSize(key, size);
            this._sizeUpdateQueue.clear();
            this.relayout();
            this._processTransactionQueue();
            this.endScrolling();
        });
        return this._scrollAnimation;
    }
    _runTransaction(action, animated) {
        this._startTransaction();
        if (this._nextTransaction) this._nextTransaction.actions.push(action);
        this._endTransaction(animated);
    }
    _startTransaction() {
        if (!this._nextTransaction) this._nextTransaction = new $8e135e531d8dcb66$export$febc5573c75cefb0;
        this._nextTransaction.level++;
    }
    _endTransaction(animated) {
        if (!this._nextTransaction) return false;
        // Save whether the transaction should be animated.
        if (animated != null) this._nextTransaction.animated = animated;
        // If we haven't reached level 0, we are still in a
        // nested transaction. Wait for the parent to end.
        if (--this._nextTransaction.level > 0) return false;
        // Do nothing for empty transactions
        if (this._nextTransaction.actions.length === 0) {
            this._nextTransaction = null;
            return false;
        }
        // Default animations to true
        if (this._nextTransaction.animated == null) this._nextTransaction.animated = true;
        // Enqueue the transaction
        this._transactionQueue.push(this._nextTransaction);
        this._nextTransaction = null;
        this._processTransactionQueue();
        return true;
    }
    _processTransactionQueue() {
        // If the current transaction is animating, wait until the end
        // to process the next transaction.
        if (this._transaction || this._scrollAnimation) return;
        let next = this._transactionQueue.shift();
        if (next) this._performTransaction(next);
    }
    _getContentRect() {
        return new $60423f92c7f9ad87$export$c79fc6492f3af13d(0, 0, this.contentSize.width, this.contentSize.height);
    }
    _performTransaction(transaction) {
        this._transaction = transaction;
        this.relayoutNow({
            transaction: transaction,
            animated: transaction.animated,
            beforeLayout: ()=>{
                // Get the initial layout infos for all views before the updates
                // so we can figure out which views to add and remove.
                if (transaction.animated) transaction.initialMap = this._getLayoutInfoMap(this._getContentRect(), true);
                // Apply the actions that occurred during this transaction
                for (let action of transaction.actions)action();
            },
            afterLayout: ()=>{
                // Get the final layout infos after the updates
                if (transaction.animated) {
                    transaction.finalMap = this._getLayoutInfoMap(this._getContentRect());
                    this._setupTransactionAnimations(transaction);
                } else this._transaction = null;
            },
            afterAnimation: ()=>{
                // Remove and reuse views when animations are done
                if (transaction.toRemove.size > 0 || transaction.removed.size > 0) for (let view of $fc36f9a046a9ce79$export$cfc14088dfefce5f(transaction.toRemove.values(), transaction.removed.values())){
                    this._children.delete(view);
                    this.reuseView(view);
                }
                this._transaction = null;
                // Ensure DOM order is correct for accessibility after animations are complete
                this._correctItemOrder();
                this._flushVisibleViews();
                this._processTransactionQueue();
            }
        });
    }
    _setupTransactionAnimations(transaction) {
        let { initialMap: initialMap , finalMap: finalMap  } = transaction;
        // Store initial and final layout infos for animations
        for (let [key, layoutInfo] of initialMap)if (finalMap.has(key)) // Store the initial layout info for use during animations.
        transaction.initialLayoutInfo.set(key, layoutInfo);
        else // This view was removed. Store the layout info for use
        // in Layout#getFinalLayoutInfo during animations.
        transaction.finalLayoutInfo.set(layoutInfo.key, layoutInfo);
        // Get initial layout infos for views that were added
        for (let [key3, layoutInfo1] of finalMap)if (!initialMap.has(key3)) {
            let initialLayoutInfo = this.layout.getInitialLayoutInfo(layoutInfo1.copy());
            transaction.initialLayoutInfo.set(key3, initialLayoutInfo);
        }
        // Figure out which views were removed.
        for (let [key4, view] of this._visibleViews)// If an item has a width of 0, there is no need to remove it from the _visibleViews.
        // Removing an item with  width of 0 can cause a loop where the item gets added, removed,
        // added, removed... etc in a loop. The resize buffer ("spooky column") often has a width of 0.
        if (!finalMap.has(key4) && view.layoutInfo.rect.width > 0) {
            transaction.removed.set(key4, view);
            this._visibleViews.delete(key4);
            // In case something weird happened, where we have a view but no
            // initial layout info, use the one attached to the view.
            if (view.layoutInfo) {
                if (!transaction.finalLayoutInfo.has(view.layoutInfo.key)) transaction.finalLayoutInfo.set(view.layoutInfo.key, view.layoutInfo);
            }
        }
    }
    constructor(options = {
    }){
        this._contentSize = new $ee1bfa90a957fb8a$export$cb6da89c6af1a8ec;
        this._visibleRect = new $60423f92c7f9ad87$export$c79fc6492f3af13d;
        this._reusableViews = {
        };
        this._visibleLayoutInfos = new Map();
        this._visibleViews = new Map();
        this._renderedContent = new WeakMap();
        this._children = new Set();
        this._invalidationContext = null;
        this._overscanManager = new $364191b3decf3697$export$4455ee6afb38dcbb();
        this._scrollAnimation = null;
        this._isScrolling = false;
        this._sizeUpdateQueue = new Map();
        this._animatedContentOffset = new $3041db3296945e6e$export$baf26146a414f24a(0, 0);
        this._transaction = null;
        this._nextTransaction = null;
        this._transactionQueue = [];
        var _transitionDuration;
        // Set options from passed object if given
        this.transitionDuration = (_transitionDuration = options.transitionDuration) !== null && _transitionDuration !== void 0 ? _transitionDuration : 500;
        this.anchorScrollPosition = options.anchorScrollPosition || false;
        this.anchorScrollPositionAtTop = options.anchorScrollPositionAtTop || false;
        this.shouldOverscan = options.shouldOverscan !== false;
        for (let key of [
            'delegate',
            'size',
            'layout',
            'collection'
        ])if (options[key]) this[key] = options[key];
    }
}


function $fc0b13b484ac1194$export$1505db82fe357e65(opts) {
    let [visibleViews, setVisibleViews] = useState([]);
    let [contentSize, setContentSize] = useState(new $ee1bfa90a957fb8a$export$cb6da89c6af1a8ec());
    let [isAnimating, setAnimating] = useState(false);
    let [isScrolling, setScrolling] = useState(false);
    let virtualizer = useMemo(()=>new $38b9490c1cca8fc4$export$89be5a243e59c4b2()
    , []);
    virtualizer.delegate = {
        setVisibleViews: setVisibleViews,
        setVisibleRect (rect) {
            virtualizer.visibleRect = rect;
            opts.onVisibleRectChange(rect);
        },
        setContentSize: setContentSize,
        renderView: opts.renderView,
        renderWrapper: opts.renderWrapper,
        beginAnimations: ()=>setAnimating(true)
        ,
        endAnimations: ()=>setAnimating(false)
        ,
        getScrollAnchor: opts.getScrollAnchor
    };
    virtualizer.layout = opts.layout;
    virtualizer.collection = opts.collection;
    virtualizer.transitionDuration = opts.transitionDuration;
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        virtualizer.afterRender();
    });
    // eslint-disable-next-line arrow-body-style
    useEffect(()=>{
        return ()=>virtualizer.willUnmount()
        ;
    }, []);
    return {
        virtualizer: virtualizer,
        visibleViews: visibleViews,
        setVisibleRect: useCallback((rect)=>{
            virtualizer.visibleRect = rect;
        }, [
            virtualizer
        ]),
        contentSize: contentSize,
        isAnimating: isAnimating,
        isScrolling: isScrolling,
        startScrolling: useCallback(()=>{
            virtualizer.startScrolling();
            setScrolling(true);
        }, [
            virtualizer
        ]),
        endScrolling: useCallback(()=>{
            virtualizer.endScrolling();
            setScrolling(false);
        }, [
            virtualizer
        ])
    };
}

function $parcel$export$4(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault$1(a) {
  return a && a.__esModule ? a.default : a;
}
var $d1c300d9c497e402$exports = {};

$parcel$export$4($d1c300d9c497e402$exports, "GridKeyboardDelegate", () => $d1c300d9c497e402$export$de9feff04fda126e);

class $d1c300d9c497e402$export$de9feff04fda126e {
    isCell(node) {
        return node.type === 'cell';
    }
    isRow(node) {
        return node.type === 'row' || node.type === 'item';
    }
    findPreviousKey(fromKey, pred) {
        let key = fromKey != null ? this.collection.getKeyBefore(fromKey) : this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (!pred || pred(item)) return key;
            key = this.collection.getKeyBefore(key);
        }
    }
    findNextKey(fromKey, pred) {
        let key = fromKey != null ? this.collection.getKeyAfter(fromKey) : this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (!pred || pred(item)) return key;
            key = this.collection.getKeyAfter(key);
        }
    }
    getKeyBelow(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus was on a cell, start searching from the parent row
        if (this.isCell(startItem)) key = startItem.parentKey;
        // Find the next item
        key = this.findNextKey(key);
        if (key != null) {
            // If focus was on a cell, focus the cell with the same index in the next row.
            if (this.isCell(startItem)) {
                let item = this.collection.getItem(key);
                return [
                    ...item.childNodes
                ][startItem.index].key;
            }
            // Otherwise, focus the next row
            if (this.focusMode === 'row') return key;
        }
    }
    getKeyAbove(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus is on a cell, start searching from the parent row
        if (this.isCell(startItem)) key = startItem.parentKey;
        // Find the previous item
        key = this.findPreviousKey(key);
        if (key != null) {
            // If focus was on a cell, focus the cell with the same index in the previous row.
            if (this.isCell(startItem)) {
                let item = this.collection.getItem(key);
                return [
                    ...item.childNodes
                ][startItem.index].key;
            }
            // Otherwise, focus the previous row
            if (this.focusMode === 'row') return key;
        }
    }
    getKeyRightOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus is on a row, focus the first child cell.
        if (this.isRow(item)) {
            let children = [
                ...item.childNodes
            ];
            return this.direction === 'rtl' ? children[children.length - 1].key : children[0].key;
        }
        // If focus is on a cell, focus the next cell if any,
        // otherwise focus the parent row.
        if (this.isCell(item)) {
            let parent = this.collection.getItem(item.parentKey);
            let children = [
                ...parent.childNodes
            ];
            let next = this.direction === 'rtl' ? children[item.index - 1] : children[item.index + 1];
            if (next) return next.key;
            // focus row only if focusMode is set to row
            if (this.focusMode === 'row') return item.parentKey;
            return this.direction === 'rtl' ? this.getFirstKey(key) : this.getLastKey(key);
        }
    }
    getKeyLeftOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus is on a row, focus the last child cell.
        if (this.isRow(item)) {
            let children = [
                ...item.childNodes
            ];
            return this.direction === 'rtl' ? children[0].key : children[children.length - 1].key;
        }
        // If focus is on a cell, focus the previous cell if any,
        // otherwise focus the parent row.
        if (this.isCell(item)) {
            let parent = this.collection.getItem(item.parentKey);
            let children = [
                ...parent.childNodes
            ];
            let prev = this.direction === 'rtl' ? children[item.index + 1] : children[item.index - 1];
            if (prev) return prev.key;
            // focus row only if focusMode is set to row
            if (this.focusMode === 'row') return item.parentKey;
            return this.direction === 'rtl' ? this.getLastKey(key) : this.getFirstKey(key);
        }
    }
    getFirstKey(key, global) {
        let item;
        if (key != null) {
            item = this.collection.getItem(key);
            if (!item) return;
            // If global flag is not set, and a cell is currently focused,
            // move focus to the first cell in the parent row.
            if (this.isCell(item) && !global) {
                let parent = this.collection.getItem(item.parentKey);
                return [
                    ...parent.childNodes
                ][0].key;
            }
        }
        // Find the first row
        key = this.findNextKey();
        // If global flag is set (or if focus mode is cell), focus the first cell in the first row.
        if (key != null && item && this.isCell(item) && global || this.focusMode === 'cell') {
            let item = this.collection.getItem(key);
            key = [
                ...item.childNodes
            ][0].key;
        }
        // Otherwise, focus the row itself.
        return key;
    }
    getLastKey(key, global) {
        let item;
        if (key != null) {
            item = this.collection.getItem(key);
            if (!item) return;
            // If global flag is not set, and a cell is currently focused,
            // move focus to the last cell in the parent row.
            if (this.isCell(item) && !global) {
                let parent = this.collection.getItem(item.parentKey);
                let children = [
                    ...parent.childNodes
                ];
                return children[children.length - 1].key;
            }
        }
        // Find the last row
        key = this.findPreviousKey();
        // If global flag is set (or if focus mode is cell), focus the last cell in the last row.
        if (key != null && item && this.isCell(item) && global || this.focusMode === 'cell') {
            let item = this.collection.getItem(key);
            let children = [
                ...item.childNodes
            ];
            key = children[children.length - 1].key;
        }
        // Otherwise, focus the row itself.
        return key;
    }
    getItem(key) {
        return this.ref.current.querySelector(`[data-key="${key}"]`);
    }
    getItemRect(key) {
        var ref;
        if (this.layout) return (ref = this.layout.getLayoutInfo(key)) === null || ref === void 0 ? void 0 : ref.rect;
        let item = this.getItem(key);
        if (item) return new $60423f92c7f9ad87$export$c79fc6492f3af13d(item.offsetLeft, item.offsetTop, item.offsetWidth, item.offsetHeight);
    }
    getPageHeight() {
        var ref, ref1, ref2;
        if (this.layout) return (ref = this.layout.virtualizer) === null || ref === void 0 ? void 0 : ref.visibleRect.height;
        return (ref1 = this.ref) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.offsetHeight;
    }
    getContentHeight() {
        var ref, ref3;
        if (this.layout) return this.layout.getContentSize().height;
        return (ref = this.ref) === null || ref === void 0 ? void 0 : (ref3 = ref.current) === null || ref3 === void 0 ? void 0 : ref3.scrollHeight;
    }
    getKeyPageAbove(key) {
        let itemRect = this.getItemRect(key);
        if (!itemRect) return null;
        let pageY = Math.max(0, itemRect.maxY - this.getPageHeight());
        while(itemRect && itemRect.y > pageY){
            key = this.getKeyAbove(key);
            itemRect = this.getItemRect(key);
        }
        return key;
    }
    getKeyPageBelow(key) {
        let itemRect = this.getItemRect(key);
        if (!itemRect) return null;
        let pageHeight = this.getPageHeight();
        let pageY = Math.min(this.getContentHeight(), itemRect.y + pageHeight);
        while(itemRect && itemRect.maxY < pageY){
            let nextKey = this.getKeyBelow(key);
            itemRect = this.getItemRect(nextKey);
            // Guard against case where maxY of the last key is barely less than pageY due to rounding
            // and thus it attempts to set key to null
            if (nextKey != null) key = nextKey;
        }
        return key;
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
        // If the starting key is a cell, search from its parent row.
        let startItem = collection.getItem(key);
        if (startItem.type === 'cell') key = startItem.parentKey;
        let hasWrapped = false;
        while(key != null){
            let item = collection.getItem(key);
            // check row text value for match
            if (item.textValue) {
                let substring = item.textValue.slice(0, search.length);
                if (this.collator.compare(substring, search) === 0) {
                    if (this.isRow(item) && this.focusMode === 'cell') return [
                        ...item.childNodes
                    ][0].key;
                    return item.key;
                }
            }
            key = this.findNextKey(key);
            // Wrap around when reaching the end of the collection
            if (key == null && !hasWrapped) {
                key = this.getFirstKey();
                hasWrapped = true;
            }
        }
        return null;
    }
    constructor(options){
        this.collection = options.collection;
        this.disabledKeys = options.disabledKeys;
        this.ref = options.ref;
        this.direction = options.direction;
        this.collator = options.collator;
        this.layout = options.layout;
        this.focusMode = options.focusMode || 'row';
    }
}


var $83c6e2eafa584c67$exports = {};

$parcel$export$4($83c6e2eafa584c67$exports, "useGrid", () => $83c6e2eafa584c67$export$f6b86a04e5d66d90);



const $1af922eb41e03c8f$export$e6235c0d09b995d0 = new WeakMap();



var $1dbe5ffd32adb38c$exports = {};
var $682989befd4f478d$exports = {};
$682989befd4f478d$exports = JSON.parse("{\"deselectedItem\":\"{item} غير المحدد\",\"longPressToSelect\":\"اضغط مطولًا للدخول إلى وضع التحديد.\",\"select\":\"تحديد\",\"selectedAll\":\"جميع العناصر المحددة.\",\"selectedCount\":\"{count, plural, =0 {لم يتم تحديد عناصر} one {# عنصر محدد} other {# عنصر محدد}}.\",\"selectedItem\":\"{item} المحدد\"}");


var $f7fca02019afd941$exports = {};
$f7fca02019afd941$exports = JSON.parse("{\"deselectedItem\":\"{item} не е избран.\",\"longPressToSelect\":\"Натиснете и задръжте за да влезете в избирателен режим.\",\"select\":\"Изберете\",\"selectedAll\":\"Всички елементи са избрани.\",\"selectedCount\":\"{count, plural, =0 {Няма избрани елементи} one {# избран елемент} other {# избрани елементи}}.\",\"selectedItem\":\"{item} избран.\"}");


var $8f86f40be75387f1$exports = {};
$8f86f40be75387f1$exports = JSON.parse("{\"deselectedItem\":\"Položka {item} není vybrána.\",\"longPressToSelect\":\"Dlouhým stisknutím přejdete do režimu výběru.\",\"select\":\"Vybrat\",\"selectedAll\":\"Vybrány všechny položky.\",\"selectedCount\":\"{count, plural, =0 {Nevybrány žádné položky} one {Vybrána # položka} other {Vybráno # položek}}.\",\"selectedItem\":\"Vybrána položka {item}.\"}");


var $db24ba43c8d652ee$exports = {};
$db24ba43c8d652ee$exports = JSON.parse("{\"deselectedItem\":\"{item} ikke valgt.\",\"longPressToSelect\":\"Lav et langt tryk for at aktivere valgtilstand.\",\"select\":\"Vælg\",\"selectedAll\":\"Alle elementer valgt.\",\"selectedCount\":\"{count, plural, =0 {Ingen elementer valgt} one {# element valgt} other {# elementer valgt}}.\",\"selectedItem\":\"{item} valgt.\"}");


var $f8f1e72c8b5447d6$exports = {};
$f8f1e72c8b5447d6$exports = JSON.parse("{\"deselectedItem\":\"{item} nicht ausgewählt.\",\"longPressToSelect\":\"Gedrückt halten, um Auswahlmodus zu öffnen.\",\"select\":\"Auswählen\",\"selectedAll\":\"Alle Elemente ausgewählt.\",\"selectedCount\":\"{count, plural, =0 {Keine Elemente ausgewählt} one {# Element ausgewählt} other {# Elemente ausgewählt}}.\",\"selectedItem\":\"{item} ausgewählt.\"}");


var $9a73ed2983c3ab0b$exports = {};
$9a73ed2983c3ab0b$exports = JSON.parse("{\"deselectedItem\":\"Δεν επιλέχθηκε το στοιχείο {item}.\",\"longPressToSelect\":\"Πατήστε παρατεταμένα για να μπείτε σε λειτουργία επιλογής.\",\"select\":\"Επιλογή\",\"selectedAll\":\"Επιλέχθηκαν όλα τα στοιχεία.\",\"selectedCount\":\"{count, plural, =0 {Δεν επιλέχθηκαν στοιχεία} one {Επιλέχθηκε # στοιχείο} other {Επιλέχθηκαν # στοιχεία}}.\",\"selectedItem\":\"Επιλέχθηκε το στοιχείο {item}.\"}");


var $583de0b3587601b9$exports = {};
$583de0b3587601b9$exports = JSON.parse("{\"deselectedItem\":\"{item} not selected.\",\"select\":\"Select\",\"selectedCount\":\"{count, plural, =0 {No items selected} one {# item selected} other {# items selected}}.\",\"selectedAll\":\"All items selected.\",\"selectedItem\":\"{item} selected.\",\"longPressToSelect\":\"Long press to enter selection mode.\"}");


var $147159c978043442$exports = {};
$147159c978043442$exports = JSON.parse("{\"deselectedItem\":\"{item} no seleccionado.\",\"longPressToSelect\":\"Mantenga pulsado para abrir el modo de selección.\",\"select\":\"Seleccionar\",\"selectedAll\":\"Todos los elementos seleccionados.\",\"selectedCount\":\"{count, plural, =0 {Ningún elemento seleccionado} one {# elemento seleccionado} other {# elementos seleccionados}}.\",\"selectedItem\":\"{item} seleccionado.\"}");


var $5cbb62c8a19173ac$exports = {};
$5cbb62c8a19173ac$exports = JSON.parse("{\"deselectedItem\":\"{item} pole valitud.\",\"longPressToSelect\":\"Valikurežiimi sisenemiseks vajutage pikalt.\",\"select\":\"Vali\",\"selectedAll\":\"Kõik üksused valitud.\",\"selectedCount\":\"{count, plural, =0 {Üksusi pole valitud} one {# üksus valitud} other {# üksust valitud}}.\",\"selectedItem\":\"{item} valitud.\"}");


var $a33d71dc804cc59e$exports = {};
$a33d71dc804cc59e$exports = JSON.parse("{\"deselectedItem\":\"Kohdetta {item} ei valittu.\",\"longPressToSelect\":\"Siirry valintatilaan painamalla pitkään.\",\"select\":\"Valitse\",\"selectedAll\":\"Kaikki kohteet valittu.\",\"selectedCount\":\"{count, plural, =0 {Ei yhtään kohdetta valittu} one {# kohde valittu} other {# kohdetta valittu}}.\",\"selectedItem\":\"{item} valittu.\"}");


var $92d800447793d084$exports = {};
$92d800447793d084$exports = JSON.parse("{\"deselectedItem\":\"{item} non sélectionné.\",\"longPressToSelect\":\"Appuyez de manière prolongée pour passer en mode de sélection.\",\"select\":\"Sélectionner\",\"selectedAll\":\"Tous les éléments sélectionnés.\",\"selectedCount\":\"{count, plural, =0 {Aucun élément sélectionné} one {# élément sélectionné} other {# éléments sélectionnés}}.\",\"selectedItem\":\"{item} sélectionné.\"}");


var $fe732cdb32124ea8$exports = {};
$fe732cdb32124ea8$exports = JSON.parse("{\"deselectedItem\":\"{item} לא נבחר.\",\"longPressToSelect\":\"הקשה ארוכה לכניסה למצב בחירה.\",\"select\":\"בחר\",\"selectedAll\":\"כל הפריטים נבחרו.\",\"selectedCount\":\"{count, plural, =0 {לא נבחרו פריטים} one {פריט # נבחר} other {# פריטים נבחרו}}.\",\"selectedItem\":\"{item} נבחר.\"}");


var $e41234e934efb4f5$exports = {};
$e41234e934efb4f5$exports = JSON.parse("{\"deselectedItem\":\"Stavka {item} nije odabrana.\",\"longPressToSelect\":\"Dugo pritisnite za ulazak u način odabira.\",\"select\":\"Odaberite\",\"selectedAll\":\"Odabrane su sve stavke.\",\"selectedCount\":\"{count, plural, =0 {Nije odabrana nijedna stavka} one {Odabrana je # stavka} other {Odabrano je # stavki}}.\",\"selectedItem\":\"Stavka {item} je odabrana.\"}");


var $1b0393182473bf9e$exports = {};
$1b0393182473bf9e$exports = JSON.parse("{\"deselectedItem\":\"{item} nincs kijelölve.\",\"longPressToSelect\":\"Nyomja hosszan a kijelöléshez.\",\"select\":\"Kijelölés\",\"selectedAll\":\"Az összes elem kijelölve.\",\"selectedCount\":\"{count, plural, =0 {Egy elem sincs kijelölve} one {# elem kijelölve} other {# elem kijelölve}}.\",\"selectedItem\":\"{item} kijelölve.\"}");


var $2eed782c1c110ce7$exports = {};
$2eed782c1c110ce7$exports = JSON.parse("{\"deselectedItem\":\"{item} non selezionato.\",\"longPressToSelect\":\"Premi a lungo per passare alla modalità di selezione.\",\"select\":\"Seleziona\",\"selectedAll\":\"Tutti gli elementi selezionati.\",\"selectedCount\":\"{count, plural, =0 {Nessun elemento selezionato} one {# elemento selezionato} other {# elementi selezionati}}.\",\"selectedItem\":\"{item} selezionato.\"}");


var $8b5d459f86e9b23c$exports = {};
$8b5d459f86e9b23c$exports = JSON.parse("{\"deselectedItem\":\"{item} が選択されていません。\",\"longPressToSelect\":\"長押しして選択モードを開きます。\",\"select\":\"選択\",\"selectedAll\":\"すべての項目を選択しました。\",\"selectedCount\":\"{count, plural, =0 {項目が選択されていません} one {# 項目を選択しました} other {# 項目を選択しました}}。\",\"selectedItem\":\"{item} を選択しました。\"}");


var $1949c3ad17295fd4$exports = {};
$1949c3ad17295fd4$exports = JSON.parse("{\"deselectedItem\":\"{item}이(가) 선택되지 않았습니다.\",\"longPressToSelect\":\"선택 모드로 들어가려면 길게 누르십시오.\",\"select\":\"선택\",\"selectedAll\":\"모든 항목이 선택되었습니다.\",\"selectedCount\":\"{count, plural, =0 {선택된 항목이 없습니다} one {#개 항목이 선택되었습니다} other {#개 항목이 선택되었습니다}}.\",\"selectedItem\":\"{item}이(가) 선택되었습니다.\"}");


var $f5e3df4dc8aa7b54$exports = {};
$f5e3df4dc8aa7b54$exports = JSON.parse("{\"deselectedItem\":\"{item} nepasirinkta.\",\"longPressToSelect\":\"Norėdami įjungti pasirinkimo režimą, paspauskite ir palaikykite.\",\"select\":\"Pasirinkti\",\"selectedAll\":\"Pasirinkti visi elementai.\",\"selectedCount\":\"{count, plural, =0 {Nepasirinktas nė vienas elementas} one {Pasirinktas # elementas} other {Pasirinkta elementų: #}}.\",\"selectedItem\":\"Pasirinkta: {item}.\"}");


var $9dd86690a5c2b2c5$exports = {};
$9dd86690a5c2b2c5$exports = JSON.parse("{\"deselectedItem\":\"Vienums {item} nav atlasīts.\",\"longPressToSelect\":\"Ilgi turiet nospiestu. lai ieslēgtu atlases režīmu.\",\"select\":\"Atlasīt\",\"selectedAll\":\"Atlasīti visi vienumi.\",\"selectedCount\":\"{count, plural, =0 {Nav atlasīts neviens vienums} one {Atlasīto vienumu skaits: #} other {Atlasīto vienumu skaits: #}}.\",\"selectedItem\":\"Atlasīts vienums {item}.\"}");


var $843964c3bf9a7d24$exports = {};
$843964c3bf9a7d24$exports = JSON.parse("{\"deselectedItem\":\"{item} er ikke valgt.\",\"longPressToSelect\":\"Bruk et langt trykk for å gå inn i valgmodus.\",\"select\":\"Velg\",\"selectedAll\":\"Alle elementer er valgt.\",\"selectedCount\":\"{count, plural, =0 {Ingen elementer er valgt} one {# element er valgt} other {# elementer er valgt}}.\",\"selectedItem\":\"{item} er valgt.\"}");


var $73f50e845f9ef3b4$exports = {};
$73f50e845f9ef3b4$exports = JSON.parse("{\"deselectedItem\":\"{item} niet geselecteerd.\",\"longPressToSelect\":\"Druk lang om de selectiemodus te openen.\",\"select\":\"Selecteren\",\"selectedAll\":\"Alle items geselecteerd.\",\"selectedCount\":\"{count, plural, =0 {Geen items geselecteerd} one {# item geselecteerd} other {# items geselecteerd}}.\",\"selectedItem\":\"{item} geselecteerd.\"}");


var $87f92a7e077514b2$exports = {};
$87f92a7e077514b2$exports = JSON.parse("{\"deselectedItem\":\"Nie zaznaczono {item}.\",\"longPressToSelect\":\"Naciśnij i przytrzymaj, aby wejść do trybu wyboru.\",\"select\":\"Zaznacz\",\"selectedAll\":\"Wszystkie zaznaczone elementy.\",\"selectedCount\":\"{count, plural, =0 {Nie zaznaczono żadnych elementów} one {# zaznaczony element} other {# zaznaczonych elementów}}.\",\"selectedItem\":\"Zaznaczono {item}.\"}");


var $c28c98d58ee9ff6f$exports = {};
$c28c98d58ee9ff6f$exports = JSON.parse("{\"deselectedItem\":\"{item} não selecionado.\",\"longPressToSelect\":\"Mantenha pressionado para entrar no modo de seleção.\",\"select\":\"Selecionar\",\"selectedAll\":\"Todos os itens selecionados.\",\"selectedCount\":\"{count, plural, =0 {Nenhum item selecionado} one {# item selecionado} other {# itens selecionados}}.\",\"selectedItem\":\"{item} selecionado.\"}");


var $b6b1503b17b2254d$exports = {};
$b6b1503b17b2254d$exports = JSON.parse("{\"deselectedItem\":\"{item} não selecionado.\",\"longPressToSelect\":\"Prima continuamente para entrar no modo de seleção.\",\"select\":\"Selecionar\",\"selectedAll\":\"Todos os itens selecionados.\",\"selectedCount\":\"{count, plural, =0 {Nenhum item selecionado} one {# item selecionado} other {# itens selecionados}}.\",\"selectedItem\":\"{item} selecionado.\"}");


var $8bdaeb71e50c3e1a$exports = {};
$8bdaeb71e50c3e1a$exports = JSON.parse("{\"deselectedItem\":\"{item} neselectat.\",\"longPressToSelect\":\"Apăsați lung pentru a intra în modul de selectare.\",\"select\":\"Selectare\",\"selectedAll\":\"Toate elementele selectate.\",\"selectedCount\":\"{count, plural, =0 {Niciun element selectat} one {# element selectat} other {# elemente selectate}}.\",\"selectedItem\":\"{item} selectat.\"}");


var $ec2b852dd7c3d1f2$exports = {};
$ec2b852dd7c3d1f2$exports = JSON.parse("{\"deselectedItem\":\"{item} не выбрано.\",\"longPressToSelect\":\"Нажмите и удерживайте для входа в режим выбора.\",\"select\":\"Выбрать\",\"selectedAll\":\"Выбраны все элементы.\",\"selectedCount\":\"{count, plural, =0 {Нет выбранных элементов} one {# элемент выбран} other {# элементов выбрано}}.\",\"selectedItem\":\"{item} выбрано.\"}");


var $79e6d900d6a4f82d$exports = {};
$79e6d900d6a4f82d$exports = JSON.parse("{\"deselectedItem\":\"Nevybraté položky: {item}.\",\"longPressToSelect\":\"Dlhším stlačením prejdite do režimu výberu.\",\"select\":\"Vybrať\",\"selectedAll\":\"Všetky vybraté položky.\",\"selectedCount\":\"{count, plural, =0 {Žiadne vybraté položky} one {# vybratá položka} other {Počet vybratých položiek:#}}.\",\"selectedItem\":\"Vybraté položky: {item}.\"}");


var $f4c1f0d5d4d03d80$exports = {};
$f4c1f0d5d4d03d80$exports = JSON.parse("{\"deselectedItem\":\"Element {item} ni izbran.\",\"longPressToSelect\":\"Za izbirni način pritisnite in dlje časa držite.\",\"select\":\"Izberite\",\"selectedAll\":\"Vsi elementi so izbrani.\",\"selectedCount\":\"{count, plural, =0 {Noben element ni izbran} one {# element je izbran} other {# elementov je izbranih}}.\",\"selectedItem\":\"Element {item} je izbran.\"}");


var $46252cd87269b10b$exports = {};
$46252cd87269b10b$exports = JSON.parse("{\"deselectedItem\":\"{item} nije izabrano.\",\"longPressToSelect\":\"Dugo pritisnite za ulazak u režim biranja.\",\"select\":\"Izaberite\",\"selectedAll\":\"Izabrane su sve stavke.\",\"selectedCount\":\"{count, plural, =0 {Nije izabrana nijedna stavka} one {Izabrana je # stavka} other {Izabrano je # stavki}}.\",\"selectedItem\":\"{item} je izabrano.\"}");


var $d4d5d8dab362555c$exports = {};
$d4d5d8dab362555c$exports = JSON.parse("{\"deselectedItem\":\"{item} ej markerat.\",\"longPressToSelect\":\"Tryck länge när du vill öppna väljarläge.\",\"select\":\"Markera\",\"selectedAll\":\"Alla markerade objekt.\",\"selectedCount\":\"{count, plural, =0 {Inga markerade objekt} one {# markerat objekt} other {# markerade objekt}}.\",\"selectedItem\":\"{item} markerat.\"}");


var $3d55d1f97c377e83$exports = {};
$3d55d1f97c377e83$exports = JSON.parse("{\"deselectedItem\":\"{item} seçilmedi.\",\"longPressToSelect\":\"Seçim moduna girmek için uzun basın.\",\"select\":\"Seç\",\"selectedAll\":\"Tüm ögeler seçildi.\",\"selectedCount\":\"{count, plural, =0 {Hiçbir öge seçilmedi} one {# öge seçildi} other {# öge seçildi}}.\",\"selectedItem\":\"{item} seçildi.\"}");


var $5368512f1c703a3f$exports = {};
$5368512f1c703a3f$exports = JSON.parse("{\"deselectedItem\":\"{item} не вибрано.\",\"longPressToSelect\":\"Виконайте довге натиснення, щоб перейти в режим вибору.\",\"select\":\"Вибрати\",\"selectedAll\":\"Усі елементи вибрано.\",\"selectedCount\":\"{count, plural, =0 {Жодних елементів не вибрано} one {# елемент вибрано} other {Вибрано елементів: #}}.\",\"selectedItem\":\"{item} вибрано.\"}");


var $f1316b1074463583$exports = {};
$f1316b1074463583$exports = JSON.parse("{\"deselectedItem\":\"未选择 {item}。\",\"longPressToSelect\":\"长按以进入选择模式。\",\"select\":\"选择\",\"selectedAll\":\"已选择所有项目。\",\"selectedCount\":\"{count, plural, =0 {未选择项目} one {已选择 # 个项目} other {已选择 # 个项目}}。\",\"selectedItem\":\"已选择 {item}。\"}");


var $7e60654723031b6f$exports = {};
$7e60654723031b6f$exports = JSON.parse("{\"deselectedItem\":\"未選取「{item}」。\",\"longPressToSelect\":\"長按以進入選擇模式。\",\"select\":\"選取\",\"selectedAll\":\"已選取所有項目。\",\"selectedCount\":\"{count, plural, =0 {未選取任何項目} one {已選取 # 個項目} other {已選取 # 個項目}}。\",\"selectedItem\":\"已選取「{item}」。\"}");


$1dbe5ffd32adb38c$exports = {
    "ar-AE": $682989befd4f478d$exports,
    "bg-BG": $f7fca02019afd941$exports,
    "cs-CZ": $8f86f40be75387f1$exports,
    "da-DK": $db24ba43c8d652ee$exports,
    "de-DE": $f8f1e72c8b5447d6$exports,
    "el-GR": $9a73ed2983c3ab0b$exports,
    "en-US": $583de0b3587601b9$exports,
    "es-ES": $147159c978043442$exports,
    "et-EE": $5cbb62c8a19173ac$exports,
    "fi-FI": $a33d71dc804cc59e$exports,
    "fr-FR": $92d800447793d084$exports,
    "he-IL": $fe732cdb32124ea8$exports,
    "hr-HR": $e41234e934efb4f5$exports,
    "hu-HU": $1b0393182473bf9e$exports,
    "it-IT": $2eed782c1c110ce7$exports,
    "ja-JP": $8b5d459f86e9b23c$exports,
    "ko-KR": $1949c3ad17295fd4$exports,
    "lt-LT": $f5e3df4dc8aa7b54$exports,
    "lv-LV": $9dd86690a5c2b2c5$exports,
    "nb-NO": $843964c3bf9a7d24$exports,
    "nl-NL": $73f50e845f9ef3b4$exports,
    "pl-PL": $87f92a7e077514b2$exports,
    "pt-BR": $c28c98d58ee9ff6f$exports,
    "pt-PT": $b6b1503b17b2254d$exports,
    "ro-RO": $8bdaeb71e50c3e1a$exports,
    "ru-RU": $ec2b852dd7c3d1f2$exports,
    "sk-SK": $79e6d900d6a4f82d$exports,
    "sl-SI": $f4c1f0d5d4d03d80$exports,
    "sr-SP": $46252cd87269b10b$exports,
    "sv-SE": $d4d5d8dab362555c$exports,
    "tr-TR": $3d55d1f97c377e83$exports,
    "uk-UA": $5368512f1c703a3f$exports,
    "zh-CN": $f1316b1074463583$exports,
    "zh-TW": $7e60654723031b6f$exports
};








function $5b9b5b5723db6ae1$export$be42ebdab07ae4c2(props) {
    let formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault$1($1dbe5ffd32adb38c$exports)));
    let modality = $507fabe10e71c6fb$export$98e20ec92f614cfe();
    // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
    let shouldLongPress = (modality === 'pointer' || modality === 'virtual' || modality == null) && typeof window !== 'undefined' && 'ontouchstart' in window;
    let interactionDescription = useMemo(()=>{
        let selectionMode = props.selectionManager.selectionMode;
        let selectionBehavior = props.selectionManager.selectionBehavior;
        let message = undefined;
        if (shouldLongPress) message = formatMessage('longPressToSelect');
        return selectionBehavior === 'replace' && selectionMode !== 'none' && props.hasItemActions ? message : undefined;
    }, [
        props.selectionManager.selectionMode,
        props.selectionManager.selectionBehavior,
        props.hasItemActions,
        formatMessage,
        shouldLongPress
    ]);
    let descriptionProps = $ef06256079686ba0$export$f8aeda7b10753fa1(interactionDescription);
    return descriptionProps;
}



function $83c6e2eafa584c67$export$f6b86a04e5d66d90(props, state, ref1) {
    let { isVirtualized: isVirtualized , keyboardDelegate: keyboardDelegate , focusMode: focusMode , getRowText: getRowText = (key)=>{
        var ref;
        return (ref = state.collection.getItem(key)) === null || ref === void 0 ? void 0 : ref.textValue;
    } , scrollRef: scrollRef , onRowAction: onRowAction , onCellAction: onCellAction  } = props;
    let formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault$1($1dbe5ffd32adb38c$exports)));
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = $325a3faab7a68acd$export$a16aca283550c30d({
        usage: 'search',
        sensitivity: 'base'
    });
    let { direction: direction  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let delegate = useMemo(()=>keyboardDelegate || new $d1c300d9c497e402$export$de9feff04fda126e({
            collection: state.collection,
            disabledKeys: state.disabledKeys,
            ref: ref1,
            direction: direction,
            collator: collator,
            focusMode: focusMode
        })
    , [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        ref1,
        direction,
        collator,
        focusMode
    ]);
    let { collectionProps: collectionProps  } = $ae20dd8cbca75726$export$d6daf82dcd84e87c({
        ref: ref1,
        selectionManager: state.selectionManager,
        keyboardDelegate: delegate,
        isVirtualized: isVirtualized,
        scrollRef: scrollRef
    });
    let id = $bdb11010cef70236$export$f680877a34711e37();
    $1af922eb41e03c8f$export$e6235c0d09b995d0.set(state, {
        keyboardDelegate: delegate,
        actions: {
            onRowAction: onRowAction,
            onCellAction: onCellAction
        }
    });
    let descriptionProps = $5b9b5b5723db6ae1$export$be42ebdab07ae4c2({
        selectionManager: state.selectionManager,
        hasItemActions: !!(onRowAction || onCellAction)
    });
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    let gridProps = $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
        role: 'grid',
        id: id,
        'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
    }, collectionProps, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = state.collection.columnCount;
    }
    // Many screen readers do not announce when items in a grid are selected/deselected.
    // We do this using an ARIA live region.
    let selection = state.selectionManager.rawSelection;
    let lastSelection = useRef(selection);
    $4f58c5f72bcf79f7$export$496315a1608d9602(()=>{
        var ref;
        if (!state.selectionManager.isFocused) {
            lastSelection.current = selection;
            return;
        }
        let addedKeys = $83c6e2eafa584c67$var$diffSelection(selection, lastSelection.current);
        let removedKeys = $83c6e2eafa584c67$var$diffSelection(lastSelection.current, selection);
        // If adding or removing a single row from the selection, announce the name of that item.
        let isReplace = state.selectionManager.selectionBehavior === 'replace';
        let messages = [];
        if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
            if (state.collection.getItem(state.selectionManager.selectedKeys.keys().next().value)) {
                let currentSelectionText = getRowText(state.selectionManager.selectedKeys.keys().next().value);
                if (currentSelectionText) messages.push(formatMessage('selectedItem', {
                    item: currentSelectionText
                }));
            }
        } else if (addedKeys.size === 1 && removedKeys.size === 0) {
            let addedText = getRowText(addedKeys.keys().next().value);
            if (addedText) messages.push(formatMessage('selectedItem', {
                item: addedText
            }));
        } else if (removedKeys.size === 1 && addedKeys.size === 0) {
            if (state.collection.getItem(removedKeys.keys().next().value)) {
                let removedText = getRowText(removedKeys.keys().next().value);
                if (removedText) messages.push(formatMessage('deselectedItem', {
                    item: removedText
                }));
            }
        }
        // Announce how many items are selected, except when selecting the first item.
        if (state.selectionManager.selectionMode === 'multiple') {
            if (messages.length === 0 || selection === 'all' || selection.size > 1 || lastSelection.current === 'all' || ((ref = lastSelection.current) === null || ref === void 0 ? void 0 : ref.size) > 1) messages.push(selection === 'all' ? formatMessage('selectedAll') : formatMessage('selectedCount', {
                count: selection.size
            }));
        }
        if (messages.length > 0) $319e236875307eab$export$a9b970dcc4ae71a9(messages.join(' '));
        lastSelection.current = selection;
    }, [
        selection
    ]);
    return {
        gridProps: gridProps
    };
}
function $83c6e2eafa584c67$var$diffSelection(a, b) {
    let res = new Set();
    if (a === 'all' || b === 'all') return res;
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}


var $e45487f8ba1cbdbf$exports = {};

$parcel$export$4($e45487f8ba1cbdbf$exports, "useGridRowGroup", () => $e45487f8ba1cbdbf$export$d3037f5d3f3e51bf);
function $e45487f8ba1cbdbf$export$d3037f5d3f3e51bf() {
    return {
        rowGroupProps: {
            role: 'rowgroup'
        }
    };
}


var $4159a7a9cbb0cc18$exports = {};

$parcel$export$4($4159a7a9cbb0cc18$exports, "useGridRow", () => $4159a7a9cbb0cc18$export$96357d5a73f686fa);


function $4159a7a9cbb0cc18$export$96357d5a73f686fa(props, state, ref) {
    let { node: node , isVirtualized: isVirtualized , shouldSelectOnPressUp: shouldSelectOnPressUp , onAction: onAction  } = props;
    let { actions: { onRowAction: onRowAction  }  } = $1af922eb41e03c8f$export$e6235c0d09b995d0.get(state);
    let { itemProps: itemProps , isPressed: isPressed  } = $880e95eb8b93ba9a$export$ecf600387e221c37({
        selectionManager: state.selectionManager,
        key: node.key,
        ref: ref,
        isVirtualized: isVirtualized,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        onAction: onRowAction ? ()=>onRowAction(node.key)
         : onAction
    });
    let isSelected = state.selectionManager.isSelected(node.key);
    let rowProps = {
        role: 'row',
        'aria-selected': state.selectionManager.selectionMode !== 'none' ? isSelected : undefined,
        ...itemProps
    };
    if (isVirtualized) rowProps['aria-rowindex'] = node.index + 1; // aria-rowindex is 1 based
    return {
        rowProps: rowProps,
        isPressed: isPressed
    };
}


var $ab90dcbc1b5466d0$exports = {};

$parcel$export$4($ab90dcbc1b5466d0$exports, "useGridCell", () => $ab90dcbc1b5466d0$export$c7e10bfc0c59f67c);






function $ab90dcbc1b5466d0$export$c7e10bfc0c59f67c(props, state, ref) {
    let { node: node , isVirtualized: isVirtualized , focusMode: focusMode = 'child' , shouldSelectOnPressUp: shouldSelectOnPressUp , onAction: onAction  } = props;
    let { direction: direction  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let { keyboardDelegate: keyboardDelegate , actions: { onCellAction: onCellAction  }  } = $1af922eb41e03c8f$export$e6235c0d09b995d0.get(state);
    // Handles focusing the cell. If there is a focusable child,
    // it is focused, otherwise the cell itself is focused.
    let focus = ()=>{
        let treeWalker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ref.current);
        if (focusMode === 'child') {
            let focusable = state.selectionManager.childFocusStrategy === 'last' ? $ab90dcbc1b5466d0$var$last(treeWalker) : treeWalker.firstChild();
            if (focusable) {
                $6a99195332edec8b$export$80f3e147d781571c(focusable);
                return;
            }
        }
        if (!ref.current.contains(document.activeElement)) $6a99195332edec8b$export$80f3e147d781571c(ref.current);
    };
    let { itemProps: itemProps , isPressed: isPressed  } = $880e95eb8b93ba9a$export$ecf600387e221c37({
        selectionManager: state.selectionManager,
        key: node.key,
        ref: ref,
        isVirtualized: isVirtualized,
        focus: focus,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        onAction: onCellAction ? ()=>onCellAction(node.key)
         : onAction
    });
    let onKeyDown = (e)=>{
        if (!e.currentTarget.contains(e.target)) return;
        let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ref.current);
        walker.currentNode = document.activeElement;
        switch(e.key){
            case 'ArrowLeft':
                {
                    // Find the next focusable element within the cell.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    // Don't focus the cell itself if focusMode is "child"
                    if (focusMode === 'child' && focusable === ref.current) focusable = null;
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        $6a99195332edec8b$export$80f3e147d781571c(focusable);
                    } else {
                        // If there is no next focusable child, then move to the next cell to the left of this one.
                        // This will be handled by useSelectableCollection. However, if there is no cell to the left
                        // of this one, only one column, and the grid doesn't focus rows, then the next key will be the
                        // same as this one. In that case we need to handle focusing either the cell or the first/last
                        // child, depending on the focus mode.
                        let prev = keyboardDelegate.getKeyLeftOf(node.key);
                        if (prev !== node.key) break;
                        e.preventDefault();
                        e.stopPropagation();
                        if (focusMode === 'cell' && direction === 'rtl') $6a99195332edec8b$export$80f3e147d781571c(ref.current);
                        else {
                            walker.currentNode = ref.current;
                            focusable = direction === 'rtl' ? walker.firstChild() : $ab90dcbc1b5466d0$var$last(walker);
                            if (focusable) $6a99195332edec8b$export$80f3e147d781571c(focusable);
                        }
                    }
                    break;
                }
            case 'ArrowRight':
                {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusMode === 'child' && focusable === ref.current) focusable = null;
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        $6a99195332edec8b$export$80f3e147d781571c(focusable);
                    } else {
                        let next = keyboardDelegate.getKeyRightOf(node.key);
                        if (next !== node.key) break;
                        e.preventDefault();
                        e.stopPropagation();
                        if (focusMode === 'cell' && direction === 'ltr') $6a99195332edec8b$export$80f3e147d781571c(ref.current);
                        else {
                            walker.currentNode = ref.current;
                            focusable = direction === 'rtl' ? $ab90dcbc1b5466d0$var$last(walker) : walker.firstChild();
                            if (focusable) $6a99195332edec8b$export$80f3e147d781571c(focusable);
                        }
                    }
                    break;
                }
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching cell children, e.g. menu buttons. We want arrow keys to navigate
                // to the cell above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && ref.current.contains(e.target)) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    // Grid cells can have focusable elements inside them. In this case, focus should
    // be marshalled to that element rather than focusing the cell itself.
    let onFocus = (e)=>{
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the gridcell itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row/cell
            // in that case since the table should act like a single tab stop.
            if (!$507fabe10e71c6fb$export$b9b3dfddab17db27()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
        // If the cell itself is focused, wait a frame so that focus finishes propagatating
        // up to the tree, and move focus to a focusable child if possible.
        requestAnimationFrame(()=>{
            if (focusMode === 'child' && document.activeElement === ref.current) focus();
        });
    };
    let gridCellProps = $3ef42575df84b30b$export$9d1611c77c2fe928(itemProps, {
        role: 'gridcell',
        onKeyDownCapture: onKeyDown,
        onFocus: onFocus
    });
    if (isVirtualized) gridCellProps['aria-colindex'] = node.index + 1; // aria-colindex is 1-based
    return {
        gridCellProps: gridCellProps,
        isPressed: isPressed
    };
}
function $ab90dcbc1b5466d0$var$last(walker) {
    let next;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last)
    return next;
}


var $7cb39d07f245a780$exports = {};

$parcel$export$4($7cb39d07f245a780$exports, "useGridSelectionCheckbox", () => $7cb39d07f245a780$export$70e2eed1a92976ad);



function $7cb39d07f245a780$export$70e2eed1a92976ad(props, state) {
    let { key: key  } = props;
    let manager = state.selectionManager;
    let checkboxId = $bdb11010cef70236$export$f680877a34711e37();
    let isDisabled = state.disabledKeys.has(key);
    let isSelected = state.selectionManager.isSelected(key);
    let onChange = ()=>manager.select(key)
    ;
    const formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault$1($1dbe5ffd32adb38c$exports)));
    return {
        checkboxProps: {
            id: checkboxId,
            'aria-label': formatMessage('select'),
            isSelected: isSelected,
            isDisabled: isDisabled || manager.selectionMode === 'none',
            onChange: onChange
        }
    };
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export$3(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $6e31608fbba75bab$exports = {};

$parcel$export$3($6e31608fbba75bab$exports, "useTable", () => $6e31608fbba75bab$export$25bceaac3c7e4dc7);


const $2140fb2337097f2d$export$552312adfd451dab = new WeakMap();
function $2140fb2337097f2d$var$normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}
function $2140fb2337097f2d$export$37cd4213f2ad742e(state, columnKey) {
    let gridId = $2140fb2337097f2d$export$552312adfd451dab.get(state);
    if (!gridId) throw new Error('Unknown grid');
    return `${gridId}-${$2140fb2337097f2d$var$normalizeKey(columnKey)}`;
}
function $2140fb2337097f2d$export$19baff3266315d44(state, rowKey, columnKey) {
    let gridId = $2140fb2337097f2d$export$552312adfd451dab.get(state);
    if (!gridId) throw new Error('Unknown grid');
    return `${gridId}-${$2140fb2337097f2d$var$normalizeKey(rowKey)}-${$2140fb2337097f2d$var$normalizeKey(columnKey)}`;
}
function $2140fb2337097f2d$export$85069b70317f543(state, rowKey) {
    // A row is labelled by it's row headers.
    return [
        ...state.collection.rowHeaderColumnKeys
    ].map((columnKey)=>$2140fb2337097f2d$export$19baff3266315d44(state, rowKey, columnKey)
    ).join(' ');
}


var $ae7e9c471762b4d3$exports = {};
var $ce3de3ff2fd66848$exports = {};
$ce3de3ff2fd66848$exports = JSON.parse("{\"ascending\":\"تصاعدي\",\"ascendingSort\":\"ترتيب حسب العمود {columnName} بترتيب تصاعدي\",\"descending\":\"تنازلي\",\"descendingSort\":\"ترتيب حسب العمود {columnName} بترتيب تنازلي\",\"select\":\"تحديد\",\"selectAll\":\"تحديد الكل\",\"sortable\":\"عمود قابل للترتيب\"}");


var $cb80dcce530985b9$exports = {};
$cb80dcce530985b9$exports = JSON.parse("{\"ascending\":\"възходящ\",\"ascendingSort\":\"сортирано по колона {columnName} във възходящ ред\",\"descending\":\"низходящ\",\"descendingSort\":\"сортирано по колона {columnName} в низходящ ред\",\"select\":\"Изберете\",\"selectAll\":\"Изберете всичко\",\"sortable\":\"сортираща колона\"}");


var $68ac86749db4c0fb$exports = {};
$68ac86749db4c0fb$exports = JSON.parse("{\"ascending\":\"vzestupně\",\"ascendingSort\":\"řazeno vzestupně podle sloupce {columnName}\",\"descending\":\"sestupně\",\"descendingSort\":\"řazeno sestupně podle sloupce {columnName}\",\"select\":\"Vybrat\",\"selectAll\":\"Vybrat vše\",\"sortable\":\"sloupec s možností řazení\"}");


var $9a6cbac08487e661$exports = {};
$9a6cbac08487e661$exports = JSON.parse("{\"ascending\":\"stigende\",\"ascendingSort\":\"sorteret efter kolonne {columnName} i stigende rækkefølge\",\"descending\":\"faldende\",\"descendingSort\":\"sorteret efter kolonne {columnName} i faldende rækkefølge\",\"select\":\"Vælg\",\"selectAll\":\"Vælg alle\",\"sortable\":\"sorterbar kolonne\"}");


var $c963661d89486e72$exports = {};
$c963661d89486e72$exports = JSON.parse("{\"ascending\":\"aufsteigend\",\"ascendingSort\":\"sortiert nach Spalte {columnName} in aufsteigender Reihenfolge\",\"descending\":\"absteigend\",\"descendingSort\":\"sortiert nach Spalte {columnName} in absteigender Reihenfolge\",\"select\":\"Auswählen\",\"selectAll\":\"Alles auswählen\",\"sortable\":\"sortierbare Spalte\"}");


var $ac03861c6e8605f4$exports = {};
$ac03861c6e8605f4$exports = JSON.parse("{\"ascending\":\"αύξουσα\",\"ascendingSort\":\"διαλογή ανά στήλη {columnName} σε αύξουσα σειρά\",\"descending\":\"φθίνουσα\",\"descendingSort\":\"διαλογή ανά στήλη {columnName} σε φθίνουσα σειρά\",\"select\":\"Επιλογή\",\"selectAll\":\"Επιλογή όλων\",\"sortable\":\"Στήλη διαλογής\"}");


var $09e6b82e0d6e466a$exports = {};
$09e6b82e0d6e466a$exports = JSON.parse("{\"select\":\"Select\",\"selectAll\":\"Select All\",\"sortable\":\"sortable column\",\"ascending\":\"ascending\",\"descending\":\"descending\",\"ascendingSort\":\"sorted by column {columnName} in ascending order\",\"descendingSort\":\"sorted by column {columnName} in descending order\"}");


var $8cc39eb66c2bf220$exports = {};
$8cc39eb66c2bf220$exports = JSON.parse("{\"ascending\":\"de subida\",\"ascendingSort\":\"ordenado por columna {columnName} en orden de subida\",\"descending\":\"de bajada\",\"descendingSort\":\"ordenado por columna {columnName} en orden de bajada\",\"select\":\"Seleccionar\",\"selectAll\":\"Seleccionar todos\",\"sortable\":\"columna ordenable\"}");


var $4e11db3c25a38112$exports = {};
$4e11db3c25a38112$exports = JSON.parse("{\"ascending\":\"tõusev järjestus\",\"ascendingSort\":\"sorditud veeru järgi {columnName} tõusvas järjestuses\",\"descending\":\"laskuv järjestus\",\"descendingSort\":\"sorditud veeru järgi {columnName} laskuvas järjestuses\",\"select\":\"Vali\",\"selectAll\":\"Vali kõik\",\"sortable\":\"sorditav veerg\"}");


var $da1e751a92575e02$exports = {};
$da1e751a92575e02$exports = JSON.parse("{\"ascending\":\"nouseva\",\"ascendingSort\":\"lajiteltu sarakkeen {columnName} mukaan nousevassa järjestyksessä\",\"descending\":\"laskeva\",\"descendingSort\":\"lajiteltu sarakkeen {columnName} mukaan laskevassa järjestyksessä\",\"select\":\"Valitse\",\"selectAll\":\"Valitse kaikki\",\"sortable\":\"lajiteltava sarake\"}");


var $1b5d6c6c47d55106$exports = {};
$1b5d6c6c47d55106$exports = JSON.parse("{\"ascending\":\"croissant\",\"ascendingSort\":\"trié en fonction de la colonne {columnName} par ordre croissant\",\"descending\":\"décroissant\",\"descendingSort\":\"trié en fonction de la colonne {columnName} par ordre décroissant\",\"select\":\"Sélectionner\",\"selectAll\":\"Sélectionner tout\",\"sortable\":\"colonne triable\"}");


var $7c18ba27b86d3308$exports = {};
$7c18ba27b86d3308$exports = JSON.parse("{\"ascending\":\"עולה\",\"ascendingSort\":\"מוין לפי עמודה {columnName} בסדר עולה\",\"descending\":\"יורד\",\"descendingSort\":\"מוין לפי עמודה {columnName} בסדר יורד\",\"select\":\"בחר\",\"selectAll\":\"בחר הכול\",\"sortable\":\"עמודה שניתן למיין\"}");


var $2cb40998e20e8a46$exports = {};
$2cb40998e20e8a46$exports = JSON.parse("{\"ascending\":\"rastući\",\"ascendingSort\":\"razvrstano po stupcima {columnName} rastućem redoslijedom\",\"descending\":\"padajući\",\"descendingSort\":\"razvrstano po stupcima {columnName} padajućim redoslijedom\",\"select\":\"Odaberite\",\"selectAll\":\"Odaberite sve\",\"sortable\":\"stupac koji se može razvrstati\"}");


var $189e23eec1d6aa3a$exports = {};
$189e23eec1d6aa3a$exports = JSON.parse("{\"ascending\":\"növekvő\",\"ascendingSort\":\"rendezve a(z) {columnName} oszlop szerint, növekvő sorrendben\",\"descending\":\"csökkenő\",\"descendingSort\":\"rendezve a(z) {columnName} oszlop szerint, csökkenő sorrendben\",\"select\":\"Kijelölés\",\"selectAll\":\"Összes kijelölése\",\"sortable\":\"rendezendő oszlop\"}");


var $3c5ec8e4f015dfd0$exports = {};
$3c5ec8e4f015dfd0$exports = JSON.parse("{\"ascending\":\"crescente\",\"ascendingSort\":\"in ordine crescente in base alla colonna {columnName}\",\"descending\":\"decrescente\",\"descendingSort\":\"in ordine decrescente in base alla colonna {columnName}\",\"select\":\"Seleziona\",\"selectAll\":\"Seleziona tutto\",\"sortable\":\"colonna ordinabile\"}");


var $d021d50e6b315ebb$exports = {};
$d021d50e6b315ebb$exports = JSON.parse("{\"ascending\":\"昇順\",\"ascendingSort\":\"列 {columnName} を昇順で並べ替え\",\"descending\":\"降順\",\"descendingSort\":\"列 {columnName} を降順で並べ替え\",\"select\":\"選択\",\"selectAll\":\"すべて選択\",\"sortable\":\"並べ替え可能な列\"}");


var $52535c35c24ec937$exports = {};
$52535c35c24ec937$exports = JSON.parse("{\"ascending\":\"오름차순\",\"ascendingSort\":\"{columnName} 열을 기준으로 오름차순으로 정렬됨\",\"descending\":\"내림차순\",\"descendingSort\":\"{columnName} 열을 기준으로 내림차순으로 정렬됨\",\"select\":\"선택\",\"selectAll\":\"모두 선택\",\"sortable\":\"정렬 가능한 열\"}");


var $b37ee03672edfd1d$exports = {};
$b37ee03672edfd1d$exports = JSON.parse("{\"ascending\":\"didėjančia tvarka\",\"ascendingSort\":\"surikiuota pagal stulpelį {columnName} didėjančia tvarka\",\"descending\":\"mažėjančia tvarka\",\"descendingSort\":\"surikiuota pagal stulpelį {columnName} mažėjančia tvarka\",\"select\":\"Pasirinkti\",\"selectAll\":\"Pasirinkti viską\",\"sortable\":\"rikiuojamas stulpelis\"}");


var $c7df6686b4189d56$exports = {};
$c7df6686b4189d56$exports = JSON.parse("{\"ascending\":\"augošā secībā\",\"ascendingSort\":\"kārtots pēc kolonnas {columnName} augošā secībā\",\"descending\":\"dilstošā secībā\",\"descendingSort\":\"kārtots pēc kolonnas {columnName} dilstošā secībā\",\"select\":\"Atlasīt\",\"selectAll\":\"Atlasīt visu\",\"sortable\":\"kārtojamā kolonna\"}");


var $da07fe8ec87e6b68$exports = {};
$da07fe8ec87e6b68$exports = JSON.parse("{\"ascending\":\"stigende\",\"ascendingSort\":\"sortert etter kolonne {columnName} i stigende rekkefølge\",\"descending\":\"synkende\",\"descendingSort\":\"sortert etter kolonne {columnName} i synkende rekkefølge\",\"select\":\"Velg\",\"selectAll\":\"Velg alle\",\"sortable\":\"kolonne som kan sorteres\"}");


var $64b7e390f5791490$exports = {};
$64b7e390f5791490$exports = JSON.parse("{\"ascending\":\"oplopend\",\"ascendingSort\":\"gesorteerd in oplopende volgorde in kolom {columnName}\",\"descending\":\"aflopend\",\"descendingSort\":\"gesorteerd in aflopende volgorde in kolom {columnName}\",\"select\":\"Selecteren\",\"selectAll\":\"Alles selecteren\",\"sortable\":\"sorteerbare kolom\"}");


var $2a03621e773f1678$exports = {};
$2a03621e773f1678$exports = JSON.parse("{\"ascending\":\"rosnąco\",\"ascendingSort\":\"posortowano według kolumny {columnName} w porządku rosnącym\",\"descending\":\"malejąco\",\"descendingSort\":\"posortowano według kolumny {columnName} w porządku malejącym\",\"select\":\"Zaznacz\",\"selectAll\":\"Zaznacz wszystko\",\"sortable\":\"kolumna z możliwością sortowania\"}");


var $0a79c0aba9e5ecc6$exports = {};
$0a79c0aba9e5ecc6$exports = JSON.parse("{\"ascending\":\"crescente\",\"ascendingSort\":\"classificado pela coluna {columnName} em ordem crescente\",\"descending\":\"decrescente\",\"descendingSort\":\"classificado pela coluna {columnName} em ordem decrescente\",\"select\":\"Selecionar\",\"selectAll\":\"Selecionar tudo\",\"sortable\":\"coluna classificável\"}");


var $de7b4d0f7dc86fc8$exports = {};
$de7b4d0f7dc86fc8$exports = JSON.parse("{\"ascending\":\"ascendente\",\"ascendingSort\":\"Ordenar por coluna {columnName} em ordem ascendente\",\"descending\":\"descendente\",\"descendingSort\":\"Ordenar por coluna {columnName} em ordem descendente\",\"select\":\"Selecionar\",\"selectAll\":\"Selecionar tudo\",\"sortable\":\"Coluna ordenável\"}");


var $28ea7e849d77bd1c$exports = {};
$28ea7e849d77bd1c$exports = JSON.parse("{\"ascending\":\"crescătoare\",\"ascendingSort\":\"sortate după coloana {columnName} în ordine crescătoare\",\"descending\":\"descrescătoare\",\"descendingSort\":\"sortate după coloana {columnName} în ordine descrescătoare\",\"select\":\"Selectare\",\"selectAll\":\"Selectare totală\",\"sortable\":\"coloană sortabilă\"}");


var $9a09321cf046b187$exports = {};
$9a09321cf046b187$exports = JSON.parse("{\"ascending\":\"возрастание\",\"ascendingSort\":\"сортировать столбец {columnName} в порядке возрастания\",\"descending\":\"убывание\",\"descendingSort\":\"сортировать столбец {columnName} в порядке убывания\",\"select\":\"Выбрать\",\"selectAll\":\"Выбрать все\",\"sortable\":\"сортируемый столбец\"}");


var $5afe469a63fcac7b$exports = {};
$5afe469a63fcac7b$exports = JSON.parse("{\"ascending\":\"vzostupne\",\"ascendingSort\":\"zoradené zostupne podľa stĺpca {columnName}\",\"descending\":\"zostupne\",\"descendingSort\":\"zoradené zostupne podľa stĺpca {columnName}\",\"select\":\"Vybrať\",\"selectAll\":\"Vybrať všetko\",\"sortable\":\"zoraditeľný stĺpec\"}");


var $2956757ac31a7ce2$exports = {};
$2956757ac31a7ce2$exports = JSON.parse("{\"ascending\":\"naraščajoče\",\"ascendingSort\":\"razvrščeno po stolpcu {columnName} v naraščajočem vrstnem redu\",\"descending\":\"padajoče\",\"descendingSort\":\"razvrščeno po stolpcu {columnName} v padajočem vrstnem redu\",\"select\":\"Izberite\",\"selectAll\":\"Izberite vse\",\"sortable\":\"razvrstljivi stolpec\"}");


var $cedee0e66b175529$exports = {};
$cedee0e66b175529$exports = JSON.parse("{\"ascending\":\"rastući\",\"ascendingSort\":\"sortirano po kolonama {columnName} rastućim redosledom\",\"descending\":\"padajući\",\"descendingSort\":\"sortirano po kolonama {columnName} padajućim redosledom\",\"select\":\"Izaberite\",\"selectAll\":\"Izaberite sve\",\"sortable\":\"kolona koja se može sortirati\"}");


var $6db19998ba4427da$exports = {};
$6db19998ba4427da$exports = JSON.parse("{\"ascending\":\"stigande\",\"ascendingSort\":\"sorterat på kolumn {columnName} i stigande ordning\",\"descending\":\"fallande\",\"descendingSort\":\"sorterat på kolumn {columnName} i fallande ordning\",\"select\":\"Markera\",\"selectAll\":\"Markera allt\",\"sortable\":\"sorterbar kolumn\"}");


var $166b7c9cc1adb1a1$exports = {};
$166b7c9cc1adb1a1$exports = JSON.parse("{\"ascending\":\"artan sırada\",\"ascendingSort\":\"{columnName} sütuna göre artan düzende sırala\",\"descending\":\"azalan sırada\",\"descendingSort\":\"{columnName} sütuna göre azalan düzende sırala\",\"select\":\"Seç\",\"selectAll\":\"Tümünü Seç\",\"sortable\":\"Sıralanabilir sütun\"}");


var $c7ab180b401e49ff$exports = {};
$c7ab180b401e49ff$exports = JSON.parse("{\"ascending\":\"висхідний\",\"ascendingSort\":\"відсортовано за стовпцем {columnName} у висхідному порядку\",\"descending\":\"низхідний\",\"descendingSort\":\"відсортовано за стовпцем {columnName} у низхідному порядку\",\"select\":\"Вибрати\",\"selectAll\":\"Вибрати все\",\"sortable\":\"сортувальний стовпець\"}");


var $1648ec00941567f3$exports = {};
$1648ec00941567f3$exports = JSON.parse("{\"ascending\":\"升序\",\"ascendingSort\":\"按列 {columnName} 升序排序\",\"descending\":\"降序\",\"descendingSort\":\"按列 {columnName} 降序排序\",\"select\":\"选择\",\"selectAll\":\"全选\",\"sortable\":\"可排序的列\"}");


var $b26f22384b3c1526$exports = {};
$b26f22384b3c1526$exports = JSON.parse("{\"ascending\":\"遞增\",\"ascendingSort\":\"已依據「{columnName}」欄遞增排序\",\"descending\":\"遞減\",\"descendingSort\":\"已依據「{columnName}」欄遞減排序\",\"select\":\"選取\",\"selectAll\":\"全選\",\"sortable\":\"可排序的欄\"}");


$ae7e9c471762b4d3$exports = {
    "ar-AE": $ce3de3ff2fd66848$exports,
    "bg-BG": $cb80dcce530985b9$exports,
    "cs-CZ": $68ac86749db4c0fb$exports,
    "da-DK": $9a6cbac08487e661$exports,
    "de-DE": $c963661d89486e72$exports,
    "el-GR": $ac03861c6e8605f4$exports,
    "en-US": $09e6b82e0d6e466a$exports,
    "es-ES": $8cc39eb66c2bf220$exports,
    "et-EE": $4e11db3c25a38112$exports,
    "fi-FI": $da1e751a92575e02$exports,
    "fr-FR": $1b5d6c6c47d55106$exports,
    "he-IL": $7c18ba27b86d3308$exports,
    "hr-HR": $2cb40998e20e8a46$exports,
    "hu-HU": $189e23eec1d6aa3a$exports,
    "it-IT": $3c5ec8e4f015dfd0$exports,
    "ja-JP": $d021d50e6b315ebb$exports,
    "ko-KR": $52535c35c24ec937$exports,
    "lt-LT": $b37ee03672edfd1d$exports,
    "lv-LV": $c7df6686b4189d56$exports,
    "nb-NO": $da07fe8ec87e6b68$exports,
    "nl-NL": $64b7e390f5791490$exports,
    "pl-PL": $2a03621e773f1678$exports,
    "pt-BR": $0a79c0aba9e5ecc6$exports,
    "pt-PT": $de7b4d0f7dc86fc8$exports,
    "ro-RO": $28ea7e849d77bd1c$exports,
    "ru-RU": $9a09321cf046b187$exports,
    "sk-SK": $5afe469a63fcac7b$exports,
    "sl-SI": $2956757ac31a7ce2$exports,
    "sr-SP": $cedee0e66b175529$exports,
    "sv-SE": $6db19998ba4427da$exports,
    "tr-TR": $166b7c9cc1adb1a1$exports,
    "uk-UA": $c7ab180b401e49ff$exports,
    "zh-CN": $1648ec00941567f3$exports,
    "zh-TW": $b26f22384b3c1526$exports
};





class $0ba3c81c7f1caedd$export$da43f8f5cb04028d extends $d1c300d9c497e402$export$de9feff04fda126e {
    isCell(node) {
        return node.type === 'cell' || node.type === 'rowheader' || node.type === 'column';
    }
    getKeyBelow(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus was on a column, then focus the first child column if any,
        // or find the corresponding cell in the first row.
        if (startItem.type === 'column') {
            let child = [
                ...startItem.childNodes
            ][0];
            if (child) return child.key;
            let firstKey = this.getFirstKey();
            if (firstKey == null) return;
            let firstItem = this.collection.getItem(firstKey);
            return [
                ...firstItem.childNodes
            ][startItem.index].key;
        }
        return super.getKeyBelow(key);
    }
    getKeyAbove(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return;
        // If focus was on a column, focus the parent column if any
        if (startItem.type === 'column') {
            let parent = this.collection.getItem(startItem.parentKey);
            if (parent && parent.type === 'column') return parent.key;
            return;
        }
        // only return above row key if not header row
        let superKey = super.getKeyAbove(key);
        if (superKey != null && this.collection.getItem(superKey).type !== 'headerrow') return superKey;
        // If no item was found, and focus was on a cell, then focus the
        // corresponding column header.
        if (this.isCell(startItem)) return this.collection.columns[startItem.index].key;
        // If focus was on a row, then focus the first column header.
        return this.collection.columns[0].key;
    }
    findNextColumnKey(column) {
        // Search following columns
        let key = this.findNextKey(column.key, (item)=>item.type === 'column'
        );
        if (key != null) return key;
        // Wrap around to the first column
        let row = this.collection.headerRows[column.level];
        for (let item1 of row.childNodes){
            if (item1.type === 'column') return item1.key;
        }
    }
    findPreviousColumnKey(column) {
        // Search previous columns
        let key = this.findPreviousKey(column.key, (item)=>item.type === 'column'
        );
        if (key != null) return key;
        // Wrap around to the last column
        let row = this.collection.headerRows[column.level];
        let childNodes = [
            ...row.childNodes
        ];
        for(let i = childNodes.length - 1; i >= 0; i--){
            let item = childNodes[i];
            if (item.type === 'column') return item.key;
        }
    }
    getKeyRightOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus was on a column, then focus the next column
        if (item.type === 'column') return this.direction === 'rtl' ? this.findPreviousColumnKey(item) : this.findNextColumnKey(item);
        return super.getKeyRightOf(key);
    }
    getKeyLeftOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return;
        // If focus was on a column, then focus the previous column
        if (item.type === 'column') return this.direction === 'rtl' ? this.findNextColumnKey(item) : this.findPreviousColumnKey(item);
        return super.getKeyLeftOf(key);
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
        if (key == null) return null;
        // If the starting key is a cell, search from its parent row.
        let startItem = collection.getItem(key);
        if (startItem.type === 'cell') key = startItem.parentKey;
        let hasWrapped = false;
        while(key != null){
            let item = collection.getItem(key);
            // Check each of the row header cells in this row for a match
            for (let cell of item.childNodes){
                let column = collection.columns[cell.index];
                if (collection.rowHeaderColumnKeys.has(column.key) && cell.textValue) {
                    let substring = cell.textValue.slice(0, search.length);
                    if (this.collator.compare(substring, search) === 0) {
                        // If we started on a cell, end on the matching cell. Otherwise, end on the row.
                        let fromItem = fromKey != null ? collection.getItem(fromKey) : startItem;
                        return fromItem.type === 'cell' ? cell.key : item.key;
                    }
                }
            }
            key = this.getKeyBelow(key);
            // Wrap around when reaching the end of the collection
            if (key == null && !hasWrapped) {
                key = this.getFirstKey();
                hasWrapped = true;
            }
        }
        return null;
    }
}




function $6e31608fbba75bab$export$25bceaac3c7e4dc7(props, state, ref1) {
    let { keyboardDelegate: keyboardDelegate , isVirtualized: isVirtualized , layout: layout  } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = $325a3faab7a68acd$export$a16aca283550c30d({
        usage: 'search',
        sensitivity: 'base'
    });
    let { direction: direction  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let delegate = useMemo(()=>keyboardDelegate || new $0ba3c81c7f1caedd$export$da43f8f5cb04028d({
            collection: state.collection,
            disabledKeys: state.disabledKeys,
            ref: ref1,
            direction: direction,
            collator: collator,
            layout: layout
        })
    , [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        ref1,
        direction,
        collator,
        layout
    ]);
    let id = $bdb11010cef70236$export$f680877a34711e37();
    $2140fb2337097f2d$export$552312adfd451dab.set(state, id);
    let { gridProps: gridProps  } = $83c6e2eafa584c67$export$f6b86a04e5d66d90({
        ...props,
        id: id,
        keyboardDelegate: delegate,
        getRowText (key) {
            let added = state.collection.getItem(key);
            if (!added) return '';
            // If the row has a textValue, use that.
            if (added.textValue != null) return added.textValue;
            // Otherwise combine the text of each of the row header columns.
            let rowHeaderColumnKeys = state.collection.rowHeaderColumnKeys;
            if (rowHeaderColumnKeys) {
                let text = [];
                for (let cell of added.childNodes){
                    let column = state.collection.columns[cell.index];
                    if (rowHeaderColumnKeys.has(column.key) && cell.textValue) text.push(cell.textValue);
                    if (text.length === rowHeaderColumnKeys.size) break;
                }
                return text.join(' ');
            }
            return '';
        }
    }, state, ref1);
    // Override to include header rows
    if (isVirtualized) gridProps['aria-rowcount'] = state.collection.size + state.collection.headerRows.length;
    let { column: column1 , direction: sortDirection  } = state.sortDescriptor || {
    };
    let formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault($ae7e9c471762b4d3$exports)));
    let sortDescription = useMemo(()=>{
        var ref;
        let columnName = (ref = state.collection.columns.find((c)=>c.key === column1
        )) === null || ref === void 0 ? void 0 : ref.textValue;
        return sortDirection && column1 ? formatMessage(`${sortDirection}Sort`, {
            columnName: columnName
        }) : undefined;
    }, [
        sortDirection,
        column1,
        state.collection.columns
    ]);
    let descriptionProps = $ef06256079686ba0$export$f8aeda7b10753fa1(sortDescription);
    // Only announce after initial render, tabbing to the table will tell you the initial sort info already
    $4f58c5f72bcf79f7$export$496315a1608d9602(()=>{
        $319e236875307eab$export$a9b970dcc4ae71a9(sortDescription, 'assertive', 500);
    }, [
        sortDescription
    ]);
    return {
        gridProps: $3ef42575df84b30b$export$9d1611c77c2fe928(gridProps, descriptionProps, {
            // merge sort description with long press information
            'aria-describedby': [
                descriptionProps['aria-describedby'],
                gridProps['aria-describedby']
            ].filter(Boolean).join(' ')
        })
    };
}


var $f329116d8ad0aba0$exports = {};

$parcel$export$3($f329116d8ad0aba0$exports, "useTableColumnHeader", () => $f329116d8ad0aba0$export$9514819a8c81e960);







function $f329116d8ad0aba0$export$9514819a8c81e960(props, state, ref) {
    var ref1, ref2;
    let { node: node  } = props;
    let allowsSorting = node.props.allowsSorting;
    let { gridCellProps: gridCellProps  } = $ab90dcbc1b5466d0$export$c7e10bfc0c59f67c(props, state, ref);
    let isSelectionCellDisabled = node.props.isSelectionCell && state.selectionManager.selectionMode === 'single';
    let { pressProps: pressProps  } = $f6c31cce2adf654f$export$45712eceda6fad21({
        isDisabled: !allowsSorting || isSelectionCellDisabled,
        onPress () {
            state.sort(node.key);
        }
    });
    // Needed to pick up the focusable context, enabling things like Tooltips for example
    let { focusableProps: focusableProps  } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c({
    }, ref);
    let ariaSort = null;
    let isSortedColumn = ((ref1 = state.sortDescriptor) === null || ref1 === void 0 ? void 0 : ref1.column) === node.key;
    let sortDirection = (ref2 = state.sortDescriptor) === null || ref2 === void 0 ? void 0 : ref2.direction;
    // aria-sort not supported in Android Talkback
    if (node.props.allowsSorting && !$c87311424ea30a05$export$a11b0059900ceec8()) ariaSort = isSortedColumn ? sortDirection : 'none';
    let formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault($ae7e9c471762b4d3$exports)));
    let sortDescription;
    if (allowsSorting) {
        sortDescription = `${formatMessage('sortable')}`;
        // Android Talkback doesn't support aria-sort so we add sort order details to the aria-described by here
        if (isSortedColumn && sortDirection && $c87311424ea30a05$export$a11b0059900ceec8()) sortDescription = `${sortDescription}, ${formatMessage(sortDirection)}`;
    }
    let descriptionProps = $ef06256079686ba0$export$f8aeda7b10753fa1(sortDescription);
    return {
        columnHeaderProps: {
            ...$3ef42575df84b30b$export$9d1611c77c2fe928(gridCellProps, pressProps, focusableProps, descriptionProps),
            role: 'columnheader',
            id: $2140fb2337097f2d$export$37cd4213f2ad742e(state, node.key),
            'aria-colspan': node.colspan && node.colspan > 1 ? node.colspan : null,
            'aria-sort': ariaSort
        }
    };
}


var $b2db214c022798eb$exports = {};

$parcel$export$3($b2db214c022798eb$exports, "useTableRow", () => $b2db214c022798eb$export$7f2f6ae19e707aa5);


function $b2db214c022798eb$export$7f2f6ae19e707aa5(props, state, ref) {
    let { node: node  } = props;
    let { rowProps: rowProps , isPressed: isPressed  } = $4159a7a9cbb0cc18$export$96357d5a73f686fa(props, state, ref);
    return {
        rowProps: {
            ...rowProps,
            'aria-labelledby': $2140fb2337097f2d$export$85069b70317f543(state, node.key)
        },
        isPressed: isPressed
    };
}


var $f917ee10f4c32dab$exports = {};

$parcel$export$3($f917ee10f4c32dab$exports, "useTableHeaderRow", () => $f917ee10f4c32dab$export$1b95a7d2d517b841);
function $f917ee10f4c32dab$export$1b95a7d2d517b841(props, state, ref) {
    let { node: node , isVirtualized: isVirtualized  } = props;
    let rowProps = {
        role: 'row'
    };
    if (isVirtualized) rowProps['aria-rowindex'] = node.index + 1; // aria-rowindex is 1 based
    return {
        rowProps: rowProps
    };
}


var $7713593715703b24$exports = {};

$parcel$export$3($7713593715703b24$exports, "useTableCell", () => $7713593715703b24$export$49571c903d73624c);


function $7713593715703b24$export$49571c903d73624c(props, state, ref) {
    let { gridCellProps: gridCellProps , isPressed: isPressed  } = $ab90dcbc1b5466d0$export$c7e10bfc0c59f67c(props, state, ref);
    let columnKey = props.node.column.key;
    if (state.collection.rowHeaderColumnKeys.has(columnKey)) {
        gridCellProps.role = 'rowheader';
        gridCellProps.id = $2140fb2337097f2d$export$19baff3266315d44(state, props.node.parentKey, columnKey);
    }
    return {
        gridCellProps: gridCellProps,
        isPressed: isPressed
    };
}


var $2a795c53a101c542$exports = {};

$parcel$export$3($2a795c53a101c542$exports, "useTableSelectionCheckbox", () => $2a795c53a101c542$export$16ea7f650bd7c1bb);
$parcel$export$3($2a795c53a101c542$exports, "useTableSelectAllCheckbox", () => $2a795c53a101c542$export$1003db6a7e384b99);




function $2a795c53a101c542$export$16ea7f650bd7c1bb(props, state) {
    let { key: key  } = props;
    const { checkboxProps: checkboxProps  } = $7cb39d07f245a780$export$70e2eed1a92976ad(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            'aria-labelledby': `${checkboxProps.id} ${$2140fb2337097f2d$export$85069b70317f543(state, key)}`
        }
    };
}
function $2a795c53a101c542$export$1003db6a7e384b99(state) {
    let { isEmpty: isEmpty , isSelectAll: isSelectAll , selectionMode: selectionMode  } = state.selectionManager;
    const formatMessage = $321bc95feeb923dd$export$ec23bf898b1eed85((/*@__PURE__*/$parcel$interopDefault($ae7e9c471762b4d3$exports)));
    return {
        checkboxProps: {
            'aria-label': formatMessage(selectionMode === 'single' ? 'select' : 'selectAll'),
            isSelected: isSelectAll,
            isDisabled: selectionMode !== 'multiple',
            isIndeterminate: !isEmpty && !isSelectAll,
            onChange: ()=>state.selectionManager.toggleSelectAll()
        }
    };
}

function $parcel$export$2(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $0175d55c2a017ebc$exports = {};

$parcel$export$2($0175d55c2a017ebc$exports, "useTab", () => $0175d55c2a017ebc$export$fdf4756d5b8ef90a);
const $99b62ae3ff97ec45$export$c5f62239608282b6 = new WeakMap();
function $99b62ae3ff97ec45$export$567fc7097e064344(state, key, role) {
    if (typeof key === 'string') key = key.replace(/\s+/g, '');
    let baseId = $99b62ae3ff97ec45$export$c5f62239608282b6.get(state);
    return `${baseId}-${role}-${key}`;
}



function $0175d55c2a017ebc$export$fdf4756d5b8ef90a(props, state, ref) {
    let { key: key , isDisabled: propsDisabled  } = props;
    let { selectionManager: manager , selectedKey: selectedKey  } = state;
    let isSelected = key === selectedKey;
    let isDisabled = propsDisabled || state.disabledKeys.has(key);
    let { itemProps: itemProps  } = $880e95eb8b93ba9a$export$ecf600387e221c37({
        selectionManager: manager,
        key: key,
        ref: ref,
        isDisabled: isDisabled
    });
    let tabId = $99b62ae3ff97ec45$export$567fc7097e064344(state, key, 'tab');
    let tabPanelId = $99b62ae3ff97ec45$export$567fc7097e064344(state, key, 'tabpanel');
    let { tabIndex: tabIndex  } = itemProps;
    return {
        tabProps: {
            ...itemProps,
            id: tabId,
            'aria-selected': isSelected,
            'aria-disabled': isDisabled || undefined,
            'aria-controls': isSelected ? tabPanelId : undefined,
            tabIndex: isDisabled ? undefined : tabIndex,
            role: 'tab'
        }
    };
}


var $34bce698202e07cb$exports = {};

$parcel$export$2($34bce698202e07cb$exports, "useTabPanel", () => $34bce698202e07cb$export$fae0121b5afe572d);




function $34bce698202e07cb$export$fae0121b5afe572d(props, state, ref) {
    let [tabIndex, setTabIndex] = useState(0);
    // The tabpanel should have tabIndex=0 when there are no tabbable elements within it.
    // Otherwise, tabbing from the focused tab should go directly to the first tabbable element
    // within the tabpanel.
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(()=>{
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            let update = ()=>{
                // Detect if there are any tabbable elements and update the tabIndex accordingly.
                let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ref.current, {
                    tabbable: true
                });
                setTabIndex(walker.nextNode() ? undefined : 0);
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            let observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    'tabIndex',
                    'disabled'
                ]
            });
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        ref
    ]);
    const id = $99b62ae3ff97ec45$export$567fc7097e064344(state, state === null || state === void 0 ? void 0 : state.selectedKey, 'tabpanel');
    const tabPanelProps = $313b98861ee5dd6c$export$d6875122194c7b44({
        ...props,
        id: id,
        'aria-labelledby': $99b62ae3ff97ec45$export$567fc7097e064344(state, state === null || state === void 0 ? void 0 : state.selectedKey, 'tab')
    });
    return {
        tabPanelProps: $3ef42575df84b30b$export$9d1611c77c2fe928(tabPanelProps, {
            tabIndex: tabIndex,
            role: 'tabpanel',
            'aria-describedby': props['aria-describedby'],
            'aria-details': props['aria-details']
        })
    };
}


var $58d314389b21fa3f$exports = {};

$parcel$export$2($58d314389b21fa3f$exports, "useTabList", () => $58d314389b21fa3f$export$773e389e644c5874);



class $bfc6f2d60b8a4c40$export$15010ca3c1abe90b {
    getKeyLeftOf(key) {
        if (this.flipDirection) return this.getNextKey(key);
        else {
            if (this.orientation === 'horizontal') return this.getPreviousKey(key);
            return null;
        }
    }
    getKeyRightOf(key) {
        if (this.flipDirection) return this.getPreviousKey(key);
        else {
            if (this.orientation === 'horizontal') return this.getNextKey(key);
            return null;
        }
    }
    getKeyAbove(key) {
        if (this.orientation === 'vertical') return this.getPreviousKey(key);
        return null;
    }
    getKeyBelow(key) {
        if (this.orientation === 'vertical') return this.getNextKey(key);
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        if (this.disabledKeys.has(key)) key = this.getNextKey(key);
        return key;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        if (this.disabledKeys.has(key)) key = this.getPreviousKey(key);
        return key;
    }
    getNextKey(key) {
        do {
            key = this.collection.getKeyAfter(key);
            if (key == null) key = this.collection.getFirstKey();
        }while (this.disabledKeys.has(key))
        return key;
    }
    getPreviousKey(key) {
        do {
            key = this.collection.getKeyBefore(key);
            if (key == null) key = this.collection.getLastKey();
        }while (this.disabledKeys.has(key))
        return key;
    }
    constructor(collection, direction, orientation, disabledKeys = new Set()){
        this.collection = collection;
        this.flipDirection = direction === 'rtl' && orientation === 'horizontal';
        this.orientation = orientation;
        this.disabledKeys = disabledKeys;
    }
}




function $58d314389b21fa3f$export$773e389e644c5874(props, state, ref) {
    let { orientation: orientation = 'horizontal' , keyboardActivation: keyboardActivation = 'automatic'  } = props;
    let { collection: collection , selectionManager: manager , disabledKeys: disabledKeys  } = state;
    let { direction: direction  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
    let delegate = useMemo(()=>new $bfc6f2d60b8a4c40$export$15010ca3c1abe90b(collection, direction, orientation, disabledKeys)
    , [
        collection,
        disabledKeys,
        orientation,
        direction
    ]);
    let { collectionProps: collectionProps  } = $ae20dd8cbca75726$export$d6daf82dcd84e87c({
        ref: ref,
        selectionManager: manager,
        keyboardDelegate: delegate,
        selectOnFocus: keyboardActivation === 'automatic',
        disallowEmptySelection: true,
        scrollRef: ref
    });
    // Compute base id for all tabs
    let tabsId = $bdb11010cef70236$export$f680877a34711e37();
    $99b62ae3ff97ec45$export$c5f62239608282b6.set(state, tabsId);
    let tabListLabelProps = $313b98861ee5dd6c$export$d6875122194c7b44({
        ...props,
        id: tabsId
    });
    return {
        tabListProps: {
            ...$3ef42575df84b30b$export$9d1611c77c2fe928(collectionProps, tabListLabelProps),
            role: 'tablist',
            'aria-orientation': orientation,
            tabIndex: undefined
        }
    };
}

function $parcel$export$1(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $326e436e94273fe1$exports = {};

$parcel$export$1($326e436e94273fe1$exports, "useTooltip", () => $326e436e94273fe1$export$1c4b08e0eca38426);


function $326e436e94273fe1$export$1c4b08e0eca38426(props, state) {
    let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
    });
    let { hoverProps: hoverProps  } = $6179b936705e76d3$export$ae780daf29e6d456({
        onHoverStart: ()=>{
            return state === null || state === void 0 ? void 0 : state.open(true);
        },
        onHoverEnd: ()=>{
            return state === null || state === void 0 ? void 0 : state.close();
        }
    });
    return {
        tooltipProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, hoverProps, {
            role: 'tooltip'
        })
    };
}


var $4e1b34546679e357$exports = {};

$parcel$export$1($4e1b34546679e357$exports, "useTooltipTrigger", () => $4e1b34546679e357$export$a6da6c504e4bba8b);





function $4e1b34546679e357$export$a6da6c504e4bba8b(props, state, ref) {
    let { isDisabled: isDisabled , trigger: trigger  } = props;
    let tooltipId = $bdb11010cef70236$export$f680877a34711e37();
    let isHovered = useRef(false);
    let isFocused = useRef(false);
    let handleShow = ()=>{
        if (isHovered.current || isFocused.current) state.open(isFocused.current);
    };
    let handleHide = (immediate)=>{
        if (!isHovered.current && !isFocused.current) state.close(immediate);
    };
    useEffect(()=>{
        let onKeyDown = (e)=>{
            if (ref && ref.current) // Escape after clicking something can give it keyboard focus
            // dismiss tooltip on esc key press
            {
                if (e.key === 'Escape') state.close(true);
            }
        };
        if (state.isOpen) {
            document.addEventListener('keydown', onKeyDown, true);
            return ()=>{
                document.removeEventListener('keydown', onKeyDown, true);
            };
        }
    }, [
        ref,
        state
    ]);
    let onHoverStart = ()=>{
        if (trigger === 'focus') return;
        // In chrome, if you hover a trigger, then another element obscures it, due to keyboard
        // interactions for example, hover will end. When hover is restored after that element disappears,
        // focus moves on for example, then the tooltip will reopen. We check the modality to know if the hover
        // is the result of moving the mouse.
        if ($507fabe10e71c6fb$export$630ff653c5ada6a9() === 'pointer') isHovered.current = true;
        else isHovered.current = false;
        handleShow();
    };
    let onHoverEnd = ()=>{
        if (trigger === 'focus') return;
        // no matter how the trigger is left, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide();
    };
    let onPressStart = ()=>{
        // no matter how the trigger is pressed, we should close the tooltip
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let onFocus = ()=>{
        let isVisible = $507fabe10e71c6fb$export$b9b3dfddab17db27();
        if (isVisible) {
            isFocused.current = true;
            handleShow();
        }
    };
    let onBlur = ()=>{
        isFocused.current = false;
        isHovered.current = false;
        handleHide(true);
    };
    let { hoverProps: hoverProps  } = $6179b936705e76d3$export$ae780daf29e6d456({
        isDisabled: isDisabled,
        onHoverStart: onHoverStart,
        onHoverEnd: onHoverEnd
    });
    let { pressProps: pressProps  } = $f6c31cce2adf654f$export$45712eceda6fad21({
        onPressStart: onPressStart
    });
    let { focusableProps: focusableProps  } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c({
        isDisabled: isDisabled,
        onFocus: onFocus,
        onBlur: onBlur
    }, ref);
    return {
        triggerProps: {
            'aria-describedby': state.isOpen ? tooltipId : undefined,
            ...$3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, hoverProps, pressProps)
        },
        tooltipProps: {
            id: tooltipId
        }
    };
}

var TextStyles = function TextStyles(_a) {
  var type = _a.type,
      tokens = _a.tokens,
      fontStyle = _a.fontStyle;
  var font = type ? tokens.font[type] : null;
  var style = fontStyle || 'inherit';
  return {
    fontFamily: font ? "\"".concat(font.family.value, "\", sans-serif") : 'inherit',
    lineHeight: font ? font.lineHeight.value : 'inherit',
    fontSize: font ? font.size.value : 'inherit',
    fontWeight: font ? font.weight.value : 'inherit',
    fontStyle: style,
    letterSpacing: font ? font.letterSpacing.value : 'inherit'
  };
};

var FocusStyles = function FocusStyles(_a) {
  var isFocused = _a.isFocused,
      tokens = _a.tokens;
  return {
    WebkitAppearance: 'none',
    appearance: 'none',
    outline: isFocused ? "".concat(tokens.focusRing.outline.width.value, " solid ").concat(tokens.focusRing.outline.color.value) : 'none',
    outlineOffset: "".concat(tokens.focusRing.outline.offset.value)
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var sizeMap = {
  small: 'b200',
  medium: 'b300',
  large: 'b400'
};

var buttonStyles = function buttonStyles(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 'medium' : _b,
      _c = _a.visualType,
      visualType = _c === void 0 ? 'primary' : _c,
      isDisabled = _a.isDisabled,
      isError = _a.isError,
      isPressed = _a.isPressed,
      isHovered = _a.isHovered,
      isFocused = _a.isFocused,
      minWidth = _a.minWidth;
  var styleState = 'default';
  if (isError) styleState = 'error';else if (isDisabled) styleState = 'disabled';else if (isPressed) styleState = 'pressed';else if (isHovered) styleState = 'hover';
  var buttonStyle = uiTokens.button[visualType];
  var backgroundColor = buttonStyle.backgroundColor[styleState].value;
  var borderColor = buttonStyle.borderColor[styleState].value;
  var color = buttonStyle.foregroundColor[styleState].value;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css(__assign(__assign(__assign({}, TextStyles({
      type: sizeMap[size],
      tokens: uiTokens
    })), FocusStyles({
      isFocused: isFocused,
      tokens: uiTokens
    })), {
      alignContent: 'center',
      backgroundColor: backgroundColor,
      borderWidth: uiTokens.button.border.width.value,
      borderRadius: uiTokens.button.border.radius.value,
      borderColor: borderColor,
      borderStyle: 'solid',
      color: color,
      cursor: !isDisabled ? 'pointer' : 'not-allowed',
      display: 'inline-flex',
      justifyContent: 'space-around',
      minWidth: minWidth,
      padding: visualType === 'icon' ? "0 ".concat(uiTokens.spacing.v50.value, "px") : "".concat(uiTokens.button.padding.vertical.value, "px ").concat(uiTokens.button.padding.horizontal.value, "px")
    }), process.env.NODE_ENV === "production" ? "" : ";label:buttonStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBOEJXIiwiZmlsZSI6IkJ1dHRvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBfX2Fzc2lnbiB9IGZyb20gXCJ0c2xpYlwiO1xyXG4vKiogQGpzeFJ1bnRpbWUgY2xhc3NpYyAqL1xyXG4vKiogQGpzeCBqc3ggKi9cclxuaW1wb3J0IHsgdXNlUmVmLCB1c2VTdGF0ZSwgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XHJcbmltcG9ydCB1bmlxdWVJZCBmcm9tICdsb2Rhc2gudW5pcXVlaWQnO1xyXG5pbXBvcnQgeyB1c2VCdXR0b24sIHVzZUZvY3VzLCB1c2VIb3ZlciB9IGZyb20gJ3JlYWN0LWFyaWEnO1xyXG5pbXBvcnQgdG9rZW5zIGZyb20gJ0BmbGV4ZS91aS10b2tlbnMnO1xyXG5pbXBvcnQgVGV4dFN0eWxlcyBmcm9tICcuLi8uLi9fc3R5bGVzL3RleHQnO1xyXG5pbXBvcnQgRm9jdXNTdHlsZXMgZnJvbSAnLi4vLi4vX3N0eWxlcy9mb2N1cyc7XHJcbnZhciBzaXplTWFwID0ge1xyXG4gICAgc21hbGw6ICdiMjAwJyxcclxuICAgIG1lZGl1bTogJ2IzMDAnLFxyXG4gICAgbGFyZ2U6ICdiNDAwJ1xyXG59O1xyXG52YXIgYnV0dG9uU3R5bGVzID0gZnVuY3Rpb24gKF9hKSB7XHJcbiAgICB2YXIgX2IgPSBfYS5zaXplLCBzaXplID0gX2IgPT09IHZvaWQgMCA/ICdtZWRpdW0nIDogX2IsIF9jID0gX2EudmlzdWFsVHlwZSwgdmlzdWFsVHlwZSA9IF9jID09PSB2b2lkIDAgPyAncHJpbWFyeScgOiBfYywgaXNEaXNhYmxlZCA9IF9hLmlzRGlzYWJsZWQsIGlzRXJyb3IgPSBfYS5pc0Vycm9yLCBpc1ByZXNzZWQgPSBfYS5pc1ByZXNzZWQsIGlzSG92ZXJlZCA9IF9hLmlzSG92ZXJlZCwgaXNGb2N1c2VkID0gX2EuaXNGb2N1c2VkLCBtaW5XaWR0aCA9IF9hLm1pbldpZHRoO1xyXG4gICAgdmFyIHN0eWxlU3RhdGUgPSAnZGVmYXVsdCc7XHJcbiAgICBpZiAoaXNFcnJvcilcclxuICAgICAgICBzdHlsZVN0YXRlID0gJ2Vycm9yJztcclxuICAgIGVsc2UgaWYgKGlzRGlzYWJsZWQpXHJcbiAgICAgICAgc3R5bGVTdGF0ZSA9ICdkaXNhYmxlZCc7XHJcbiAgICBlbHNlIGlmIChpc1ByZXNzZWQpXHJcbiAgICAgICAgc3R5bGVTdGF0ZSA9ICdwcmVzc2VkJztcclxuICAgIGVsc2UgaWYgKGlzSG92ZXJlZClcclxuICAgICAgICBzdHlsZVN0YXRlID0gJ2hvdmVyJztcclxuICAgIHZhciBidXR0b25TdHlsZSA9IHRva2Vucy5idXR0b25bdmlzdWFsVHlwZV07XHJcbiAgICB2YXIgYmFja2dyb3VuZENvbG9yID0gYnV0dG9uU3R5bGUuYmFja2dyb3VuZENvbG9yW3N0eWxlU3RhdGVdLnZhbHVlO1xyXG4gICAgdmFyIGJvcmRlckNvbG9yID0gYnV0dG9uU3R5bGUuYm9yZGVyQ29sb3Jbc3R5bGVTdGF0ZV0udmFsdWU7XHJcbiAgICB2YXIgY29sb3IgPSBidXR0b25TdHlsZS5mb3JlZ3JvdW5kQ29sb3Jbc3R5bGVTdGF0ZV0udmFsdWU7XHJcbiAgICByZXR1cm4gY3NzKF9fYXNzaWduKF9fYXNzaWduKF9fYXNzaWduKHt9LCBUZXh0U3R5bGVzKHsgdHlwZTogc2l6ZU1hcFtzaXplXSwgdG9rZW5zOiB0b2tlbnMgfSkpLCBGb2N1c1N0eWxlcyh7IGlzRm9jdXNlZDogaXNGb2N1c2VkLCB0b2tlbnM6IHRva2VucyB9KSksIHsgYWxpZ25Db250ZW50OiAnY2VudGVyJywgYmFja2dyb3VuZENvbG9yOiBiYWNrZ3JvdW5kQ29sb3IsIGJvcmRlcldpZHRoOiB0b2tlbnMuYnV0dG9uLmJvcmRlci53aWR0aC52YWx1ZSwgYm9yZGVyUmFkaXVzOiB0b2tlbnMuYnV0dG9uLmJvcmRlci5yYWRpdXMudmFsdWUsIGJvcmRlckNvbG9yOiBib3JkZXJDb2xvciwgYm9yZGVyU3R5bGU6ICdzb2xpZCcsIGNvbG9yOiBjb2xvciwgY3Vyc29yOiAhaXNEaXNhYmxlZCA/ICdwb2ludGVyJyA6ICdub3QtYWxsb3dlZCcsIGRpc3BsYXk6ICdpbmxpbmUtZmxleCcsIGp1c3RpZnlDb250ZW50OiAnc3BhY2UtYXJvdW5kJywgbWluV2lkdGg6IG1pbldpZHRoLCBwYWRkaW5nOiB2aXN1YWxUeXBlID09PSAnaWNvbidcclxuICAgICAgICAgICAgPyBcIjAgXCIuY29uY2F0KHRva2Vucy5zcGFjaW5nLnY1MC52YWx1ZSwgXCJweFwiKVxyXG4gICAgICAgICAgICA6IFwiXCIuY29uY2F0KHRva2Vucy5idXR0b24ucGFkZGluZy52ZXJ0aWNhbC52YWx1ZSwgXCJweCBcIikuY29uY2F0KHRva2Vucy5idXR0b24ucGFkZGluZy5ob3Jpem9udGFsLnZhbHVlLCBcInB4XCIpIH0pKTtcclxufTtcclxudmFyIGZpbGVJbnB1dFN0eWxlcyA9IGNzcyh7XHJcbiAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcclxuICAgIHdpZHRoOiAnMXB4JyxcclxuICAgIGhlaWdodDogJzFweCcsXHJcbiAgICBwYWRkaW5nOiAnMCcsXHJcbiAgICBtYXJnaW46ICctMXB4JyxcclxuICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcclxuICAgIGNsaXA6ICdyZWN0KDAsMCwwLDApJyxcclxuICAgIGJvcmRlcjogJzAnXHJcbn0pO1xyXG4vKipcclxuICogVGhpcyBjb21wb25lbnQgcHJvdmlkZXMgYSBiYXNpYyBidXR0b25cclxuICogd2l0aCB0aHJlZSBzdHlsZXM6IGBkZWZhdWx0YCwgYHByaW1hcnlgLCBhbmQgYHNlY29uZGFyeWAuXHJcbiAqL1xyXG52YXIgQnV0dG9uID0gZm9yd2FyZFJlZihmdW5jdGlvbiAocHJvcHMsIHJlZikge1xyXG4gICAgdmFyIGNoaWxkcmVuID0gcHJvcHMuY2hpbGRyZW4sIHNpemUgPSBwcm9wcy5zaXplLCBpc0Rpc2FibGVkID0gcHJvcHMuaXNEaXNhYmxlZCwgaXNFcnJvciA9IHByb3BzLmlzRXJyb3IsIG1pbldpZHRoID0gcHJvcHMubWluV2lkdGgsIG9uQmx1ciA9IHByb3BzLm9uQmx1ciwgb25GaWxlU2VsZWN0ZWQgPSBwcm9wcy5vbkZpbGVTZWxlY3RlZCwgb25Gb2N1cyA9IHByb3BzLm9uRm9jdXMsIG9uTW91c2VFbnRlciA9IHByb3BzLm9uTW91c2VFbnRlciwgb25Nb3VzZUxlYXZlID0gcHJvcHMub25Nb3VzZUxlYXZlLCB0ZXN0aWQgPSBwcm9wcy50ZXN0aWQsIHZpc3VhbFR5cGUgPSBwcm9wcy52aXN1YWxUeXBlO1xyXG4gICAgdmFyIGJ1dHRvblJlZiA9IHJlZiB8fCB1c2VSZWYobnVsbCk7XHJcbiAgICB2YXIgX2EgPSB1c2VTdGF0ZShmYWxzZSksIGlzRm9jdXNlZCA9IF9hWzBdLCBzZXRJc0ZvY3VzZWQgPSBfYVsxXTtcclxuICAgIHZhciBmaWxlSW5wdXRJZCA9IHVuaXF1ZUlkKCd1aS1jb21wb25lbnRzLWZpbGUtaW5wdXQtJyk7XHJcbiAgICB2YXIgX2IgPSB1c2VCdXR0b24oX19hc3NpZ24oX19hc3NpZ24oe30sIHByb3BzKSwgeyBlbGVtZW50VHlwZTogJ2RpdicgfSksIGJ1dHRvblJlZiksIGJ1dHRvblByb3BzID0gX2IuYnV0dG9uUHJvcHMsIGlzUHJlc3NlZCA9IF9iLmlzUHJlc3NlZDtcclxuICAgIHZhciBfYyA9IHVzZUhvdmVyKHtcclxuICAgICAgICBvbkhvdmVyU3RhcnQ6IGZ1bmN0aW9uIChlKSB7IHJldHVybiAob25Nb3VzZUVudGVyID8gb25Nb3VzZUVudGVyKGUpIDogbnVsbCk7IH0sXHJcbiAgICAgICAgb25Ib3ZlckVuZDogZnVuY3Rpb24gKGUpIHsgcmV0dXJuIChvbk1vdXNlTGVhdmUgPyBvbk1vdXNlTGVhdmUoZSkgOiBudWxsKTsgfVxyXG4gICAgfSksIGhvdmVyUHJvcHMgPSBfYy5ob3ZlclByb3BzLCBpc0hvdmVyZWQgPSBfYy5pc0hvdmVyZWQ7XHJcbiAgICB2YXIgZm9jdXNQcm9wcyA9IHVzZUZvY3VzKHtcclxuICAgICAgICBvbkZvY3VzOiBmdW5jdGlvbiAoZSkgeyByZXR1cm4gKG9uRm9jdXMgPyBvbkZvY3VzKGUpIDogbnVsbCk7IH0sXHJcbiAgICAgICAgb25CbHVyOiBmdW5jdGlvbiAoZSkgeyByZXR1cm4gKG9uQmx1ciA/IG9uQmx1cihlKSA6IG51bGwpOyB9LFxyXG4gICAgICAgIG9uRm9jdXNDaGFuZ2U6IGZ1bmN0aW9uICgpIHsgcmV0dXJuIHNldElzRm9jdXNlZCghaXNGb2N1c2VkKTsgfVxyXG4gICAgfSkuZm9jdXNQcm9wcztcclxuICAgIHZhciBoYW5kbGVGaWxlSW5wdXRDbGlja2VkID0gZnVuY3Rpb24gKGUpIHtcclxuICAgICAgICBlLmN1cnJlbnRUYXJnZXQudmFsdWUgPSAnJztcclxuICAgIH07XHJcbiAgICByZXR1cm4gcHJvcHMuaXNGaWxlSW5wdXQgPyAoanN4KFwibGFiZWxcIiwgX19hc3NpZ24oe30sIGJ1dHRvblByb3BzLCBmb2N1c1Byb3BzLCBob3ZlclByb3BzLCB7IFwiZGF0YS10ZXN0aWRcIjogdGVzdGlkLCBpZDogcHJvcHMuaWQsIHJvbGU6IHVuZGVmaW5lZCwgaHRtbEZvcjogZmlsZUlucHV0SWQsIGNzczogYnV0dG9uU3R5bGVzKHtcclxuICAgICAgICAgICAgc2l6ZTogc2l6ZSxcclxuICAgICAgICAgICAgdmlzdWFsVHlwZTogdmlzdWFsVHlwZSxcclxuICAgICAgICAgICAgaXNEaXNhYmxlZDogaXNEaXNhYmxlZCxcclxuICAgICAgICAgICAgaXNFcnJvcjogaXNFcnJvcixcclxuICAgICAgICAgICAgaXNQcmVzc2VkOiBpc1ByZXNzZWQsXHJcbiAgICAgICAgICAgIGlzSG92ZXJlZDogaXNIb3ZlcmVkLFxyXG4gICAgICAgICAgICBpc0ZvY3VzZWQ6IGlzRm9jdXNlZCxcclxuICAgICAgICAgICAgbWluV2lkdGg6IG1pbldpZHRoXHJcbiAgICAgICAgfSkgfSksXHJcbiAgICAgICAganN4KFwiaW5wdXRcIiwgeyBhY2NlcHQ6IHByb3BzLmZpbGVJbnB1dEFjY2VwdCwgY2FwdHVyZTogcHJvcHMuZmlsZUlucHV0Q2FwdHVyZSwgbXVsdGlwbGU6IHByb3BzLmZpbGVJbnB1dE11bHRpcGxlLCBjc3M6IGZpbGVJbnB1dFN0eWxlcywgaWQ6IGZpbGVJbnB1dElkLCBvbkNoYW5nZTogb25GaWxlU2VsZWN0ZWQsIG9uQ2xpY2s6IGhhbmRsZUZpbGVJbnB1dENsaWNrZWQsIHR5cGU6IFwiZmlsZVwiIH0pLFxyXG4gICAgICAgIGNoaWxkcmVuKSkgOiAoanN4KFwiZGl2XCIsIF9fYXNzaWduKHt9LCBidXR0b25Qcm9wcywgaG92ZXJQcm9wcywgZm9jdXNQcm9wcywgeyBcImRhdGEtdGVzdGlkXCI6IHRlc3RpZCwgaWQ6IHByb3BzLmlkLCBmb3JtOiBwcm9wcy5mb3JtLCB0eXBlOiBwcm9wcy5zdWJtaXQgPyAnc3VibWl0JyA6ICdidXR0b24nLCBcImFyaWEtbGFiZWxcIjogcHJvcHMubGFiZWwsIGNzczogYnV0dG9uU3R5bGVzKHtcclxuICAgICAgICAgICAgc2l6ZTogc2l6ZSxcclxuICAgICAgICAgICAgdmlzdWFsVHlwZTogdmlzdWFsVHlwZSxcclxuICAgICAgICAgICAgaXNEaXNhYmxlZDogaXNEaXNhYmxlZCxcclxuICAgICAgICAgICAgaXNFcnJvcjogaXNFcnJvcixcclxuICAgICAgICAgICAgaXNQcmVzc2VkOiBpc1ByZXNzZWQsXHJcbiAgICAgICAgICAgIGlzSG92ZXJlZDogaXNIb3ZlcmVkLFxyXG4gICAgICAgICAgICBpc0ZvY3VzZWQ6IGlzRm9jdXNlZCxcclxuICAgICAgICAgICAgbWluV2lkdGg6IG1pbldpZHRoXHJcbiAgICAgICAgfSkgfSksIGNoaWxkcmVuKSk7XHJcbn0pO1xyXG5CdXR0b24uZGlzcGxheU5hbWUgPSAnQnV0dG9uJztcclxuQnV0dG9uLmRlZmF1bHRQcm9wcyA9IHtcclxuICAgIHNpemU6ICdtZWRpdW0nLFxyXG4gICAgdmlzdWFsVHlwZTogJ2RlZmF1bHQnXHJcbn07XHJcbmV4cG9ydCBkZWZhdWx0IEJ1dHRvbjtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9QnV0dG9uLmpzLm1hcCJdfQ== */", process.env.NODE_ENV === "production" ? "" : ";label:buttonStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};

var fileInputStyles = process.env.NODE_ENV === "production" ? {
  name: "ccj1rl",
  styles: "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0"
} : {
  name: "1udjmzf-fileInputStyles",
  styles: "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0;label:fileInputStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
};
/**
 * This component provides a basic button
 * with three styles: `default`, `primary`, and `secondary`.
 */

var Button = /*#__PURE__*/forwardRef$2(function (props, ref) {
  var children = props.children,
      size = props.size,
      isDisabled = props.isDisabled,
      isError = props.isError,
      minWidth = props.minWidth,
      _onBlur = props.onBlur,
      onFileSelected = props.onFileSelected,
      _onFocus = props.onFocus,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      testid = props.testid,
      visualType = props.visualType;
  var buttonRef = ref || useRef(null);

  var _a = useState(false),
      isFocused = _a[0],
      setIsFocused = _a[1];

  var fileInputId = lodash_uniqueid('ui-components-file-input-');

  var _b = $701a24aa0da5b062$export$ea18c227d4417cc3(__assign(__assign({}, props), {
    elementType: 'div'
  }), buttonRef),
      buttonProps = _b.buttonProps,
      isPressed = _b.isPressed;

  var _c = $6179b936705e76d3$export$ae780daf29e6d456({
    onHoverStart: function onHoverStart(e) {
      return onMouseEnter ? onMouseEnter(e) : null;
    },
    onHoverEnd: function onHoverEnd(e) {
      return onMouseLeave ? onMouseLeave(e) : null;
    }
  }),
      hoverProps = _c.hoverProps,
      isHovered = _c.isHovered;

  var focusProps = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    onFocus: function onFocus(e) {
      return _onFocus ? _onFocus(e) : null;
    },
    onBlur: function onBlur(e) {
      return _onBlur ? _onBlur(e) : null;
    },
    onFocusChange: function onFocusChange() {
      return setIsFocused(!isFocused);
    }
  }).focusProps;

  var handleFileInputClicked = function handleFileInputClicked(e) {
    e.currentTarget.value = '';
  };

  return props.isFileInput ? jsx("label", __assign({}, buttonProps, focusProps, hoverProps, {
    "data-testid": testid,
    id: props.id,
    role: undefined,
    htmlFor: fileInputId,
    css: buttonStyles({
      size: size,
      visualType: visualType,
      isDisabled: isDisabled,
      isError: isError,
      isPressed: isPressed,
      isHovered: isHovered,
      isFocused: isFocused,
      minWidth: minWidth
    })
  }), jsx("input", {
    accept: props.fileInputAccept,
    capture: props.fileInputCapture,
    multiple: props.fileInputMultiple,
    css: fileInputStyles,
    id: fileInputId,
    onChange: onFileSelected,
    onClick: handleFileInputClicked,
    type: "file"
  }), children) : jsx("div", __assign({}, buttonProps, hoverProps, focusProps, {
    "data-testid": testid,
    id: props.id,
    form: props.form,
    type: props.submit ? 'submit' : 'button',
    "aria-label": props.label,
    css: buttonStyles({
      size: size,
      visualType: visualType,
      isDisabled: isDisabled,
      isError: isError,
      isPressed: isPressed,
      isHovered: isHovered,
      isFocused: isFocused,
      minWidth: minWidth
    })
  }), children);
});
Button.displayName = 'Button';
Button.defaultProps = {
  size: 'medium',
  visualType: 'default'
};

var styles = function styles(_a) {
  var headerBorder = _a.headerBorder,
      zebraStripe = _a.zebraStripe,
      showLegend = _a.showLegend;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css(__assign(__assign({}, TextStyles({
      type: 'b300',
      tokens: uiTokens
    })), {
      borderCollapse: 'collapse',
      width: '100%',
      thead: {
        border: headerBorder ? "1px solid ".concat(uiTokens.color.base.gray.v200.value) : 'none'
      },
      th: {
        textAlign: 'start',
        padding: '8px 16px 8px 16px'
      },
      td: {
        padding: '8px 16px'
      },
      'tbody tr:nth-of-type(odd)': {
        backgroundColor: zebraStripe ? uiTokens.color.base.gray.v50.value : undefined
      },
      'tbody tr:last-child': {
        backgroundColor: showLegend ? 'transparent' : undefined,
        borderTop: showLegend ? "1px solid ".concat(uiTokens.color.base.gray.v100.value) : 'none'
      }
    }), process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};

var useTable = function useTable(_a) {
  var _b = _a.headerBorder,
      headerBorder = _b === void 0 ? false : _b,
      _c = _a.zebraStripe,
      zebraStripe = _c === void 0 ? false : _c,
      _d = _a.showLegend,
      showLegend = _d === void 0 ? false : _d;
  var tableStyles = {
    css: styles({
      headerBorder: headerBorder,
      zebraStripe: zebraStripe,
      showLegend: showLegend
    })
  };
  return {
    tableStyles: tableStyles
  };
};

var DetailedErrorsTable = function DetailedErrorsTable(props) {
  var tableStyles = useTable({
    headerBorder: false,
    zebraStripe: true
  }).tableStyles;
  return jsx("table", __assign({}, tableStyles), props.headers && jsx("thead", null, jsx("tr", null, props.headers.map(function (header) {
    return jsx("th", {
      key: header
    }, header);
  }))), jsx("tbody", null, props.details.map(function (detail) {
    return jsx(React__default.Fragment, {
      key: lodash_uniqueid('info-box-')
    }, props.renderInfoBoxDetailTableRow(detail));
  })));
};

DetailedErrorsTable.defaultProps = {
  headers: ['Error', 'Detail']
};

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
} (classnames));

var classNames = classnames.exports;

var fontAwesomeAnimations = ['spin'];
var customAnimations = ['spin-fast'];
var fontAwesomeAnimationValues = __spreadArray([], fontAwesomeAnimations, true);
__spreadArray([], customAnimations, true);

/**
 * This check allows us access to Font Awesome animations that must be passed via classnames,
 * as well as custom animations that are passed via emotion.js
 */

var isFAAnimation = function isFAAnimation(a) {
  var bool = false; // eslint-disable-next-line no-plusplus

  for (var i = 0; i < fontAwesomeAnimationValues.length; i++) {
    if (fontAwesomeAnimationValues[i] === a) {
      bool = true;
      break;
    }
  }

  return bool;
};

var rotateKeyframes = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    transform: rotate(-360deg);\n  }\n  100% {\n    transform: rotate(0);\n  }\n"], ["\n  0% {\n    transform: rotate(-360deg);\n  }\n  100% {\n    transform: rotate(0);\n  }\n"]))); // custom animations and color are passed via emotion.js

var iconStyles = function iconStyles(_a) {
  var color = _a.color,
      customAnimation = _a.customAnimation;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css({
      color: color,
      animation: customAnimation && "".concat(rotateKeyframes, " 1s linear infinite"),
      lineHeight: 'inherit'
    }, process.env.NODE_ENV === "production" ? "" : ";label:iconStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:iconStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};

var Icon = function Icon(props) {
  // Font Awesome animations are passed via classnames
  var customAnimation = !isFAAnimation(props.animation) ? props.animation : undefined;
  var iconClasses = ['fa', "fa-".concat(props.icon), props.size && "fa-".concat(props.size), isFAAnimation(props.animation) && "fa-".concat(props.animation)];
  return jsx("i", {
    "data-testid": "".concat(props.icon, "-icon"),
    css: iconStyles({
      color: props.color,
      customAnimation: customAnimation
    }),
    className: classNames(iconClasses),
    "aria-label": props.label,
    "aria-hidden": !props.label,
    role: "img"
  });
};
var templateObject_1;

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var infoBoxStyles = function infoBoxStyles(_a) {
  var infoType = _a.infoType;
  var colorMap = {
    bg: {
      error: uiTokens.color.base.red.v50.value,
      success: uiTokens.color.base.green.v50.value,
      warning: uiTokens.color.base.yellow.v50.value,
      info: uiTokens.color.base.blue.v50.value
    },
    text: {
      error: uiTokens.color.base.red.v500.value,
      success: uiTokens.color.base.green.v500.value,
      warning: uiTokens.color.base.red.v500.value,
      info: uiTokens.color.base.blue.v500.value
    }
  };
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css({
      padding: '16px 24px',
      backgroundColor: colorMap.bg[infoType],
      color: colorMap.text[infoType],
      display: 'flex',
      alignItems: 'center'
    }, process.env.NODE_ENV === "production" ? "" : ";label:infoBoxStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:infoBoxStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};

var infoBoxIconStyles = process.env.NODE_ENV === "production" ? {
  name: "1cpgvw2",
  styles: "display:inline-block;margin-right:16px"
} : {
  name: "1t7vgp7-infoBoxIconStyles",
  styles: "display:inline-block;margin-right:16px;label:infoBoxIconStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
};
var infoBoxMsgStyles =
/*#__PURE__*/

/*#__PURE__*/
css({
  fontWeight: uiTokens.font.h100.weight.value
}, process.env.NODE_ENV === "production" ? "" : ";label:infoBoxMsgStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:infoBoxMsgStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluZm9Cb3gudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQStCdUIiLCJmaWxlIjoiSW5mb0JveC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcclxuaW1wb3J0IHRva2VucyBmcm9tICdAZmxleGUvdWktdG9rZW5zJztcclxuaW1wb3J0IEljb24gZnJvbSAnLi4vSWNvbi9JY29uJztcclxudmFyIGluZm9Cb3hTdHlsZXMgPSBmdW5jdGlvbiAoX2EpIHtcclxuICAgIHZhciBpbmZvVHlwZSA9IF9hLmluZm9UeXBlO1xyXG4gICAgdmFyIGNvbG9yTWFwID0ge1xyXG4gICAgICAgIGJnOiB7XHJcbiAgICAgICAgICAgIGVycm9yOiB0b2tlbnMuY29sb3IuYmFzZS5yZWQudjUwLnZhbHVlLFxyXG4gICAgICAgICAgICBzdWNjZXNzOiB0b2tlbnMuY29sb3IuYmFzZS5ncmVlbi52NTAudmFsdWUsXHJcbiAgICAgICAgICAgIHdhcm5pbmc6IHRva2Vucy5jb2xvci5iYXNlLnllbGxvdy52NTAudmFsdWUsXHJcbiAgICAgICAgICAgIGluZm86IHRva2Vucy5jb2xvci5iYXNlLmJsdWUudjUwLnZhbHVlXHJcbiAgICAgICAgfSxcclxuICAgICAgICB0ZXh0OiB7XHJcbiAgICAgICAgICAgIGVycm9yOiB0b2tlbnMuY29sb3IuYmFzZS5yZWQudjUwMC52YWx1ZSxcclxuICAgICAgICAgICAgc3VjY2VzczogdG9rZW5zLmNvbG9yLmJhc2UuZ3JlZW4udjUwMC52YWx1ZSxcclxuICAgICAgICAgICAgd2FybmluZzogdG9rZW5zLmNvbG9yLmJhc2UucmVkLnY1MDAudmFsdWUsXHJcbiAgICAgICAgICAgIGluZm86IHRva2Vucy5jb2xvci5iYXNlLmJsdWUudjUwMC52YWx1ZVxyXG4gICAgICAgIH1cclxuICAgIH07XHJcbiAgICByZXR1cm4gY3NzKHtcclxuICAgICAgICBwYWRkaW5nOiAnMTZweCAyNHB4JyxcclxuICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IGNvbG9yTWFwLmJnW2luZm9UeXBlXSxcclxuICAgICAgICBjb2xvcjogY29sb3JNYXAudGV4dFtpbmZvVHlwZV0sXHJcbiAgICAgICAgZGlzcGxheTogJ2ZsZXgnLFxyXG4gICAgICAgIGFsaWduSXRlbXM6ICdjZW50ZXInXHJcbiAgICB9KTtcclxufTtcclxudmFyIGluZm9Cb3hJY29uU3R5bGVzID0gY3NzKHtcclxuICAgIGRpc3BsYXk6ICdpbmxpbmUtYmxvY2snLFxyXG4gICAgbWFyZ2luUmlnaHQ6ICcxNnB4J1xyXG59KTtcclxudmFyIGluZm9Cb3hNc2dTdHlsZXMgPSBjc3Moe1xyXG4gICAgZm9udFdlaWdodDogdG9rZW5zLmZvbnQuaDEwMC53ZWlnaHQudmFsdWVcclxufSk7XHJcbnZhciBjaGlsZHJlblN0eWxlcyA9IGNzcyh7XHJcbiAgICBtYXJnaW5MZWZ0OiAnOHB4J1xyXG59KTtcclxudmFyIEluZm9Cb3ggPSBmdW5jdGlvbiAocHJvcHMpIHtcclxuICAgIHZhciBpY29uTWFwID0ge1xyXG4gICAgICAgIGVycm9yOiAndGltZXMtY2lyY2xlJyxcclxuICAgICAgICBzdWNjZXNzOiAnY2hlY2stY2lyY2xlJyxcclxuICAgICAgICB3YXJuaW5nOiAnZXhjbGFtYXRpb24tY2lyY2xlJyxcclxuICAgICAgICBpbmZvOiAnaW5mby1jaXJjbGUnXHJcbiAgICB9O1xyXG4gICAgcmV0dXJuIChqc3goXCJkaXZcIiwgeyByb2xlOiBcImFsZXJ0XCIsIGNzczogaW5mb0JveFN0eWxlcyh7IGluZm9UeXBlOiBwcm9wcy5pbmZvVHlwZSB9KSwgXCJkYXRhLXRlc3RpZFwiOiBcImluZm8tYm94LWNvbXBvbmVudC1cIi5jb25jYXQocHJvcHMuaW5mb1R5cGUpIH0sXHJcbiAgICAgICAganN4KFwiZGl2XCIsIHsgY3NzOiBpbmZvQm94SWNvblN0eWxlcyB9LFxyXG4gICAgICAgICAgICBqc3goSWNvbiwgeyBpY29uOiBpY29uTWFwW3Byb3BzLmluZm9UeXBlXSwgc2l6ZTogXCIyeFwiIH0pKSxcclxuICAgICAgICBqc3goXCJzcGFuXCIsIHsgY3NzOiBpbmZvQm94TXNnU3R5bGVzIH0sIHByb3BzLmluZm8pLFxyXG4gICAgICAgIHByb3BzLmNoaWxkcmVuICYmIChqc3goXCJzcGFuXCIsIHsgY3NzOiBjaGlsZHJlblN0eWxlcywgXCJkYXRhLXRlc3RpZFwiOiBcImluZm8tYm94LWNoaWxkcmVuLVwiLmNvbmNhdChwcm9wcy5pbmZvVHlwZSkgfSwgcHJvcHMuY2hpbGRyZW4pKSkpO1xyXG59O1xyXG5leHBvcnQgZGVmYXVsdCBJbmZvQm94O1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1JbmZvQm94LmpzLm1hcCJdfQ== */");
var childrenStyles = process.env.NODE_ENV === "production" ? {
  name: "1q4vxyr",
  styles: "margin-left:8px"
} : {
  name: "17mh5if-childrenStyles",
  styles: "margin-left:8px;label:childrenStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
};

var InfoBox = function InfoBox(props) {
  var iconMap = {
    error: 'times-circle',
    success: 'check-circle',
    warning: 'exclamation-circle',
    info: 'info-circle'
  };
  return jsx("div", {
    role: "alert",
    css: infoBoxStyles({
      infoType: props.infoType
    }),
    "data-testid": "info-box-component-".concat(props.infoType)
  }, jsx("div", {
    css: infoBoxIconStyles
  }, jsx(Icon, {
    icon: iconMap[props.infoType],
    size: "2x"
  })), jsx("span", {
    css: infoBoxMsgStyles
  }, props.info), props.children && jsx("span", {
    css: childrenStyles,
    "data-testid": "info-box-children-".concat(props.infoType)
  }, props.children));
};

/**
 * Displays an InfoBox with a table of detailed messages
 */

var DetailedInfoBox = function DetailedInfoBox(props) {
  var detailedInfoBoxWrapperStyles = function detailedInfoBoxWrapperStyles(_a) {
    var infoType = _a.infoType;
    var colorMap = {
      error: uiTokens.color.base.red.v100.value,
      success: uiTokens.color.base.green.v100.value,
      warning: uiTokens.color.base.yellow.v100.value,
      info: uiTokens.color.base.blue.v100.value
    };
    return (
      /*#__PURE__*/

      /*#__PURE__*/
      css({
        border: "1px solid ".concat(colorMap[infoType])
      }, process.env.NODE_ENV === "production" ? "" : ";label:detailedInfoBoxWrapperStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRldGFpbGVkSW5mb0JveC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZWUiLCJmaWxlIjoiRGV0YWlsZWRJbmZvQm94LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5pbXBvcnQgdG9rZW5zIGZyb20gJ0BmbGV4ZS91aS10b2tlbnMnO1xyXG5pbXBvcnQgSW5mb0JveCBmcm9tICcuLi9JbmZvQm94L0luZm9Cb3gnO1xyXG4vKipcclxuICogRGlzcGxheXMgYW4gSW5mb0JveCB3aXRoIGEgdGFibGUgb2YgZGV0YWlsZWQgbWVzc2FnZXNcclxuICovXHJcbnZhciBEZXRhaWxlZEluZm9Cb3ggPSBmdW5jdGlvbiAocHJvcHMpIHtcclxuICAgIHZhciBkZXRhaWxlZEluZm9Cb3hXcmFwcGVyU3R5bGVzID0gZnVuY3Rpb24gKF9hKSB7XHJcbiAgICAgICAgdmFyIGluZm9UeXBlID0gX2EuaW5mb1R5cGU7XHJcbiAgICAgICAgdmFyIGNvbG9yTWFwID0ge1xyXG4gICAgICAgICAgICBlcnJvcjogdG9rZW5zLmNvbG9yLmJhc2UucmVkLnYxMDAudmFsdWUsXHJcbiAgICAgICAgICAgIHN1Y2Nlc3M6IHRva2Vucy5jb2xvci5iYXNlLmdyZWVuLnYxMDAudmFsdWUsXHJcbiAgICAgICAgICAgIHdhcm5pbmc6IHRva2Vucy5jb2xvci5iYXNlLnllbGxvdy52MTAwLnZhbHVlLFxyXG4gICAgICAgICAgICBpbmZvOiB0b2tlbnMuY29sb3IuYmFzZS5ibHVlLnYxMDAudmFsdWVcclxuICAgICAgICB9O1xyXG4gICAgICAgIHJldHVybiBjc3Moe1xyXG4gICAgICAgICAgICBib3JkZXI6IFwiMXB4IHNvbGlkIFwiLmNvbmNhdChjb2xvck1hcFtpbmZvVHlwZV0pXHJcbiAgICAgICAgfSk7XHJcbiAgICB9O1xyXG4gICAgdmFyIGRldGFpbGVkSW5mb0JveENoaWxkU3R5bGVzID0gY3NzKHtcclxuICAgICAgICBwYWRkaW5nOiBcIlwiLmNvbmNhdCh0b2tlbnMuc3BhY2luZy52MjAwLnZhbHVlLCBcInB4XCIpXHJcbiAgICB9KTtcclxuICAgIHJldHVybiAoanN4KFwiZGl2XCIsIHsgY3NzOiBkZXRhaWxlZEluZm9Cb3hXcmFwcGVyU3R5bGVzKHsgaW5mb1R5cGU6IHByb3BzLmluZm9UeXBlIH0pIH0sXHJcbiAgICAgICAganN4KEluZm9Cb3gsIHsgaW5mb1R5cGU6IHByb3BzLmluZm9UeXBlLCBpbmZvOiBwcm9wcy5pbmZvIH0pLFxyXG4gICAgICAgIGpzeChcImRpdlwiLCB7IGNzczogZGV0YWlsZWRJbmZvQm94Q2hpbGRTdHlsZXMgfSwgcHJvcHMuY2hpbGRyZW4pKSk7XHJcbn07XHJcbmV4cG9ydCBkZWZhdWx0IERldGFpbGVkSW5mb0JveDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9RGV0YWlsZWRJbmZvQm94LmpzLm1hcCJdfQ== */", process.env.NODE_ENV === "production" ? "" : ";label:detailedInfoBoxWrapperStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRldGFpbGVkSW5mb0JveC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZWUiLCJmaWxlIjoiRGV0YWlsZWRJbmZvQm94LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5pbXBvcnQgdG9rZW5zIGZyb20gJ0BmbGV4ZS91aS10b2tlbnMnO1xyXG5pbXBvcnQgSW5mb0JveCBmcm9tICcuLi9JbmZvQm94L0luZm9Cb3gnO1xyXG4vKipcclxuICogRGlzcGxheXMgYW4gSW5mb0JveCB3aXRoIGEgdGFibGUgb2YgZGV0YWlsZWQgbWVzc2FnZXNcclxuICovXHJcbnZhciBEZXRhaWxlZEluZm9Cb3ggPSBmdW5jdGlvbiAocHJvcHMpIHtcclxuICAgIHZhciBkZXRhaWxlZEluZm9Cb3hXcmFwcGVyU3R5bGVzID0gZnVuY3Rpb24gKF9hKSB7XHJcbiAgICAgICAgdmFyIGluZm9UeXBlID0gX2EuaW5mb1R5cGU7XHJcbiAgICAgICAgdmFyIGNvbG9yTWFwID0ge1xyXG4gICAgICAgICAgICBlcnJvcjogdG9rZW5zLmNvbG9yLmJhc2UucmVkLnYxMDAudmFsdWUsXHJcbiAgICAgICAgICAgIHN1Y2Nlc3M6IHRva2Vucy5jb2xvci5iYXNlLmdyZWVuLnYxMDAudmFsdWUsXHJcbiAgICAgICAgICAgIHdhcm5pbmc6IHRva2Vucy5jb2xvci5iYXNlLnllbGxvdy52MTAwLnZhbHVlLFxyXG4gICAgICAgICAgICBpbmZvOiB0b2tlbnMuY29sb3IuYmFzZS5ibHVlLnYxMDAudmFsdWVcclxuICAgICAgICB9O1xyXG4gICAgICAgIHJldHVybiBjc3Moe1xyXG4gICAgICAgICAgICBib3JkZXI6IFwiMXB4IHNvbGlkIFwiLmNvbmNhdChjb2xvck1hcFtpbmZvVHlwZV0pXHJcbiAgICAgICAgfSk7XHJcbiAgICB9O1xyXG4gICAgdmFyIGRldGFpbGVkSW5mb0JveENoaWxkU3R5bGVzID0gY3NzKHtcclxuICAgICAgICBwYWRkaW5nOiBcIlwiLmNvbmNhdCh0b2tlbnMuc3BhY2luZy52MjAwLnZhbHVlLCBcInB4XCIpXHJcbiAgICB9KTtcclxuICAgIHJldHVybiAoanN4KFwiZGl2XCIsIHsgY3NzOiBkZXRhaWxlZEluZm9Cb3hXcmFwcGVyU3R5bGVzKHsgaW5mb1R5cGU6IHByb3BzLmluZm9UeXBlIH0pIH0sXHJcbiAgICAgICAganN4KEluZm9Cb3gsIHsgaW5mb1R5cGU6IHByb3BzLmluZm9UeXBlLCBpbmZvOiBwcm9wcy5pbmZvIH0pLFxyXG4gICAgICAgIGpzeChcImRpdlwiLCB7IGNzczogZGV0YWlsZWRJbmZvQm94Q2hpbGRTdHlsZXMgfSwgcHJvcHMuY2hpbGRyZW4pKSk7XHJcbn07XHJcbmV4cG9ydCBkZWZhdWx0IERldGFpbGVkSW5mb0JveDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9RGV0YWlsZWRJbmZvQm94LmpzLm1hcCJdfQ== */")
    );
  };

  var detailedInfoBoxChildStyles =
  /*#__PURE__*/

  /*#__PURE__*/
  css({
    padding: "".concat(uiTokens.spacing.v200.value, "px")
  }, process.env.NODE_ENV === "production" ? "" : ";label:detailedInfoBoxChildStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRldGFpbGVkSW5mb0JveC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJxQyIsImZpbGUiOiJEZXRhaWxlZEluZm9Cb3gudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XHJcbmltcG9ydCB0b2tlbnMgZnJvbSAnQGZsZXhlL3VpLXRva2Vucyc7XHJcbmltcG9ydCBJbmZvQm94IGZyb20gJy4uL0luZm9Cb3gvSW5mb0JveCc7XHJcbi8qKlxyXG4gKiBEaXNwbGF5cyBhbiBJbmZvQm94IHdpdGggYSB0YWJsZSBvZiBkZXRhaWxlZCBtZXNzYWdlc1xyXG4gKi9cclxudmFyIERldGFpbGVkSW5mb0JveCA9IGZ1bmN0aW9uIChwcm9wcykge1xyXG4gICAgdmFyIGRldGFpbGVkSW5mb0JveFdyYXBwZXJTdHlsZXMgPSBmdW5jdGlvbiAoX2EpIHtcclxuICAgICAgICB2YXIgaW5mb1R5cGUgPSBfYS5pbmZvVHlwZTtcclxuICAgICAgICB2YXIgY29sb3JNYXAgPSB7XHJcbiAgICAgICAgICAgIGVycm9yOiB0b2tlbnMuY29sb3IuYmFzZS5yZWQudjEwMC52YWx1ZSxcclxuICAgICAgICAgICAgc3VjY2VzczogdG9rZW5zLmNvbG9yLmJhc2UuZ3JlZW4udjEwMC52YWx1ZSxcclxuICAgICAgICAgICAgd2FybmluZzogdG9rZW5zLmNvbG9yLmJhc2UueWVsbG93LnYxMDAudmFsdWUsXHJcbiAgICAgICAgICAgIGluZm86IHRva2Vucy5jb2xvci5iYXNlLmJsdWUudjEwMC52YWx1ZVxyXG4gICAgICAgIH07XHJcbiAgICAgICAgcmV0dXJuIGNzcyh7XHJcbiAgICAgICAgICAgIGJvcmRlcjogXCIxcHggc29saWQgXCIuY29uY2F0KGNvbG9yTWFwW2luZm9UeXBlXSlcclxuICAgICAgICB9KTtcclxuICAgIH07XHJcbiAgICB2YXIgZGV0YWlsZWRJbmZvQm94Q2hpbGRTdHlsZXMgPSBjc3Moe1xyXG4gICAgICAgIHBhZGRpbmc6IFwiXCIuY29uY2F0KHRva2Vucy5zcGFjaW5nLnYyMDAudmFsdWUsIFwicHhcIilcclxuICAgIH0pO1xyXG4gICAgcmV0dXJuIChqc3goXCJkaXZcIiwgeyBjc3M6IGRldGFpbGVkSW5mb0JveFdyYXBwZXJTdHlsZXMoeyBpbmZvVHlwZTogcHJvcHMuaW5mb1R5cGUgfSkgfSxcclxuICAgICAgICBqc3goSW5mb0JveCwgeyBpbmZvVHlwZTogcHJvcHMuaW5mb1R5cGUsIGluZm86IHByb3BzLmluZm8gfSksXHJcbiAgICAgICAganN4KFwiZGl2XCIsIHsgY3NzOiBkZXRhaWxlZEluZm9Cb3hDaGlsZFN0eWxlcyB9LCBwcm9wcy5jaGlsZHJlbikpKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgRGV0YWlsZWRJbmZvQm94O1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1EZXRhaWxlZEluZm9Cb3guanMubWFwIl19 */", process.env.NODE_ENV === "production" ? "" : ";label:detailedInfoBoxChildStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRldGFpbGVkSW5mb0JveC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJxQyIsImZpbGUiOiJEZXRhaWxlZEluZm9Cb3gudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XHJcbmltcG9ydCB0b2tlbnMgZnJvbSAnQGZsZXhlL3VpLXRva2Vucyc7XHJcbmltcG9ydCBJbmZvQm94IGZyb20gJy4uL0luZm9Cb3gvSW5mb0JveCc7XHJcbi8qKlxyXG4gKiBEaXNwbGF5cyBhbiBJbmZvQm94IHdpdGggYSB0YWJsZSBvZiBkZXRhaWxlZCBtZXNzYWdlc1xyXG4gKi9cclxudmFyIERldGFpbGVkSW5mb0JveCA9IGZ1bmN0aW9uIChwcm9wcykge1xyXG4gICAgdmFyIGRldGFpbGVkSW5mb0JveFdyYXBwZXJTdHlsZXMgPSBmdW5jdGlvbiAoX2EpIHtcclxuICAgICAgICB2YXIgaW5mb1R5cGUgPSBfYS5pbmZvVHlwZTtcclxuICAgICAgICB2YXIgY29sb3JNYXAgPSB7XHJcbiAgICAgICAgICAgIGVycm9yOiB0b2tlbnMuY29sb3IuYmFzZS5yZWQudjEwMC52YWx1ZSxcclxuICAgICAgICAgICAgc3VjY2VzczogdG9rZW5zLmNvbG9yLmJhc2UuZ3JlZW4udjEwMC52YWx1ZSxcclxuICAgICAgICAgICAgd2FybmluZzogdG9rZW5zLmNvbG9yLmJhc2UueWVsbG93LnYxMDAudmFsdWUsXHJcbiAgICAgICAgICAgIGluZm86IHRva2Vucy5jb2xvci5iYXNlLmJsdWUudjEwMC52YWx1ZVxyXG4gICAgICAgIH07XHJcbiAgICAgICAgcmV0dXJuIGNzcyh7XHJcbiAgICAgICAgICAgIGJvcmRlcjogXCIxcHggc29saWQgXCIuY29uY2F0KGNvbG9yTWFwW2luZm9UeXBlXSlcclxuICAgICAgICB9KTtcclxuICAgIH07XHJcbiAgICB2YXIgZGV0YWlsZWRJbmZvQm94Q2hpbGRTdHlsZXMgPSBjc3Moe1xyXG4gICAgICAgIHBhZGRpbmc6IFwiXCIuY29uY2F0KHRva2Vucy5zcGFjaW5nLnYyMDAudmFsdWUsIFwicHhcIilcclxuICAgIH0pO1xyXG4gICAgcmV0dXJuIChqc3goXCJkaXZcIiwgeyBjc3M6IGRldGFpbGVkSW5mb0JveFdyYXBwZXJTdHlsZXMoeyBpbmZvVHlwZTogcHJvcHMuaW5mb1R5cGUgfSkgfSxcclxuICAgICAgICBqc3goSW5mb0JveCwgeyBpbmZvVHlwZTogcHJvcHMuaW5mb1R5cGUsIGluZm86IHByb3BzLmluZm8gfSksXHJcbiAgICAgICAganN4KFwiZGl2XCIsIHsgY3NzOiBkZXRhaWxlZEluZm9Cb3hDaGlsZFN0eWxlcyB9LCBwcm9wcy5jaGlsZHJlbikpKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgRGV0YWlsZWRJbmZvQm94O1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1EZXRhaWxlZEluZm9Cb3guanMubWFwIl19 */");
  return jsx("div", {
    css: detailedInfoBoxWrapperStyles({
      infoType: props.infoType
    })
  }, jsx(InfoBox, {
    infoType: props.infoType,
    info: props.info
  }), jsx("div", {
    css: detailedInfoBoxChildStyles
  }, props.children));
};

var EmailAddressLink = function EmailAddressLink(props) {
  var hostname = window.location.hostname;
  var start = Math.max(0, hostname.indexOf('flexe'));
  var domain = hostname.slice(start);
  var address = "".concat(props.localPart, "@").concat(domain);

  if (props.className !== undefined) {
    return /*#__PURE__*/React__default.createElement("a", {
      className: props.className,
      href: "mailto:".concat(address)
    }, address);
  }

  return /*#__PURE__*/React__default.createElement("a", {
    href: "mailto:".concat(address)
  }, address);
};

let updateQueue = makeQueue();
const raf = fn => schedule(fn, updateQueue);
let writeQueue = makeQueue();

raf.write = fn => schedule(fn, writeQueue);

let onStartQueue = makeQueue();

raf.onStart = fn => schedule(fn, onStartQueue);

let onFrameQueue = makeQueue();

raf.onFrame = fn => schedule(fn, onFrameQueue);

let onFinishQueue = makeQueue();

raf.onFinish = fn => schedule(fn, onFinishQueue);

let timeouts = [];

raf.setTimeout = (handler, ms) => {
  let time = raf.now() + ms;

  let cancel = () => {
    let i = timeouts.findIndex(t => t.cancel == cancel);
    if (~i) timeouts.splice(i, 1);
    pendingCount -= ~i ? 1 : 0;
  };

  let timeout = {
    time,
    handler,
    cancel
  };
  timeouts.splice(findTimeout(time), 0, timeout);
  pendingCount += 1;
  start();
  return timeout;
};

let findTimeout = time => ~(~timeouts.findIndex(t => t.time > time) || ~timeouts.length);

raf.cancel = fn => {
  onStartQueue.delete(fn);
  onFrameQueue.delete(fn);
  updateQueue.delete(fn);
  writeQueue.delete(fn);
  onFinishQueue.delete(fn);
};

raf.sync = fn => {
  sync = true;
  raf.batchedUpdates(fn);
  sync = false;
};

raf.throttle = fn => {
  let lastArgs;

  function queuedFn() {
    try {
      fn(...lastArgs);
    } finally {
      lastArgs = null;
    }
  }

  function throttled(...args) {
    lastArgs = args;
    raf.onStart(queuedFn);
  }

  throttled.handler = fn;

  throttled.cancel = () => {
    onStartQueue.delete(queuedFn);
    lastArgs = null;
  };

  return throttled;
};

let nativeRaf = typeof window != 'undefined' ? window.requestAnimationFrame : () => {};

raf.use = impl => nativeRaf = impl;

raf.now = typeof performance != 'undefined' ? () => performance.now() : Date.now;

raf.batchedUpdates = fn => fn();

raf.catch = console.error;
raf.frameLoop = 'always';

raf.advance = () => {
  if (raf.frameLoop !== 'demand') {
    console.warn('Cannot call the manual advancement of rafz whilst frameLoop is not set as demand');
  } else {
    update();
  }
};

let ts = -1;
let pendingCount = 0;
let sync = false;

function schedule(fn, queue) {
  if (sync) {
    queue.delete(fn);
    fn(0);
  } else {
    queue.add(fn);
    start();
  }
}

function start() {
  if (ts < 0) {
    ts = 0;

    if (raf.frameLoop !== 'demand') {
      nativeRaf(loop);
    }
  }
}

function stop() {
  ts = -1;
}

function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update);
  }
}

function update() {
  let prevTs = ts;
  ts = raf.now();
  let count = findTimeout(ts);

  if (count) {
    eachSafely(timeouts.splice(0, count), t => t.handler());
    pendingCount -= count;
  }

  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();

  if (!pendingCount) {
    stop();
  }
}

function makeQueue() {
  let next = new Set();
  let current = next;
  return {
    add(fn) {
      pendingCount += current == next && !next.has(fn) ? 1 : 0;
      next.add(fn);
    },

    delete(fn) {
      pendingCount -= current == next && next.has(fn) ? 1 : 0;
      return next.delete(fn);
    },

    flush(arg) {
      if (current.size) {
        next = new Set();
        pendingCount -= current.size;
        eachSafely(current, fn => fn(arg) && next.add(fn));
        pendingCount += next.size;
        current = next;
      }
    }

  };
}

function eachSafely(values, each) {
  values.forEach(value => {
    try {
      each(value);
    } catch (e) {
      raf.catch(e);
    }
  });
}

function noop$1() {}
const defineHidden = (obj, key, value) => Object.defineProperty(obj, key, {
  value,
  writable: true,
  configurable: true
});
const is = {
  arr: Array.isArray,
  obj: a => !!a && a.constructor.name === 'Object',
  fun: a => typeof a === 'function',
  str: a => typeof a === 'string',
  num: a => typeof a === 'number',
  und: a => a === undefined
};
function isEqual(a, b) {
  if (is.arr(a)) {
    if (!is.arr(b) || a.length !== b.length) return false;

    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }

    return true;
  }

  return a === b;
}
const each = (obj, fn) => obj.forEach(fn);
function eachProp(obj, fn, ctx) {
  if (is.arr(obj)) {
    for (let i = 0; i < obj.length; i++) {
      fn.call(ctx, obj[i], `${i}`);
    }

    return;
  }

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn.call(ctx, obj[key], key);
    }
  }
}
const toArray = a => is.und(a) ? [] : is.arr(a) ? a : [a];
function flush(queue, iterator) {
  if (queue.size) {
    const items = Array.from(queue);
    queue.clear();
    each(items, iterator);
  }
}
const flushCalls = (queue, ...args) => flush(queue, fn => fn(...args));
const isSSR = () => typeof window === 'undefined' || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);

let createStringInterpolator$1;
let to;
let colors$1 = null;
let skipAnimation = false;
let willAdvance = noop$1;
const assign = globals => {
  if (globals.to) to = globals.to;
  if (globals.now) raf.now = globals.now;
  if (globals.colors !== undefined) colors$1 = globals.colors;
  if (globals.skipAnimation != null) skipAnimation = globals.skipAnimation;
  if (globals.createStringInterpolator) createStringInterpolator$1 = globals.createStringInterpolator;
  if (globals.requestAnimationFrame) raf.use(globals.requestAnimationFrame);
  if (globals.batchedUpdates) raf.batchedUpdates = globals.batchedUpdates;
  if (globals.willAdvance) willAdvance = globals.willAdvance;
  if (globals.frameLoop) raf.frameLoop = globals.frameLoop;
};

var globals = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get createStringInterpolator () { return createStringInterpolator$1; },
  get to () { return to; },
  get colors () { return colors$1; },
  get skipAnimation () { return skipAnimation; },
  get willAdvance () { return willAdvance; },
  assign: assign
});

const startQueue = new Set();
let currentFrame = [];
let prevFrame = [];
let priority = 0;
const frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },

  start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      raf(advance);
    }
  },

  advance,

  sort(animation) {
    if (priority) {
      raf.onFrame(() => frameLoop.sort(animation));
    } else {
      const prevIndex = currentFrame.indexOf(animation);

      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },

  clear() {
    currentFrame = [];
    startQueue.clear();
  }

};

function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  raf(advance);
}

function startSafely(animation) {
  if (!currentFrame.includes(animation)) startUnsafely(animation);
}

function startUnsafely(animation) {
  currentFrame.splice(findIndex(currentFrame, other => other.priority > animation.priority), 0, animation);
}

function advance(dt) {
  const nextFrame = prevFrame;

  for (let i = 0; i < currentFrame.length; i++) {
    const animation = currentFrame[i];
    priority = animation.priority;

    if (!animation.idle) {
      willAdvance(animation);
      animation.advance(dt);

      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }

  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}

function findIndex(arr, test) {
  const index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

const colors = {
  transparent: 0x00000000,
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff
};

const NUMBER = '[-+]?\\d*\\.?\\d+';
const PERCENTAGE = NUMBER + '%';

function call(...parts) {
  return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
}

const rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
const rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
const hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
const hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
const hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex6 = /^#([0-9a-fA-F]{6})$/;
const hex8 = /^#([0-9a-fA-F]{8})$/;

function normalizeColor(color) {
  let match;

  if (typeof color === 'number') {
    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
  }

  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;

  if (colors$1 && colors$1[color] !== undefined) {
    return colors$1[color];
  }

  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | 0x000000ff) >>> 0;
  }

  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | parse1(match[4])) >>> 0;
  }

  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + 'ff', 16) >>> 0;
  }

  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
  }

  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | 0x000000ff) >>> 0;
  }

  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | parse1(match[4])) >>> 0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0) return 0;
  if (int > 255) return 255;
  return int;
}

function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}

function parse1(str) {
  const num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  const int = parseFloat(str);
  if (int < 0) return 0;
  if (int > 100) return 1;
  return int / 100;
}

function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  let r = (int32Color & 0xff000000) >>> 24;
  let g = (int32Color & 0x00ff0000) >>> 16;
  let b = (int32Color & 0x0000ff00) >>> 8;
  let a = (int32Color & 0x000000ff) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

const createInterpolator = (range, output, extrapolate) => {
  if (is.fun(range)) {
    return range;
  }

  if (is.arr(range)) {
    return createInterpolator({
      range,
      output: output,
      extrapolate
    });
  }

  if (is.str(range.output[0])) {
    return createStringInterpolator$1(range);
  }

  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
  const extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';

  const easing = config.easing || (t => t);

  return input => {
    const range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
};

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input;

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
  }

  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;

  return i - 1;
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

const $get = Symbol.for('FluidValue.get');
const $observers = Symbol.for('FluidValue.observers');

const hasFluidValue = arg => Boolean(arg && arg[$get]);

const getFluidValue = arg => arg && arg[$get] ? arg[$get]() : arg;

const getFluidObservers = target => target[$observers] || null;

function callFluidObserver(observer, event) {
  if (observer.eventObserved) {
    observer.eventObserved(event);
  } else {
    observer(event);
  }
}

function callFluidObservers(target, event) {
  let observers = target[$observers];

  if (observers) {
    observers.forEach(observer => {
      callFluidObserver(observer, event);
    });
  }
}

class FluidValue {
  constructor(get) {
    this[$get] = void 0;
    this[$observers] = void 0;

    if (!get && !(get = this.get)) {
      throw Error('Unknown getter');
    }

    setFluidGetter(this, get);
  }

}

const setFluidGetter = (target, get) => setHidden(target, $get, get);

function addFluidObserver(target, observer) {
  if (target[$get]) {
    let observers = target[$observers];

    if (!observers) {
      setHidden(target, $observers, observers = new Set());
    }

    if (!observers.has(observer)) {
      observers.add(observer);

      if (target.observerAdded) {
        target.observerAdded(observers.size, observer);
      }
    }
  }

  return observer;
}

function removeFluidObserver(target, observer) {
  let observers = target[$observers];

  if (observers && observers.has(observer)) {
    const count = observers.size - 1;

    if (count) {
      observers.delete(observer);
    } else {
      target[$observers] = null;
    }

    if (target.observerRemoved) {
      target.observerRemoved(count, observer);
    }
  }
}

const setHidden = (target, key, value) => Object.defineProperty(target, key, {
  value,
  writable: true,
  configurable: true
});

const numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
const unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, 'i');
const rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
const cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

const variableToRgba = input => {
  const [token, fallback] = parseCSSVariable(input);

  if (!token || isSSR()) {
    return input;
  }

  const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);

  if (value) {
    return value.trim();
  } else if (fallback && fallback.startsWith('--')) {
    const _value = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);

    if (_value) {
      return _value;
    } else {
      return input;
    }
  } else if (fallback && cssVariableRegex.test(fallback)) {
    return variableToRgba(fallback);
  } else if (fallback) {
    return fallback;
  }

  return input;
};

const parseCSSVariable = current => {
  const match = cssVariableRegex.exec(current);
  if (!match) return [,];
  const [, token, fallback] = match;
  return [token, fallback];
};

let namedColorRegex;

const rgbaRound = (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;

const createStringInterpolator = config => {
  if (!namedColorRegex) namedColorRegex = colors$1 ? new RegExp(`(${Object.keys(colors$1).join('|')})(?!\\w)`, 'g') : /^\b$/;
  const output = config.output.map(value => {
    return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
  });
  const keyframes = output.map(value => value.match(numberRegex).map(Number));
  const outputRanges = keyframes[0].map((_, i) => keyframes.map(values => {
    if (!(i in values)) {
      throw Error('The arity of each "output" value must be equal');
    }

    return values[i];
  }));
  const interpolators = outputRanges.map(output => createInterpolator(_extends$2({}, config, {
    output
  })));
  return input => {
    var _output$find;

    const missingUnit = !unitRegex.test(output[0]) && ((_output$find = output.find(value => unitRegex.test(value))) == null ? void 0 : _output$find.replace(numberRegex, ''));
    let i = 0;
    return output[0].replace(numberRegex, () => `${interpolators[i++](input)}${missingUnit || ''}`).replace(rgbaRegex, rgbaRound);
  };
};

const prefix$1 = 'react-spring: ';

const once = fn => {
  const func = fn;
  let called = false;

  if (typeof func != 'function') {
    throw new TypeError(`${prefix$1}once requires a function parameter`);
  }

  return (...args) => {
    if (!called) {
      func(...args);
      called = true;
    }
  };
};

const warnInterpolate = once(console.warn);
function deprecateInterpolate() {
  warnInterpolate(`${prefix$1}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
const warnDirectCall = once(console.warn);
function deprecateDirectCall() {
  warnDirectCall(`${prefix$1}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}

function isAnimatedString(value) {
  return is.str(value) && (value[0] == '#' || /\d/.test(value) || !isSSR() && cssVariableRegex.test(value) || value in (colors$1 || {}));
}

const useLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

const useIsMounted = () => {
  const isMounted = useRef(false);
  useLayoutEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};

function useForceUpdate() {
  const update = useState()[1];
  const isMounted = useIsMounted();
  return () => {
    if (isMounted.current) {
      update(Math.random());
    }
  };
}

function useMemoOne(getResult, inputs) {
  const [initial] = useState(() => ({
    inputs,
    result: getResult()
  }));
  const committed = useRef();
  const prevCache = committed.current;
  let cache = prevCache;

  if (cache) {
    const useCache = Boolean(inputs && cache.inputs && areInputsEqual(inputs, cache.inputs));

    if (!useCache) {
      cache = {
        inputs,
        result: getResult()
      };
    }
  } else {
    cache = initial;
  }

  useEffect(() => {
    committed.current = cache;

    if (prevCache == initial) {
      initial.inputs = initial.result = undefined;
    }
  }, [cache]);
  return cache.result;
}

function areInputsEqual(next, prev) {
  if (next.length !== prev.length) {
    return false;
  }

  for (let i = 0; i < next.length; i++) {
    if (next[i] !== prev[i]) {
      return false;
    }
  }

  return true;
}

const useOnce = effect => useEffect(effect, emptyDeps);
const emptyDeps = [];

function usePrev(value) {
  const prevRef = useRef();
  useEffect(() => {
    prevRef.current = value;
  });
  return prevRef.current;
}

const $node = Symbol.for('Animated:node');
const isAnimated = value => !!value && value[$node] === value;
const getAnimated = owner => owner && owner[$node];
const setAnimated = (owner, node) => defineHidden(owner, $node, node);
const getPayload = owner => owner && owner[$node] && owner[$node].getPayload();
class Animated {
  constructor() {
    this.payload = void 0;
    setAnimated(this, this);
  }

  getPayload() {
    return this.payload || [];
  }

}

class AnimatedValue extends Animated {
  constructor(_value) {
    super();
    this.done = true;
    this.elapsedTime = void 0;
    this.lastPosition = void 0;
    this.lastVelocity = void 0;
    this.v0 = void 0;
    this.durationProgress = 0;
    this._value = _value;

    if (is.num(this._value)) {
      this.lastPosition = this._value;
    }
  }

  static create(value) {
    return new AnimatedValue(value);
  }

  getPayload() {
    return [this];
  }

  getValue() {
    return this._value;
  }

  setValue(value, step) {
    if (is.num(value)) {
      this.lastPosition = value;

      if (step) {
        value = Math.round(value / step) * step;

        if (this.done) {
          this.lastPosition = value;
        }
      }
    }

    if (this._value === value) {
      return false;
    }

    this._value = value;
    return true;
  }

  reset() {
    const {
      done
    } = this;
    this.done = false;

    if (is.num(this._value)) {
      this.elapsedTime = 0;
      this.durationProgress = 0;
      this.lastPosition = this._value;
      if (done) this.lastVelocity = null;
      this.v0 = null;
    }
  }

}

class AnimatedString extends AnimatedValue {
  constructor(value) {
    super(0);
    this._string = null;
    this._toString = void 0;
    this._toString = createInterpolator({
      output: [value, value]
    });
  }

  static create(value) {
    return new AnimatedString(value);
  }

  getValue() {
    let value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }

  setValue(value) {
    if (is.str(value)) {
      if (value == this._string) {
        return false;
      }

      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }

    return true;
  }

  reset(goal) {
    if (goal) {
      this._toString = createInterpolator({
        output: [this.getValue(), goal]
      });
    }

    this._value = 0;
    super.reset();
  }

}

const TreeContext = {
  dependencies: null
};

class AnimatedObject extends Animated {
  constructor(source) {
    super();
    this.source = source;
    this.setValue(source);
  }

  getValue(animated) {
    const values = {};
    eachProp(this.source, (source, key) => {
      if (isAnimated(source)) {
        values[key] = source.getValue(animated);
      } else if (hasFluidValue(source)) {
        values[key] = getFluidValue(source);
      } else if (!animated) {
        values[key] = source;
      }
    });
    return values;
  }

  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }

  reset() {
    if (this.payload) {
      each(this.payload, node => node.reset());
    }
  }

  _makePayload(source) {
    if (source) {
      const payload = new Set();
      eachProp(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }

  _addToPayload(source) {
    if (TreeContext.dependencies && hasFluidValue(source)) {
      TreeContext.dependencies.add(source);
    }

    const payload = getPayload(source);

    if (payload) {
      each(payload, node => this.add(node));
    }
  }

}

class AnimatedArray extends AnimatedObject {
  constructor(source) {
    super(source);
  }

  static create(source) {
    return new AnimatedArray(source);
  }

  getValue() {
    return this.source.map(node => node.getValue());
  }

  setValue(source) {
    const payload = this.getPayload();

    if (source.length == payload.length) {
      return payload.map((node, i) => node.setValue(source[i])).some(Boolean);
    }

    super.setValue(source.map(makeAnimated));
    return true;
  }

}

function makeAnimated(value) {
  const nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}

function getAnimatedType(value) {
  const parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

const withAnimated = (Component, host) => {
  const hasInstance = !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
  return forwardRef$2((givenProps, givenRef) => {
    const instanceRef = useRef(null);
    const ref = hasInstance && useCallback(value => {
      instanceRef.current = updateRef(givenRef, value);
    }, [givenRef]);
    const [props, deps] = getAnimatedState(givenProps, host);
    const forceUpdate = useForceUpdate();

    const callback = () => {
      const instance = instanceRef.current;

      if (hasInstance && !instance) {
        return;
      }

      const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;

      if (didUpdate === false) {
        forceUpdate();
      }
    };

    const observer = new PropsObserver(callback, deps);
    const observerRef = useRef();
    useLayoutEffect(() => {
      observerRef.current = observer;
      each(deps, dep => addFluidObserver(dep, observer));
      return () => {
        if (observerRef.current) {
          each(observerRef.current.deps, dep => removeFluidObserver(dep, observerRef.current));
          raf.cancel(observerRef.current.update);
        }
      };
    });
    useEffect(callback, []);
    useOnce(() => () => {
      const observer = observerRef.current;
      each(observer.deps, dep => removeFluidObserver(dep, observer));
    });
    const usedProps = host.getComponentProps(props.getValue());
    return React.createElement(Component, _extends$1({}, usedProps, {
      ref: ref
    }));
  });
};

class PropsObserver {
  constructor(update, deps) {
    this.update = update;
    this.deps = deps;
  }

  eventObserved(event) {
    if (event.type == 'change') {
      raf.write(this.update);
    }
  }

}

function getAnimatedState(props, host) {
  const dependencies = new Set();
  TreeContext.dependencies = dependencies;
  if (props.style) props = _extends$1({}, props, {
    style: host.createAnimatedStyle(props.style)
  });
  props = new AnimatedObject(props);
  TreeContext.dependencies = null;
  return [props, dependencies];
}

function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref)) ref(value);else ref.current = value;
  }

  return value;
}

const cacheKey = Symbol.for('AnimatedComponent');
const createHost = (components, {
  applyAnimatedValues: _applyAnimatedValues = () => false,
  createAnimatedStyle: _createAnimatedStyle = style => new AnimatedObject(style),
  getComponentProps: _getComponentProps = props => props
} = {}) => {
  const hostConfig = {
    applyAnimatedValues: _applyAnimatedValues,
    createAnimatedStyle: _createAnimatedStyle,
    getComponentProps: _getComponentProps
  };

  const animated = Component => {
    const displayName = getDisplayName(Component) || 'Anonymous';

    if (is.str(Component)) {
      Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }

    Component.displayName = `Animated(${displayName})`;
    return Component;
  };

  eachProp(components, (Component, key) => {
    if (is.arr(components)) {
      key = getDisplayName(Component);
    }

    animated[key] = animated(Component);
  });
  return {
    animated
  };
};

const getDisplayName = arg => is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function callProp(value, ...args) {
  return is.fun(value) ? value(...args) : value;
}
const matchProp = (value, key) => value === true || !!(key && value && (is.fun(value) ? value(key) : toArray(value).includes(key)));
const resolveProp = (prop, key) => is.obj(prop) ? key && prop[key] : prop;
const getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : undefined;

const noopTransform = value => value;

const getDefaultProps = (props, transform = noopTransform) => {
  let keys = DEFAULT_PROPS;

  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }

  const defaults = {};

  for (const key of keys) {
    const value = transform(props[key], key);

    if (!is.und(value)) {
      defaults[key] = value;
    }
  }

  return defaults;
};
const DEFAULT_PROPS = ['config', 'onProps', 'onStart', 'onChange', 'onPause', 'onResume', 'onRest'];
const RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  keys: 1,
  callId: 1,
  parentId: 1
};

function getForwardProps(props) {
  const forward = {};
  let count = 0;
  eachProp(props, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });

  if (count) {
    return forward;
  }
}

function inferTo(props) {
  const to = getForwardProps(props);

  if (to) {
    const out = {
      to
    };
    eachProp(props, (val, key) => key in to || (out[key] = val));
    return out;
  }

  return _extends({}, props);
}
function computeGoal(value) {
  value = getFluidValue(value);
  return is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? globals.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function hasProps(props) {
  for (const _ in props) return true;

  return false;
}
function isAsyncTo(to) {
  return is.fun(to) || is.arr(to) && is.obj(to[0]);
}
function detachRefs(ctrl, ref) {
  var _ctrl$ref;

  (_ctrl$ref = ctrl.ref) == null ? void 0 : _ctrl$ref.delete(ctrl);
  ref == null ? void 0 : ref.delete(ctrl);
}
function replaceRef(ctrl, ref) {
  if (ref && ctrl.ref !== ref) {
    var _ctrl$ref2;

    (_ctrl$ref2 = ctrl.ref) == null ? void 0 : _ctrl$ref2.delete(ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
}

const config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};
const c1 = 1.70158;
const c2 = c1 * 1.525;
const c3 = c1 + 1;
const c4 = 2 * Math.PI / 3;
const c5 = 2 * Math.PI / 4.5;

const bounceOut = x => {
  const n1 = 7.5625;
  const d1 = 2.75;

  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  } else {
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  }
};

const easings = {
  linear: x => x,
  easeInQuad: x => x * x,
  easeOutQuad: x => 1 - (1 - x) * (1 - x),
  easeInOutQuad: x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
  easeInCubic: x => x * x * x,
  easeOutCubic: x => 1 - Math.pow(1 - x, 3),
  easeInOutCubic: x => x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
  easeInQuart: x => x * x * x * x,
  easeOutQuart: x => 1 - Math.pow(1 - x, 4),
  easeInOutQuart: x => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
  easeInQuint: x => x * x * x * x * x,
  easeOutQuint: x => 1 - Math.pow(1 - x, 5),
  easeInOutQuint: x => x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
  easeInSine: x => 1 - Math.cos(x * Math.PI / 2),
  easeOutSine: x => Math.sin(x * Math.PI / 2),
  easeInOutSine: x => -(Math.cos(Math.PI * x) - 1) / 2,
  easeInExpo: x => x === 0 ? 0 : Math.pow(2, 10 * x - 10),
  easeOutExpo: x => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
  easeInOutExpo: x => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
  easeInCirc: x => 1 - Math.sqrt(1 - Math.pow(x, 2)),
  easeOutCirc: x => Math.sqrt(1 - Math.pow(x - 1, 2)),
  easeInOutCirc: x => x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
  easeInBack: x => c3 * x * x * x - c1 * x * x,
  easeOutBack: x => 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2),
  easeInOutBack: x => x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2,
  easeInElastic: x => x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4),
  easeOutElastic: x => x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1,
  easeInOutElastic: x => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1,
  easeInBounce: x => 1 - bounceOut(1 - x),
  easeOutBounce: bounceOut,
  easeInOutBounce: x => x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2
};

const defaults = _extends({}, config.default, {
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
});

class AnimationConfig {
  constructor() {
    this.tension = void 0;
    this.friction = void 0;
    this.frequency = void 0;
    this.damping = void 0;
    this.mass = void 0;
    this.velocity = 0;
    this.restVelocity = void 0;
    this.precision = void 0;
    this.progress = void 0;
    this.duration = void 0;
    this.easing = void 0;
    this.clamp = void 0;
    this.bounce = void 0;
    this.decay = void 0;
    this.round = void 0;
    Object.assign(this, defaults);
  }

}
function mergeConfig(config, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = _extends({}, defaultConfig);
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = _extends({}, defaultConfig, newConfig);
  }

  sanitizeConfig(config, newConfig);
  Object.assign(config, newConfig);

  for (const key in defaults) {
    if (config[key] == null) {
      config[key] = defaults[key];
    }
  }

  let {
    mass,
    frequency,
    damping
  } = config;

  if (!is.und(frequency)) {
    if (frequency < 0.01) frequency = 0.01;
    if (damping < 0) damping = 0;
    config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config.friction = 4 * Math.PI * damping * mass / frequency;
  }

  return config;
}

function sanitizeConfig(config, props) {
  if (!is.und(props.decay)) {
    config.duration = undefined;
  } else {
    const isTensionConfig = !is.und(props.tension) || !is.und(props.friction);

    if (isTensionConfig || !is.und(props.frequency) || !is.und(props.damping) || !is.und(props.mass)) {
      config.duration = undefined;
      config.decay = undefined;
    }

    if (isTensionConfig) {
      config.frequency = undefined;
    }
  }
}

const emptyArray = [];
class Animation {
  constructor() {
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.to = void 0;
    this.from = void 0;
    this.config = new AnimationConfig();
    this.immediate = false;
  }

}

function scheduleProps(callId, {
  key,
  props,
  defaultProps,
  state,
  actions
}) {
  return new Promise((resolve, reject) => {
    var _props$cancel;

    let delay;
    let timeout;
    let cancel = matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);

    if (cancel) {
      onStart();
    } else {
      if (!is.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }

      let pause = defaultProps == null ? void 0 : defaultProps.pause;

      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }

      delay = callProp(props.delay || 0, key);

      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }

    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout);
      timeout.cancel();
      delay = timeout.time - raf.now();
    }

    function onResume() {
      if (delay > 0 && !globals.skipAnimation) {
        state.delayed = true;
        timeout = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }

    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }

      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout);

      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }

      try {
        actions.start(_extends({}, props, {
          callId,
          cancel
        }), resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

const getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some(result => result.cancelled) ? getCancelledResult(target.get()) : results.every(result => result.noop) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every(result => result.finished));
const getNoopResult = value => ({
  value,
  noop: true,
  finished: true,
  cancelled: false
});
const getFinishedResult = (value, finished, cancelled = false) => ({
  value,
  finished,
  cancelled
});
const getCancelledResult = value => ({
  value,
  cancelled: true,
  finished: false
});

function runAsync(to, props, state, target) {
  const {
    callId,
    parentId,
    onRest
  } = props;
  const {
    asyncTo: prevTo,
    promise: prevPromise
  } = state;

  if (!parentId && to === prevTo && !props.reset) {
    return prevPromise;
  }

  return state.promise = (async () => {
    state.asyncId = callId;
    state.asyncTo = to;
    const defaultProps = getDefaultProps(props, (value, key) => key === 'onRest' ? undefined : value);
    let preventBail;
    let bail;
    const bailPromise = new Promise((resolve, reject) => (preventBail = resolve, bail = reject));

    const bailIfEnded = bailSignal => {
      const bailResult = callId <= (state.cancelId || 0) && getCancelledResult(target) || callId !== state.asyncId && getFinishedResult(target, false);

      if (bailResult) {
        bailSignal.result = bailResult;
        bail(bailSignal);
        throw bailSignal;
      }
    };

    const animate = (arg1, arg2) => {
      const bailSignal = new BailSignal();
      const skipAnimationSignal = new SkipAniamtionSignal();
      return (async () => {
        if (globals.skipAnimation) {
          stopAsync(state);
          skipAnimationSignal.result = getFinishedResult(target, false);
          bail(skipAnimationSignal);
          throw skipAnimationSignal;
        }

        bailIfEnded(bailSignal);
        const props = is.obj(arg1) ? _extends({}, arg1) : _extends({}, arg2, {
          to: arg1
        });
        props.parentId = callId;
        eachProp(defaultProps, (value, key) => {
          if (is.und(props[key])) {
            props[key] = value;
          }
        });
        const result = await target.start(props);
        bailIfEnded(bailSignal);

        if (state.paused) {
          await new Promise(resume => {
            state.resumeQueue.add(resume);
          });
        }

        return result;
      })();
    };

    let result;

    if (globals.skipAnimation) {
      stopAsync(state);
      return getFinishedResult(target, false);
    }

    try {
      let animating;

      if (is.arr(to)) {
        animating = (async queue => {
          for (const props of queue) {
            await animate(props);
          }
        })(to);
      } else {
          animating = Promise.resolve(to(animate, target.stop.bind(target)));
        }

      await Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target.get(), true, false);
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else if (err instanceof SkipAniamtionSignal) {
        result = err.result;
      } else {
        throw err;
      }
    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : undefined;
        state.promise = parentId ? prevPromise : undefined;
      }
    }

    if (is.fun(onRest)) {
      raf.batchedUpdates(() => {
        onRest(result, target, target.item);
      });
    }

    return result;
  })();
}
function stopAsync(state, cancelId) {
  flush(state.timeouts, t => t.cancel());
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = undefined;
  if (cancelId) state.cancelId = cancelId;
}
class BailSignal extends Error {
  constructor() {
    super('An async animation has been interrupted. You see this error because you ' + 'forgot to use `await` or `.catch(...)` on its returned promise.');
    this.result = void 0;
  }

}
class SkipAniamtionSignal extends Error {
  constructor() {
    super('SkipAnimationSignal');
    this.result = void 0;
  }

}

const isFrameValue = value => value instanceof FrameValue;
let nextId$1 = 1;
class FrameValue extends FluidValue {
  constructor(...args) {
    super(...args);
    this.id = nextId$1++;
    this.key = void 0;
    this._priority = 0;
  }

  get priority() {
    return this._priority;
  }

  set priority(priority) {
    if (this._priority != priority) {
      this._priority = priority;

      this._onPriorityChange(priority);
    }
  }

  get() {
    const node = getAnimated(this);
    return node && node.getValue();
  }

  to(...args) {
    return globals.to(this, args);
  }

  interpolate(...args) {
    deprecateInterpolate();
    return globals.to(this, args);
  }

  toJSON() {
    return this.get();
  }

  observerAdded(count) {
    if (count == 1) this._attach();
  }

  observerRemoved(count) {
    if (count == 0) this._detach();
  }

  _attach() {}

  _detach() {}

  _onChange(value, idle = false) {
    callFluidObservers(this, {
      type: 'change',
      parent: this,
      value,
      idle
    });
  }

  _onPriorityChange(priority) {
    if (!this.idle) {
      frameLoop.sort(this);
    }

    callFluidObservers(this, {
      type: 'priority',
      parent: this,
      priority
    });
  }

}

const $P = Symbol.for('SpringPhase');
const HAS_ANIMATED = 1;
const IS_ANIMATING = 2;
const IS_PAUSED = 4;
const hasAnimated = target => (target[$P] & HAS_ANIMATED) > 0;
const isAnimating = target => (target[$P] & IS_ANIMATING) > 0;
const isPaused = target => (target[$P] & IS_PAUSED) > 0;
const setActiveBit = (target, active) => active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
const setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;

class SpringValue extends FrameValue {
  constructor(arg1, arg2) {
    super();
    this.key = void 0;
    this.animation = new Animation();
    this.queue = void 0;
    this.defaultProps = {};
    this._state = {
      paused: false,
      delayed: false,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    };
    this._pendingCalls = new Set();
    this._lastCallId = 0;
    this._lastToId = 0;
    this._memoizedDuration = 0;

    if (!is.und(arg1) || !is.und(arg2)) {
      const props = is.obj(arg1) ? _extends({}, arg1) : _extends({}, arg2, {
        from: arg1
      });

      if (is.und(props.default)) {
        props.default = true;
      }

      this.start(props);
    }
  }

  get idle() {
    return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
  }

  get goal() {
    return getFluidValue(this.animation.to);
  }

  get velocity() {
    const node = getAnimated(this);
    return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map(node => node.lastVelocity || 0);
  }

  get hasAnimated() {
    return hasAnimated(this);
  }

  get isAnimating() {
    return isAnimating(this);
  }

  get isPaused() {
    return isPaused(this);
  }

  get isDelayed() {
    return this._state.delayed;
  }

  advance(dt) {
    let idle = true;
    let changed = false;
    const anim = this.animation;
    let {
      config,
      toValues
    } = anim;
    const payload = getPayload(anim.to);

    if (!payload && hasFluidValue(anim.to)) {
      toValues = toArray(getFluidValue(anim.to));
    }

    anim.values.forEach((node, i) => {
      if (node.done) return;
      const to = node.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i];
      let finished = anim.immediate;
      let position = to;

      if (!finished) {
        position = node.lastPosition;

        if (config.tension <= 0) {
          node.done = true;
          return;
        }

        let elapsed = node.elapsedTime += dt;
        const from = anim.fromValues[i];
        const v0 = node.v0 != null ? node.v0 : node.v0 = is.arr(config.velocity) ? config.velocity[i] : config.velocity;
        let velocity;

        if (!is.und(config.duration)) {
          let p = 1;

          if (config.duration > 0) {
            if (this._memoizedDuration !== config.duration) {
              this._memoizedDuration = config.duration;

              if (node.durationProgress > 0) {
                node.elapsedTime = config.duration * node.durationProgress;
                elapsed = node.elapsedTime += dt;
              }
            }

            p = (config.progress || 0) + elapsed / this._memoizedDuration;
            p = p > 1 ? 1 : p < 0 ? 0 : p;
            node.durationProgress = p;
          }

          position = from + config.easing(p) * (to - from);
          velocity = (position - node.lastPosition) / dt;
          finished = p == 1;
        } else if (config.decay) {
            const decay = config.decay === true ? 0.998 : config.decay;
            const e = Math.exp(-(1 - decay) * elapsed);
            position = from + v0 / (1 - decay) * (1 - e);
            finished = Math.abs(node.lastPosition - position) < 0.1;
            velocity = v0 * e;
          } else {
              velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
              const precision = config.precision || (from == to ? 0.005 : Math.min(1, Math.abs(to - from) * 0.001));
              const restVelocity = config.restVelocity || precision / 10;
              const bounceFactor = config.clamp ? 0 : config.bounce;
              const canBounce = !is.und(bounceFactor);
              const isGrowing = from == to ? node.v0 > 0 : from < to;
              let isMoving;
              let isBouncing = false;
              const step = 1;
              const numSteps = Math.ceil(dt / step);

              for (let n = 0; n < numSteps; ++n) {
                isMoving = Math.abs(velocity) > restVelocity;

                if (!isMoving) {
                  finished = Math.abs(to - position) <= precision;

                  if (finished) {
                    break;
                  }
                }

                if (canBounce) {
                  isBouncing = position == to || position > to == isGrowing;

                  if (isBouncing) {
                    velocity = -velocity * bounceFactor;
                    position = to;
                  }
                }

                const springForce = -config.tension * 0.000001 * (position - to);
                const dampingForce = -config.friction * 0.001 * velocity;
                const acceleration = (springForce + dampingForce) / config.mass;
                velocity = velocity + acceleration * step;
                position = position + velocity * step;
              }
            }

        node.lastVelocity = velocity;

        if (Number.isNaN(position)) {
          console.warn(`Got NaN while animating:`, this);
          finished = true;
        }
      }

      if (payload && !payload[i].done) {
        finished = false;
      }

      if (finished) {
        node.done = true;
      } else {
        idle = false;
      }

      if (node.setValue(position, config.round)) {
        changed = true;
      }
    });
    const node = getAnimated(this);
    const currVal = node.getValue();

    if (idle) {
      const finalVal = getFluidValue(anim.to);

      if ((currVal !== finalVal || changed) && !config.decay) {
        node.setValue(finalVal);

        this._onChange(finalVal);
      } else if (changed && config.decay) {
        this._onChange(currVal);
      }

      this._stop();
    } else if (changed) {
      this._onChange(currVal);
    }
  }

  set(value) {
    raf.batchedUpdates(() => {
      this._stop();

      this._focus(value);

      this._set(value);
    });
    return this;
  }

  pause() {
    this._update({
      pause: true
    });
  }

  resume() {
    this._update({
      pause: false
    });
  }

  finish() {
    if (isAnimating(this)) {
      const {
        to,
        config
      } = this.animation;
      raf.batchedUpdates(() => {
        this._onStart();

        if (!config.decay) {
          this._set(to, false);
        }

        this._stop();
      });
    }

    return this;
  }

  update(props) {
    const queue = this.queue || (this.queue = []);
    queue.push(props);
    return this;
  }

  start(to, arg2) {
    let queue;

    if (!is.und(to)) {
      queue = [is.obj(to) ? to : _extends({}, arg2, {
        to
      })];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }

    return Promise.all(queue.map(props => {
      const up = this._update(props);

      return up;
    })).then(results => getCombinedResult(this, results));
  }

  stop(cancel) {
    const {
      to
    } = this.animation;

    this._focus(this.get());

    stopAsync(this._state, cancel && this._lastCallId);
    raf.batchedUpdates(() => this._stop(to, cancel));
    return this;
  }

  reset() {
    this._update({
      reset: true
    });
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._start();
    } else if (event.type == 'priority') {
      this.priority = event.priority + 1;
    }
  }

  _prepareNode(props) {
    const key = this.key || '';
    let {
      to,
      from
    } = props;
    to = is.obj(to) ? to[key] : to;

    if (to == null || isAsyncTo(to)) {
      to = undefined;
    }

    from = is.obj(from) ? from[key] : from;

    if (from == null) {
      from = undefined;
    }

    const range = {
      to,
      from
    };

    if (!hasAnimated(this)) {
      if (props.reverse) [to, from] = [from, to];
      from = getFluidValue(from);

      if (!is.und(from)) {
        this._set(from);
      } else if (!getAnimated(this)) {
          this._set(to);
        }
    }

    return range;
  }

  _update(_ref, isLoop) {
    let props = _extends({}, _ref);

    const {
      key,
      defaultProps
    } = this;
    if (props.default) Object.assign(defaultProps, getDefaultProps(props, (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value));
    mergeActiveFn(this, props, 'onProps');
    sendEvent(this, 'onProps', props, this);

    const range = this._prepareNode(props);

    if (Object.isFrozen(this)) {
      throw Error('Cannot animate a `SpringValue` object that is frozen. ' + 'Did you forget to pass your component to `animated(...)` before animating its props?');
    }

    const state = this._state;
    return scheduleProps(++this._lastCallId, {
      key,
      props,
      defaultProps,
      state,
      actions: {
        pause: () => {
          if (!isPaused(this)) {
            setPausedBit(this, true);
            flushCalls(state.pauseQueue);
            sendEvent(this, 'onPause', getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        resume: () => {
          if (isPaused(this)) {
            setPausedBit(this, false);

            if (isAnimating(this)) {
              this._resume();
            }

            flushCalls(state.resumeQueue);
            sendEvent(this, 'onResume', getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        start: this._merge.bind(this, range)
      }
    }).then(result => {
      if (props.loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props);

        if (nextProps) {
          return this._update(nextProps, true);
        }
      }

      return result;
    });
  }

  _merge(range, props, resolve) {
    if (props.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }

    const hasToProp = !is.und(range.to);
    const hasFromProp = !is.und(range.from);

    if (hasToProp || hasFromProp) {
      if (props.callId > this._lastToId) {
        this._lastToId = props.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }

    const {
      key,
      defaultProps,
      animation: anim
    } = this;
    const {
      to: prevTo,
      from: prevFrom
    } = anim;
    let {
      to = prevTo,
      from = prevFrom
    } = range;

    if (hasFromProp && !hasToProp && (!props.default || is.und(to))) {
      to = from;
    }

    if (props.reverse) [to, from] = [from, to];
    const hasFromChanged = !isEqual(from, prevFrom);

    if (hasFromChanged) {
      anim.from = from;
    }

    from = getFluidValue(from);
    const hasToChanged = !isEqual(to, prevTo);

    if (hasToChanged) {
      this._focus(to);
    }

    const hasAsyncTo = isAsyncTo(props.to);
    const {
      config
    } = anim;
    const {
      decay,
      velocity
    } = config;

    if (hasToProp || hasFromProp) {
      config.velocity = 0;
    }

    if (props.config && !hasAsyncTo) {
      mergeConfig(config, callProp(props.config, key), props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
    }

    let node = getAnimated(this);

    if (!node || is.und(to)) {
      return resolve(getFinishedResult(this, true));
    }

    const reset = is.und(props.reset) ? hasFromProp && !props.default : !is.und(from) && matchProp(props.reset, key);
    const value = reset ? from : this.get();
    const goal = computeGoal(to);
    const isAnimatable = is.num(goal) || is.arr(goal) || isAnimatedString(goal);
    const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));

    if (hasToChanged) {
      const nodeType = getAnimatedType(to);

      if (nodeType !== node.constructor) {
        if (immediate) {
          node = this._set(goal);
        } else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
      }
    }

    const goalType = node.constructor;
    let started = hasFluidValue(to);
    let finished = false;

    if (!started) {
      const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;

      if (hasToChanged || hasValueChanged) {
        finished = isEqual(computeGoal(value), goal);
        started = !finished;
      }

      if (!isEqual(anim.immediate, immediate) && !immediate || !isEqual(config.decay, decay) || !isEqual(config.velocity, velocity)) {
        started = true;
      }
    }

    if (finished && isAnimating(this)) {
      if (anim.changed && !reset) {
        started = true;
      } else if (!started) {
          this._stop(prevTo);
        }
    }

    if (!hasAsyncTo) {
      if (started || hasFluidValue(prevTo)) {
        anim.values = node.getPayload();
        anim.toValues = hasFluidValue(to) ? null : goalType == AnimatedString ? [1] : toArray(goal);
      }

      if (anim.immediate != immediate) {
        anim.immediate = immediate;

        if (!immediate && !reset) {
          this._set(prevTo);
        }
      }

      if (started) {
        const {
          onRest
        } = anim;
        each(ACTIVE_EVENTS, type => mergeActiveFn(this, props, type));
        const result = getFinishedResult(this, checkFinished(this, prevTo));
        flushCalls(this._pendingCalls, result);

        this._pendingCalls.add(resolve);

        if (anim.changed) raf.batchedUpdates(() => {
          anim.changed = !reset;
          onRest == null ? void 0 : onRest(result, this);

          if (reset) {
            callProp(defaultProps.onRest, result);
          } else {
              anim.onStart == null ? void 0 : anim.onStart(result, this);
            }
        });
      }
    }

    if (reset) {
      this._set(value);
    }

    if (hasAsyncTo) {
      resolve(runAsync(props.to, props, this._state, this));
    } else if (started) {
        this._start();
      } else if (isAnimating(this) && !hasToChanged) {
          this._pendingCalls.add(resolve);
        } else {
            resolve(getNoopResult(value));
          }
  }

  _focus(value) {
    const anim = this.animation;

    if (value !== anim.to) {
      if (getFluidObservers(this)) {
        this._detach();
      }

      anim.to = value;

      if (getFluidObservers(this)) {
        this._attach();
      }
    }
  }

  _attach() {
    let priority = 0;
    const {
      to
    } = this.animation;

    if (hasFluidValue(to)) {
      addFluidObserver(to, this);

      if (isFrameValue(to)) {
        priority = to.priority + 1;
      }
    }

    this.priority = priority;
  }

  _detach() {
    const {
      to
    } = this.animation;

    if (hasFluidValue(to)) {
      removeFluidObserver(to, this);
    }
  }

  _set(arg, idle = true) {
    const value = getFluidValue(arg);

    if (!is.und(value)) {
      const oldNode = getAnimated(this);

      if (!oldNode || !isEqual(value, oldNode.getValue())) {
        const nodeType = getAnimatedType(value);

        if (!oldNode || oldNode.constructor != nodeType) {
          setAnimated(this, nodeType.create(value));
        } else {
          oldNode.setValue(value);
        }

        if (oldNode) {
          raf.batchedUpdates(() => {
            this._onChange(value, idle);
          });
        }
      }
    }

    return getAnimated(this);
  }

  _onStart() {
    const anim = this.animation;

    if (!anim.changed) {
      anim.changed = true;
      sendEvent(this, 'onStart', getFinishedResult(this, checkFinished(this, anim.to)), this);
    }
  }

  _onChange(value, idle) {
    if (!idle) {
      this._onStart();

      callProp(this.animation.onChange, value, this);
    }

    callProp(this.defaultProps.onChange, value, this);

    super._onChange(value, idle);
  }

  _start() {
    const anim = this.animation;
    getAnimated(this).reset(getFluidValue(anim.to));

    if (!anim.immediate) {
      anim.fromValues = anim.values.map(node => node.lastPosition);
    }

    if (!isAnimating(this)) {
      setActiveBit(this, true);

      if (!isPaused(this)) {
        this._resume();
      }
    }
  }

  _resume() {
    if (globals.skipAnimation) {
      this.finish();
    } else {
      frameLoop.start(this);
    }
  }

  _stop(goal, cancel) {
    if (isAnimating(this)) {
      setActiveBit(this, false);
      const anim = this.animation;
      each(anim.values, node => {
        node.done = true;
      });

      if (anim.toValues) {
        anim.onChange = anim.onPause = anim.onResume = undefined;
      }

      callFluidObservers(this, {
        type: 'idle',
        parent: this
      });
      const result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal != null ? goal : anim.to));
      flushCalls(this._pendingCalls, result);

      if (anim.changed) {
        anim.changed = false;
        sendEvent(this, 'onRest', result, this);
      }
    }
  }

}

function checkFinished(target, to) {
  const goal = computeGoal(to);
  const value = computeGoal(target.get());
  return isEqual(value, goal);
}

function createLoopUpdate(props, loop = props.loop, to = props.to) {
  let loopRet = callProp(loop);

  if (loopRet) {
    const overrides = loopRet !== true && inferTo(loopRet);
    const reverse = (overrides || props).reverse;
    const reset = !overrides || overrides.reset;
    return createUpdate(_extends({}, props, {
      loop,
      default: false,
      pause: undefined,
      to: !reverse || isAsyncTo(to) ? to : undefined,
      from: reset ? props.from : undefined,
      reset
    }, overrides));
  }
}
function createUpdate(props) {
  const {
    to,
    from
  } = props = inferTo(props);
  const keys = new Set();
  if (is.obj(to)) findDefined(to, keys);
  if (is.obj(from)) findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
function declareUpdate(props) {
  const update = createUpdate(props);

  if (is.und(update.default)) {
    update.default = getDefaultProps(update);
  }

  return update;
}

function findDefined(values, keys) {
  eachProp(values, (value, key) => value != null && keys.add(key));
}

const ACTIVE_EVENTS = ['onStart', 'onRest', 'onChange', 'onPause', 'onResume'];

function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : undefined;
}

function sendEvent(target, type, ...args) {
  var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;

  (_target$animation$typ = (_target$animation = target.animation)[type]) == null ? void 0 : _target$animation$typ.call(_target$animation, ...args);
  (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) == null ? void 0 : _target$defaultProps$.call(_target$defaultProps, ...args);
}

const BATCHED_EVENTS = ['onStart', 'onChange', 'onRest'];
let nextId = 1;
class Controller {
  constructor(props, flush) {
    this.id = nextId++;
    this.springs = {};
    this.queue = [];
    this.ref = void 0;
    this._flush = void 0;
    this._initialProps = void 0;
    this._lastAsyncId = 0;
    this._active = new Set();
    this._changed = new Set();
    this._started = false;
    this._item = void 0;
    this._state = {
      paused: false,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    };
    this._events = {
      onStart: new Map(),
      onChange: new Map(),
      onRest: new Map()
    };
    this._onFrame = this._onFrame.bind(this);

    if (flush) {
      this._flush = flush;
    }

    if (props) {
      this.start(_extends({
        default: true
      }, props));
    }
  }

  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every(spring => {
      return spring.idle && !spring.isDelayed && !spring.isPaused;
    });
  }

  get item() {
    return this._item;
  }

  set item(item) {
    this._item = item;
  }

  get() {
    const values = {};
    this.each((spring, key) => values[key] = spring.get());
    return values;
  }

  set(values) {
    for (const key in values) {
      const value = values[key];

      if (!is.und(value)) {
        this.springs[key].set(value);
      }
    }
  }

  update(props) {
    if (props) {
      this.queue.push(createUpdate(props));
    }

    return this;
  }

  start(props) {
    let {
      queue
    } = this;

    if (props) {
      queue = toArray(props).map(createUpdate);
    } else {
      this.queue = [];
    }

    if (this._flush) {
      return this._flush(this, queue);
    }

    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }

  stop(arg, keys) {
    if (arg !== !!arg) {
      keys = arg;
    }

    if (keys) {
      const springs = this.springs;
      each(toArray(keys), key => springs[key].stop(!!arg));
    } else {
      stopAsync(this._state, this._lastAsyncId);
      this.each(spring => spring.stop(!!arg));
    }

    return this;
  }

  pause(keys) {
    if (is.und(keys)) {
      this.start({
        pause: true
      });
    } else {
      const springs = this.springs;
      each(toArray(keys), key => springs[key].pause());
    }

    return this;
  }

  resume(keys) {
    if (is.und(keys)) {
      this.start({
        pause: false
      });
    } else {
      const springs = this.springs;
      each(toArray(keys), key => springs[key].resume());
    }

    return this;
  }

  each(iterator) {
    eachProp(this.springs, iterator);
  }

  _onFrame() {
    const {
      onStart,
      onChange,
      onRest
    } = this._events;
    const active = this._active.size > 0;
    const changed = this._changed.size > 0;

    if (active && !this._started || changed && !this._started) {
      this._started = true;
      flush(onStart, ([onStart, result]) => {
        result.value = this.get();
        onStart(result, this, this._item);
      });
    }

    const idle = !active && this._started;
    const values = changed || idle && onRest.size ? this.get() : null;

    if (changed && onChange.size) {
      flush(onChange, ([onChange, result]) => {
        result.value = values;
        onChange(result, this, this._item);
      });
    }

    if (idle) {
      this._started = false;
      flush(onRest, ([onRest, result]) => {
        result.value = values;
        onRest(result, this, this._item);
      });
    }
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._changed.add(event.parent);

      if (!event.idle) {
        this._active.add(event.parent);
      }
    } else if (event.type == 'idle') {
      this._active.delete(event.parent);
    } else return;

    raf.onFrame(this._onFrame);
  }

}
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map(props => flushUpdate(ctrl, props))).then(results => getCombinedResult(ctrl, results));
}
async function flushUpdate(ctrl, props, isLoop) {
  const {
    keys,
    to,
    from,
    loop,
    onRest,
    onResolve
  } = props;
  const defaults = is.obj(props.default) && props.default;

  if (loop) {
    props.loop = false;
  }

  if (to === false) props.to = null;
  if (from === false) props.from = null;
  const asyncTo = is.arr(to) || is.fun(to) ? to : undefined;

  if (asyncTo) {
    props.to = undefined;
    props.onRest = undefined;

    if (defaults) {
      defaults.onRest = undefined;
    }
  } else {
      each(BATCHED_EVENTS, key => {
        const handler = props[key];

        if (is.fun(handler)) {
          const queue = ctrl['_events'][key];

          props[key] = ({
            finished,
            cancelled
          }) => {
            const result = queue.get(handler);

            if (result) {
              if (!finished) result.finished = false;
              if (cancelled) result.cancelled = true;
            } else {
              queue.set(handler, {
                value: null,
                finished: finished || false,
                cancelled: cancelled || false
              });
            }
          };

          if (defaults) {
            defaults[key] = props[key];
          }
        }
      });
    }

  const state = ctrl['_state'];

  if (props.pause === !state.paused) {
    state.paused = props.pause;
    flushCalls(props.pause ? state.pauseQueue : state.resumeQueue);
  } else if (state.paused) {
      props.pause = true;
    }

  const promises = (keys || Object.keys(ctrl.springs)).map(key => ctrl.springs[key].start(props));
  const cancel = props.cancel === true || getDefaultProp(props, 'cancel') === true;

  if (asyncTo || cancel && state.asyncId) {
    promises.push(scheduleProps(++ctrl['_lastAsyncId'], {
      props,
      state,
      actions: {
        pause: noop$1,
        resume: noop$1,

        start(props, resolve) {
          if (cancel) {
            stopAsync(state, ctrl['_lastAsyncId']);
            resolve(getCancelledResult(ctrl));
          } else {
            props.onRest = onRest;
            resolve(runAsync(asyncTo, props, state, ctrl));
          }
        }

      }
    }));
  }

  if (state.paused) {
    await new Promise(resume => {
      state.resumeQueue.add(resume);
    });
  }

  const result = getCombinedResult(ctrl, await Promise.all(promises));

  if (loop && result.finished && !(isLoop && result.noop)) {
    const nextProps = createLoopUpdate(props, loop, to);

    if (nextProps) {
      prepareKeys(ctrl, [nextProps]);
      return flushUpdate(ctrl, nextProps, true);
    }
  }

  if (onResolve) {
    raf.batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
  }

  return result;
}
function getSprings(ctrl, props) {
  const springs = _extends({}, ctrl.springs);

  if (props) {
    each(toArray(props), props => {
      if (is.und(props.keys)) {
        props = createUpdate(props);
      }

      if (!is.obj(props.to)) {
        props = _extends({}, props, {
          to: undefined
        });
      }

      prepareSprings(springs, props, key => {
        return createSpring(key);
      });
    });
  }

  setSprings(ctrl, springs);
  return springs;
}
function setSprings(ctrl, springs) {
  eachProp(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver(spring, ctrl);
    }
  });
}

function createSpring(key, observer) {
  const spring = new SpringValue();
  spring.key = key;

  if (observer) {
    addFluidObserver(spring, observer);
  }

  return spring;
}

function prepareSprings(springs, props, create) {
  if (props.keys) {
    each(props.keys, key => {
      const spring = springs[key] || (springs[key] = create(key));
      spring['_prepareNode'](props);
    });
  }
}

function prepareKeys(ctrl, queue) {
  each(queue, props => {
    prepareSprings(ctrl.springs, props, key => {
      return createSpring(key, ctrl);
    });
  });
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const _excluded$3$1 = ["children"];
const SpringContext = _ref => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose$3(_ref, _excluded$3$1);

  const inherited = useContext(ctx);
  const pause = props.pause || !!inherited.pause,
        immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(() => ({
    pause,
    immediate
  }), [pause, immediate]);
  const {
    Provider
  } = ctx;
  return React.createElement(Provider, {
    value: props
  }, children);
};
const ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;

function makeContext(target, init) {
  Object.assign(target, React.createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}

const SpringRef = () => {
  const current = [];

  const SpringRef = function SpringRef(props) {
    deprecateDirectCall();
    const results = [];
    each(current, (ctrl, i) => {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update = _getProps(props, ctrl, i);

        if (update) {
          results.push(ctrl.start(update));
        }
      }
    });
    return results;
  };

  SpringRef.current = current;

  SpringRef.add = function (ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };

  SpringRef.delete = function (ctrl) {
    const i = current.indexOf(ctrl);
    if (~i) current.splice(i, 1);
  };

  SpringRef.pause = function () {
    each(current, ctrl => ctrl.pause(...arguments));
    return this;
  };

  SpringRef.resume = function () {
    each(current, ctrl => ctrl.resume(...arguments));
    return this;
  };

  SpringRef.set = function (values) {
    each(current, ctrl => ctrl.set(values));
  };

  SpringRef.start = function (props) {
    const results = [];
    each(current, (ctrl, i) => {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update = this._getProps(props, ctrl, i);

        if (update) {
          results.push(ctrl.start(update));
        }
      }
    });
    return results;
  };

  SpringRef.stop = function () {
    each(current, ctrl => ctrl.stop(...arguments));
    return this;
  };

  SpringRef.update = function (props) {
    each(current, (ctrl, i) => ctrl.update(this._getProps(props, ctrl, i)));
    return this;
  };

  const _getProps = function _getProps(arg, ctrl, index) {
    return is.fun(arg) ? arg(index, ctrl) : arg;
  };

  SpringRef._getProps = _getProps;
  return SpringRef;
};

function useSprings(length, props, deps) {
  const propsFn = is.fun(props) && props;
  if (propsFn && !deps) deps = [];
  const ref = useMemo(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
  const layoutId = useRef(0);
  const forceUpdate = useForceUpdate();
  const state = useMemo(() => ({
    ctrls: [],
    queue: [],

    flush(ctrl, updates) {
      const springs = getSprings(ctrl, updates);
      const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some(key => !ctrl.springs[key]);
      return canFlushSync ? flushUpdateQueue(ctrl, updates) : new Promise(resolve => {
        setSprings(ctrl, springs);
        state.queue.push(() => {
          resolve(flushUpdateQueue(ctrl, updates));
        });
        forceUpdate();
      });
    }

  }), []);
  const ctrls = useRef([...state.ctrls]);
  const updates = [];
  const prevLength = usePrev(length) || 0;
  useMemo(() => {
    each(ctrls.current.slice(length, prevLength), ctrl => {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    ctrls.current.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  useMemo(() => {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);

  function declareUpdates(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      const ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
      const update = propsFn ? propsFn(i, ctrl) : props[i];

      if (update) {
        updates[i] = declareUpdate(update);
      }
    }
  }

  const springs = ctrls.current.map((ctrl, i) => getSprings(ctrl, updates[i]));
  const context = useContext(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  useLayoutEffect(() => {
    layoutId.current++;
    state.ctrls = ctrls.current;
    const {
      queue
    } = state;

    if (queue.length) {
      state.queue = [];
      each(queue, cb => cb());
    }

    each(ctrls.current, (ctrl, i) => {
      ref == null ? void 0 : ref.add(ctrl);

      if (hasContext) {
        ctrl.start({
          default: context
        });
      }

      const update = updates[i];

      if (update) {
        replaceRef(ctrl, update.ref);

        if (ctrl.ref) {
          ctrl.queue.push(update);
        } else {
          ctrl.start(update);
        }
      }
    });
  });
  useOnce(() => () => {
    each(state.ctrls, ctrl => ctrl.stop(true));
  });
  const values = springs.map(x => _extends({}, x));
  return ref ? [values, ref] : values;
}

function useSpring(props, deps) {
  const isFn = is.fun(props);
  const [[values], ref] = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps);
  return isFn || arguments.length == 2 ? [values, ref] : values;
}

let TransitionPhase;

(function (TransitionPhase) {
  TransitionPhase["MOUNT"] = "mount";
  TransitionPhase["ENTER"] = "enter";
  TransitionPhase["UPDATE"] = "update";
  TransitionPhase["LEAVE"] = "leave";
})(TransitionPhase || (TransitionPhase = {}));

function useTransition(data, props, deps) {
  const propsFn = is.fun(props) && props;
  const {
    reset,
    sort,
    trail = 0,
    expires = true,
    exitBeforeEnter = false,
    onDestroyed,
    ref: propsRef,
    config: propsConfig
  } = propsFn ? propsFn() : props;
  const ref = useMemo(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
  const items = toArray(data);
  const transitions = [];
  const usedTransitions = useRef(null);
  const prevTransitions = reset ? null : usedTransitions.current;
  useLayoutEffect(() => {
    usedTransitions.current = transitions;
  });
  useOnce(() => {
    each(usedTransitions.current, t => {
      var _t$ctrl$ref;

      (_t$ctrl$ref = t.ctrl.ref) == null ? void 0 : _t$ctrl$ref.add(t.ctrl);
      const change = changes.get(t);

      if (change) {
        t.ctrl.start(change.payload);
      }
    });
    return () => {
      each(usedTransitions.current, t => {
        if (t.expired) {
          clearTimeout(t.expirationId);
        }

        detachRefs(t.ctrl, ref);
        t.ctrl.stop(true);
      });
    };
  });
  const keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
  const expired = reset && usedTransitions.current || [];
  useLayoutEffect(() => each(expired, ({
    ctrl,
    item,
    key
  }) => {
    detachRefs(ctrl, ref);
    callProp(onDestroyed, item, key);
  }));
  const reused = [];
  if (prevTransitions) each(prevTransitions, (t, i) => {
    if (t.expired) {
      clearTimeout(t.expirationId);
      expired.push(t);
    } else {
      i = reused[i] = keys.indexOf(t.key);
      if (~i) transitions[i] = t;
    }
  });
  each(items, (item, i) => {
    if (!transitions[i]) {
      transitions[i] = {
        key: keys[i],
        item,
        phase: TransitionPhase.MOUNT,
        ctrl: new Controller()
      };
      transitions[i].ctrl.item = item;
    }
  });

  if (reused.length) {
    let i = -1;
    const {
      leave
    } = propsFn ? propsFn() : props;
    each(reused, (keyIndex, prevIndex) => {
      const t = prevTransitions[prevIndex];

      if (~keyIndex) {
        i = transitions.indexOf(t);
        transitions[i] = _extends({}, t, {
          item: items[keyIndex]
        });
      } else if (leave) {
        transitions.splice(++i, 0, t);
      }
    });
  }

  if (is.fun(sort)) {
    transitions.sort((a, b) => sort(a.item, b.item));
  }

  let delay = -trail;
  const forceUpdate = useForceUpdate();
  const defaultProps = getDefaultProps(props);
  const changes = new Map();
  const exitingTransitions = useRef(new Map());
  const forceChange = useRef(false);
  each(transitions, (t, i) => {
    const key = t.key;
    const prevPhase = t.phase;
    const p = propsFn ? propsFn() : props;
    let to;
    let phase;
    let propsDelay = callProp(p.delay || 0, key);

    if (prevPhase == TransitionPhase.MOUNT) {
      to = p.enter;
      phase = TransitionPhase.ENTER;
    } else {
      const isLeave = keys.indexOf(key) < 0;

      if (prevPhase != TransitionPhase.LEAVE) {
        if (isLeave) {
          to = p.leave;
          phase = TransitionPhase.LEAVE;
        } else if (to = p.update) {
          phase = TransitionPhase.UPDATE;
        } else return;
      } else if (!isLeave) {
        to = p.enter;
        phase = TransitionPhase.ENTER;
      } else return;
    }

    to = callProp(to, t.item, i);
    to = is.obj(to) ? inferTo(to) : {
      to
    };

    if (!to.config) {
      const config = propsConfig || defaultProps.config;
      to.config = callProp(config, t.item, i, phase);
    }

    delay += trail;

    const payload = _extends({}, defaultProps, {
      delay: propsDelay + delay,
      ref: propsRef,
      immediate: p.immediate,
      reset: false
    }, to);

    if (phase == TransitionPhase.ENTER && is.und(payload.from)) {
      const _p = propsFn ? propsFn() : props;

      const from = is.und(_p.initial) || prevTransitions ? _p.from : _p.initial;
      payload.from = callProp(from, t.item, i);
    }

    const {
      onResolve
    } = payload;

    payload.onResolve = result => {
      callProp(onResolve, result);
      const transitions = usedTransitions.current;
      const t = transitions.find(t => t.key === key);
      if (!t) return;

      if (result.cancelled && t.phase != TransitionPhase.UPDATE) {
        return;
      }

      if (t.ctrl.idle) {
        const idle = transitions.every(t => t.ctrl.idle);

        if (t.phase == TransitionPhase.LEAVE) {
          const expiry = callProp(expires, t.item);

          if (expiry !== false) {
            const expiryMs = expiry === true ? 0 : expiry;
            t.expired = true;

            if (!idle && expiryMs > 0) {
              if (expiryMs <= 0x7fffffff) t.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        }

        if (idle && transitions.some(t => t.expired)) {
          exitingTransitions.current.delete(t);

          if (exitBeforeEnter) {
            forceChange.current = true;
          }

          forceUpdate();
        }
      }
    };

    const springs = getSprings(t.ctrl, payload);

    if (phase === TransitionPhase.LEAVE && exitBeforeEnter) {
      exitingTransitions.current.set(t, {
        phase,
        springs,
        payload
      });
    } else {
      changes.set(t, {
        phase,
        springs,
        payload
      });
    }
  });
  const context = useContext(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  useLayoutEffect(() => {
    if (hasContext) {
      each(transitions, t => {
        t.ctrl.start({
          default: context
        });
      });
    }
  }, [context]);
  each(changes, (_, t) => {
    if (exitingTransitions.current.size) {
      const ind = transitions.findIndex(state => state.key === t.key);
      transitions.splice(ind, 1);
    }
  });
  useLayoutEffect(() => {
    each(exitingTransitions.current.size ? exitingTransitions.current : changes, ({
      phase,
      payload
    }, t) => {
      const {
        ctrl
      } = t;
      t.phase = phase;
      ref == null ? void 0 : ref.add(ctrl);

      if (hasContext && phase == TransitionPhase.ENTER) {
        ctrl.start({
          default: context
        });
      }

      if (payload) {
        replaceRef(ctrl, payload.ref);

        if (ctrl.ref && !forceChange.current) {
          ctrl.update(payload);
        } else {
          ctrl.start(payload);

          if (forceChange.current) {
            forceChange.current = false;
          }
        }
      }
    });
  }, reset ? void 0 : deps);

  const renderTransitions = render => React.createElement(React.Fragment, null, transitions.map((t, i) => {
    const {
      springs
    } = changes.get(t) || t.ctrl;
    const elem = render(_extends({}, springs), t.item, t, i);
    return elem && elem.type ? React.createElement(elem.type, _extends({}, elem.props, {
      key: is.str(t.key) || is.num(t.key) ? t.key : t.ctrl.id,
      ref: elem.ref
    })) : elem;
  }));

  return ref ? [renderTransitions, ref] : renderTransitions;
}
let nextKey = 1;

function getKeys(items, {
  key,
  keys = key
}, prevTransitions) {
  if (keys === null) {
    const reused = new Set();
    return items.map(item => {
      const t = prevTransitions && prevTransitions.find(t => t.item === item && t.phase !== TransitionPhase.LEAVE && !reused.has(t));

      if (t) {
        reused.add(t);
        return t.key;
      }

      return nextKey++;
    });
  }

  return is.und(keys) ? items : is.fun(keys) ? items.map(keys) : toArray(keys);
}

class Interpolation extends FrameValue {
  constructor(source, args) {
    super();
    this.key = void 0;
    this.idle = true;
    this.calc = void 0;
    this._active = new Set();
    this.source = source;
    this.calc = createInterpolator(...args);

    const value = this._get();

    const nodeType = getAnimatedType(value);
    setAnimated(this, nodeType.create(value));
  }

  advance(_dt) {
    const value = this._get();

    const oldValue = this.get();

    if (!isEqual(value, oldValue)) {
      getAnimated(this).setValue(value);

      this._onChange(value, this.idle);
    }

    if (!this.idle && checkIdle(this._active)) {
      becomeIdle(this);
    }
  }

  _get() {
    const inputs = is.arr(this.source) ? this.source.map(getFluidValue) : toArray(getFluidValue(this.source));
    return this.calc(...inputs);
  }

  _start() {
    if (this.idle && !checkIdle(this._active)) {
      this.idle = false;
      each(getPayload(this), node => {
        node.done = false;
      });

      if (globals.skipAnimation) {
        raf.batchedUpdates(() => this.advance());
        becomeIdle(this);
      } else {
        frameLoop.start(this);
      }
    }
  }

  _attach() {
    let priority = 1;
    each(toArray(this.source), source => {
      if (hasFluidValue(source)) {
        addFluidObserver(source, this);
      }

      if (isFrameValue(source)) {
        if (!source.idle) {
          this._active.add(source);
        }

        priority = Math.max(priority, source.priority + 1);
      }
    });
    this.priority = priority;

    this._start();
  }

  _detach() {
    each(toArray(this.source), source => {
      if (hasFluidValue(source)) {
        removeFluidObserver(source, this);
      }
    });

    this._active.clear();

    becomeIdle(this);
  }

  eventObserved(event) {
    if (event.type == 'change') {
      if (event.idle) {
        this.advance();
      } else {
        this._active.add(event.parent);

        this._start();
      }
    } else if (event.type == 'idle') {
        this._active.delete(event.parent);
      } else if (event.type == 'priority') {
          this.priority = toArray(this.source).reduce((highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1), 0);
        }
  }

}

function isIdle(source) {
  return source.idle !== false;
}

function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}

function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    each(getPayload(self), node => {
      node.done = true;
    });
    callFluidObservers(self, {
      type: 'idle',
      parent: self
    });
  }
}

globals.assign({
  createStringInterpolator,
  to: (source, args) => new Interpolation(source, args)
});

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const _excluded$2 = ["style", "children", "scrollTop", "scrollLeft"];
const isCustomPropRE = /^--/;

function dangerousStyleValue(name, value) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (typeof value === 'number' && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px';
  return ('' + value).trim();
}

const attributeCache = {};
function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }

  const isFilterElement = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';

  const _ref = props,
        {
    style,
    children,
    scrollTop,
    scrollLeft
  } = _ref,
        attributes = _objectWithoutPropertiesLoose$2(_ref, _excluded$2);

  const values = Object.values(attributes);
  const names = Object.keys(attributes).map(name => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, n => '-' + n.toLowerCase())));

  if (children !== void 0) {
    instance.textContent = children;
  }

  for (let name in style) {
    if (style.hasOwnProperty(name)) {
      const value = dangerousStyleValue(name, style[name]);

      if (isCustomPropRE.test(name)) {
        instance.style.setProperty(name, value);
      } else {
        instance.style[name] = value;
      }
    }
  }

  names.forEach((name, i) => {
    instance.setAttribute(name, values[i]);
  });

  if (scrollTop !== void 0) {
    instance.scrollTop = scrollTop;
  }

  if (scrollLeft !== void 0) {
    instance.scrollLeft = scrollLeft;
  }
}
let isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

const prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);

const prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach(prefix => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

const _excluded$1 = ["x", "y", "z"];
const domTransforms = /^(matrix|translate|scale|rotate|skew)/;
const pxTransforms = /^(translate)/;
const degTransforms = /^(rotate|skew)/;

const addUnit = (value, unit) => is.num(value) && value !== 0 ? value + unit : value;

const isValueIdentity = (value, id) => is.arr(value) ? value.every(v => isValueIdentity(v, id)) : is.num(value) ? value === id : parseFloat(value) === id;

class AnimatedStyle extends AnimatedObject {
  constructor(_ref) {
    let {
      x,
      y,
      z
    } = _ref,
        style = _objectWithoutPropertiesLoose$2(_ref, _excluded$1);

    const inputs = [];
    const transforms = [];

    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push(xyz => [`translate3d(${xyz.map(v => addUnit(v, 'px')).join(',')})`, isValueIdentity(xyz, 0)]);
    }

    eachProp(style, (value, key) => {
      if (key === 'transform') {
        inputs.push([value || '']);
        transforms.push(transform => [transform, transform === '']);
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (is.und(value)) return;
        const unit = pxTransforms.test(key) ? 'px' : degTransforms.test(key) ? 'deg' : '';
        inputs.push(toArray(value));
        transforms.push(key === 'rotate3d' ? ([x, y, z, deg]) => [`rotate3d(${x},${y},${z},${addUnit(deg, unit)})`, isValueIdentity(deg, 0)] : input => [`${key}(${input.map(v => addUnit(v, unit)).join(',')})`, isValueIdentity(input, key.startsWith('scale') ? 1 : 0)]);
      }
    });

    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }

    super(style);
  }

}

class FluidTransform extends FluidValue {
  constructor(inputs, transforms) {
    super();
    this._value = null;
    this.inputs = inputs;
    this.transforms = transforms;
  }

  get() {
    return this._value || (this._value = this._get());
  }

  _get() {
    let transform = '';
    let identity = true;
    each(this.inputs, (input, i) => {
      const arg1 = getFluidValue(input[0]);
      const [t, id] = this.transforms[i](is.arr(arg1) ? arg1 : input.map(getFluidValue));
      transform += ' ' + t;
      identity = identity && id;
    });
    return identity ? 'none' : transform;
  }

  observerAdded(count) {
    if (count == 1) each(this.inputs, input => each(input, value => hasFluidValue(value) && addFluidObserver(value, this)));
  }

  observerRemoved(count) {
    if (count == 0) each(this.inputs, input => each(input, value => hasFluidValue(value) && removeFluidObserver(value, this)));
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._value = null;
    }

    callFluidObservers(this, event);
  }

}

const primitives = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

const _excluded$3 = ["scrollTop", "scrollLeft"];
globals.assign({
  batchedUpdates: unstable_batchedUpdates,
  createStringInterpolator,
  colors
});
const host = createHost(primitives, {
  applyAnimatedValues,
  createAnimatedStyle: style => new AnimatedStyle(style),
  getComponentProps: _ref => {
    let props = _objectWithoutPropertiesLoose$2(_ref, _excluded$3);

    return props;
  }
});
const animated = host.animated;

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var childContainerStyles = process.env.NODE_ENV === "production" ? {
  name: "1om60a6",
  styles: "overflow:hidden;padding-top:8px"
} : {
  name: "1kd57e4-childContainerStyles",
  styles: "overflow:hidden;padding-top:8px;label:childContainerStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};

var titleContainerStyles = function titleContainerStyles(_a) {
  var isFocused = _a.isFocused;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css(__assign(__assign(__assign({}, TextStyles({
      type: 'b300',
      tokens: uiTokens
    })), FocusStyles({
      isFocused: isFocused,
      tokens: uiTokens
    })), {
      cursor: 'pointer',
      display: 'inline-flex',
      flexDirection: 'row'
    }), process.env.NODE_ENV === "production" ? "" : ";label:titleContainerStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:titleContainerStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};

var titleStyles$1 = process.env.NODE_ENV === "production" ? {
  name: "110i5o6",
  styles: "padding-right:16px"
} : {
  name: "p075db-titleStyles",
  styles: "padding-right:16px;label:titleStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
/**
 * This component provides an expander/showHide control
 * that, upon activation, reveals a content area.
 */

var Expander = function Expander(props) {
  var children = props.children,
      title = props.title,
      isOpen = props.isOpen,
      onToggle = props.onToggle,
      id = props.id,
      maxHeight = props.maxHeight;

  var _a = useState(false),
      isFocused = _a[0],
      setIsFocused = _a[1];

  var ref = useRef(null);
  var buttonProps = $701a24aa0da5b062$export$ea18c227d4417cc3(__assign(__assign({}, props), {
    elementType: 'div'
  }), ref).buttonProps;
  var focusProps = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    onFocusChange: function onFocusChange() {
      return setIsFocused(!isFocused);
    }
  }).focusProps;
  var rotateZ = useSpring({
    rotateZ: isOpen ? 0 : 180
  }).rotateZ;
  var childTransitions = useTransition(isOpen, {
    from: {
      opacity: 0,
      maxHeight: 0
    },
    enter: {
      opacity: 1,
      maxHeight: maxHeight
    },
    reverse: isOpen,
    config: config.gentle,
    expires: false
  });

  var handleToggle = function handleToggle() {
    onToggle(!isOpen);
  };

  var handleKeyboardEvent = function handleKeyboardEvent(event) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      handleToggle();
    }
  };

  return jsx("div", {
    id: id
  }, jsx("div", __assign({}, buttonProps, focusProps, {
    css: titleContainerStyles({
      isFocused: isFocused
    }),
    "aria-pressed": isOpen,
    onClick: handleToggle,
    onKeyDown: handleKeyboardEvent,
    ref: ref,
    role: "button",
    tabIndex: 0
  }), jsx("span", {
    css: titleStyles$1
  }, title), jsx(animated.div, {
    style: {
      transform: rotateZ.to(function (z) {
        return "rotateZ(".concat(z, "deg)");
      })
    }
  }, jsx(Icon, {
    icon: "angle-up"
  }))), childTransitions(function (styles, loaded) {
    return loaded && jsx(animated.div, {
      css: childContainerStyles,
      style: styles
    }, children);
  }));
};

Expander.defaultProps = {
  maxHeight: 500
};

var propTypes = {exports: {}};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = require$$0;
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = require$$0;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value.dataTransfer);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (dt === null) {
                        return [2 /*return*/, []];
                    }
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var _default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray$1(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).map(function (_ref4) {
      var _ref5 = _slicedToArray$1(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return {
        accept: _defineProperty$1({}, mimeType, ext)
      };
    });
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray$1(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */

var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/forwardRef$2(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React__default.createElement(Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: propTypes.exports.func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: propTypes.exports.objectOf(propTypes.exports.arrayOf(propTypes.exports.string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: propTypes.exports.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: propTypes.exports.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: propTypes.exports.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: propTypes.exports.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: propTypes.exports.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: propTypes.exports.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: propTypes.exports.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: propTypes.exports.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: propTypes.exports.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: propTypes.exports.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: propTypes.exports.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: propTypes.exports.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: propTypes.exports.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: propTypes.exports.bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: propTypes.exports.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: propTypes.exports.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: propTypes.exports.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: propTypes.exports.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: propTypes.exports.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: propTypes.exports.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: propTypes.exports.func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: propTypes.exports.func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: propTypes.exports.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = useMemo(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = useMemo(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = useMemo(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

  useEffect(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = useCallback(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case "reset":
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}

var titleIconWrapperStyles = function titleIconWrapperStyles(_a) {
  var isDisabled = _a.isDisabled;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css({
      display: 'flex',
      border: "2px dashed ".concat(isDisabled ? uiTokens.color.base.gray.v100.value : uiTokens.color.base.gray.v400.value),
      borderRadius: '4px',
      padding: "".concat(uiTokens.spacing.v300.value, "px"),
      backgroundColor: uiTokens.color.base.gray.v25.value,
      textAlign: 'left',
      verticalAlign: 'middle',
      maxWidth: '100%',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      color: isDisabled ? uiTokens.color.base.gray.v600.value : uiTokens.color.base.black.value
    }, process.env.NODE_ENV === "production" ? "" : ";label:titleIconWrapperStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbGVEcm9wem9uZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUVciLCJmaWxlIjoiRmlsZURyb3B6b25lLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IF9fYXNzaWduIH0gZnJvbSBcInRzbGliXCI7XHJcbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5pbXBvcnQgdG9rZW5zIGZyb20gJ0BmbGV4ZS91aS10b2tlbnMnO1xyXG5pbXBvcnQgRHJvcHpvbmUgZnJvbSAncmVhY3QtZHJvcHpvbmUnO1xyXG5pbXBvcnQgSWNvbiBmcm9tICcuLi9JY29uL0ljb24nO1xyXG5pbXBvcnQgVGV4dFN0eWxlcyBmcm9tICcuLi8uLi9fc3R5bGVzL3RleHQnO1xyXG52YXIgdGl0bGVJY29uV3JhcHBlclN0eWxlcyA9IGZ1bmN0aW9uIChfYSkge1xyXG4gICAgdmFyIGlzRGlzYWJsZWQgPSBfYS5pc0Rpc2FibGVkO1xyXG4gICAgcmV0dXJuIGNzcyh7XHJcbiAgICAgICAgZGlzcGxheTogJ2ZsZXgnLFxyXG4gICAgICAgIGJvcmRlcjogXCIycHggZGFzaGVkIFwiLmNvbmNhdChpc0Rpc2FibGVkXHJcbiAgICAgICAgICAgID8gdG9rZW5zLmNvbG9yLmJhc2UuZ3JheS52MTAwLnZhbHVlXHJcbiAgICAgICAgICAgIDogdG9rZW5zLmNvbG9yLmJhc2UuZ3JheS52NDAwLnZhbHVlKSxcclxuICAgICAgICBib3JkZXJSYWRpdXM6ICc0cHgnLFxyXG4gICAgICAgIHBhZGRpbmc6IFwiXCIuY29uY2F0KHRva2Vucy5zcGFjaW5nLnYzMDAudmFsdWUsIFwicHhcIiksXHJcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0b2tlbnMuY29sb3IuYmFzZS5ncmF5LnYyNS52YWx1ZSxcclxuICAgICAgICB0ZXh0QWxpZ246ICdsZWZ0JyxcclxuICAgICAgICB2ZXJ0aWNhbEFsaWduOiAnbWlkZGxlJyxcclxuICAgICAgICBtYXhXaWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGN1cnNvcjogaXNEaXNhYmxlZCA/ICdub3QtYWxsb3dlZCcgOiAncG9pbnRlcicsXHJcbiAgICAgICAgY29sb3I6IGlzRGlzYWJsZWRcclxuICAgICAgICAgICAgPyB0b2tlbnMuY29sb3IuYmFzZS5ncmF5LnY2MDAudmFsdWVcclxuICAgICAgICAgICAgOiB0b2tlbnMuY29sb3IuYmFzZS5ibGFjay52YWx1ZVxyXG4gICAgfSk7XHJcbn07XHJcbnZhciB0aXRsZUljb25JY29uU3R5bGVzID0gZnVuY3Rpb24gKF9hKSB7XHJcbiAgICB2YXIgaXNEaXNhYmxlZCA9IF9hLmlzRGlzYWJsZWQ7XHJcbiAgICByZXR1cm4gY3NzKHtcclxuICAgICAgICBkaXNwbGF5OiAnZmxleCcsXHJcbiAgICAgICAgYWxpZ25JdGVtczogJ2NlbnRlcicsXHJcbiAgICAgICAgcGFkZGluZ1JpZ2h0OiB0b2tlbnMuc3BhY2luZy52NDAwLnZhbHVlLFxyXG4gICAgICAgIGNvbG9yOiBpc0Rpc2FibGVkXHJcbiAgICAgICAgICAgID8gdG9rZW5zLmNvbG9yLmJhc2UuYmx1ZS52MTAwLnZhbHVlXHJcbiAgICAgICAgICAgIDogdG9rZW5zLmNvbG9yLmJhc2UuZGlnaXRhbFNlY29uZGFyeS52MzAwLnZhbHVlXHJcbiAgICB9KTtcclxufTtcclxudmFyIHRpdGxlU3R5bGVzID0gY3NzKF9fYXNzaWduKF9fYXNzaWduKHt9LCBUZXh0U3R5bGVzKHsgdHlwZTogJ2gzMDAnLCB0b2tlbnM6IHRva2VucyB9KSksIHsgbWFyZ2luQm90dG9tOiAnMCcgfSkpO1xyXG52YXIgc3VidGl0bGVTdHlsZXMgPSBjc3MoX19hc3NpZ24oX19hc3NpZ24oe30sIFRleHRTdHlsZXMoeyB0eXBlOiAnYjMwMCcsIHRva2VuczogdG9rZW5zIH0pKSwgeyBtYXJnaW5Ub3A6IFwiXCIuY29uY2F0KHRva2Vucy5zcGFjaW5nLnYxMDAudmFsdWUsIFwicHhcIiksIG1hcmdpbkJvdHRvbTogXCJcIi5jb25jYXQodG9rZW5zLnNwYWNpbmcudjIwMC52YWx1ZSwgXCJweFwiKSB9KSk7XHJcbi8qKlxyXG4gKiBBbGxvd3Mgc2VsZWN0aW9uIG9mIGZpbGVzIGZvciB1cGxvYWQgdmlhIGRyYWcgJ24gZHJvcCBvciBjbGljayBuJyBwaWNrLiAgVGhpcyBjb21wb25lbnQgX2RvZXMgbm90XyBhY3R1YWxseSB1cGxvYWQgdGhlIGZpbGVzIVxyXG4gKi9cclxudmFyIEZpbGVEcm9wem9uZSA9IGZ1bmN0aW9uIChwcm9wcykge1xyXG4gICAgcmV0dXJuIChqc3goRHJvcHpvbmUsIHsgb25Ecm9wOiBwcm9wcy5vbkZpbGVEcm9wLCBvbkRyb3BBY2NlcHRlZDogcHJvcHMub25BY2NlcHRlZEZpbGVzLCBvbkRyb3BSZWplY3RlZDogcHJvcHMub25SZWplY3RlZEZpbGVzLCBvbkVycm9yOiBwcm9wcy5vbkRyb3B6b25lRXJyb3IsIGFjY2VwdDogcHJvcHMuYWNjZXB0ZWRGaWxlVHlwZXMsIG11bHRpcGxlOiBwcm9wcy5tdWx0aXBsZSwgZGlzYWJsZWQ6IHByb3BzLmlzRGlzYWJsZWQsIG1heFNpemU6IHByb3BzLm1heFNpemUsIG1heEZpbGVzOiBwcm9wcy5tYXhGaWxlcywgbm9DbGljazogcHJvcHMubm9DbGljaywgdmFsaWRhdG9yOiBwcm9wcy52YWxpZGF0b3IsIGF1dG9Gb2N1czogcHJvcHMuYXV0b0ZvY3VzLCBvbkRyYWdFbnRlcjogcHJvcHMub25EcmFnRW50ZXIsIG9uRHJhZ0xlYXZlOiBwcm9wcy5vbkRyYWdMZWF2ZSwgb25EcmFnT3ZlcjogcHJvcHMub25EcmFnT3ZlciwgZ2V0RmlsZXNGcm9tRXZlbnQ6IHByb3BzLmdldEZpbGVzRnJvbUV2ZW50IH0sIGZ1bmN0aW9uIChfYSkge1xyXG4gICAgICAgIHZhciBnZXRSb290UHJvcHMgPSBfYS5nZXRSb290UHJvcHMsIGdldElucHV0UHJvcHMgPSBfYS5nZXRJbnB1dFByb3BzO1xyXG4gICAgICAgIHJldHVybiAoanN4KFwic3BhblwiLCBfX2Fzc2lnbih7fSwgZ2V0Um9vdFByb3BzKCkpLFxyXG4gICAgICAgICAgICBqc3goXCJpbnB1dFwiLCBfX2Fzc2lnbih7fSwgZ2V0SW5wdXRQcm9wcygpLCB7IFwiZGF0YS10ZXN0aWRcIjogXCJkcm9wem9uZS1pbnB1dFwiIH0pKSxcclxuICAgICAgICAgICAganN4KFwiZGl2XCIsIHsgY3NzOiB0aXRsZUljb25XcmFwcGVyU3R5bGVzKHsgaXNEaXNhYmxlZDogcHJvcHMuaXNEaXNhYmxlZCB9KSB9LFxyXG4gICAgICAgICAgICAgICAganN4KFwic3BhblwiLCB7IGNzczogdGl0bGVJY29uSWNvblN0eWxlcyh7IGlzRGlzYWJsZWQ6IHByb3BzLmlzRGlzYWJsZWQgfSkgfSxcclxuICAgICAgICAgICAgICAgICAgICBqc3goSWNvbiwgeyBpY29uOiBcInVwbG9hZFwiLCBzaXplOiBcIjJ4XCIgfSkpLFxyXG4gICAgICAgICAgICAgICAganN4KFwiZGl2XCIsIG51bGwsXHJcbiAgICAgICAgICAgICAgICAgICAganN4KFwicFwiLCB7IGNzczogdGl0bGVTdHlsZXMgfSwgcHJvcHMudGl0bGUpLFxyXG4gICAgICAgICAgICAgICAgICAgIGpzeChcInBcIiwgeyBjc3M6IHN1YnRpdGxlU3R5bGVzIH0sIHByb3BzLnN1YnRpdGxlKSkpKSk7XHJcbiAgICB9KSk7XHJcbn07XHJcbi8vIG1vc3Qgb2YgdGhlIGRlZmF1bHRzIGFyZSBzZXQgYnkgcmVhY3QtZHJvcHpvbmVcclxuLy8gdGhlc2UgbmVlZCB0byBiZSBzZXQgZXhwbGljaXRseSBmb3Igb3VyIHVzZSBjYXNlc1xyXG5GaWxlRHJvcHpvbmUuZGVmYXVsdFByb3BzID0ge1xyXG4gICAgbXVsdGlwbGU6IGZhbHNlLFxyXG4gICAgbWF4U2l6ZTogMiAqIDEwMjQgKiAxMDI0LFxyXG4gICAgdGl0bGU6ICdVcGxvYWQgWW91ciBGaWxlJyxcclxuICAgIHN1YnRpdGxlOiAnRHJhZyBhbmQgZHJvcCBvciBjbGljayB0byBjaG9vc2UgYSBmaWxlIGZvciB1cGxvYWQnXHJcbn07XHJcbmV4cG9ydCBkZWZhdWx0IEZpbGVEcm9wem9uZTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9RmlsZURyb3B6b25lLmpzLm1hcCJdfQ== */", process.env.NODE_ENV === "production" ? "" : ";label:titleIconWrapperStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};

var titleIconIconStyles = function titleIconIconStyles(_a) {
  var isDisabled = _a.isDisabled;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css({
      display: 'flex',
      alignItems: 'center',
      paddingRight: uiTokens.spacing.v400.value,
      color: isDisabled ? uiTokens.color.base.blue.v100.value : uiTokens.color.base.digitalSecondary.v300.value
    }, process.env.NODE_ENV === "production" ? "" : ";label:titleIconIconStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:titleIconIconStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};

var titleStyles =
/*#__PURE__*/

/*#__PURE__*/
css(__assign(__assign({}, TextStyles({
  type: 'h300',
  tokens: uiTokens
})), {
  marginBottom: '0'
}), process.env.NODE_ENV === "production" ? "" : ";label:titleStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:titleStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var subtitleStyles =
/*#__PURE__*/

/*#__PURE__*/
css(__assign(__assign({}, TextStyles({
  type: 'b300',
  tokens: uiTokens
})), {
  marginTop: "".concat(uiTokens.spacing.v100.value, "px"),
  marginBottom: "".concat(uiTokens.spacing.v200.value, "px")
}), process.env.NODE_ENV === "production" ? "" : ";label:subtitleStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:subtitleStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbGVEcm9wem9uZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBcUNxQiIsImZpbGUiOiJGaWxlRHJvcHpvbmUudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19hc3NpZ24gfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XHJcbmltcG9ydCB0b2tlbnMgZnJvbSAnQGZsZXhlL3VpLXRva2Vucyc7XHJcbmltcG9ydCBEcm9wem9uZSBmcm9tICdyZWFjdC1kcm9wem9uZSc7XHJcbmltcG9ydCBJY29uIGZyb20gJy4uL0ljb24vSWNvbic7XHJcbmltcG9ydCBUZXh0U3R5bGVzIGZyb20gJy4uLy4uL19zdHlsZXMvdGV4dCc7XHJcbnZhciB0aXRsZUljb25XcmFwcGVyU3R5bGVzID0gZnVuY3Rpb24gKF9hKSB7XHJcbiAgICB2YXIgaXNEaXNhYmxlZCA9IF9hLmlzRGlzYWJsZWQ7XHJcbiAgICByZXR1cm4gY3NzKHtcclxuICAgICAgICBkaXNwbGF5OiAnZmxleCcsXHJcbiAgICAgICAgYm9yZGVyOiBcIjJweCBkYXNoZWQgXCIuY29uY2F0KGlzRGlzYWJsZWRcclxuICAgICAgICAgICAgPyB0b2tlbnMuY29sb3IuYmFzZS5ncmF5LnYxMDAudmFsdWVcclxuICAgICAgICAgICAgOiB0b2tlbnMuY29sb3IuYmFzZS5ncmF5LnY0MDAudmFsdWUpLFxyXG4gICAgICAgIGJvcmRlclJhZGl1czogJzRweCcsXHJcbiAgICAgICAgcGFkZGluZzogXCJcIi5jb25jYXQodG9rZW5zLnNwYWNpbmcudjMwMC52YWx1ZSwgXCJweFwiKSxcclxuICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRva2Vucy5jb2xvci5iYXNlLmdyYXkudjI1LnZhbHVlLFxyXG4gICAgICAgIHRleHRBbGlnbjogJ2xlZnQnLFxyXG4gICAgICAgIHZlcnRpY2FsQWxpZ246ICdtaWRkbGUnLFxyXG4gICAgICAgIG1heFdpZHRoOiAnMTAwJScsXHJcbiAgICAgICAgY3Vyc29yOiBpc0Rpc2FibGVkID8gJ25vdC1hbGxvd2VkJyA6ICdwb2ludGVyJyxcclxuICAgICAgICBjb2xvcjogaXNEaXNhYmxlZFxyXG4gICAgICAgICAgICA/IHRva2Vucy5jb2xvci5iYXNlLmdyYXkudjYwMC52YWx1ZVxyXG4gICAgICAgICAgICA6IHRva2Vucy5jb2xvci5iYXNlLmJsYWNrLnZhbHVlXHJcbiAgICB9KTtcclxufTtcclxudmFyIHRpdGxlSWNvbkljb25TdHlsZXMgPSBmdW5jdGlvbiAoX2EpIHtcclxuICAgIHZhciBpc0Rpc2FibGVkID0gX2EuaXNEaXNhYmxlZDtcclxuICAgIHJldHVybiBjc3Moe1xyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcclxuICAgICAgICBwYWRkaW5nUmlnaHQ6IHRva2Vucy5zcGFjaW5nLnY0MDAudmFsdWUsXHJcbiAgICAgICAgY29sb3I6IGlzRGlzYWJsZWRcclxuICAgICAgICAgICAgPyB0b2tlbnMuY29sb3IuYmFzZS5ibHVlLnYxMDAudmFsdWVcclxuICAgICAgICAgICAgOiB0b2tlbnMuY29sb3IuYmFzZS5kaWdpdGFsU2Vjb25kYXJ5LnYzMDAudmFsdWVcclxuICAgIH0pO1xyXG59O1xyXG52YXIgdGl0bGVTdHlsZXMgPSBjc3MoX19hc3NpZ24oX19hc3NpZ24oe30sIFRleHRTdHlsZXMoeyB0eXBlOiAnaDMwMCcsIHRva2VuczogdG9rZW5zIH0pKSwgeyBtYXJnaW5Cb3R0b206ICcwJyB9KSk7XHJcbnZhciBzdWJ0aXRsZVN0eWxlcyA9IGNzcyhfX2Fzc2lnbihfX2Fzc2lnbih7fSwgVGV4dFN0eWxlcyh7IHR5cGU6ICdiMzAwJywgdG9rZW5zOiB0b2tlbnMgfSkpLCB7IG1hcmdpblRvcDogXCJcIi5jb25jYXQodG9rZW5zLnNwYWNpbmcudjEwMC52YWx1ZSwgXCJweFwiKSwgbWFyZ2luQm90dG9tOiBcIlwiLmNvbmNhdCh0b2tlbnMuc3BhY2luZy52MjAwLnZhbHVlLCBcInB4XCIpIH0pKTtcclxuLyoqXHJcbiAqIEFsbG93cyBzZWxlY3Rpb24gb2YgZmlsZXMgZm9yIHVwbG9hZCB2aWEgZHJhZyAnbiBkcm9wIG9yIGNsaWNrIG4nIHBpY2suICBUaGlzIGNvbXBvbmVudCBfZG9lcyBub3RfIGFjdHVhbGx5IHVwbG9hZCB0aGUgZmlsZXMhXHJcbiAqL1xyXG52YXIgRmlsZURyb3B6b25lID0gZnVuY3Rpb24gKHByb3BzKSB7XHJcbiAgICByZXR1cm4gKGpzeChEcm9wem9uZSwgeyBvbkRyb3A6IHByb3BzLm9uRmlsZURyb3AsIG9uRHJvcEFjY2VwdGVkOiBwcm9wcy5vbkFjY2VwdGVkRmlsZXMsIG9uRHJvcFJlamVjdGVkOiBwcm9wcy5vblJlamVjdGVkRmlsZXMsIG9uRXJyb3I6IHByb3BzLm9uRHJvcHpvbmVFcnJvciwgYWNjZXB0OiBwcm9wcy5hY2NlcHRlZEZpbGVUeXBlcywgbXVsdGlwbGU6IHByb3BzLm11bHRpcGxlLCBkaXNhYmxlZDogcHJvcHMuaXNEaXNhYmxlZCwgbWF4U2l6ZTogcHJvcHMubWF4U2l6ZSwgbWF4RmlsZXM6IHByb3BzLm1heEZpbGVzLCBub0NsaWNrOiBwcm9wcy5ub0NsaWNrLCB2YWxpZGF0b3I6IHByb3BzLnZhbGlkYXRvciwgYXV0b0ZvY3VzOiBwcm9wcy5hdXRvRm9jdXMsIG9uRHJhZ0VudGVyOiBwcm9wcy5vbkRyYWdFbnRlciwgb25EcmFnTGVhdmU6IHByb3BzLm9uRHJhZ0xlYXZlLCBvbkRyYWdPdmVyOiBwcm9wcy5vbkRyYWdPdmVyLCBnZXRGaWxlc0Zyb21FdmVudDogcHJvcHMuZ2V0RmlsZXNGcm9tRXZlbnQgfSwgZnVuY3Rpb24gKF9hKSB7XHJcbiAgICAgICAgdmFyIGdldFJvb3RQcm9wcyA9IF9hLmdldFJvb3RQcm9wcywgZ2V0SW5wdXRQcm9wcyA9IF9hLmdldElucHV0UHJvcHM7XHJcbiAgICAgICAgcmV0dXJuIChqc3goXCJzcGFuXCIsIF9fYXNzaWduKHt9LCBnZXRSb290UHJvcHMoKSksXHJcbiAgICAgICAgICAgIGpzeChcImlucHV0XCIsIF9fYXNzaWduKHt9LCBnZXRJbnB1dFByb3BzKCksIHsgXCJkYXRhLXRlc3RpZFwiOiBcImRyb3B6b25lLWlucHV0XCIgfSkpLFxyXG4gICAgICAgICAgICBqc3goXCJkaXZcIiwgeyBjc3M6IHRpdGxlSWNvbldyYXBwZXJTdHlsZXMoeyBpc0Rpc2FibGVkOiBwcm9wcy5pc0Rpc2FibGVkIH0pIH0sXHJcbiAgICAgICAgICAgICAgICBqc3goXCJzcGFuXCIsIHsgY3NzOiB0aXRsZUljb25JY29uU3R5bGVzKHsgaXNEaXNhYmxlZDogcHJvcHMuaXNEaXNhYmxlZCB9KSB9LFxyXG4gICAgICAgICAgICAgICAgICAgIGpzeChJY29uLCB7IGljb246IFwidXBsb2FkXCIsIHNpemU6IFwiMnhcIiB9KSksXHJcbiAgICAgICAgICAgICAgICBqc3goXCJkaXZcIiwgbnVsbCxcclxuICAgICAgICAgICAgICAgICAgICBqc3goXCJwXCIsIHsgY3NzOiB0aXRsZVN0eWxlcyB9LCBwcm9wcy50aXRsZSksXHJcbiAgICAgICAgICAgICAgICAgICAganN4KFwicFwiLCB7IGNzczogc3VidGl0bGVTdHlsZXMgfSwgcHJvcHMuc3VidGl0bGUpKSkpKTtcclxuICAgIH0pKTtcclxufTtcclxuLy8gbW9zdCBvZiB0aGUgZGVmYXVsdHMgYXJlIHNldCBieSByZWFjdC1kcm9wem9uZVxyXG4vLyB0aGVzZSBuZWVkIHRvIGJlIHNldCBleHBsaWNpdGx5IGZvciBvdXIgdXNlIGNhc2VzXHJcbkZpbGVEcm9wem9uZS5kZWZhdWx0UHJvcHMgPSB7XHJcbiAgICBtdWx0aXBsZTogZmFsc2UsXHJcbiAgICBtYXhTaXplOiAyICogMTAyNCAqIDEwMjQsXHJcbiAgICB0aXRsZTogJ1VwbG9hZCBZb3VyIEZpbGUnLFxyXG4gICAgc3VidGl0bGU6ICdEcmFnIGFuZCBkcm9wIG9yIGNsaWNrIHRvIGNob29zZSBhIGZpbGUgZm9yIHVwbG9hZCdcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgRmlsZURyb3B6b25lO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1GaWxlRHJvcHpvbmUuanMubWFwIl19 */");
/**
 * Allows selection of files for upload via drag 'n drop or click n' pick.  This component _does not_ actually upload the files!
 */

var FileDropzone = function FileDropzone(props) {
  return jsx(Dropzone, {
    onDrop: props.onFileDrop,
    onDropAccepted: props.onAcceptedFiles,
    onDropRejected: props.onRejectedFiles,
    onError: props.onDropzoneError,
    accept: props.acceptedFileTypes,
    multiple: props.multiple,
    disabled: props.isDisabled,
    maxSize: props.maxSize,
    maxFiles: props.maxFiles,
    noClick: props.noClick,
    validator: props.validator,
    autoFocus: props.autoFocus,
    onDragEnter: props.onDragEnter,
    onDragLeave: props.onDragLeave,
    onDragOver: props.onDragOver,
    getFilesFromEvent: props.getFilesFromEvent
  }, function (_a) {
    var getRootProps = _a.getRootProps,
        getInputProps = _a.getInputProps;
    return jsx("span", __assign({}, getRootProps()), jsx("input", __assign({}, getInputProps(), {
      "data-testid": "dropzone-input"
    })), jsx("div", {
      css: titleIconWrapperStyles({
        isDisabled: props.isDisabled
      })
    }, jsx("span", {
      css: titleIconIconStyles({
        isDisabled: props.isDisabled
      })
    }, jsx(Icon, {
      icon: "upload",
      size: "2x"
    })), jsx("div", null, jsx("p", {
      css: titleStyles
    }, props.title), jsx("p", {
      css: subtitleStyles
    }, props.subtitle))));
  });
}; // most of the defaults are set by react-dropzone
// these need to be set explicitly for our use cases


FileDropzone.defaultProps = {
  multiple: false,
  maxSize: 2 * 1024 * 1024,
  title: 'Upload Your File',
  subtitle: 'Drag and drop or click to choose a file for upload'
};

var chosenFileStyles =
/*#__PURE__*/

/*#__PURE__*/
css(__assign(__assign({}, TextStyles({
  type: 'h100',
  tokens: uiTokens
})), {
  margin: "".concat(uiTokens.spacing.v200.value, "px 0"),
  color: uiTokens.color.base.gray.v500.value
}), process.env.NODE_ENV === "production" ? "" : ";label:chosenFileStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbGVTZWxlY3RMYWJlbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSXVCIiwiZmlsZSI6IkZpbGVTZWxlY3RMYWJlbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBfX2Fzc2lnbiB9IGZyb20gXCJ0c2xpYlwiO1xyXG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcclxuaW1wb3J0IHRva2VucyBmcm9tICdAZmxleGUvdWktdG9rZW5zJztcclxuaW1wb3J0IFRleHRTdHlsZXMgZnJvbSAnLi4vLi4vX3N0eWxlcy90ZXh0JztcclxudmFyIGNob3NlbkZpbGVTdHlsZXMgPSBjc3MoX19hc3NpZ24oX19hc3NpZ24oe30sIFRleHRTdHlsZXMoeyB0eXBlOiAnaDEwMCcsIHRva2VuczogdG9rZW5zIH0pKSwgeyBtYXJnaW46IFwiXCIuY29uY2F0KHRva2Vucy5zcGFjaW5nLnYyMDAudmFsdWUsIFwicHggMFwiKSwgY29sb3I6IHRva2Vucy5jb2xvci5iYXNlLmdyYXkudjUwMC52YWx1ZSB9KSk7XHJcbnZhciBmaWxlbmFtZVN0eWxlcyA9IGNzcyh7XHJcbiAgICBmb250U3R5bGU6ICdpdGFsaWMnLFxyXG4gICAgZm9udFdlaWdodDogdG9rZW5zLmZvbnQuYjQwMC53ZWlnaHQudmFsdWVcclxufSk7XHJcbnZhciBGaWxlU2VsZWN0TGFiZWwgPSBmdW5jdGlvbiAocHJvcHMpIHtcclxuICAgIHJldHVybiAoanN4KFwiZGl2XCIsIHsgY3NzOiBjaG9zZW5GaWxlU3R5bGVzIH0sXHJcbiAgICAgICAgXCJGaWxlIHNlbGVjdGVkOlwiLFxyXG4gICAgICAgIGpzeChcInNwYW5cIiwgeyBjc3M6IGZpbGVuYW1lU3R5bGVzIH0sIHByb3BzLnNlbGVjdGVkRmlsZSA/IFwiIFwiLmNvbmNhdChwcm9wcy5zZWxlY3RlZEZpbGUpIDogJyBubyBmaWxlIHNlbGVjdGVkJykpKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgRmlsZVNlbGVjdExhYmVsO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1GaWxlU2VsZWN0TGFiZWwuanMubWFwIl19 */", process.env.NODE_ENV === "production" ? "" : ";label:chosenFileStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbGVTZWxlY3RMYWJlbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSXVCIiwiZmlsZSI6IkZpbGVTZWxlY3RMYWJlbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBfX2Fzc2lnbiB9IGZyb20gXCJ0c2xpYlwiO1xyXG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcclxuaW1wb3J0IHRva2VucyBmcm9tICdAZmxleGUvdWktdG9rZW5zJztcclxuaW1wb3J0IFRleHRTdHlsZXMgZnJvbSAnLi4vLi4vX3N0eWxlcy90ZXh0JztcclxudmFyIGNob3NlbkZpbGVTdHlsZXMgPSBjc3MoX19hc3NpZ24oX19hc3NpZ24oe30sIFRleHRTdHlsZXMoeyB0eXBlOiAnaDEwMCcsIHRva2VuczogdG9rZW5zIH0pKSwgeyBtYXJnaW46IFwiXCIuY29uY2F0KHRva2Vucy5zcGFjaW5nLnYyMDAudmFsdWUsIFwicHggMFwiKSwgY29sb3I6IHRva2Vucy5jb2xvci5iYXNlLmdyYXkudjUwMC52YWx1ZSB9KSk7XHJcbnZhciBmaWxlbmFtZVN0eWxlcyA9IGNzcyh7XHJcbiAgICBmb250U3R5bGU6ICdpdGFsaWMnLFxyXG4gICAgZm9udFdlaWdodDogdG9rZW5zLmZvbnQuYjQwMC53ZWlnaHQudmFsdWVcclxufSk7XHJcbnZhciBGaWxlU2VsZWN0TGFiZWwgPSBmdW5jdGlvbiAocHJvcHMpIHtcclxuICAgIHJldHVybiAoanN4KFwiZGl2XCIsIHsgY3NzOiBjaG9zZW5GaWxlU3R5bGVzIH0sXHJcbiAgICAgICAgXCJGaWxlIHNlbGVjdGVkOlwiLFxyXG4gICAgICAgIGpzeChcInNwYW5cIiwgeyBjc3M6IGZpbGVuYW1lU3R5bGVzIH0sIHByb3BzLnNlbGVjdGVkRmlsZSA/IFwiIFwiLmNvbmNhdChwcm9wcy5zZWxlY3RlZEZpbGUpIDogJyBubyBmaWxlIHNlbGVjdGVkJykpKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgRmlsZVNlbGVjdExhYmVsO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1GaWxlU2VsZWN0TGFiZWwuanMubWFwIl19 */");
var filenameStyles =
/*#__PURE__*/

/*#__PURE__*/
css({
  fontStyle: 'italic',
  fontWeight: uiTokens.font.b400.weight.value
}, process.env.NODE_ENV === "production" ? "" : ";label:filenameStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbGVTZWxlY3RMYWJlbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS3FCIiwiZmlsZSI6IkZpbGVTZWxlY3RMYWJlbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBfX2Fzc2lnbiB9IGZyb20gXCJ0c2xpYlwiO1xyXG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcclxuaW1wb3J0IHRva2VucyBmcm9tICdAZmxleGUvdWktdG9rZW5zJztcclxuaW1wb3J0IFRleHRTdHlsZXMgZnJvbSAnLi4vLi4vX3N0eWxlcy90ZXh0JztcclxudmFyIGNob3NlbkZpbGVTdHlsZXMgPSBjc3MoX19hc3NpZ24oX19hc3NpZ24oe30sIFRleHRTdHlsZXMoeyB0eXBlOiAnaDEwMCcsIHRva2VuczogdG9rZW5zIH0pKSwgeyBtYXJnaW46IFwiXCIuY29uY2F0KHRva2Vucy5zcGFjaW5nLnYyMDAudmFsdWUsIFwicHggMFwiKSwgY29sb3I6IHRva2Vucy5jb2xvci5iYXNlLmdyYXkudjUwMC52YWx1ZSB9KSk7XHJcbnZhciBmaWxlbmFtZVN0eWxlcyA9IGNzcyh7XHJcbiAgICBmb250U3R5bGU6ICdpdGFsaWMnLFxyXG4gICAgZm9udFdlaWdodDogdG9rZW5zLmZvbnQuYjQwMC53ZWlnaHQudmFsdWVcclxufSk7XHJcbnZhciBGaWxlU2VsZWN0TGFiZWwgPSBmdW5jdGlvbiAocHJvcHMpIHtcclxuICAgIHJldHVybiAoanN4KFwiZGl2XCIsIHsgY3NzOiBjaG9zZW5GaWxlU3R5bGVzIH0sXHJcbiAgICAgICAgXCJGaWxlIHNlbGVjdGVkOlwiLFxyXG4gICAgICAgIGpzeChcInNwYW5cIiwgeyBjc3M6IGZpbGVuYW1lU3R5bGVzIH0sIHByb3BzLnNlbGVjdGVkRmlsZSA/IFwiIFwiLmNvbmNhdChwcm9wcy5zZWxlY3RlZEZpbGUpIDogJyBubyBmaWxlIHNlbGVjdGVkJykpKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgRmlsZVNlbGVjdExhYmVsO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1GaWxlU2VsZWN0TGFiZWwuanMubWFwIl19 */", process.env.NODE_ENV === "production" ? "" : ";label:filenameStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbGVTZWxlY3RMYWJlbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS3FCIiwiZmlsZSI6IkZpbGVTZWxlY3RMYWJlbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBfX2Fzc2lnbiB9IGZyb20gXCJ0c2xpYlwiO1xyXG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcclxuaW1wb3J0IHRva2VucyBmcm9tICdAZmxleGUvdWktdG9rZW5zJztcclxuaW1wb3J0IFRleHRTdHlsZXMgZnJvbSAnLi4vLi4vX3N0eWxlcy90ZXh0JztcclxudmFyIGNob3NlbkZpbGVTdHlsZXMgPSBjc3MoX19hc3NpZ24oX19hc3NpZ24oe30sIFRleHRTdHlsZXMoeyB0eXBlOiAnaDEwMCcsIHRva2VuczogdG9rZW5zIH0pKSwgeyBtYXJnaW46IFwiXCIuY29uY2F0KHRva2Vucy5zcGFjaW5nLnYyMDAudmFsdWUsIFwicHggMFwiKSwgY29sb3I6IHRva2Vucy5jb2xvci5iYXNlLmdyYXkudjUwMC52YWx1ZSB9KSk7XHJcbnZhciBmaWxlbmFtZVN0eWxlcyA9IGNzcyh7XHJcbiAgICBmb250U3R5bGU6ICdpdGFsaWMnLFxyXG4gICAgZm9udFdlaWdodDogdG9rZW5zLmZvbnQuYjQwMC53ZWlnaHQudmFsdWVcclxufSk7XHJcbnZhciBGaWxlU2VsZWN0TGFiZWwgPSBmdW5jdGlvbiAocHJvcHMpIHtcclxuICAgIHJldHVybiAoanN4KFwiZGl2XCIsIHsgY3NzOiBjaG9zZW5GaWxlU3R5bGVzIH0sXHJcbiAgICAgICAgXCJGaWxlIHNlbGVjdGVkOlwiLFxyXG4gICAgICAgIGpzeChcInNwYW5cIiwgeyBjc3M6IGZpbGVuYW1lU3R5bGVzIH0sIHByb3BzLnNlbGVjdGVkRmlsZSA/IFwiIFwiLmNvbmNhdChwcm9wcy5zZWxlY3RlZEZpbGUpIDogJyBubyBmaWxlIHNlbGVjdGVkJykpKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgRmlsZVNlbGVjdExhYmVsO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1GaWxlU2VsZWN0TGFiZWwuanMubWFwIl19 */");

var FileSelectLabel = function FileSelectLabel(props) {
  return jsx("div", {
    css: chosenFileStyles
  }, "File selected:", jsx("span", {
    css: filenameStyles
  }, props.selectedFile ? " ".concat(props.selectedFile) : ' no file selected'));
};

var LEVEL_MAP = {
  Headline1: {
    token: 'h600',
    bold: 'h600'
  },
  Headline2: {
    token: 'b800',
    bold: 'h500'
  },
  Title1: {
    token: 'b700',
    bold: 'h400'
  },
  Title2: {
    token: 'b600',
    bold: 'h300'
  },
  Title3: {
    token: 'b500',
    bold: 'h200'
  },
  Body1: {
    token: 'b400',
    bold: 'h100'
  },
  Body2: {
    token: 'b300',
    bold: 'h90'
  },
  Caption1: {
    token: 'b200',
    bold: 'h80'
  },
  Caption2: {
    token: 'b100',
    bold: 'h70'
  }
};

var textStyles = function textStyles(_a) {
  var _b, _c;

  var propType = _a.type,
      alignment = _a.alignment,
      bold = _a.bold,
      breakWord = _a.breakWord,
      color = _a.color,
      level = _a.level,
      transform = _a.transform,
      truncate = _a.truncate,
      fontStyle = _a.fontStyle; // If the propType (aka the more advanced way to select font tokens)
  // is set, we use that. Otherwise we use the level property in
  // conjunction with the bold property to get the token from
  // the LEVEL_MAP.

  var type;
  if (propType) type = propType;else if (level && bold) type = (_b = LEVEL_MAP[level]) === null || _b === void 0 ? void 0 : _b.bold;else if (level) type = (_c = LEVEL_MAP[level]) === null || _c === void 0 ? void 0 : _c.token;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css(__assign(__assign({}, TextStyles({
      type: type,
      tokens: uiTokens,
      fontStyle: fontStyle
    })), {
      color: color || uiTokens.color.base.black.value,
      overflow: truncate ? 'hidden' : 'visible',
      overflowWrap: breakWord ? 'break-word' : 'normal',
      textAlign: alignment || 'start',
      textOverflow: truncate ? 'ellipsis' : '',
      textTransform: transform,
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale'
    }), process.env.NODE_ENV === "production" ? "" : ";label:textStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:textStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};
/**
 * This component can be used to apply ui-component text styles to the UI. Text
 * styles will cascade to descendant Text, Heading, and Link components as well
 * as native HTML elements, but not to other ui-components that define
 * their own text styles.
 */


var Text = function Text(_a) {
  var alignment = _a.alignment,
      bold = _a.bold,
      breakWord = _a.breakWord,
      children = _a.children,
      color = _a.color,
      htmlFor = _a.htmlFor,
      id = _a.id,
      _b = _a.level,
      level = _b === void 0 ? 'Body1' : _b,
      role = _a.role,
      tabIndex = _a.tabIndex,
      _c = _a.tag,
      tag = _c === void 0 ? 'p' : _c,
      title = _a.title,
      transform = _a.transform,
      truncate = _a.truncate,
      type = _a.type,
      fontStyle = _a.fontStyle;
  return jsx(tag, {
    css: textStyles({
      type: type,
      alignment: alignment,
      bold: bold,
      breakWord: breakWord,
      color: color,
      level: level,
      transform: transform,
      truncate: truncate,
      fontStyle: fontStyle || 'inherit'
    }),
    id: id,
    htmlFor: htmlFor,
    role: role,
    tabIndex: tabIndex,
    title: title !== undefined && truncate && typeof children === 'string' ? title : ''
  }, children);
};

Text.defaultProps = {
  tag: 'p',
  level: 'Body 1',
  fontStyle: 'inherit'
};
Text.displayName = 'Text';

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var fileSelectorWrapperStyles = process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "alwkjf-fileSelectorWrapperStyles",
  styles: "display:flex;align-items:center;label:fileSelectorWrapperStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
var spacerStyles =
/*#__PURE__*/

/*#__PURE__*/
css({
  margin: "0 ".concat(uiTokens.spacing.v400.value, "px")
}, process.env.NODE_ENV === "production" ? "" : ";label:spacerStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:spacerStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var dropzonePositioningStyles = process.env.NODE_ENV === "production" ? {
  name: "mkkf9p",
  styles: "flex:1 1 auto"
} : {
  name: "1gldue-dropzonePositioningStyles",
  styles: "flex:1 1 auto;label:dropzonePositioningStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
/**
 *
 * For selecting a file to upload. This component **does not actually upload the chosen file!**
 */

var FileSelector = function FileSelector(_a) {
  var _b = _a.buttonVisualType,
      buttonVisualType = _b === void 0 ? 'default' : _b,
      props = __rest(_a, ["buttonVisualType"]);

  return jsx(React__default.Fragment, null, jsx("div", {
    css: fileSelectorWrapperStyles
  }, props.dropzoneProps && jsx("span", {
    css: dropzonePositioningStyles
  }, jsx(FileDropzone, __assign({}, props.dropzoneProps))), props.dropzoneProps && props.fileInputAccept && jsx("span", {
    css: spacerStyles
  }, jsx(Text, {
    tag: "span",
    type: "h200"
  }, "or")), props.fileInputAccept && jsx(Button, {
    isFileInput: true,
    fileInputAccept: props.fileInputAccept,
    onFileSelected: props.fileInputOnChange,
    visualType: buttonVisualType
  }, "Choose File")), jsx(FileSelectLabel, {
    selectedFile: props.selectedFile
  }), props.errors);
};

FileSelector.propTypes = {
  fileInputAccept: function fileInputAccept(props, componentName) {
    if (!props.fileInputAccept && !props.dropzoneProps) {
      return new Error("You need to specify either 'fileInputAccept' or 'dropzoneProps' when using '".concat(componentName, "'."));
    }

    return null;
  },
  dropzoneProps: function dropzoneProps(props, componentName) {
    if (!props.fileInputAccept && !props.dropzoneProps) {
      return new Error("You need to specify either 'fileInputAccept' or 'dropzoneProps' when using '".concat(componentName, "'."));
    }

    return null;
  }
};
FileSelector.defaultProps = {
  showSelected: true
};

var headingTokenMapping = {
  h1: 'h600',
  h2: 'h500',
  h3: 'h400',
  h4: 'h300',
  h5: 'h200',
  h6: 'h100'
};
/**
 * This component can be used to easily create headings that
 * correspond to the [6 HTML headings](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Heading_Elements).
 */

var Heading = function Heading(_a) {
  var alignment = _a.alignment,
      level = _a.level,
      children = _a.children,
      color = _a.color,
      id = _a.id,
      tabIndex = _a.tabIndex,
      type = _a.type,
      truncate = _a.truncate,
      transform = _a.transform;
  return /*#__PURE__*/React__default.createElement(Text, {
    alignment: alignment,
    color: color,
    tabIndex: tabIndex,
    tag: level,
    id: id,
    transform: transform,
    truncate: truncate,
    type: type || headingTokenMapping[level]
  }, children);
};

Heading.displayName = 'Heading';

var errorMessageStyles =
/*#__PURE__*/

/*#__PURE__*/
css(__assign(__assign({}, TextStyles({
  type: 'b100',
  tokens: uiTokens
})), {
  color: uiTokens.color.base.red.v500.value
}), process.env.NODE_ENV === "production" ? "" : ";label:errorMessageStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0RXJyb3JNZXNzYWdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNeUIiLCJmaWxlIjoiSW5wdXRFcnJvck1lc3NhZ2UudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19hc3NpZ24gfSBmcm9tIFwidHNsaWJcIjtcclxuLyoqIEBqc3hSdW50aW1lIGNsYXNzaWMgKi9cclxuLyoqIEBqc3gganN4ICovXHJcbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5pbXBvcnQgdG9rZW5zIGZyb20gJ0BmbGV4ZS91aS10b2tlbnMnO1xyXG5pbXBvcnQgVGV4dFN0eWxlcyBmcm9tICcuLi8uLi9fc3R5bGVzL3RleHQnO1xyXG52YXIgZXJyb3JNZXNzYWdlU3R5bGVzID0gY3NzKF9fYXNzaWduKF9fYXNzaWduKHt9LCBUZXh0U3R5bGVzKHsgdHlwZTogJ2IxMDAnLCB0b2tlbnM6IHRva2VucyB9KSksIHsgY29sb3I6IHRva2Vucy5jb2xvci5iYXNlLnJlZC52NTAwLnZhbHVlIH0pKTtcclxuLyoqXHJcbiAqIEVycm9yIG1lc3NhZ2UgZm9yIGlucHV0IGNvbXBvbmVudHMuIE5vdGUgdGhhdCBpZiB5b3UncmUgdXNpbmcgdGhlIGBUZXh0SW5wdXRgIGNvbXBvbmVudCwgeW91IHNob3VsZCB1c2UgdGhlIGBlcnJvck1lc3NhZ2VgIHByb3AgaW5zdGVhZCBvZiB0aGlzIGNvbXBvbmVudC5cclxuICovXHJcbnZhciBJbnB1dEVycm9yTWVzc2FnZSA9IGZ1bmN0aW9uIChfYSkge1xyXG4gICAgdmFyIGNoaWxkcmVuID0gX2EuY2hpbGRyZW4sIGlkID0gX2EuaWQ7XHJcbiAgICByZXR1cm4gKGpzeChcImRpdlwiLCB7IGlkOiBpZCwgY3NzOiBlcnJvck1lc3NhZ2VTdHlsZXMgfSwgY2hpbGRyZW4pKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgSW5wdXRFcnJvck1lc3NhZ2U7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUlucHV0RXJyb3JNZXNzYWdlLmpzLm1hcCJdfQ== */", process.env.NODE_ENV === "production" ? "" : ";label:errorMessageStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0RXJyb3JNZXNzYWdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNeUIiLCJmaWxlIjoiSW5wdXRFcnJvck1lc3NhZ2UudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19hc3NpZ24gfSBmcm9tIFwidHNsaWJcIjtcclxuLyoqIEBqc3hSdW50aW1lIGNsYXNzaWMgKi9cclxuLyoqIEBqc3gganN4ICovXHJcbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5pbXBvcnQgdG9rZW5zIGZyb20gJ0BmbGV4ZS91aS10b2tlbnMnO1xyXG5pbXBvcnQgVGV4dFN0eWxlcyBmcm9tICcuLi8uLi9fc3R5bGVzL3RleHQnO1xyXG52YXIgZXJyb3JNZXNzYWdlU3R5bGVzID0gY3NzKF9fYXNzaWduKF9fYXNzaWduKHt9LCBUZXh0U3R5bGVzKHsgdHlwZTogJ2IxMDAnLCB0b2tlbnM6IHRva2VucyB9KSksIHsgY29sb3I6IHRva2Vucy5jb2xvci5iYXNlLnJlZC52NTAwLnZhbHVlIH0pKTtcclxuLyoqXHJcbiAqIEVycm9yIG1lc3NhZ2UgZm9yIGlucHV0IGNvbXBvbmVudHMuIE5vdGUgdGhhdCBpZiB5b3UncmUgdXNpbmcgdGhlIGBUZXh0SW5wdXRgIGNvbXBvbmVudCwgeW91IHNob3VsZCB1c2UgdGhlIGBlcnJvck1lc3NhZ2VgIHByb3AgaW5zdGVhZCBvZiB0aGlzIGNvbXBvbmVudC5cclxuICovXHJcbnZhciBJbnB1dEVycm9yTWVzc2FnZSA9IGZ1bmN0aW9uIChfYSkge1xyXG4gICAgdmFyIGNoaWxkcmVuID0gX2EuY2hpbGRyZW4sIGlkID0gX2EuaWQ7XHJcbiAgICByZXR1cm4gKGpzeChcImRpdlwiLCB7IGlkOiBpZCwgY3NzOiBlcnJvck1lc3NhZ2VTdHlsZXMgfSwgY2hpbGRyZW4pKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgSW5wdXRFcnJvck1lc3NhZ2U7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUlucHV0RXJyb3JNZXNzYWdlLmpzLm1hcCJdfQ== */");
/**
 * Error message for input components. Note that if you're using the `TextInput` component, you should use the `errorMessage` prop instead of this component.
 */

var InputErrorMessage = function InputErrorMessage(_a) {
  var children = _a.children,
      id = _a.id;
  return jsx("div", {
    id: id,
    css: errorMessageStyles
  }, children);
};

var descriptionStyles = function descriptionStyles(_a) {
  var isDisabled = _a.isDisabled;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css(__assign(__assign({}, TextStyles({
      type: 'b100',
      tokens: uiTokens
    })), {
      color: isDisabled ? uiTokens.color.base.gray.v100.value : uiTokens.color.base.gray.v400.value
    }), process.env.NODE_ENV === "production" ? "" : ";label:descriptionStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0RGVzY3JpcHRpb24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFXIiwiZmlsZSI6IklucHV0RGVzY3JpcHRpb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19hc3NpZ24gfSBmcm9tIFwidHNsaWJcIjtcclxuLyoqIEBqc3hSdW50aW1lIGNsYXNzaWMgKi9cclxuLyoqIEBqc3gganN4ICovXHJcbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5pbXBvcnQgdG9rZW5zIGZyb20gJ0BmbGV4ZS91aS10b2tlbnMnO1xyXG5pbXBvcnQgVGV4dFN0eWxlcyBmcm9tICcuLi8uLi9fc3R5bGVzL3RleHQnO1xyXG52YXIgZGVzY3JpcHRpb25TdHlsZXMgPSBmdW5jdGlvbiAoX2EpIHtcclxuICAgIHZhciBpc0Rpc2FibGVkID0gX2EuaXNEaXNhYmxlZDtcclxuICAgIHJldHVybiBjc3MoX19hc3NpZ24oX19hc3NpZ24oe30sIFRleHRTdHlsZXMoeyB0eXBlOiAnYjEwMCcsIHRva2VuczogdG9rZW5zIH0pKSwgeyBjb2xvcjogaXNEaXNhYmxlZFxyXG4gICAgICAgICAgICA/IHRva2Vucy5jb2xvci5iYXNlLmdyYXkudjEwMC52YWx1ZVxyXG4gICAgICAgICAgICA6IHRva2Vucy5jb2xvci5iYXNlLmdyYXkudjQwMC52YWx1ZSB9KSk7XHJcbn07XHJcbi8qKlxyXG4gKlxyXG4gKiBIZWxwZXIgdGV4dCBmb3IgaW5wdXQgY29tcG9uZW50cy4gTm90ZSB0aGF0IGlmIHlvdSdyZSB1c2luZyB0aGUgYFRleHRJbnB1dGAgY29tcG9uZW50LCB5b3Ugc2hvdWxkIHVzZSB0aGUgYGhlbHBlclRleHRgIHByb3AgaW5zdGVhZCBvZiB0aGlzIGNvbXBvbmVudC5cclxuICovXHJcbnZhciBJbnB1dERlc2NyaXB0aW9uID0gZnVuY3Rpb24gKF9hKSB7XHJcbiAgICB2YXIgY2hpbGRyZW4gPSBfYS5jaGlsZHJlbiwgaWQgPSBfYS5pZCwgaXNEaXNhYmxlZCA9IF9hLmlzRGlzYWJsZWQ7XHJcbiAgICByZXR1cm4gKGpzeChcImRpdlwiLCB7IGlkOiBpZCwgY3NzOiBkZXNjcmlwdGlvblN0eWxlcyh7IGlzRGlzYWJsZWQ6IGlzRGlzYWJsZWQgfSkgfSwgY2hpbGRyZW4pKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgSW5wdXREZXNjcmlwdGlvbjtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9SW5wdXREZXNjcmlwdGlvbi5qcy5tYXAiXX0= */", process.env.NODE_ENV === "production" ? "" : ";label:descriptionStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0RGVzY3JpcHRpb24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFXIiwiZmlsZSI6IklucHV0RGVzY3JpcHRpb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19hc3NpZ24gfSBmcm9tIFwidHNsaWJcIjtcclxuLyoqIEBqc3hSdW50aW1lIGNsYXNzaWMgKi9cclxuLyoqIEBqc3gganN4ICovXHJcbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5pbXBvcnQgdG9rZW5zIGZyb20gJ0BmbGV4ZS91aS10b2tlbnMnO1xyXG5pbXBvcnQgVGV4dFN0eWxlcyBmcm9tICcuLi8uLi9fc3R5bGVzL3RleHQnO1xyXG52YXIgZGVzY3JpcHRpb25TdHlsZXMgPSBmdW5jdGlvbiAoX2EpIHtcclxuICAgIHZhciBpc0Rpc2FibGVkID0gX2EuaXNEaXNhYmxlZDtcclxuICAgIHJldHVybiBjc3MoX19hc3NpZ24oX19hc3NpZ24oe30sIFRleHRTdHlsZXMoeyB0eXBlOiAnYjEwMCcsIHRva2VuczogdG9rZW5zIH0pKSwgeyBjb2xvcjogaXNEaXNhYmxlZFxyXG4gICAgICAgICAgICA/IHRva2Vucy5jb2xvci5iYXNlLmdyYXkudjEwMC52YWx1ZVxyXG4gICAgICAgICAgICA6IHRva2Vucy5jb2xvci5iYXNlLmdyYXkudjQwMC52YWx1ZSB9KSk7XHJcbn07XHJcbi8qKlxyXG4gKlxyXG4gKiBIZWxwZXIgdGV4dCBmb3IgaW5wdXQgY29tcG9uZW50cy4gTm90ZSB0aGF0IGlmIHlvdSdyZSB1c2luZyB0aGUgYFRleHRJbnB1dGAgY29tcG9uZW50LCB5b3Ugc2hvdWxkIHVzZSB0aGUgYGhlbHBlclRleHRgIHByb3AgaW5zdGVhZCBvZiB0aGlzIGNvbXBvbmVudC5cclxuICovXHJcbnZhciBJbnB1dERlc2NyaXB0aW9uID0gZnVuY3Rpb24gKF9hKSB7XHJcbiAgICB2YXIgY2hpbGRyZW4gPSBfYS5jaGlsZHJlbiwgaWQgPSBfYS5pZCwgaXNEaXNhYmxlZCA9IF9hLmlzRGlzYWJsZWQ7XHJcbiAgICByZXR1cm4gKGpzeChcImRpdlwiLCB7IGlkOiBpZCwgY3NzOiBkZXNjcmlwdGlvblN0eWxlcyh7IGlzRGlzYWJsZWQ6IGlzRGlzYWJsZWQgfSkgfSwgY2hpbGRyZW4pKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgSW5wdXREZXNjcmlwdGlvbjtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9SW5wdXREZXNjcmlwdGlvbi5qcy5tYXAiXX0= */")
  );
};
/**
 *
 * Helper text for input components. Note that if you're using the `TextInput` component, you should use the `helperText` prop instead of this component.
 */


var InputDescription = function InputDescription(_a) {
  var children = _a.children,
      id = _a.id,
      isDisabled = _a.isDisabled;
  return jsx("div", {
    id: id,
    css: descriptionStyles({
      isDisabled: isDisabled
    })
  }, children);
};

var CSSTransitionGroup = {exports: {}};

var TransitionGroup = {exports: {}};

var chainFunction = function chain(){
  var len = arguments.length;
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i];

  args = args.filter(function(fn){ return fn != null });

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
};

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning$1 = function() {};

if (__DEV__) {
  warning$1 = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

var warning_1 = warning$1;

var ChildMapping = {};

ChildMapping.__esModule = true;
ChildMapping.getChildMapping = getChildMapping;
ChildMapping.mergeChildMappings = mergeChildMappings;

var _react$1 = React__default;

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react$1.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

(function (module, exports) {

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _chainFunction = chainFunction;

	var _chainFunction2 = _interopRequireDefault(_chainFunction);

	var _react = React__default;

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = propTypes.exports;

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _warning = warning_1;

	var _warning2 = _interopRequireDefault(_warning);

	var _ChildMapping = ChildMapping;

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var propTypes$1 = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};

	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};

	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);

	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);

	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;

	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };

	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }

	      delete _this.currentlyTransitioningKeys[key];

	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };

	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;

	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };

	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }

	      delete _this.currentlyTransitioningKeys[key];

	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };

	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;

	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };

	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }

	      delete _this.currentlyTransitioningKeys[key];

	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };

	    _this.childRefs = Object.create(null);

	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }

	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };

	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };

	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;

	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });

	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }

	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }

	    // If we want to someday check for reordering, we could do it here.
	  };

	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;

	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });

	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };

	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;

	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];

	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };

	        process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }

	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };

	    for (var key in this.state.children) {
	      _loop(key);
	    }

	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;

	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };

	  return TransitionGroup;
	}(_react2.default.Component);

	TransitionGroup.displayName = 'TransitionGroup';


	TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? propTypes$1 : {};
	TransitionGroup.defaultProps = defaultProps;

	exports.default = TransitionGroup;
	module.exports = exports['default'];
} (TransitionGroup, TransitionGroup.exports));

var CSSTransitionGroupChild = {exports: {}};

var addClass = {exports: {}};

var hasClass = {exports: {}};

var hasRequiredHasClass;

function requireHasClass () {
	if (hasRequiredHasClass) return hasClass.exports;
	hasRequiredHasClass = 1;
	(function (module, exports) {

		exports.__esModule = true;
		exports.default = hasClass;

		function hasClass(element, className) {
		  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
		}

		module.exports = exports["default"];
} (hasClass, hasClass.exports));
	return hasClass.exports;
}

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefault.exports;

	exports.__esModule = true;
	exports.default = addClass;

	var _hasClass = _interopRequireDefault(requireHasClass());

	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}

	module.exports = exports["default"];
} (addClass, addClass.exports));

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

var removeClass = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

var requestAnimationFrame$1 = {exports: {}};

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefault.exports;

	exports.__esModule = true;
	exports.default = void 0;

	var _inDOM = _interopRequireDefault(requireInDOM());

	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;

	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};

	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');

	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */


	var prev = new Date().getTime();

	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}

	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};

	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};

	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];
} (requestAnimationFrame$1, requestAnimationFrame$1.exports));

var PropTypes = {};

PropTypes.__esModule = true;
PropTypes.nameShape = undefined;
PropTypes.transitionTimeout = transitionTimeout;

var _react = React__default;

_interopRequireDefault$1(_react);

var _propTypes = propTypes.exports;

var _propTypes2 = _interopRequireDefault$1(_propTypes);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

PropTypes.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

(function (module, exports) {

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _addClass = addClass.exports;

	var _addClass2 = _interopRequireDefault(_addClass);

	var _removeClass = removeClass;

	var _removeClass2 = _interopRequireDefault(_removeClass);

	var _requestAnimationFrame = requestAnimationFrame$1.exports;

	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

	var _properties = properties;

	var _react = React__default;

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = propTypes.exports;

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _reactDom = $9Q8De$reactdom;

	var _PropTypes = PropTypes;

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);

	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }

	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}

	var propTypes$1 = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,

	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};

	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);

	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, CSSTransitionGroupChild);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };

	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;

	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });

	    this.classNameAndNodeQueue.length = 0;
	  };

	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);

	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }

	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;

	    (0, _addClass2.default)(node, className);

	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);

	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }

	      clearTimeout(timer);
	      if (removeListeners) removeListeners();

	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);

	      if (removeListeners) removeListeners();

	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };

	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };

	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;

	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });

	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };

	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };

	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };

	  return CSSTransitionGroupChild;
	}(_react2.default.Component);

	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


	CSSTransitionGroupChild.propTypes = process.env.NODE_ENV !== "production" ? propTypes$1 : {};

	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];
} (CSSTransitionGroupChild, CSSTransitionGroupChild.exports));

(function (module, exports) {

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _react = React__default;

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = propTypes.exports;

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _TransitionGroup = TransitionGroup.exports;

	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

	var _CSSTransitionGroupChild = CSSTransitionGroupChild.exports;

	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

	var _PropTypes = PropTypes;

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var propTypes$1 = {
	  transitionName: _PropTypes.nameShape.isRequired,

	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};

	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};

	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);

	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, CSSTransitionGroup);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.


	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };

	  return CSSTransitionGroup;
	}(_react2.default.Component);

	CSSTransitionGroup.displayName = 'CSSTransitionGroup';


	CSSTransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? propTypes$1 : {};
	CSSTransitionGroup.defaultProps = defaultProps;

	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];
} (CSSTransitionGroup, CSSTransitionGroup.exports));

var _CSSTransitionGroup = CSSTransitionGroup.exports;

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TransitionGroup = TransitionGroup.exports;

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reactTransitionGroup = {
  TransitionGroup: _TransitionGroup2.default,
  CSSTransitionGroup: _CSSTransitionGroup2.default
};

/* eslint-disable react/no-unused-prop-types */

var LegacyModal = function LegacyModal(props) {
  var transitionTimeouts = {
    fast: 1,
    slow: 250
  };
  var transitionSpeed = props.transitionSpeed || 'slow';
  var transitionTimeout = transitionTimeouts[transitionSpeed];
  return /*#__PURE__*/React__default.createElement(reactTransitionGroup.CSSTransitionGroup, {
    transitionName: "react-modal",
    transitionEnterTimeout: transitionTimeout,
    transitionLeaveTimeout: transitionTimeout
  }, props.show && /*#__PURE__*/React__default.createElement("div", {
    className: "react-modal"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "modal-backdrop"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "modal",
    id: props.id,
    role: "dialog",
    "aria-labelledby": "".concat(props.id, "_label")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "modal-dialog".concat(props.size ? " modal-".concat(props.size) : ''),
    role: "document"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "modal-header"
  }, !props.hideClose && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    "data-testid": "close-button",
    className: "close",
    "aria-label": "Close",
    onClick: props.toggleModal,
    disabled: props.disableClose
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), typeof props.title === 'string' ? /*#__PURE__*/React__default.createElement("h4", {
    className: "modal-title",
    id: "".concat(props.id, "_label")
  }, props.title) : props.title), /*#__PURE__*/React__default.createElement("div", {
    className: "modal-body"
  }, props.children), props.footer && /*#__PURE__*/React__default.createElement("div", {
    className: "modal-footer text-center"
  }, props.footer))))));
};

var labelStyles = function labelStyles(_a) {
  var isDisabled = _a.isDisabled;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css(__assign(__assign({}, TextStyles({
      type: 'b100',
      tokens: uiTokens
    })), {
      color: isDisabled ? uiTokens.color.base.gray.v100.value : uiTokens.color.base.gray.v400.value,
      display: 'inline-flex'
    }), process.env.NODE_ENV === "production" ? "" : ";label:labelStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxhYmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRVyIsImZpbGUiOiJMYWJlbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBfX2Fzc2lnbiB9IGZyb20gXCJ0c2xpYlwiO1xyXG4vKiogQGpzeFJ1bnRpbWUgY2xhc3NpYyAqL1xyXG4vKiogQGpzeCBqc3ggKi9cclxuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XHJcbmltcG9ydCB0b2tlbnMgZnJvbSAnQGZsZXhlL3VpLXRva2Vucyc7XHJcbmltcG9ydCBUZXh0U3R5bGVzIGZyb20gJy4uLy4uL19zdHlsZXMvdGV4dCc7XHJcbnZhciBsYWJlbFN0eWxlcyA9IGZ1bmN0aW9uIChfYSkge1xyXG4gICAgdmFyIGlzRGlzYWJsZWQgPSBfYS5pc0Rpc2FibGVkO1xyXG4gICAgcmV0dXJuIGNzcyhfX2Fzc2lnbihfX2Fzc2lnbih7fSwgVGV4dFN0eWxlcyh7IHR5cGU6ICdiMTAwJywgdG9rZW5zOiB0b2tlbnMgfSkpLCB7IGNvbG9yOiBpc0Rpc2FibGVkXHJcbiAgICAgICAgICAgID8gdG9rZW5zLmNvbG9yLmJhc2UuZ3JheS52MTAwLnZhbHVlXHJcbiAgICAgICAgICAgIDogdG9rZW5zLmNvbG9yLmJhc2UuZ3JheS52NDAwLnZhbHVlLCBkaXNwbGF5OiAnaW5saW5lLWZsZXgnIH0pKTtcclxufTtcclxudmFyIExhYmVsID0gZnVuY3Rpb24gKF9hKSB7XHJcbiAgICB2YXIgY2hpbGRyZW4gPSBfYS5jaGlsZHJlbiwgaHRtbEZvciA9IF9hLmh0bWxGb3IsIGlkID0gX2EuaWQsIGlzRGlzYWJsZWQgPSBfYS5pc0Rpc2FibGVkO1xyXG4gICAgcmV0dXJuIChqc3goXCJsYWJlbFwiLCB7IGNzczogbGFiZWxTdHlsZXMoeyBpc0Rpc2FibGVkOiBpc0Rpc2FibGVkIH0pLCBpZDogaWQsIGh0bWxGb3I6IGh0bWxGb3IgfSwgY2hpbGRyZW4pKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgTGFiZWw7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUxhYmVsLmpzLm1hcCJdfQ== */", process.env.NODE_ENV === "production" ? "" : ";label:labelStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxhYmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRVyIsImZpbGUiOiJMYWJlbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBfX2Fzc2lnbiB9IGZyb20gXCJ0c2xpYlwiO1xyXG4vKiogQGpzeFJ1bnRpbWUgY2xhc3NpYyAqL1xyXG4vKiogQGpzeCBqc3ggKi9cclxuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XHJcbmltcG9ydCB0b2tlbnMgZnJvbSAnQGZsZXhlL3VpLXRva2Vucyc7XHJcbmltcG9ydCBUZXh0U3R5bGVzIGZyb20gJy4uLy4uL19zdHlsZXMvdGV4dCc7XHJcbnZhciBsYWJlbFN0eWxlcyA9IGZ1bmN0aW9uIChfYSkge1xyXG4gICAgdmFyIGlzRGlzYWJsZWQgPSBfYS5pc0Rpc2FibGVkO1xyXG4gICAgcmV0dXJuIGNzcyhfX2Fzc2lnbihfX2Fzc2lnbih7fSwgVGV4dFN0eWxlcyh7IHR5cGU6ICdiMTAwJywgdG9rZW5zOiB0b2tlbnMgfSkpLCB7IGNvbG9yOiBpc0Rpc2FibGVkXHJcbiAgICAgICAgICAgID8gdG9rZW5zLmNvbG9yLmJhc2UuZ3JheS52MTAwLnZhbHVlXHJcbiAgICAgICAgICAgIDogdG9rZW5zLmNvbG9yLmJhc2UuZ3JheS52NDAwLnZhbHVlLCBkaXNwbGF5OiAnaW5saW5lLWZsZXgnIH0pKTtcclxufTtcclxudmFyIExhYmVsID0gZnVuY3Rpb24gKF9hKSB7XHJcbiAgICB2YXIgY2hpbGRyZW4gPSBfYS5jaGlsZHJlbiwgaHRtbEZvciA9IF9hLmh0bWxGb3IsIGlkID0gX2EuaWQsIGlzRGlzYWJsZWQgPSBfYS5pc0Rpc2FibGVkO1xyXG4gICAgcmV0dXJuIChqc3goXCJsYWJlbFwiLCB7IGNzczogbGFiZWxTdHlsZXMoeyBpc0Rpc2FibGVkOiBpc0Rpc2FibGVkIH0pLCBpZDogaWQsIGh0bWxGb3I6IGh0bWxGb3IgfSwgY2hpbGRyZW4pKTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgTGFiZWw7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUxhYmVsLmpzLm1hcCJdfQ== */")
  );
};

var Label = function Label(_a) {
  var children = _a.children,
      htmlFor = _a.htmlFor,
      id = _a.id,
      isDisabled = _a.isDisabled;
  return jsx("label", {
    css: labelStyles({
      isDisabled: isDisabled
    }),
    id: id,
    htmlFor: htmlFor
  }, children);
};

var linkStyles = function linkStyles(_a) {
  var isDisabled = _a.isDisabled,
      type = _a.type,
      isFocused = _a.isFocused,
      isHovered = _a.isHovered,
      isPressed = _a.isPressed;
  var styleState = 'default';
  if (isDisabled) styleState = 'disabled';else if (isPressed) styleState = 'pressed';else if (isHovered) styleState = 'hover';
  var linkTokens = uiTokens.link;
  var color = linkTokens.foregroundColor[styleState].value;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css(__assign(__assign(__assign({}, TextStyles({
      type: type || null,
      tokens: uiTokens
    })), FocusStyles({
      isFocused: isFocused,
      tokens: uiTokens
    })), {
      color: color,
      cursor: !isDisabled ? 'pointer' : 'not-allowed',
      textDecoration: isHovered ? 'underline' : 'none',
      '&:visited': {
        color: linkTokens.foregroundColor.pressed.value
      }
    }), process.env.NODE_ENV === "production" ? "" : ";label:linkStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:linkStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};
/**
 * This component creates an accessible
 * 'a' tag for linking to other pages.
 */


var Link$1 = /*#__PURE__*/forwardRef$2(function (props, ref) {
  var children = props.children,
      href = props.href,
      rel = props.rel,
      isDisabled = props.isDisabled,
      tabIndex = props.tabIndex,
      target = props.target,
      type = props.type;
  var linkRef = ref || useRef(null);
  var linkProps = $298d61e98472621b$export$dcf14c9974fe2767(props, linkRef).linkProps;

  var _a = $f7dceffc5ad7768b$export$4e328f61c538687f(),
      isFocusVisible = _a.isFocusVisible,
      focusProps = _a.focusProps;

  var _b = $6179b936705e76d3$export$ae780daf29e6d456({}),
      hoverProps = _b.hoverProps,
      isHovered = _b.isHovered;

  var _c = $f6c31cce2adf654f$export$45712eceda6fad21({}),
      pressProps = _c.pressProps,
      isPressed = _c.isPressed;

  return jsx("a", __assign({
    css: linkStyles({
      isDisabled: isDisabled,
      type: type,
      isFocused: isFocusVisible,
      isHovered: isHovered,
      isPressed: isPressed
    })
  }, linkProps, focusProps, hoverProps, pressProps, {
    ref: linkRef,
    href: href,
    rel: rel,
    tabIndex: tabIndex,
    target: target
  }), children);
});

/** @jsxRuntime classic */

var Loader = function Loader(props) {
  return jsx("div", {
    className: "loader-component",
    "data-testid": "loader-wrap"
  }, props.loading && jsx("div", {
    className: "loader",
    "data-testid": "loader-visible"
  }, jsx("div", {
    className: "lds-ring"
  }, jsx("div", null), jsx("div", null), jsx("div", null), jsx("div", null))));
};

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $fc909762b330b746$exports = {};

$parcel$export($fc909762b330b746$exports, "useOverlayTriggerState", () => $fc909762b330b746$export$61c6a8c84e605fb6);

function $fc909762b330b746$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open () {
            setOpen(true);
        },
        close () {
            setOpen(false);
        },
        toggle () {
            setOpen(!isOpen);
        }
    };
}

var ModalHeader = function ModalHeader(props) {
  var headerWrapperStyles =
  /*#__PURE__*/

  /*#__PURE__*/
  css({
    borderRadius: '16px 16px 0 0',
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(uiTokens.color.base.gray.v100.value),
    padding: "".concat(uiTokens.spacing.v100.value, "px")
  }, process.env.NODE_ENV === "production" ? "" : ";label:headerWrapperStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:headerWrapperStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  var closeButtonStyles =
  /*#__PURE__*/

  /*#__PURE__*/
  css({
    marginLeft: "".concat(uiTokens.spacing.v200.value, "px")
  }, process.env.NODE_ENV === "production" ? "" : ";label:closeButtonStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:closeButtonStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

  var headerStyles = function headerStyles(_a) {
    var _b = _a.type,
        type = _b === void 0 ? 'h400' : _b,
        alignment = _a.alignment,
        breakWord = _a.breakWord,
        color = _a.color,
        transform = _a.transform,
        truncate = _a.truncate;
    return (
      /*#__PURE__*/

      /*#__PURE__*/
      css(__assign(__assign({}, TextStyles({
        type: type,
        tokens: uiTokens
      })), {
        color: color || uiTokens.color.base.black.value,
        overflow: truncate ? 'hidden' : 'visible',
        overflowWrap: breakWord ? 'break-word' : 'normal',
        textAlign: alignment || 'start',
        textOverflow: truncate ? 'ellipsis' : '',
        textTransform: transform
      }), process.env.NODE_ENV === "production" ? "" : ";label:headerStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:headerStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    );
  };

  var renderCloseButton = function renderCloseButton() {
    return jsx("span", {
      css: closeButtonStyles
    }, jsx(Button, {
      visualType: "icon",
      onPress: props.toggleModal
    }, jsx(Icon, {
      icon: "times",
      size: "2x"
    })));
  };

  return jsx("div", __assign({}, props.titleProps, {
    css: headerWrapperStyles
  }), jsx("span", {
    css: headerStyles
  }, jsx(Heading, {
    level: "h3"
  }, props.title), props.children), renderCloseButton());
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1xhs7ie",
  styles: "position:fixed;z-index:100;top:0;left:0;bottom:0;right:0;background:rgba(0, 0, 0, 0.5);display:flex;align-items:center;justify-content:center"
} : {
  name: "1tdqraw-modalStyles",
  styles: "position:fixed;z-index:100;top:0;left:0;bottom:0;right:0;background:rgba(0, 0, 0, 0.5);display:flex;align-items:center;justify-content:center;label:modalStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

var Modal = function Modal(props) {
  var title = props.title,
      subtitle = props.subtitle,
      isOpen = props.isOpen,
      toggleModal = props.toggleModal,
      size = props.size,
      children = props.children;
  var state = $fc909762b330b746$export$61c6a8c84e605fb6({
    isOpen: isOpen
  });
  var modalStyles = _ref;

  var modalBodyStyles = function modalBodyStyles(_a) {
    var sz = _a.sz;
    var maxWidthMap = {
      small: '24vw',
      medium: '48vw',
      large: '80vw',
      full: '96vw'
    };
    var minWidthMap = {
      small: '16vw',
      medium: '32vw',
      large: '48vw',
      full: '88vw'
    };
    return (
      /*#__PURE__*/

      /*#__PURE__*/
      css({
        background: uiTokens.color.base.white.value,
        borderRadius: '16px',
        padding: '8px',
        maxWidth: sz ? maxWidthMap[sz] : 'medium',
        minWidth: sz ? minWidthMap[sz] : 'medium'
      }, process.env.NODE_ENV === "production" ? "" : ";label:modalBodyStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:modalBodyStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    );
  };

  var closeButtonStyles = function closeButtonStyles(_a) {
    var hasHeader = _a.hasHeader;
    return (
      /*#__PURE__*/

      /*#__PURE__*/
      css({
        flex: hasHeader ? '' : '0 1 auto',
        marginLeft: "".concat(hasHeader && uiTokens.spacing.v200.value, "px"),
        position: !hasHeader ? 'absolute' : 'relative',
        top: !hasHeader ? '8px' : '',
        right: !hasHeader ? '8px' : '' // this pixel value is for absolute positioning

      }, process.env.NODE_ENV === "production" ? "" : ";label:closeButtonStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1vZGFsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFvRGUiLCJmaWxlIjoiTW9kYWwudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19hc3NpZ24gfSBmcm9tIFwidHNsaWJcIjtcclxuLyoqIEBqc3hSdW50aW1lIGNsYXNzaWMgKi9cclxuLyoqIEBqc3gganN4ICovXHJcbmltcG9ydCBSZWFjdCwgeyB1c2VSZWYgfSBmcm9tICdyZWFjdCc7XHJcbmltcG9ydCB7IHVzZVRyYW5zaXRpb24sIGFuaW1hdGVkLCBjb25maWcgfSBmcm9tICdAcmVhY3Qtc3ByaW5nL3dlYic7XHJcbmltcG9ydCB7IHVzZU92ZXJsYXlUcmlnZ2VyU3RhdGUgfSBmcm9tICdAcmVhY3Qtc3RhdGVseS9vdmVybGF5cyc7XHJcbmltcG9ydCB7IEZvY3VzU2NvcGUsIHVzZURpYWxvZywgdXNlT3ZlcmxheSwgdXNlUHJldmVudFNjcm9sbCB9IGZyb20gJ3JlYWN0LWFyaWEnO1xyXG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcclxuaW1wb3J0IHRva2VucyBmcm9tICdAZmxleGUvdWktdG9rZW5zJztcclxuaW1wb3J0IEJ1dHRvbiBmcm9tICcuLi9CdXR0b24vQnV0dG9uJztcclxuaW1wb3J0IEljb24gZnJvbSAnLi4vSWNvbi9JY29uJztcclxuaW1wb3J0IE1vZGFsSGVhZGVyIGZyb20gJy4uL01vZGFsSGVhZGVyL01vZGFsSGVhZGVyJztcclxudmFyIE1vZGFsID0gZnVuY3Rpb24gKHByb3BzKSB7XHJcbiAgICB2YXIgdGl0bGUgPSBwcm9wcy50aXRsZSwgc3VidGl0bGUgPSBwcm9wcy5zdWJ0aXRsZSwgaXNPcGVuID0gcHJvcHMuaXNPcGVuLCB0b2dnbGVNb2RhbCA9IHByb3BzLnRvZ2dsZU1vZGFsLCBzaXplID0gcHJvcHMuc2l6ZSwgY2hpbGRyZW4gPSBwcm9wcy5jaGlsZHJlbjtcclxuICAgIHZhciBzdGF0ZSA9IHVzZU92ZXJsYXlUcmlnZ2VyU3RhdGUoeyBpc09wZW46IGlzT3BlbiB9KTtcclxuICAgIHZhciBtb2RhbFN0eWxlcyA9IGNzcyh7XHJcbiAgICAgICAgcG9zaXRpb246ICdmaXhlZCcsXHJcbiAgICAgICAgLy8gVE9ETzogUE9SVC0yMDEgYnJpbmcgdGhpcyB6SW5kZXggdmFsdWUgaW50byBhbGlnbm1lbnRcclxuICAgICAgICB6SW5kZXg6ICcxMDAnLFxyXG4gICAgICAgIHRvcDogMCxcclxuICAgICAgICBsZWZ0OiAwLFxyXG4gICAgICAgIGJvdHRvbTogMCxcclxuICAgICAgICByaWdodDogMCxcclxuICAgICAgICBiYWNrZ3JvdW5kOiAncmdiYSgwLCAwLCAwLCAwLjUpJyxcclxuICAgICAgICBkaXNwbGF5OiAnZmxleCcsXHJcbiAgICAgICAgYWxpZ25JdGVtczogJ2NlbnRlcicsXHJcbiAgICAgICAganVzdGlmeUNvbnRlbnQ6ICdjZW50ZXInXHJcbiAgICB9KTtcclxuICAgIHZhciBtb2RhbEJvZHlTdHlsZXMgPSBmdW5jdGlvbiAoX2EpIHtcclxuICAgICAgICB2YXIgc3ogPSBfYS5zejtcclxuICAgICAgICB2YXIgbWF4V2lkdGhNYXAgPSB7XHJcbiAgICAgICAgICAgIHNtYWxsOiAnMjR2dycsXHJcbiAgICAgICAgICAgIG1lZGl1bTogJzQ4dncnLFxyXG4gICAgICAgICAgICBsYXJnZTogJzgwdncnLFxyXG4gICAgICAgICAgICBmdWxsOiAnOTZ2dydcclxuICAgICAgICB9O1xyXG4gICAgICAgIHZhciBtaW5XaWR0aE1hcCA9IHtcclxuICAgICAgICAgICAgc21hbGw6ICcxNnZ3JyxcclxuICAgICAgICAgICAgbWVkaXVtOiAnMzJ2dycsXHJcbiAgICAgICAgICAgIGxhcmdlOiAnNDh2dycsXHJcbiAgICAgICAgICAgIGZ1bGw6ICc4OHZ3J1xyXG4gICAgICAgIH07XHJcbiAgICAgICAgcmV0dXJuIGNzcyh7XHJcbiAgICAgICAgICAgIGJhY2tncm91bmQ6IHRva2Vucy5jb2xvci5iYXNlLndoaXRlLnZhbHVlLFxyXG4gICAgICAgICAgICBib3JkZXJSYWRpdXM6ICcxNnB4JyxcclxuICAgICAgICAgICAgcGFkZGluZzogJzhweCcsXHJcbiAgICAgICAgICAgIG1heFdpZHRoOiBzeiA/IG1heFdpZHRoTWFwW3N6XSA6ICdtZWRpdW0nLFxyXG4gICAgICAgICAgICBtaW5XaWR0aDogc3ogPyBtaW5XaWR0aE1hcFtzel0gOiAnbWVkaXVtJ1xyXG4gICAgICAgIH0pO1xyXG4gICAgfTtcclxuICAgIHZhciBjbG9zZUJ1dHRvblN0eWxlcyA9IGZ1bmN0aW9uIChfYSkge1xyXG4gICAgICAgIHZhciBoYXNIZWFkZXIgPSBfYS5oYXNIZWFkZXI7XHJcbiAgICAgICAgcmV0dXJuIGNzcyh7XHJcbiAgICAgICAgICAgIGZsZXg6IGhhc0hlYWRlciA/ICcnIDogJzAgMSBhdXRvJyxcclxuICAgICAgICAgICAgbWFyZ2luTGVmdDogXCJcIi5jb25jYXQoaGFzSGVhZGVyICYmIHRva2Vucy5zcGFjaW5nLnYyMDAudmFsdWUsIFwicHhcIiksXHJcbiAgICAgICAgICAgIHBvc2l0aW9uOiAhaGFzSGVhZGVyID8gJ2Fic29sdXRlJyA6ICdyZWxhdGl2ZScsXHJcbiAgICAgICAgICAgIHRvcDogIWhhc0hlYWRlciA/ICc4cHgnIDogJycsXHJcbiAgICAgICAgICAgIHJpZ2h0OiAhaGFzSGVhZGVyID8gJzhweCcgOiAnJyAvLyB0aGlzIHBpeGVsIHZhbHVlIGlzIGZvciBhYnNvbHV0ZSBwb3NpdGlvbmluZ1xyXG4gICAgICAgIH0pO1xyXG4gICAgfTtcclxuICAgIHZhciBtb2RhbENvbnRlbnRTdHlsZXMgPSBmdW5jdGlvbiAoX2EpIHtcclxuICAgICAgICB2YXIgaGFzSGVhZGVyID0gX2EuaGFzSGVhZGVyO1xyXG4gICAgICAgIHZhciBiaWdQYWQgPSBcIlwiLmNvbmNhdCh0b2tlbnMuc3BhY2luZy52MjAwLnZhbHVlLCBcInB4XCIpO1xyXG4gICAgICAgIHZhciBsaXR0bGVQYWQgPSBcIlwiLmNvbmNhdCh0b2tlbnMuc3BhY2luZy52MTAwLnZhbHVlLCBcInB4XCIpO1xyXG4gICAgICAgIHJldHVybiBjc3Moe1xyXG4gICAgICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcclxuICAgICAgICAgICAgcGFkZGluZzogIWhhc0hlYWRlclxyXG4gICAgICAgICAgICAgICAgPyBcIlwiLmNvbmNhdChiaWdQYWQsIFwiIFwiKS5jb25jYXQobGl0dGxlUGFkLCBcIiBcIikuY29uY2F0KGxpdHRsZVBhZCwgXCIgXCIpLmNvbmNhdChsaXR0bGVQYWQpXHJcbiAgICAgICAgICAgICAgICA6IFwiXCIuY29uY2F0KGxpdHRsZVBhZCksXHJcbiAgICAgICAgICAgIG92ZXJmbG93OiAnYXV0bycsXHJcbiAgICAgICAgICAgIG1heEhlaWdodDogJzcwdmgnLFxyXG4gICAgICAgICAgICBtaW5IZWlnaHQ6ICcxMHZoJ1xyXG4gICAgICAgIH0pO1xyXG4gICAgfTtcclxuICAgIC8vIEhhbmRsZSBpbnRlcmFjdGluZyBvdXRzaWRlIHRoZSBkaWFsb2cgYW5kIHByZXNzaW5nXHJcbiAgICAvLyB0aGUgRXNjYXBlIGtleSB0byBjbG9zZSB0aGUgbW9kYWwuXHJcbiAgICB2YXIgcmVmID0gdXNlUmVmKG51bGwpO1xyXG4gICAgdmFyIF9hID0gdXNlT3ZlcmxheShfX2Fzc2lnbihfX2Fzc2lnbih7fSwgcHJvcHMpLCB7IG9uQ2xvc2U6IHByb3BzLnRvZ2dsZU1vZGFsIH0pLCByZWYpLCBvdmVybGF5UHJvcHMgPSBfYS5vdmVybGF5UHJvcHMsIHVuZGVybGF5UHJvcHMgPSBfYS51bmRlcmxheVByb3BzO1xyXG4gICAgLy8gUHJldmVudCBzY3JvbGxpbmcgd2hpbGUgdGhlIG1vZGFsIGlzIG9wZW4sIGFuZCBoaWRlIGNvbnRlbnRcclxuICAgIC8vIG91dHNpZGUgdGhlIG1vZGFsIGZyb20gc2NyZWVuIHJlYWRlcnMuXHJcbiAgICB1c2VQcmV2ZW50U2Nyb2xsKHsgaXNEaXNhYmxlZDogIXN0YXRlLmlzT3BlbiB9KTtcclxuICAgIC8vIEdldCBwcm9wcyBmb3IgdGhlIGRpYWxvZyBhbmQgaXRzIHRpdGxlXHJcbiAgICB2YXIgX2IgPSB1c2VEaWFsb2cocHJvcHMsIHJlZiksIGRpYWxvZ1Byb3BzID0gX2IuZGlhbG9nUHJvcHMsIHRpdGxlUHJvcHMgPSBfYi50aXRsZVByb3BzO1xyXG4gICAgdmFyIHJlbmRlckNsb3NlQnV0dG9uID0gZnVuY3Rpb24gKCkge1xyXG4gICAgICAgIHJldHVybiAoanN4KFwic3BhblwiLCB7IGNzczogY2xvc2VCdXR0b25TdHlsZXMoeyBoYXNIZWFkZXI6ICEhdGl0bGUgfSkgfSxcclxuICAgICAgICAgICAganN4KEJ1dHRvbiwgeyB2aXN1YWxUeXBlOiBcImljb25cIiwgb25QcmVzczogdG9nZ2xlTW9kYWwgfSxcclxuICAgICAgICAgICAgICAgIGpzeChJY29uLCB7IGljb246IFwidGltZXNcIiB9KSkpKTtcclxuICAgIH07XHJcbiAgICB2YXIgcmVuZGVySGVhZGVyID0gZnVuY3Rpb24gKHRpdGxlVGV4dCkge1xyXG4gICAgICAgIHJldHVybiAoanN4KE1vZGFsSGVhZGVyLCB7IHRpdGxlOiB0aXRsZVRleHQsIHRvZ2dsZU1vZGFsOiB0b2dnbGVNb2RhbCwgdGl0bGVQcm9wczogdGl0bGVQcm9wcyB9LCBzdWJ0aXRsZSkpO1xyXG4gICAgfTtcclxuICAgIHZhciBtb2RhbFRyYW5zaXRpb25zID0gdXNlVHJhbnNpdGlvbihzdGF0ZS5pc09wZW4sIHtcclxuICAgICAgICBmcm9tOiB7IG9wYWNpdHk6IDAgfSxcclxuICAgICAgICBlbnRlcjogeyBvcGFjaXR5OiAxIH0sXHJcbiAgICAgICAgbGVhdmU6IHsgb3BhY2l0eTogMCB9LFxyXG4gICAgICAgIHJldmVyc2U6IHN0YXRlLmlzT3BlbixcclxuICAgICAgICBjb25maWc6IGNvbmZpZy5nZW50bGVcclxuICAgIH0pO1xyXG4gICAgcmV0dXJuIHN0YXRlLmlzT3BlbiA/IChqc3goUmVhY3QuRnJhZ21lbnQsIG51bGwsIG1vZGFsVHJhbnNpdGlvbnMoZnVuY3Rpb24gKHN0eWxlcywgbG9hZGVkKSB7XHJcbiAgICAgICAgcmV0dXJuIGxvYWRlZCAmJiAoanN4KGFuaW1hdGVkLmRpdiwgX19hc3NpZ24oeyBjc3M6IG1vZGFsU3R5bGVzIH0sIHVuZGVybGF5UHJvcHMsIHsgc3R5bGU6IHN0eWxlcyB9KSxcclxuICAgICAgICAgICAganN4KEZvY3VzU2NvcGUsIHsgY29udGFpbjogdHJ1ZSwgcmVzdG9yZUZvY3VzOiB0cnVlLCBhdXRvRm9jdXM6IHRydWUgfSxcclxuICAgICAgICAgICAgICAgIGpzeChcImRpdlwiLCBfX2Fzc2lnbih7fSwgb3ZlcmxheVByb3BzLCBkaWFsb2dQcm9wcywgeyByZWY6IHJlZiwgY3NzOiBtb2RhbEJvZHlTdHlsZXMoeyBzejogc2l6ZSB9KSB9KSxcclxuICAgICAgICAgICAgICAgICAgICB0aXRsZSAmJiByZW5kZXJIZWFkZXIodGl0bGUpLFxyXG4gICAgICAgICAgICAgICAgICAgIGpzeChcImRpdlwiLCB7IGNzczogbW9kYWxDb250ZW50U3R5bGVzKHsgaGFzSGVhZGVyOiAhIXRpdGxlIH0pIH0sXHJcbiAgICAgICAgICAgICAgICAgICAgICAgICF0aXRsZSAmJiByZW5kZXJDbG9zZUJ1dHRvbigpLFxyXG4gICAgICAgICAgICAgICAgICAgICAgICBjaGlsZHJlbikpKSkpO1xyXG4gICAgfSkpKSA6IG51bGw7XHJcbn07XHJcbk1vZGFsLmRlZmF1bHRQcm9wcyA9IHtcclxuICAgIHJvbGU6ICdkaWFsb2cnLFxyXG4gICAgc2l6ZTogJ21lZGl1bSdcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgTW9kYWw7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPU1vZGFsLmpzLm1hcCJdfQ== */", process.env.NODE_ENV === "production" ? "" : ";label:closeButtonStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    );
  };

  var modalContentStyles = function modalContentStyles(_a) {
    var hasHeader = _a.hasHeader;
    var bigPad = "".concat(uiTokens.spacing.v200.value, "px");
    var littlePad = "".concat(uiTokens.spacing.v100.value, "px");
    return (
      /*#__PURE__*/

      /*#__PURE__*/
      css({
        position: 'relative',
        padding: !hasHeader ? "".concat(bigPad, " ").concat(littlePad, " ").concat(littlePad, " ").concat(littlePad) : "".concat(littlePad),
        overflow: 'auto',
        maxHeight: '70vh',
        minHeight: '10vh'
      }, process.env.NODE_ENV === "production" ? "" : ";label:modalContentStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:modalContentStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    );
  }; // Handle interacting outside the dialog and pressing
  // the Escape key to close the modal.


  var ref = useRef(null);

  var _a = $a11501f3d1d39e6c$export$ea8f71083e90600f(__assign(__assign({}, props), {
    onClose: props.toggleModal
  }), ref),
      overlayProps = _a.overlayProps,
      underlayProps = _a.underlayProps; // Prevent scrolling while the modal is open, and hide content
  // outside the modal from screen readers.


  $49c51c25361d4cd2$export$ee0f7cc6afcd1c18({
    isDisabled: !state.isOpen
  }); // Get props for the dialog and its title

  var _b = $40df3f8667284809$export$d55e7ee900f34e93(props, ref),
      dialogProps = _b.dialogProps,
      titleProps = _b.titleProps;

  var renderCloseButton = function renderCloseButton() {
    return jsx("span", {
      css: closeButtonStyles({
        hasHeader: !!title
      })
    }, jsx(Button, {
      visualType: "icon",
      onPress: toggleModal
    }, jsx(Icon, {
      icon: "times"
    })));
  };

  var renderHeader = function renderHeader(titleText) {
    return jsx(ModalHeader, {
      title: titleText,
      toggleModal: toggleModal,
      titleProps: titleProps
    }, subtitle);
  };

  var modalTransitions = useTransition(state.isOpen, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    reverse: state.isOpen,
    config: config.gentle
  });
  return state.isOpen ? jsx(React__default.Fragment, null, modalTransitions(function (styles, loaded) {
    return loaded && jsx(animated.div, __assign({
      css: modalStyles
    }, underlayProps, {
      style: styles
    }), jsx($9bf71ea28793e738$export$20e40289641fbbb6, {
      contain: true,
      restoreFocus: true,
      autoFocus: true
    }, jsx("div", __assign({}, overlayProps, dialogProps, {
      ref: ref,
      css: modalBodyStyles({
        sz: size
      })
    }), title && renderHeader(title), jsx("div", {
      css: modalContentStyles({
        hasHeader: !!title
      })
    }, !title && renderCloseButton(), children))));
  })) : null;
};

Modal.defaultProps = {
  role: 'dialog',
  size: 'medium'
};

var Pagination =
/** @class */
function (_super) {
  __extends(Pagination, _super);

  function Pagination() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.paginate = function (event) {
      var page = parseInt(event.currentTarget.getAttribute('data-page'), 10);

      _this.props.paginationHandler(page);
    };

    return _this;
  }

  Pagination.prototype.render = function () {
    var _a = this.props,
        page = _a.page,
        pageSize = _a.pageSize,
        totalCount = _a.totalCount;
    return /*#__PURE__*/React.createElement("div", {
      className: "pagination-component text-right",
      "data-testid": "pagination-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      "data-testid": "quant-of-total"
    }, page * pageSize - (pageSize - 1), "\u2014", Math.min(page * pageSize, totalCount), " of ", totalCount), /*#__PURE__*/React.createElement("div", {
      "data-testid": "pointer"
    }, page > 1 &&
    /*#__PURE__*/

    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions */
    React.createElement("a", {
      "data-page": page - 1,
      onClick: this.paginate,
      className: "prev-page"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-chevron-left",
      "data-testid": "prev-pointer"
    })), page < Math.ceil(totalCount / pageSize) && /*#__PURE__*/React.createElement("a", {
      "data-page": page + 1,
      onClick: this.paginate,
      className: "next-page"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-chevron-right",
      "data-testid": "next-pointer"
    }))
    /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions */
    ));
  };

  return Pagination;
}(React.Component);

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var gridColumns = 12;

var parseWidth = function parseWidth(width) {
  var result = {
    type: 'empty',
    value: null
  };

  if (typeof width === 'string' && /^grid-/.test(width)) {
    // Turns "grid-X" into a numeric percentage w/ four significant digits (e.g.
    // "grid-4" to 0.3333)
    result.type = 'grid';
    result.value = Math.floor(10000 * parseInt(width.substring(5), 10) / gridColumns) / 10000;
  } else if (typeof width === 'string' && /^[0-9.]+%\s*$/.test(width)) {
    // Turns "X%" into a numeric percentage w/ four significant digis (e.g. "33.33%"
    // to 0.3333)
    result.type = 'percentage';
    result.value = Math.floor(100 * parseFloat(width)) / 10000;
  } else if (width === 'fit' || width === 'fill') {
    result.type = 'flex';
    result.value = width;
  } else if (width !== undefined && width !== null && width !== '') {
    result.type = 'css';
    result.value = width;
  }

  return result;
}; // These styles stretch the inner div to fill the entire box so that a width or
// height applied to the box will also apply to the inner div. This is only
// necessary for rows that wrap (which have two containing divs in order to make
// the gutter spacing work correctly - see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#Creating_gutters_between_items)


var wrapContainerStyles = process.env.NODE_ENV === "production" ? {
  name: "1yea8zh",
  styles: "align-items:stretch;display:flex;flex-direction:row"
} : {
  name: "1naceaj-wrapContainerStyles",
  styles: "align-items:stretch;display:flex;flex-direction:row;label:wrapContainerStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var childStyles = function childStyles(_a) {
  var width = _a.width,
      wrap = _a.wrap,
      marginHorizontal = _a.marginHorizontal;
  var widthRule;
  var parsedWidth = parseWidth(width);

  if (parsedWidth.type === 'grid' || parsedWidth.type === 'percentage') {
    // For percentage widths (or grid widths), set the element to the
    // specified percentage of the row's width (e.g. 50%) but subtract the
    // gutter spacing from the width to ensure there's enough room for the
    // element and its gutter (e.g. 50% - 16px). For rows that wrap we can
    // subtract the full gutter width since each element has a full gutter
    // to its right (the extra gutter on the right edge of the row is
    // removed with a negative margin on the parent element). For rows
    // that don't wrap the last element doesn't have a gutter to its
    // right, so things are a bit more complicated. In this case there's
    // one less gutter than there are elements in the row (e.g. 3 elements
    // have 2 gutters between them) so subtracting a full gutter from each
    // element's width would be too much. We have to spread out this saved
    // saved gutter space proportional to the percentage of the row that
    // the element takes up. For example if a row has two elements that
    // each take up 50% of the row with a single 16px gutter between them,
    // then we'd subtract 50% of the 16px gutter from each element giving
    // us a final width of 50% - 8px for each element.
    widthRule = parsedWidth.value !== null ? "calc(".concat(parsedWidth.value * 100, "% - ").concat(marginHorizontal - (wrap === 'none' ? parsedWidth.value * marginHorizontal : 0), "px) !important") : undefined;
  } else if (parsedWidth.type === 'css') {
    // If the size is a plain CSS value then just use that directly
    widthRule = "".concat(parsedWidth.value).concat(typeof parsedWidth.value === 'number' ? 'px' : '', " !important");
  }

  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css({
      flex: parsedWidth.type === 'flex' && parsedWidth.value === 'fill' ? '1 !important' : undefined,
      flexShrink: parsedWidth.type === 'grid' || parsedWidth.type === 'percentage' || parsedWidth.type === 'flex' && parsedWidth.value === 'fit' || parsedWidth.type === 'css' && parsedWidth.value !== 'auto' ? '0 !important' : undefined,
      width: widthRule
    }, process.env.NODE_ENV === "production" ? "" : ";label:childStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:childStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};

var rowStyles = function rowStyles(_a) {
  var _b;

  var _c = _a.alignmentHorizontal,
      alignmentHorizontal = _c === void 0 ? 'start' : _c,
      _d = _a.alignmentVertical,
      alignmentVertical = _d === void 0 ? 'center' : _d,
      backgroundColor = _a.backgroundColor,
      childWidths = _a.childWidths,
      height = _a.height,
      _e = _a.margin,
      margin = _e === void 0 ? '200' : _e,
      maxHeight = _a.maxHeight,
      maxWidth = _a.maxWidth,
      minHeight = _a.minHeight,
      minWidth = _a.minWidth,
      overflowX = _a.overflowX,
      overflowY = _a.overflowY,
      reverse = _a.reverse,
      type = _a.type,
      width = _a.width,
      _f = _a.wrap,
      wrap = _f === void 0 ? 'none' : _f;
  var marginVertical = Array.isArray(margin) ? uiTokens.spacing["v".concat(margin[0])].value : uiTokens.spacing["v".concat(margin)].value;
  var marginHorizontal = Array.isArray(margin) ? uiTokens.spacing["v".concat(margin[1])].value : marginVertical;
  var flexWrap;
  var stringWidth;
  if (wrap === 'down') flexWrap = 'wrap';else if (wrap === 'up') flexWrap = 'wrap-reverse';else flexWrap = 'nowrap';
  if (typeof width === 'string') stringWidth = width;else if (typeof width === 'number') stringWidth = "".concat(width, "px");
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css((_b = {
      alignItems: {
        top: 'flex-start',
        bottom: 'flex-end',
        center: 'center',
        stretch: 'stretch',
        baseline: 'baseline'
      }[alignmentVertical],
      backgroundColor: backgroundColor,
      border: type === 'outline' ? "1px solid ".concat(uiTokens.color.base.black.value) : 'none',
      display: 'flex',
      flexDirection: reverse ? 'row-reverse' : 'row',
      flexWrap: flexWrap,
      height: height,
      justifyContent: {
        start: 'flex-start',
        end: 'flex-end',
        center: 'center',
        justify: 'justify'
      }[alignmentHorizontal],
      // Reset the extra margins caused by the children on the right/bottom
      // edges. We can't do a simple reset on the first/last child because
      // there may be any number of children on the right/bottom edges if the
      // row wraps.
      margin: wrap === 'none' ? undefined : "0 -".concat(marginHorizontal, "px ").concat(-marginVertical, "px 0"),
      '& > *': {
        // Make sure that any borders or padding applied to the child don't throw
        // off the widths that we apply
        boxSizing: 'border-box !important',
        // Set margins for horizontal spacing and vertical spacing if the row is
        // allowed to wrap (and clear other margins)
        margin: "0 ".concat(marginHorizontal, "px ").concat(marginVertical, "px 0 !important")
      }
    }, _b["& > *:".concat(reverse ? 'first' : 'last', "-child")] = {
      marginRight: '0px !important'
    }, _b.maxHeight = maxHeight, _b.maxWidth = maxWidth, _b.minHeight = minHeight, _b.minWidth = minWidth, _b.overflowX = overflowX, _b.overflowY = overflowY, _b.width = wrap === 'none' ? undefined : "calc(".concat(stringWidth || '100%', " + ").concat(marginHorizontal, "px)"), _b), // If we've got an array of widths, apply each width to the child whose
    // index in the dom matches the widths's index in the array. If we've
    // got a single width, apply that to all children.
    childWidths && Array.isArray(childWidths) ? childWidths.reduce(function (result, childWidth, index) {
      // eslint-disable-next-line no-param-reassign
      result["& > *:nth-child(".concat(index + 1, ")")] = childStyles({
        width: childWidth,
        wrap: wrap,
        marginHorizontal: marginHorizontal
      });
      return result;
    }, {}) : {
      '& > *': childStyles({
        width: childWidths,
        wrap: wrap,
        marginHorizontal: marginHorizontal
      })
    }, process.env.NODE_ENV === "production" ? "" : ";label:rowStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:rowStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
}; // Apply the row styles to an extra div inside the box so margins that are
// applied to the box (e.g. if the row is nested in another row) don't
// conflict with the margins that are applied by `rowStyles`.


var childrenWithinDiv = function childrenWithinDiv(children, styles) {
  return jsx("div", {
    css: styles
  }, children);
};
/**
 * The Row component lines children up horizontally in a row with even spacing
 * in-between them. If a value is provided for the `wrap` property then the Row
 * component can also be used to stack elements with even vertical spacing
 * between them. It uses flexbox to do this.
 */


var Row = function Row(_a) {
  var _b = _a.alignmentHorizontal,
      alignmentHorizontal = _b === void 0 ? 'start' : _b,
      _c = _a.alignmentVertical,
      alignmentVertical = _c === void 0 ? 'center' : _c,
      backgroundColor = _a.backgroundColor,
      children = _a.children,
      childWidths = _a.childWidths,
      height = _a.height,
      _d = _a.margin,
      margin = _d === void 0 ? '200' : _d,
      maxHeight = _a.maxHeight,
      maxWidth = _a.maxWidth,
      minHeight = _a.minHeight,
      minWidth = _a.minWidth,
      overflowX = _a.overflowX,
      overflowY = _a.overflowY,
      reverse = _a.reverse,
      _e = _a.tag,
      tag = _e === void 0 ? 'div' : _e,
      type = _a.type,
      width = _a.width,
      _f = _a.wrap,
      wrapProp = _f === void 0 ? 'none' : _f;
  var wrap = height === undefined ? wrapProp : 'none';
  var styles = rowStyles({
    alignmentHorizontal: alignmentHorizontal,
    alignmentVertical: alignmentVertical,
    backgroundColor: backgroundColor,
    childWidths: childWidths,
    height: height,
    margin: margin,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    minHeight: minHeight,
    minWidth: minWidth,
    overflowX: overflowX,
    overflowY: overflowY,
    reverse: reverse,
    type: type,
    width: width,
    wrap: wrap
  }); // Either return the children wrapped within the tag (with rowStyles applied),
  // or wrap the children in a div that has row styles applied, and apply
  // wrapper styles to the tag.

  return jsx(tag, {
    css: wrap === 'none' ? styles : wrapContainerStyles
  }, wrap === 'none' ? children : childrenWithinDiv(children, styles));
};

var Row$1 = /*#__PURE__*/memo(Row);

// But it could be added more customization to it in the future.

var TableCell = function (props) {
  if (props.sortConfig) {
    var sortClassName = function (sortDirection) {
      var classString = 'fa ';

      switch (sortDirection) {
        case SortDirection.Ascending:
          classString = classString.concat('fa-sort-asc');
          break;

        case SortDirection.Descending:
          classString = classString.concat('fa-sort-desc');
          break;

        case SortDirection.None:
          classString = classString.concat('fa-sort');
          break;
      }

      return classString;
    }(props.sortConfig.sortDirection);

    return (
      /*#__PURE__*/

      /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions */
      React__default.createElement("a", {
        "data-testid": "sort-link-".concat(props.testIdKey),
        className: "sort",
        onClick: props.sortConfig.onSort
      }, /*#__PURE__*/React__default.createElement("span", null, props.element), /*#__PURE__*/React__default.createElement("i", {
        "data-testid": "sort-icon-".concat(props.testIdKey),
        className: sortClassName
      }))
      /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions */

    );
  } // This branch is intented for adding more customization in the future.
  // eslint-disable-next-line react/jsx-no-useless-fragment


  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.element);
};

var Table = function Table(props) {
  var headers = null;

  if (!props.tableData.headers || props.tableData.headers.length <= 0) {
    return headers;
  }

  if (props.sortConfig) {
    var _a = useState(props.sortConfig),
        sortConfig_1 = _a[0],
        setSortConfig_1 = _a[1];

    var handleSort_1 = function handleSort_1(index, sortDirection) {
      var newSortDirection = SortDirection.Ascending;

      if (sortConfig_1.sortColumnIndex === index) {
        newSortDirection = sortDirection === SortDirection.Ascending ? SortDirection.Descending : SortDirection.Ascending;
      }

      sortConfig_1.onSort(index, newSortDirection);
      setSortConfig_1(function (prevConfig) {
        return __assign(__assign({}, prevConfig), {
          sortDirection: newSortDirection,
          sortColumnIndex: index
        });
      });
    };

    headers = props.tableData.headers.map(function (header, index) {
      var cfg = sortConfig_1.sortableHeaders.includes(index) ? {
        onSort: function onSort() {
          return handleSort_1(index, sortConfig_1.sortDirection);
        },
        sortDirection: index === sortConfig_1.sortColumnIndex ? sortConfig_1.sortDirection : SortDirection.None
      } : undefined;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        React__default.createElement("th", {
          key: index,
          className: header.className
        }, /*#__PURE__*/React__default.createElement(TableCell, {
          testIdKey: index,
          element: header.element,
          sortConfig: cfg
        }))
      );
    });
  } else {
    headers = props.tableData.headers.map(function (header, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        React__default.createElement("th", {
          key: index,
          className: header.className
        }, /*#__PURE__*/React__default.createElement(TableCell, {
          testIdKey: index,
          element: header.element
        }))
      );
    });
  }

  var data = props.tableData.rows.map(function (row, rowIndex) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React__default.createElement("tr", {
        "data-testid": "table-data-row-".concat(rowIndex),
        key: rowIndex
      }, row.map(function (column, colIndex) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React__default.createElement("td", {
            "data-testid": "table-cell-r".concat(rowIndex, "-c").concat(colIndex),
            key: colIndex
          }, column)
        );
      }))
    );
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "table-component"
  }, props.tableData.rows && props.tableData.rows.length > 0 && /*#__PURE__*/React__default.createElement("table", {
    className: props.tableClass ? "table ".concat(props.tableClass) : 'table',
    "data-testid": "table-main"
  }, /*#__PURE__*/React__default.createElement("thead", {
    "data-testid": "table-head"
  }, /*#__PURE__*/React__default.createElement("tr", {
    "data-testid": "table-header-row"
  }, headers)), /*#__PURE__*/React__default.createElement("tbody", {
    "data-testid": "table-body"
  }, data)));
};

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

var isProduction$1 = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction$1) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
}

function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends$4({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = resolvePathname(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
    process.env.NODE_ENV !== "production" ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          process.env.NODE_ENV !== "production" ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ? process.env.NODE_ENV !== "production" ? invariant(false, 'Browser history needs a DOM') : invariant(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
    process.env.NODE_ENV !== "production" ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends$4(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
    process.env.NODE_ENV !== "production" ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
        process.env.NODE_ENV !== "production" ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
    process.env.NODE_ENV !== "production" ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
        process.env.NODE_ENV !== "production" ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ? process.env.NODE_ENV !== "production" ? invariant(false, 'Hash history needs a DOM') : invariant(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
    process.env.NODE_ENV !== "production" ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends$4(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
    process.env.NODE_ENV !== "production" ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
        process.env.NODE_ENV !== "production" ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
    process.env.NODE_ENV !== "production" ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    process.env.NODE_ENV !== "production" ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = createBrowserHistory(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React__default.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(React__default.Component);

if (process.env.NODE_ENV !== "production") {
  BrowserRouter.propTypes = {
    basename: propTypes.exports.string,
    children: propTypes.exports.node,
    forceRefresh: propTypes.exports.bool,
    getUserConfirmation: propTypes.exports.func,
    keyLength: propTypes.exports.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = createHashHistory(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React__default.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(React__default.Component);

if (process.env.NODE_ENV !== "production") {
  HashRouter.propTypes = {
    basename: propTypes.exports.string,
    children: propTypes.exports.node,
    getUserConfirmation: propTypes.exports.func,
    hashType: propTypes.exports.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? createLocation(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = React__default.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = _objectWithoutPropertiesLoose(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = _extends$4({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }
  /* eslint-disable-next-line jsx-a11y/anchor-has-content */


  return /*#__PURE__*/React__default.createElement("a", props);
});

if (process.env.NODE_ENV !== "production") {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = _objectWithoutPropertiesLoose(_ref2, ["component", "replace", "to", "innerRef"]);

  return /*#__PURE__*/React__default.createElement(__RouterContext.Consumer, null, function (context) {
    !context ? process.env.NODE_ENV !== "production" ? invariant(false, "You should not use <Link> outside a <Router>") : invariant(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = _extends$4({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var isDuplicateNavigation = createPath(context.location) === createPath(normalizeToLocation(location));
        var method = replace || isDuplicateNavigation ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return /*#__PURE__*/React__default.createElement(component, props);
  });
});

if (process.env.NODE_ENV !== "production") {
  var toType = propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.object, propTypes.exports.func]);
  var refType = propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.func, propTypes.exports.shape({
    current: propTypes.exports.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: propTypes.exports.func,
    replace: propTypes.exports.bool,
    target: propTypes.exports.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = React__default.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      sensitive = _ref.sensitive,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = _objectWithoutPropertiesLoose(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);

  return /*#__PURE__*/React__default.createElement(__RouterContext.Consumer, null, function (context) {
    !context ? process.env.NODE_ENV !== "production" ? invariant(false, "You should not use <NavLink> outside a <Router>") : invariant(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? matchPath(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      sensitive: sensitive,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
    var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;

    if (isActive) {
      className = joinClassnames(className, activeClassName);
      style = _extends$4({}, style, activeStyle);
    }

    var props = _extends$4({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return /*#__PURE__*/React__default.createElement(Link, props);
  });
});

if (process.env.NODE_ENV !== "production") {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = propTypes.exports.oneOf(["page", "step", "location", "date", "time", "true", "false"]);
  NavLink.propTypes = _extends$4({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: propTypes.exports.string,
    activeStyle: propTypes.exports.object,
    className: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.func]),
    exact: propTypes.exports.bool,
    isActive: propTypes.exports.func,
    location: propTypes.exports.object,
    sensitive: propTypes.exports.bool,
    strict: propTypes.exports.bool,
    style: propTypes.exports.oneOfType([propTypes.exports.object, propTypes.exports.func])
  });
}

var Tabs =
/** @class */
function (_super) {
  __extends(Tabs, _super);

  function Tabs() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleTabClick = function (event) {
      var tabKey = event.currentTarget.getAttribute('data-key');

      _this.props.tabEvent(tabKey);
    };

    return _this;
  }

  Tabs.prototype.render = function () {
    var _this = this;

    var tabs = this.props.tabs.map(function (tab) {
      var tabClass = tab.active ? 'active' : '';
      tabClass = tab.pullRight ? "pull-right ".concat(tabClass) : tabClass;
      return /*#__PURE__*/React.createElement("li", {
        key: tab.key,
        className: tabClass
      }, tab.href && /*#__PURE__*/React.createElement(NavLink, {
        to: tab.href,
        activeClassName: "active",
        exact: true
      }, tab.title && /*#__PURE__*/React.createElement("h2", null, tab.title), tab.subTitle && /*#__PURE__*/React.createElement("div", null, tab.subTitle)), !tab.href &&
      /*#__PURE__*/

      /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions */
      React.createElement("a", {
        "data-key": tab.key,
        "data-testid": tab.key,
        onClick: _this.handleTabClick
      }, tab.title && /*#__PURE__*/React.createElement("h2", null, tab.title), tab.subTitle && /*#__PURE__*/React.createElement("div", null, tab.subTitle))
      /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions */
      );
    });
    var navClass = 'nav';
    navClass = this.props.pills ? "".concat(navClass, " nav-pills") : "".concat(navClass, " nav-tabs");
    navClass = this.props.stacked ? "".concat(navClass, " stacked") : navClass;
    return /*#__PURE__*/React.createElement("ul", {
      className: navClass,
      id: "tabs-component"
    }, tabs);
  };

  return Tabs;
}(React.Component);

var InputResetStyles = function (_a) {
  var color = _a.color,
      placeholderColor = _a.placeholderColor;
  return {
    display: 'block',
    backgroundColor: 'white',
    width: '100%',
    color: color,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    outline: 'none',
    // Base built-in style resets
    WebkitAppearance: 'none',
    MozAppearance: 'textfield',
    // Remove the clear button from search inputs
    '::-ms-clear': {
      display: 'none'
    },
    '::-ms-reveal': {
      display: 'none'
    },
    '::-webkit-search-decoration': {
      display: 'none'
    },
    '::-webkit-search-cancel-button': {
      display: 'none'
    },
    '::-webkit-search-results-button': {
      display: 'none'
    },
    '::-webkit-search-results-decoration ': {
      display: 'none'
    },
    // Remove the built-in error outline
    ':invalid': {
      boxShadow: 'none'
    },
    ':-moz-submit-invalid': {
      boxShadow: 'none'
    },
    ':-moz-ui-invalid': {
      boxShadow: 'none'
    },
    // Remove the numeric input up/down buttons in webkit
    '::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: '0'
    },
    '::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: '0'
    },
    // Set the placeholder colors
    '::-moz-placeholder': {
      opacity: '1',
      color: placeholderColor
    },
    ':-moz-placeholder': {
      opacity: '1',
      color: placeholderColor
    },
    '::-ms-input-placeholder': {
      opacity: '1',
      color: placeholderColor
    },
    ':-ms-input-placeholder': {
      opacity: '1',
      color: placeholderColor
    },
    '::-webkit-input-placeholder': {
      opacity: '1',
      color: placeholderColor
    },
    '::placeholder': {
      opacity: '1',
      color: placeholderColor
    }
  };
};

var InputStyles = function (_a) {
  var isDisabled = _a.isDisabled,
      isFocused = _a.isFocused,
      errorMessage = _a.errorMessage;
  /* TODO: Tokenize these values and put them into ui-tokens a la the states on the button component PORT-469 */

  var color = uiTokens.color.base.gray.v800.value;
  var borderColor = uiTokens.color.base.gray.v50.value;
  var placeholderColor = uiTokens.color.base.gray.v400.value;

  if (errorMessage) {
    borderColor = uiTokens.color.base.red.v500.value;
  } else if (isDisabled) {
    borderColor = uiTokens.color.base.gray.v50.value;
    color = uiTokens.color.base.gray.v100.value;
    placeholderColor = uiTokens.color.base.gray.v100.value;
  }

  return __assign(__assign(__assign(__assign({}, InputResetStyles({
    color: color,
    placeholderColor: placeholderColor
  })), TextStyles({
    type: 'b300',
    tokens: uiTokens
  })), FocusStyles({
    isFocused: isFocused,
    tokens: uiTokens
  })), {
    borderColor: borderColor,
    borderRadius: '4px',
    borderStyle: 'solid',
    borderWidth: '1.5px',
    color: color,
    cursor: isDisabled ? 'not-allowed' : 'text',
    padding: "".concat(uiTokens.spacing.v100, "px")
  });
};

/**
 *
 * The `TextInput` component is used to collect text from the user. It includes a built-in label, helper text, and error message.
 * It also supports a number of different types of inputs, including password, email, and number.
 */

var TextInput = function TextInput(_a) {
  var autoComplete = _a.autoComplete,
      errorMessage = _a.errorMessage,
      helperText = _a.helperText,
      isDisabled = _a.isDisabled,
      isReadOnly = _a.isReadOnly,
      isRequired = _a.isRequired,
      label = _a.label,
      maxLength = _a.maxLength,
      maxWidth = _a.maxWidth,
      minLength = _a.minLength,
      minWidth = _a.minWidth,
      name = _a.name,
      pattern = _a.pattern,
      onBlur = _a.onBlur,
      onChange = _a.onChange,
      onFocus = _a.onFocus,
      placeholder = _a.placeholder,
      type = _a.type,
      value = _a.value;

  var _b = useState(false),
      isFocused = _b[0],
      setIsFocused = _b[1];

  var ref = useRef(null);

  var handleBlur = function handleBlur(e) {
    if (onBlur) {
      onBlur(e);
    }

    setIsFocused(false);
  };

  var handleFocus = function handleFocus(e) {
    if (onFocus) {
      onFocus(e);
    }

    setIsFocused(true);
  };

  var _c = $2d73ec29415bd339$export$712718f7aec83d5({
    autoComplete: autoComplete,
    description: helperText,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired,
    errorMessage: errorMessage,
    label: label,
    maxLength: maxLength,
    minLength: minLength,
    name: name,
    onBlur: handleBlur,
    onChange: onChange,
    onFocus: handleFocus,
    pattern: pattern,
    placeholder: placeholder,
    type: type,
    value: value
  }, ref),
      labelProps = _c.labelProps,
      inputProps = _c.inputProps,
      descriptionProps = _c.descriptionProps,
      errorMessageProps = _c.errorMessageProps;

  return jsx(Column$1, {
    maxWidth: maxWidth,
    minWidth: minWidth,
    margin: "50"
  }, jsx(Label, __assign({}, labelProps, {
    isDisabled: isDisabled
  }), label), jsx("input", __assign({}, inputProps, {
    ref: ref,
    css:
    /*#__PURE__*/

    /*#__PURE__*/
    css(InputStyles({
      errorMessage: errorMessage,
      isDisabled: isDisabled,
      isFocused: isFocused
    }), process.env.NODE_ENV === "production" ? "" : ";label:css;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:css;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  })), helperText && !errorMessage && jsx(InputDescription, __assign({}, descriptionProps, {
    isDisabled: isDisabled
  }), helperText), errorMessage && jsx(InputErrorMessage, __assign({}, errorMessageProps), errorMessage));
};

var getTextAreaStyles = function getTextAreaStyles(_a) {
  var errorMessage = _a.errorMessage,
      isDisabled = _a.isDisabled,
      isFocused = _a.isFocused,
      minWidth = _a.minWidth,
      maxWidth = _a.maxWidth;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    css(__assign(__assign({}, InputStyles({
      errorMessage: errorMessage,
      isDisabled: isDisabled,
      isFocused: isFocused
    })), {
      minWidth: minWidth,
      maxWidth: maxWidth
    }), process.env.NODE_ENV === "production" ? "" : ";label:getTextAreaStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", process.env.NODE_ENV === "production" ? "" : ";label:getTextAreaStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  );
};
/**
 *
 * The `TextArea` component is used to collect text from the user. It includes a built-in label, helper text, and error message.
 * It also supports a number of different types of inputs, including password, email, and number.
 */


var TextArea = function TextArea(_a) {
  var rows = _a.rows,
      cols = _a.cols,
      autoComplete = _a.autoComplete,
      errorMessage = _a.errorMessage,
      helperText = _a.helperText,
      isDisabled = _a.isDisabled,
      isReadOnly = _a.isReadOnly,
      isRequired = _a.isRequired,
      label = _a.label,
      maxLength = _a.maxLength,
      maxWidth = _a.maxWidth,
      minLength = _a.minLength,
      minWidth = _a.minWidth,
      name = _a.name,
      pattern = _a.pattern,
      onBlur = _a.onBlur,
      onChange = _a.onChange,
      onFocus = _a.onFocus,
      placeholder = _a.placeholder,
      type = _a.type,
      value = _a.value;

  var _b = useState(false),
      isFocused = _b[0],
      setIsFocused = _b[1];

  var ref = useRef(null);

  var handleBlur = function handleBlur(e) {
    if (onBlur) {
      onBlur(e);
    }

    setIsFocused(false);
  };

  var handleFocus = function handleFocus(e) {
    if (onFocus) {
      onFocus(e);
    }

    setIsFocused(true);
  };

  var _c = $2d73ec29415bd339$export$712718f7aec83d5({
    autoComplete: autoComplete,
    description: helperText,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired,
    errorMessage: errorMessage,
    label: label,
    maxLength: maxLength,
    minLength: minLength,
    name: name,
    onBlur: handleBlur,
    onChange: onChange,
    onFocus: handleFocus,
    pattern: pattern,
    placeholder: placeholder,
    type: type,
    value: value,
    inputElementType: 'textarea'
  }, ref),
      labelProps = _c.labelProps,
      inputProps = _c.inputProps,
      descriptionProps = _c.descriptionProps,
      errorMessageProps = _c.errorMessageProps;

  return jsx(Column$1, {
    maxWidth: maxWidth,
    minWidth: minWidth,
    margin: "50"
  }, jsx(Label, __assign({}, labelProps, {
    isDisabled: isDisabled
  }), label), jsx("textarea", __assign({
    rows: rows,
    cols: cols
  }, inputProps, {
    ref: ref,
    css: getTextAreaStyles({
      errorMessage: errorMessage,
      isDisabled: isDisabled,
      isFocused: isFocused,
      minWidth: minWidth,
      maxWidth: maxWidth
    })
  })), helperText && !errorMessage && jsx(InputDescription, __assign({}, descriptionProps, {
    isDisabled: isDisabled
  }), helperText), errorMessage && jsx(InputErrorMessage, __assign({}, errorMessageProps), errorMessage));
};

var UITable = function UITable(_a) {
  var children = _a.children,
      headerBorder = _a.headerBorder,
      zebraStripe = _a.zebraStripe;
  var tableStyles = useTable({
    headerBorder: headerBorder,
    zebraStripe: zebraStripe
  }).tableStyles;
  return jsx("table", __assign({}, tableStyles), children);
};

var UITableCell = function UITableCell(_a) {
  var children = _a.children,
      _b = _a.tag,
      tag = _b === void 0 ? 'td' : _b;
  return /*#__PURE__*/React__default.createElement(tag, {}, children);
};

var UITableContainer = function UITableContainer(_a) {
  var children = _a.children,
      _b = _a.tag,
      tag = _b === void 0 ? 'tbody' : _b;
  return /*#__PURE__*/React__default.createElement(tag, {}, children);
};

var UITableRow = function UITableRow(_a) {
  var children = _a.children;
  return /*#__PURE__*/React__default.createElement("tr", null, children);
};

function friendlyCount(count) {
  if (count > 0 && count < 10) {
    return "0".concat(count);
  }

  if (count >= 1000 && count < 10000) {
    var numString = count.toString();
    return "".concat(numString.slice(0, 1), ",").concat(numString.slice(1));
  }

  if (count >= 10000) {
    var numString = count.toString();
    return "".concat(numString.slice(0, numString.length - 3), "K+");
  }

  return count.toString();
}

export { Box, Button, Column$1 as Column, DetailedErrorsTable, DetailedInfoBox, EmailAddressLink as EmailAddress, Expander, FileDropzone, FileSelectLabel, FileSelector, Heading, Icon, InfoBox, InputDescription, InputErrorMessage, Label, LegacyModal, Link$1 as Link, Loader, Modal, ModalHeader, Pagination, Row$1 as Row, SortDirection, Table, Tabs, Text, TextArea, TextInput, UITable, UITableCell, UITableContainer, UITableRow, friendlyCount, useTable };
//# sourceMappingURL=index.es.js.map
